import { defineComponent as G, useModel as bt, createElementBlock as R, openBlock as j, normalizeClass as ae, createElementVNode as A, withDirectives as Ur, createVNode as $, renderSlot as ge, unref as D, vShow as ai, Fragment as Se, toDisplayString as V, ref as B, onMounted as Ee, watchEffect as nt, watch as Ie, createCommentVNode as te, createBlock as ne, withCtx as ee, createTextVNode as Oe, useSlots as Gd, computed as U, mergeModels as lt, Transition as Kn, renderList as Ke, inject as Fe, nextTick as it, cloneVNode as Hd, h as qe, provide as Qe, onUnmounted as rt, shallowRef as Wd, getCurrentInstance as Kd, Teleport as Qn, reactive as Qd, toRaw as ze, resolveComponent as Yn, withModifiers as St, normalizeStyle as _t, vModelDynamic as Yd, isRef as Xd, withKeys as ds, useCssVars as ef, withAsyncContext as Ks, TransitionGroup as tf, mergeProps as rf, resolveDynamicComponent as sf, vModelText as nf } from "vue";
import { FontAwesomeIcon as je } from "@fortawesome/vue-fontawesome";
import { DateTime as Vt } from "luxon";
import { createPopper as of } from "@popperjs/core";
import ke from "axios";
import { useInject as pr } from "inversify-hooks";
import { createI18n as af, useI18n as At } from "vue-i18n";
import * as ii from "@sentry/vue";
import hu from "mitt";
import { useDebounceFn as Xn, onClickOutside as du, useStorage as fu, useSessionStorage as lf, watchDebounced as uf } from "@vueuse/core";
import cf from "@vuepic/vue-datepicker";
import "reflect-metadata";
import { library as hf } from "@fortawesome/fontawesome-svg-core";
import { faCheck as df, faXmark as ff, faFilters as pf, faFileArrowUp as mf, faMagnifyingGlass as vf, faArrowUp as gf, faArrowUpArrowDown as yf, faCaretDown as _f, faArrowLeft as bf, faPlus as wf, faCircleExclamation as Pf, faChevronLeft as xf, faChevronRight as Sf, faCheckCircle as Tf, faBooks as Lf, faTriangleExclamation as Cf, faCopy as Af, faInfoCircle as Of, faStarChristmas as kf } from "@fortawesome/pro-light-svg-icons";
import { faFilters as If, faBadgeCheck as jf } from "@fortawesome/pro-solid-svg-icons";
import { defineStore as Ef } from "pinia";
const Df = {
  success: "Erfolg",
  warning: "Warnung",
  error: "Fehler",
  name: "Name",
  display_name: "Anzeigename",
  description: "Beschreibung",
  no_items_available: "Es stehen keine Einträge zur Auswahl",
  view_item: "{name} anzeigen",
  edit_item: "{name} bearbeiten",
  edit: "Bearbeiten",
  cancel: "Abbrechen",
  close: "Schließen",
  save: "Speichern",
  delete: "Löschen",
  add: "Hinzufügen",
  title: "Titel",
  placeholder: "Platzhalter",
  required: "Erforderlich",
  confirm_delete: {
    title: "{name} löschen",
    text: 'Möchten Sie "{name}" wirklich löschen?'
  },
  deleted: {
    success_title: "{name} gelöscht",
    success_text: '"{name}" wurde erfolgreich gelöscht.',
    failed_text: '"{name}" konnte nicht gelöscht werden.'
  },
  copy_error_text: "Fehlermeldung kopieren",
  error_text_copied_title: "Fehlermeldung kopiert",
  error_text_copied_text: "Die Fehlermeldung wurde in die Zwischenablage kopiert.",
  error_text_copy_failed_title: "Fehlermeldung konnte nicht kopiert werden",
  error_text_copy_failed_text: "Die Fehlermeldung konnte nicht in die Zwischenablage kopiert werden."
}, Mf = {
  backoffice: "Backoffice",
  title: "Bei Ihrem Konto anmelden",
  login_with: "Jetzt anmelden mit",
  privacy_policy: "Datenschutzerklärung",
  imprint: "Impressum"
}, Nf = {
  unknown: "Ein unbekannter Fehler ist aufgetreten.",
  network: "Ein Netzwerkfehler ist aufgetreten. Bitte überprüfen Sie Ihre Internetverbindung.",
  questionnaire: {
    not_found: "Der Fragebogen konnte nicht gefunden werden.",
    already_exists: "Dieser Fragebogen existiert bereits."
  },
  project: {
    not_found: "Das Projekt konnte nicht gefunden werden.",
    access_denied: "Sie haben keinen Zugriff auf dieses Projekt.",
    changes_denied: "Sie dürfen diese Änderung an diesem Projekt nicht vornehmen."
  },
  project_member: {
    not_found: "Das Projektmitglied konnte nicht gefunden werden.",
    is_lead: "Dieses Projektmitglied kann nicht gelöscht werden, da es Projektleiter ist."
  },
  team_member: {
    not_found: "Das Projektmitglied konnte nicht gefunden werden.",
    is_lead: "Dieses Teammitglied kann nicht gelöscht werden, da es Teamleiter ist."
  },
  absence: {
    overlapping: "Es gibt bereits eine Abwesenheit, die sich mit dieser überschneidet.",
    not_found: "Die Abwesenheit konnte nicht gefunden werden.",
    not_allowed: "Sie haben keine Berechtigung, diese Abwesenheit anzulegen oder zu bearbeiten."
  },
  push: {
    no_notifications_sent: "Es konnten keine Benachrichtigungen gesendet werden. Eventuell wurden Benachrichtigungen deaktiviert."
  },
  product: {
    has_questions: "Das Produkt kann nicht gelöscht werden, da es in einem Fragebogen verwendet wird. Entfernen Sie zuerst die zugehörige Auswahlmöglichkeit."
  },
  question: {
    not_found: "Die Frage konnte nicht gefunden werden",
    type_change_not_allowed: "Der Fragetyp kann nicht geändert werden, da eine oder mehrere Fragen abhängig sind."
  },
  question_option: {
    not_removable: "Die Auswahlmöglichkeit kann nicht entfernt werden, da eine andere Frage von ihr abhängt."
  },
  visit: {
    contact_missing: "Es wurde kein Kontakt für diesen Besuch angegeben.",
    not_found: "Der Besuch konnte nicht gefunden werden.",
    no_dates_available: "Sie können für dieses Projekt keinen Besuch anlegen, da alle verfügbaren Tage bereits abgeschlossen wurden.",
    invalid_date: "Dieses Datum kann nicht verwendet werden, da es außerhalb des gültigen Zeitraums liegt oder weil bereits ein Tagesabschluss existiert.",
    creation_not_allowed_without_task: "In diesem Projekt dürfen Berichte nur über zugeteilte Aufgaben erstellt werden."
  },
  end_of_day_questionnaire: {
    not_found: "Der Tagesabschluss konnte nicht gefunden werden.",
    user_already_added: "Dieses Mitglied wurde bereits einem Tagesabschluss zugeteilt",
    user_not_found: "Dieses Mitglied ist diesem Tagesabschluss nicht zugeteilt"
  },
  user: {
    not_found: "Der Benutzer konnte nicht gefunden werden.",
    has_responsibilities: "Der Benutzer kann nicht gelöscht werden, da er Projekt- oder Teamleiter ist.",
    not_subordinate: "Dieser Benutzer ist Ihnen nicht unterstellt.",
    already_exists: "Ein Benutzer mit dieser E-Mail-Adresse existiert bereits."
  },
  submission: {
    not_found: "Der Bericht konnte nicht gefunden werden.",
    day_finalized: "Sie haben den heutigen Tag bereits abgeschlossen. Es können keine weiteren Besuche erstellt werden.",
    cannot_delete_finalized: "Der Besuch kann nicht gelöscht werden, da der Tag bereits abgeschlossen ist."
  },
  contact_status: {
    duplicate_project_status: "Dieser Kontakt hat bereits diesen Status."
  },
  filter_preset: {
    not_found: "Der Filter konnte nicht gefunden werden.",
    name_already_exists: "Ein Filter mit diesem Namen existiert bereits."
  },
  city: {
    not_found: "Die Stadt für diese PLZ konnte nicht gefunden werden."
  }
}, Jf = {
  back: "Zurück",
  forward: "Weiter",
  results: "Ergebnis | Ergebnissen",
  no_data: "Keine Ergebnisse",
  search: "Schnellsuche",
  search_fields: "Suchen in:",
  to: "bis",
  from: "von",
  entries: "Einträge",
  filters_set: "Keine Filter gesetzt | Ein Filter gesetzt | {n} Filter gesetzt",
  contains: "enthält",
  before: "vor",
  after: "nach",
  equals: "gleich",
  lower_than: "kleiner",
  lower_than_equals: "kleiner gleich",
  greater_than: "größer",
  greater_than_equals: "größer gleich"
}, Uf = {
  absence: "Abwesenheit | Abwesenheiten",
  new: "Neue Abwesenheit",
  confirm_delete_text: "Möchten Sie diese Abwesenheit wirklich löschen?",
  range: "Zeitraum",
  from: "Von",
  to: "Bis",
  type: "Typ",
  types: {
    vacation: "Urlaub",
    sick_leave: "Krankenstand",
    training: "Schulung",
    holiday: "Feiertag"
  }
}, Bf = {
  no_results: "Keine Ergebnisse gefunden"
}, Rf = {
  title: "Zugriff verweigert",
  text: "Sie haben keine Berechtigung, diese Seite anzuzeigen."
}, zf = {
  address: "Adresse",
  title: "Kontakt",
  name: "Name",
  company_name: "Firmenname",
  email: "E-Mail",
  phone: "Telefon",
  note: "Notiz",
  street: "Straße",
  contact_name: "Ansprechpartner",
  contact_role: "Funktion",
  zip: "PLZ",
  city: "Stadt",
  details: "Adresszusatz",
  country: "Land | Länder",
  countries: {
    austria: "Österreich",
    germany: "Deutschland"
  }
}, qf = {
  contact_type: "Kontakttyp | Kontakttypen",
  business: "B2B",
  private: "B2C"
}, Zf = {
  potential: "Erkannte Potentiale",
  product_count: "Verkaufte Anzahl an {product}"
}, Vf = {
  filters: {
    title: "Kartenfilter",
    filter: "Filter | Filter",
    general_filters: "Allgemeine Filter",
    report_filters: "Berichtsfilter",
    potential_filters: "Potentialfilter",
    task_filters: "Aufgabenfilter",
    group_status: "Statusgruppe",
    project_status: "Projektstatus",
    reference_users: "Nutzer",
    postal_code: "Postleitzahl",
    street: "Straße",
    city: "Ort",
    country: "Land",
    potential: "Potenzial",
    show_visits: "Besuche anzeigen",
    visit_date: "Besuchsdatum",
    show_open_tasks: "Offene Aufgaben anzeigen",
    show_potentials: "Potenziale anzeigen",
    show_unassigned: "Unzugeordnete Einträge anzeigen"
  },
  legend: {
    title: "Legende",
    pin_types: "Pin-Arten",
    visits: "Besuche",
    open_tasks: "Offene Aufgaben",
    potentials: "Potenziale",
    status_colors: "Statusfarben"
  }
}, $f = {
  title: "Ihr Standort konnte nicht bestimmt werden.",
  locate: "Aktuellen Standort bestimmen",
  not_supported: "Ihr Browser unterstützt dieses Feature nicht.",
  denied: "Bitte aktivieren Sie die Standortbestimmung in Ihren Browsereinstellungen.",
  unavailable: "Der Standort ist nicht verfügbar.",
  timeout: "Die Standortanfrage hat zu lange gedauert.",
  unknown: "Ein unbekannter Fehler ist aufgetreten.",
  within: "Sie befinden sich innerhalb von {distance} Metern von diesem Punkt."
}, Ff = {
  title: "Adresse nicht validiert",
  text: "Die eingegebene Adresse konnte nicht vollständig validiert werden. Möchten Sie trotzdem fortfahren?",
  save_anyway: "Trotzdem speichern",
  correction_title: "Adressvorschlag",
  correction_text: "Das System empfiehlt folgende Adresse, welche sich von Ihrer Eingabe unterscheidet. Bitte wählen Sie die zu verwendende Adresse:",
  your_input: "Ihre Eingabe",
  our_suggestion: "Unser Vorschlag",
  apply: "Übernehmen"
}, pu = {
  common: Df,
  login: Mf,
  errors: Nf,
  table: Jf,
  absences: Uf,
  autocomplete: Bf,
  signin_failed: Rf,
  address_details: zf,
  contact_types: qf,
  special_question: Zf,
  map: Vf,
  geolocation: $f,
  address_validation: Ff
}, Gf = { class: "text-sm leading-tight text-gray-500" }, Hf = { class: "border-t border-gray-200 px-4 py-3" }, UP = /* @__PURE__ */ G({
  __name: "AccordionItem",
  props: {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(a) {
    const e = bt(a, "modelValue");
    return (t, o) => (j(), R("div", {
      class: ae(["overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xs transition-all duration-200", e.value ? "mb-4" : "mb-0"])
    }, [
      A("button", {
        type: "button",
        class: "flex w-full items-center justify-between px-4 py-3 text-left hover:bg-gray-50",
        onClick: o[0] || (o[0] = (r) => e.value = !e.value)
      }, [
        A("span", Gf, [
          ge(t.$slots, "title")
        ]),
        $(D(je), {
          icon: ["fal", "chevron-right"],
          class: ae(["h-5 w-5 text-gray-500 transition", e.value ? "-rotate-90" : "rotate-90"]),
          "aria-hidden": "true"
        }, null, 8, ["class"])
      ]),
      Ur(A("div", Hf, [
        ge(t.$slots, "default")
      ], 512), [
        [ai, e.value]
      ])
    ], 2));
  }
}), Wf = { class: "text-sm/6 font-medium text-gray-900" }, Kf = {
  role: "list",
  class: "mt-4 space-y-6"
}, BP = /* @__PURE__ */ G({
  __name: "ActivityFeed",
  props: {
    title: {}
  },
  setup(a) {
    const e = a;
    return (t, o) => (j(), R(Se, null, [
      A("h2", Wf, V(e.title), 1),
      A("ul", Kf, [
        ge(t.$slots, "default")
      ])
    ], 64));
  }
}), eo = (a) => {
  const e = B(null), t = B(null);
  return Ee(() => {
    nt((o) => {
      if (!t.value || !e.value) return;
      const r = t.value.el || t.value, s = e.value.el || e.value;
      if (!(s instanceof HTMLElement) || !(r instanceof HTMLElement)) return;
      const { destroy: i } = of(s, r, a);
      o(i);
    });
  }), [e, t];
}, gs = /* @__PURE__ */ G({
  __name: "Tooltip",
  props: {
    enabled: { type: Boolean, default: !0 },
    placement: { default: "top" },
    offset: {},
    contentClass: {}
  },
  setup(a) {
    const e = a;
    Ie(
      () => e.enabled,
      (s) => {
        s || (r.value = !1);
      }
    );
    const [t, o] = eo({
      placement: e.placement,
      strategy: "fixed",
      modifiers: [{ name: "offset", options: { offset: e.offset ?? [0, 4] } }]
    }), r = B(!1);
    return (s, i) => (j(), R(Se, null, [
      A("div", {
        ref_key: "trigger",
        ref: t,
        onMouseenter: i[0] || (i[0] = (u) => s.enabled ? r.value = !0 : null),
        onMouseleave: i[1] || (i[1] = (u) => r.value = !1),
        onClick: i[2] || (i[2] = (u) => r.value = !1)
      }, [
        ge(s.$slots, "trigger")
      ], 544),
      r.value ? (j(), R("div", {
        key: 0,
        class: ae(["dark:border-dark-600 dark:bg-dark-800 z-50 max-w-sm !whitespace-break-spaces rounded-md border border-gray-200 bg-white px-3 py-2 text-sm leading-relaxed text-gray-900 shadow-lg dark:text-white", s.contentClass]),
        ref_key: "container",
        ref: o
      }, [
        ge(s.$slots, "content")
      ], 2)) : te("", !0)
    ], 64));
  }
}), Qf = /* @__PURE__ */ A("div", { class: "w-px bg-gray-200" }, null, -1), Yf = [
  Qf
], Xf = { class: "relative flex size-6 flex-none items-center justify-center bg-white" }, ep = {
  key: 1,
  class: "size-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300"
}, tp = { class: "flex-auto py-0.5 text-xs/5 text-gray-500" }, rp = { class: "shrink-0" }, sp = ["datetime"], ip = {
  key: 1,
  class: "flex-auto rounded-md p-3 ring-1 ring-gray-200 ring-inset"
}, np = { class: "flex justify-between gap-x-4" }, op = { class: "py-0.5 text-xs/5 text-gray-500" }, ap = { class: "shrink-0" }, lp = ["datetime"], RP = /* @__PURE__ */ G({
  __name: "ActivityFeedItem",
  props: {
    listKey: {},
    isLast: { type: Boolean },
    icon: {},
    iconColor: { default: "text-primary-500" },
    emph: { type: Boolean },
    dateTime: {}
  },
  setup(a) {
    const e = a, t = Vt.now(), o = e.dateTime ? e.dateTime.toISOString() : "", r = B(""), s = B("");
    return e.dateTime && (r.value = Vt.fromJSDate(e.dateTime).setLocale("de-AT").toRelative(t) ?? "", s.value = Vt.fromJSDate(e.dateTime).setLocale("de-AT").toLocaleString({
      weekday: "long",
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    })), (i, u) => (j(), R("li", {
      key: e.listKey,
      class: "relative flex gap-x-4"
    }, [
      A("div", {
        class: ae([i.isLast ? "h-6" : "-bottom-6", "absolute top-0 left-0 flex w-6 justify-center"])
      }, Yf, 2),
      A("div", Xf, [
        e.icon ? (j(), ne(D(je), {
          key: 0,
          icon: ["fas", e.icon],
          class: ae(["size-5", e.iconColor]),
          "aria-hidden": "true"
        }, null, 8, ["icon", "class"])) : (j(), R("div", ep))
      ]),
      e.emph ? (j(), R("div", ip, [
        A("div", np, [
          A("div", op, [
            ge(i.$slots, "default")
          ]),
          A("div", ap, [
            $(gs, null, {
              trigger: ee(() => [
                A("time", {
                  datetime: D(o),
                  class: "flex-none py-0.5 text-xs/5 text-gray-500"
                }, V(r.value), 9, lp)
              ]),
              content: ee(() => [
                Oe(V(s.value), 1)
              ]),
              _: 1
            })
          ])
        ]),
        ge(i.$slots, "emphAdditionalContent")
      ])) : (j(), R(Se, { key: 0 }, [
        A("p", tp, [
          ge(i.$slots, "default")
        ]),
        A("div", rp, [
          $(gs, null, {
            trigger: ee(() => [
              A("time", {
                datetime: D(o),
                class: "flex-none py-0.5 text-xs/5 text-gray-500"
              }, V(r.value), 9, sp)
            ]),
            content: ee(() => [
              Oe(V(s.value), 1)
            ]),
            _: 1
          })
        ])
      ], 64))
    ]));
  }
});
class up {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  listUserAbsences(e, t, o) {
    let r = this.baseUrl + "/absences/of_user/{userId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    r = r.replace("{userId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processListUserAbsences(u));
  }
  processListUserAbsences(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = ms.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  listCurrentUserAbsences(e, t) {
    let o = this.baseUrl + "/absences/of_current_user/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processListCurrentUserAbsences(i));
  }
  processListCurrentUserAbsences(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = ms.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/absences/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = xi.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/absences/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = ms.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class cp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  updateBulk(e, t) {
    let o = this.baseUrl + "/answers/bulk";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      responseType: "blob",
      method: "PUT",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processUpdateBulk(i));
  }
  processUpdateBulk(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200 || t === 206) {
      const r = e.headers ? e.headers["content-disposition"] : void 0;
      let s = r ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(r) : void 0, i = s && s.length > 1 ? s[3] || s[2] : void 0;
      return i ? i = decodeURIComponent(i) : (s = r ? /filename="?([^"]*?)"?(;|$)/g.exec(r) : void 0, i = s && s.length > 1 ? s[1] : void 0), Promise.resolve({ fileName: i, status: t, data: new Blob([e.data], { type: e.headers["content-type"] }), headers: o });
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/answers";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = vr.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/answers/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = vr.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/answers/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = vr.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/answers/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/answers/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = so.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class mu {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  login(e, t) {
    let o = this.baseUrl + "/auth/login?";
    if (e === null)
      throw new globalThis.Error("The parameter 'pwa' cannot be null.");
    e !== void 0 && (o += "pwa=" + encodeURIComponent("" + e) + "&"), o = o.replace(/[?&]$/, "");
    let r = {
      responseType: "blob",
      method: "GET",
      url: o,
      headers: {
        Accept: "application/octet-stream"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processLogin(s));
  }
  processLogin(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200 || t === 206) {
      const r = e.headers ? e.headers["content-disposition"] : void 0;
      let s = r ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(r) : void 0, i = s && s.length > 1 ? s[3] || s[2] : void 0;
      return i ? i = decodeURIComponent(i) : (s = r ? /filename="?([^"]*?)"?(;|$)/g.exec(r) : void 0, i = s && s.length > 1 ? s[1] : void 0), Promise.resolve({ fileName: i, status: t, data: new Blob([e.data], { type: e.headers["content-type"] }), headers: o });
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  logout(e) {
    let t = this.baseUrl + "/auth/logout";
    t = t.replace(/[?&]$/, "");
    let o = {
      method: "GET",
      url: t,
      headers: {},
      cancelToken: e
    };
    return this.instance.request(o).catch((r) => {
      if (O(r) && r.response)
        return r.response;
      throw r;
    }).then((r) => this.processLogout(r));
  }
  processLogout(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  microsoftSignIn(e) {
    let t = this.baseUrl + "/auth/signin-microsoft";
    t = t.replace(/[?&]$/, "");
    let o = {
      responseType: "blob",
      method: "GET",
      url: t,
      headers: {
        Accept: "application/octet-stream"
      },
      cancelToken: e
    };
    return this.instance.request(o).catch((r) => {
      if (O(r) && r.response)
        return r.response;
      throw r;
    }).then((r) => this.processMicrosoftSignIn(r));
  }
  processMicrosoftSignIn(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200 || t === 206) {
      const r = e.headers ? e.headers["content-disposition"] : void 0;
      let s = r ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(r) : void 0, i = s && s.length > 1 ? s[3] || s[2] : void 0;
      return i ? i = decodeURIComponent(i) : (s = r ? /filename="?([^"]*?)"?(;|$)/g.exec(r) : void 0, i = s && s.length > 1 ? s[1] : void 0), Promise.resolve({ fileName: i, status: t, data: new Blob([e.data], { type: e.headers["content-type"] }), headers: o });
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getSession(e) {
    let t = this.baseUrl + "/auth/session";
    t = t.replace(/[?&]$/, "");
    let o = {
      method: "GET",
      url: t,
      headers: {
        Accept: "application/json"
      },
      cancelToken: e
    };
    return this.instance.request(o).catch((r) => {
      if (O(r) && r.response)
        return r.response;
      throw r;
    }).then((r) => this.processGetSession(r));
  }
  processGetSession(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = no.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class vu {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  create(e, t) {
    let o = this.baseUrl + "/contacts";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = We.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  search(e, t, o) {
    let r = this.baseUrl + "/contacts/search?";
    if (e === null)
      throw new globalThis.Error("The parameter 'query' cannot be null.");
    if (e !== void 0 && (r += "query=" + encodeURIComponent("" + e) + "&"), t === null)
      throw new globalThis.Error("The parameter 'contactType' cannot be null.");
    t !== void 0 && (r += "contactType=" + encodeURIComponent("" + t) + "&"), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processSearch(i));
  }
  processSearch(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(We.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  visitedTodayForProject(e, t, o) {
    let r = this.baseUrl + "/contacts/visited_today_for_project/{projectId}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    if (r = r.replace("{projectId}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'contactType' cannot be null.");
    t !== void 0 && (r += "contactType=" + encodeURIComponent("" + t) + "&"), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processVisitedTodayForProject(i));
  }
  processVisitedTodayForProject(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(We.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getAllWithVisits(e, t, o) {
    let r = this.baseUrl + "/contacts/all_with_visits_in_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processGetAllWithVisits(u));
  }
  processGetAllWithVisits(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(We.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getAllWithOpenTasks(e, t, o) {
    let r = this.baseUrl + "/contacts/all_with_tasks_in_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processGetAllWithOpenTasks(u));
  }
  processGetAllWithOpenTasks(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(We.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getAllWithRelevantPotentials(e, t, o) {
    let r = this.baseUrl + "/contacts/all_with_open_potential_for_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processGetAllWithRelevantPotentials(u));
  }
  processGetAllWithRelevantPotentials(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(We.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/contacts/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = We.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/contacts/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = We.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/contacts/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/contacts/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = uo.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class hp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  createWithVisit(e, t, o) {
    let r = this.baseUrl + "/contact_status/with_visit/{visitId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'visitId' must be defined.");
    r = r.replace("{visitId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processCreateWithVisit(u));
  }
  processCreateWithVisit(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Dt.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getHistory(e, t, o) {
    let r = this.baseUrl + "/contact_status/get_history/{contactId},{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'contactId' must be defined.");
    if (r = r.replace("{contactId}", encodeURIComponent("" + e)), t == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + t)), r = r.replace(/[?&]$/, "");
    let s = {
      method: "POST",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGetHistory(i));
  }
  processGetHistory(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(Dt.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getCurrent(e, t, o) {
    let r = this.baseUrl + "/contact_status/get_current/{contactId},{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'contactId' must be defined.");
    if (r = r.replace("{contactId}", encodeURIComponent("" + e)), t == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + t)), r = r.replace(/[?&]$/, "");
    let s = {
      method: "POST",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGetCurrent(i));
  }
  processGetCurrent(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Dt.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  listByProjectId(e, t, o) {
    let r = this.baseUrl + "/contact_status/list_by_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processListByProjectId(u));
  }
  processListByProjectId(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = co.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/contact_status";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Dt.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class dp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  addUser(e, t, o) {
    let r = this.baseUrl + "/end_of_day_questionnaires/{id}/users/{userId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t == null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    r = r.replace("{userId}", encodeURIComponent("" + t)), r = r.replace(/[?&]$/, "");
    let s = {
      method: "POST",
      url: r,
      headers: {},
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processAddUser(i));
  }
  processAddUser(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  removeUser(e, t, o) {
    let r = this.baseUrl + "/end_of_day_questionnaires/{id}/users/{userId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t == null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    r = r.replace("{userId}", encodeURIComponent("" + t)), r = r.replace(/[?&]$/, "");
    let s = {
      method: "DELETE",
      url: r,
      headers: {},
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processRemoveUser(i));
  }
  processRemoveUser(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getUsers(e, t) {
    let o = this.baseUrl + "/end_of_day_questionnaires/{id}/users";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      url: o,
      headers: {
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processGetUsers(s));
  }
  processGetUsers(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(Ze.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/end_of_day_questionnaires";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Nr.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/end_of_day_questionnaires/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Nr.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/end_of_day_questionnaires/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Nr.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/end_of_day_questionnaires/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/end_of_day_questionnaires/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = ho.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class fp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  listCurrentUserFilterPresets(e, t) {
    let o = this.baseUrl + "/filter_presets/of_current_user/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processListCurrentUserFilterPresets(i));
  }
  processListCurrentUserFilterPresets(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = fo.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  updateCurrentUserFilterPreset(e, t, o) {
    let r = this.baseUrl + "/filter_presets/of_current_user/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdateCurrentUserFilterPreset(u));
  }
  processUpdateCurrentUserFilterPreset(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = ys.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  deleteCurrentUserFilterPreset(e, t) {
    let o = this.baseUrl + "/filter_presets/of_current_user/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDeleteCurrentUserFilterPreset(s));
  }
  processDeleteCurrentUserFilterPreset(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/filter_presets";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = ys.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class pp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  listByProject(e, t, o) {
    let r = this.baseUrl + "/imports/list_by_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processListByProject(u));
  }
  processListByProject(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = po.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  downloadFile(e, t) {
    let o = this.baseUrl + "/imports/{id}/file";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      responseType: "blob",
      method: "GET",
      url: o,
      headers: {
        Accept: "application/octet-stream"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDownloadFile(s));
  }
  processDownloadFile(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200 || t === 206) {
      const r = e.headers ? e.headers["content-disposition"] : void 0;
      let s = r ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(r) : void 0, i = s && s.length > 1 ? s[3] || s[2] : void 0;
      return i ? i = decodeURIComponent(i) : (s = r ? /filename="?([^"]*?)"?(;|$)/g.exec(r) : void 0, i = s && s.length > 1 ? s[1] : void 0), Promise.resolve({ fileName: i, status: t, data: new Blob([e.data], { type: e.headers["content-type"] }), headers: o });
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  downloadFailedRows(e, t) {
    let o = this.baseUrl + "/imports/{id}/failed_rows";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      responseType: "blob",
      method: "GET",
      url: o,
      headers: {
        Accept: "application/octet-stream"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDownloadFailedRows(s));
  }
  processDownloadFailedRows(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200 || t === 206) {
      const r = e.headers ? e.headers["content-disposition"] : void 0;
      let s = r ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(r) : void 0, i = s && s.length > 1 ? s[3] || s[2] : void 0;
      return i ? i = decodeURIComponent(i) : (s = r ? /filename="?([^"]*?)"?(;|$)/g.exec(r) : void 0, i = s && s.length > 1 ? s[1] : void 0), Promise.resolve({ fileName: i, status: t, data: new Blob([e.data], { type: e.headers["content-type"] }), headers: o });
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  deleteImportTasks(e, t) {
    let o = this.baseUrl + "/imports/{id}/delete_tasks";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "POST",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDeleteImportTasks(s));
  }
  processDeleteImportTasks(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 403) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class mp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  notifyUsersWithMissingEndOfDaySubmissionsToday(e) {
    let t = this.baseUrl + "/notifications/sales";
    t = t.replace(/[?&]$/, "");
    let o = {
      responseType: "blob",
      method: "POST",
      url: t,
      headers: {
        Accept: "application/octet-stream"
      },
      cancelToken: e
    };
    return this.instance.request(o).catch((r) => {
      if (O(r) && r.response)
        return r.response;
      throw r;
    }).then((r) => this.processNotifyUsersWithMissingEndOfDaySubmissionsToday(r));
  }
  processNotifyUsersWithMissingEndOfDaySubmissionsToday(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200 || t === 206) {
      const r = e.headers ? e.headers["content-disposition"] : void 0;
      let s = r ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(r) : void 0, i = s && s.length > 1 ? s[3] || s[2] : void 0;
      return i ? i = decodeURIComponent(i) : (s = r ? /filename="?([^"]*?)"?(;|$)/g.exec(r) : void 0, i = s && s.length > 1 ? s[1] : void 0), Promise.resolve({ fileName: i, status: t, data: new Blob([e.data], { type: e.headers["content-type"] }), headers: o });
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  notifyLeadsAboutMissingEndOfDaySubmissionsToday(e) {
    let t = this.baseUrl + "/notifications/leads";
    t = t.replace(/[?&]$/, "");
    let o = {
      responseType: "blob",
      method: "POST",
      url: t,
      headers: {
        Accept: "application/octet-stream"
      },
      cancelToken: e
    };
    return this.instance.request(o).catch((r) => {
      if (O(r) && r.response)
        return r.response;
      throw r;
    }).then((r) => this.processNotifyLeadsAboutMissingEndOfDaySubmissionsToday(r));
  }
  processNotifyLeadsAboutMissingEndOfDaySubmissionsToday(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200 || t === 206) {
      const r = e.headers ? e.headers["content-disposition"] : void 0;
      let s = r ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(r) : void 0, i = s && s.length > 1 ? s[3] || s[2] : void 0;
      return i ? i = decodeURIComponent(i) : (s = r ? /filename="?([^"]*?)"?(;|$)/g.exec(r) : void 0, i = s && s.length > 1 ? s[1] : void 0), Promise.resolve({ fileName: i, status: t, data: new Blob([e.data], { type: e.headers["content-type"] }), headers: o });
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class vp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  create(e, t) {
    let o = this.baseUrl + "/organisations";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = _r.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/organisations/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = _r.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/organisations/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/organisations/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = _r.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/organisations/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = vo.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class gu {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  getNearbyPlaces(e, t, o, r) {
    let s = this.baseUrl + "/places/nearby?";
    if (e === null)
      throw new globalThis.Error("The parameter 'latitude' cannot be null.");
    if (e !== void 0 && (s += "latitude=" + encodeURIComponent("" + e) + "&"), t === null)
      throw new globalThis.Error("The parameter 'longitude' cannot be null.");
    if (t !== void 0 && (s += "longitude=" + encodeURIComponent("" + t) + "&"), o === null)
      throw new globalThis.Error("The parameter 'radius' cannot be null.");
    o !== void 0 && (s += "radius=" + encodeURIComponent("" + o) + "&"), s = s.replace(/[?&]$/, "");
    let i = {
      method: "GET",
      url: s,
      headers: {
        Accept: "application/json"
      },
      cancelToken: r
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processGetNearbyPlaces(u));
  }
  processGetNearbyPlaces(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(Er.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getAddresses(e, t, o) {
    let r = this.baseUrl + "/places/addresses?";
    if (e === null)
      throw new globalThis.Error("The parameter 'latitude' cannot be null.");
    if (e !== void 0 && (r += "latitude=" + encodeURIComponent("" + e) + "&"), t === null)
      throw new globalThis.Error("The parameter 'longitude' cannot be null.");
    t !== void 0 && (r += "longitude=" + encodeURIComponent("" + t) + "&"), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGetAddresses(i));
  }
  processGetAddresses(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(Er.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  search(e, t, o, r, s) {
    let i = this.baseUrl + "/places/search?";
    if (e === null)
      throw new globalThis.Error("The parameter 'searchText' cannot be null.");
    if (e !== void 0 && (i += "searchText=" + encodeURIComponent("" + e) + "&"), t === null)
      throw new globalThis.Error("The parameter 'type' cannot be null.");
    if (t !== void 0 && (i += "type=" + encodeURIComponent("" + t) + "&"), o === null)
      throw new globalThis.Error("The parameter 'latitude' cannot be null.");
    if (o !== void 0 && (i += "latitude=" + encodeURIComponent("" + o) + "&"), r === null)
      throw new globalThis.Error("The parameter 'longitude' cannot be null.");
    r !== void 0 && (i += "longitude=" + encodeURIComponent("" + r) + "&"), i = i.replace(/[?&]$/, "");
    let u = {
      method: "GET",
      url: i,
      headers: {
        Accept: "application/json"
      },
      cancelToken: s
    };
    return this.instance.request(u).catch((d) => {
      if (O(d) && d.response)
        return d.response;
      throw d;
    }).then((d) => this.processSearch(d));
  }
  processSearch(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(Er.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  autocomplete(e, t, o, r, s) {
    let i = this.baseUrl + "/places/autocomplete?";
    if (e === null)
      throw new globalThis.Error("The parameter 'searchText' cannot be null.");
    if (e !== void 0 && (i += "searchText=" + encodeURIComponent("" + e) + "&"), t === null)
      throw new globalThis.Error("The parameter 'type' cannot be null.");
    if (t !== void 0 && (i += "type=" + encodeURIComponent("" + t) + "&"), o === null)
      throw new globalThis.Error("The parameter 'latitude' cannot be null.");
    if (o !== void 0 && (i += "latitude=" + encodeURIComponent("" + o) + "&"), r === null)
      throw new globalThis.Error("The parameter 'longitude' cannot be null.");
    r !== void 0 && (i += "longitude=" + encodeURIComponent("" + r) + "&"), i = i.replace(/[?&]$/, "");
    let u = {
      method: "GET",
      url: i,
      headers: {
        Accept: "application/json"
      },
      cancelToken: s
    };
    return this.instance.request(u).catch((d) => {
      if (O(d) && d.response)
        return d.response;
      throw d;
    }).then((d) => this.processAutocomplete(d));
  }
  processAutocomplete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(go.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getCities(e, t, o) {
    let r = this.baseUrl + "/places/cities?";
    if (e === null)
      throw new globalThis.Error("The parameter 'postalCode' cannot be null.");
    if (e !== void 0 && (r += "postalCode=" + encodeURIComponent("" + e) + "&"), t === null)
      throw new globalThis.Error("The parameter 'country' cannot be null.");
    t !== void 0 && (r += "country=" + encodeURIComponent("" + t) + "&"), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGetCities(i));
  }
  processGetCities(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(u);
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getColdOutreachSuggestions(e, t, o, r) {
    let s = this.baseUrl + "/places/suggestions_for_project?";
    if (e === null)
      throw new globalThis.Error("The parameter 'projectId' cannot be null.");
    if (e !== void 0 && (s += "projectId=" + encodeURIComponent("" + e) + "&"), t === null)
      throw new globalThis.Error("The parameter 'latitude' cannot be null.");
    if (t !== void 0 && (s += "latitude=" + encodeURIComponent("" + t) + "&"), o === null)
      throw new globalThis.Error("The parameter 'longitude' cannot be null.");
    o !== void 0 && (s += "longitude=" + encodeURIComponent("" + o) + "&"), s = s.replace(/[?&]$/, "");
    let i = {
      method: "GET",
      url: s,
      headers: {
        Accept: "application/json"
      },
      cancelToken: r
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processGetColdOutreachSuggestions(u));
  }
  processGetColdOutreachSuggestions(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(Er.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  validateAddress(e, t) {
    let o = this.baseUrl + "/places/validate";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processValidateAddress(i));
  }
  processValidateAddress(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = yo.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class gp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  listByContactId(e, t, o) {
    let r = this.baseUrl + "/potentials/list_by_contact/{contactId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'contactId' must be defined.");
    r = r.replace("{contactId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processListByContactId(u));
  }
  processListByContactId(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = vs.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  listSatisfiableByProject(e, t, o) {
    let r = this.baseUrl + "/potentials/list_satisfiable_by_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processListSatisfiableByProject(u));
  }
  processListSatisfiableByProject(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = vs.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/potentials/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Li.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/potentials/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = vs.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class yp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  create(e, t) {
    let o = this.baseUrl + "/product_groups";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = $t.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/product_groups/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = $t.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/product_groups/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/product_groups/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = $t.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/product_groups/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = _o.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class yu {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  listByProjectId(e, t, o) {
    let r = this.baseUrl + "/products/list_by_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processListByProjectId(u));
  }
  processListByProjectId(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = li.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/products";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = gr.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/products/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = gr.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/products/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/products/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = gr.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/products/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = li.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class _p {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  getProjectMembers(e, t, o) {
    let r = this.baseUrl + "/project_members/of_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processGetProjectMembers(u));
  }
  processGetProjectMembers(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = ui.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/project_members";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = br.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/project_members/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = br.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/project_members/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/project_members/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = br.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  setMonthlyTargets(e, t, o) {
    let r = this.baseUrl + "/project_members/{id}/monthly_targets";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processSetMonthlyTargets(u));
  }
  processSetMonthlyTargets(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/project_members/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = ui.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class bp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  listByProjectId(e, t, o) {
    let r = this.baseUrl + "/project_product_groups/list_by_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processListByProjectId(u));
  }
  processListByProjectId(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = ci.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/project_product_groups";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Jr.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/project_product_groups/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Jr.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/project_product_groups/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/project_product_groups/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Jr.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/project_product_groups/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = ci.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class wp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  createQuestionnairesForContactType(e, t) {
    let o = this.baseUrl + "/project_questionnaires";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreateQuestionnairesForContactType(i));
  }
  processCreateQuestionnairesForContactType(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(hi.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getProjectQuestionnaires(e, t) {
    let o = this.baseUrl + "/project_questionnaires/of_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    o = o.replace("{projectId}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "POST",
      url: o,
      headers: {
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processGetProjectQuestionnaires(s));
  }
  processGetProjectQuestionnaires(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(hi.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  deleteQuestionnairesForContactType(e, t, o) {
    let r = this.baseUrl + "/project_questionnaires/of_project/{projectId}/contact_type/{contactType}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    if (r = r.replace("{projectId}", encodeURIComponent("" + e)), t == null)
      throw new globalThis.Error("The parameter 'contactType' must be defined.");
    r = r.replace("{contactType}", encodeURIComponent("" + t)), r = r.replace(/[?&]$/, "");
    let s = {
      method: "DELETE",
      url: r,
      headers: {},
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processDeleteQuestionnairesForContactType(i));
  }
  processDeleteQuestionnairesForContactType(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getProjectQuestionnaireDetails(e, t, o) {
    let r = this.baseUrl + "/project_questionnaires/{id}/details?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGetProjectQuestionnaireDetails(i));
  }
  processGetProjectQuestionnaireDetails(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = bo.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class Pp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  getRegionProjects(e, t, o) {
    let r = this.baseUrl + "/projects/of_region/{regionId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'regionId' must be defined.");
    r = r.replace("{regionId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processGetRegionProjects(u));
  }
  processGetRegionProjects(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = di.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/projects";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = st.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/projects/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = st.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/projects/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/projects/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = st.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getCurrentUserProjects(e) {
    let t = this.baseUrl + "/projects/of_current_user";
    t = t.replace(/[?&]$/, "");
    let o = {
      method: "GET",
      url: t,
      headers: {
        Accept: "application/json"
      },
      cancelToken: e
    };
    return this.instance.request(o).catch((r) => {
      if (O(r) && r.response)
        return r.response;
      throw r;
    }).then((r) => this.processGetCurrentUserProjects(r));
  }
  processGetCurrentUserProjects(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(Po.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getProjectsForUser(e, t) {
    let o = this.baseUrl + "/projects/for_user/{userId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    o = o.replace("{userId}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      url: o,
      headers: {
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processGetProjectsForUser(s));
  }
  processGetProjectsForUser(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(st.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  setMonthlyTargets(e, t, o) {
    let r = this.baseUrl + "/projects/{id}/monthly_targets";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processSetMonthlyTargets(u));
  }
  processSetMonthlyTargets(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/projects/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = di.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class _u {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  listByProjectId(e, t) {
    let o = this.baseUrl + "/project_status/list_by_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    o = o.replace("{projectId}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "POST",
      url: o,
      headers: {
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processListByProjectId(s));
  }
  processListByProjectId(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(Qt.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/project_status";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Qt.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/project_status/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Qt.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/project_status/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  adjustOrder(e, t, o) {
    let r = this.baseUrl + "/project_status/adjust_order/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processAdjustOrder(u));
  }
  processAdjustOrder(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(Qt.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class xp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  createPushSubscription(e, t) {
    let o = this.baseUrl + "/push_subscriptions";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreatePushSubscription(i));
  }
  processCreatePushSubscription(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  notify(e, t, o) {
    let r = this.baseUrl + "/push_subscriptions/of_user/{userId}/notify";
    if (e == null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    r = r.replace("{userId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processNotify(u));
  }
  processNotify(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  hasPushSubscriptions(e, t) {
    let o = this.baseUrl + "/push_subscriptions/of_user/{userId}/exist";
    if (e == null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    o = o.replace("{userId}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      url: o,
      headers: {
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processHasPushSubscriptions(s));
  }
  processHasPushSubscriptions(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = i !== void 0 ? i : null, Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  currentUserHasPushSubscriptions(e) {
    let t = this.baseUrl + "/push_subscriptions/of_current_user/exist";
    t = t.replace(/[?&]$/, "");
    let o = {
      method: "GET",
      url: t,
      headers: {
        Accept: "application/json"
      },
      cancelToken: e
    };
    return this.instance.request(o).catch((r) => {
      if (O(r) && r.response)
        return r.response;
      throw r;
    }).then((r) => this.processCurrentUserHasPushSubscriptions(r));
  }
  processCurrentUserHasPushSubscriptions(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = i !== void 0 ? i : null, Promise.resolve(s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class Sp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  getQuestionnaireDetails(e, t, o) {
    let r = this.baseUrl + "/questionnaires/{id}/details?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGetQuestionnaireDetails(i));
  }
  processGetQuestionnaireDetails(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = So.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class Tp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  update(e, t, o) {
    let r = this.baseUrl + "/questions/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = er.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/questions/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = er.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/questions/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  canRemoveQuestionOption(e, t, o) {
    let r = this.baseUrl + "/questions/{questionId}/options/{optionId}/can-remove";
    if (e == null)
      throw new globalThis.Error("The parameter 'questionId' must be defined.");
    if (r = r.replace("{questionId}", encodeURIComponent("" + e)), t == null)
      throw new globalThis.Error("The parameter 'optionId' must be defined.");
    r = r.replace("{optionId}", encodeURIComponent("" + t)), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCanRemoveQuestionOption(i));
  }
  processCanRemoveQuestionOption(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = i !== void 0 ? i : null, Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  sort(e, t, o) {
    let r = this.baseUrl + "/questions/sort?";
    if (t === null)
      throw new globalThis.Error("The parameter 'questionnaireId' cannot be null.");
    t !== void 0 && (r += "questionnaireId=" + encodeURIComponent("" + t) + "&"), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(e),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processSort(u));
  }
  processSort(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/questions";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = er.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/questions/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Ao.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class Lp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  getOrganisationRegions(e, t, o) {
    let r = this.baseUrl + "/regions/of_organisation/{organisationId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'organisationId' must be defined.");
    r = r.replace("{organisationId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processGetOrganisationRegions(u));
  }
  processGetOrganisationRegions(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = fi.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/regions";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = yr.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/regions/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = yr.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/regions/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/regions/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = yr.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/regions/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = fi.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class Cp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  search(e, t) {
    let o = this.baseUrl + "/search";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processSearch(i));
  }
  processSearch(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(u);
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class bu {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  update(e, t, o) {
    let r = this.baseUrl + "/status_group/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Br.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/status_group/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Br.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/status_group/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Oo.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class Ap {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  getCurrentUserEndOfDaySubmission(e, t, o) {
    let r = this.baseUrl + "/submissions/of_current_user?";
    if (e === null)
      throw new globalThis.Error("The parameter 'date' cannot be null.");
    if (e !== void 0 && (r += "date=" + encodeURIComponent(e ? "" + e.toISOString() : "") + "&"), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGetCurrentUserEndOfDaySubmission(i));
  }
  processGetCurrentUserEndOfDaySubmission(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Et.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  createCurrentUserEndOfDaySubmission(e, t) {
    let o = this.baseUrl + "/submissions/of_current_user?";
    if (e === null)
      throw new globalThis.Error("The parameter 'date' cannot be null.");
    e !== void 0 && (o += "date=" + encodeURIComponent(e ? "" + e.toISOString() : "") + "&"), o = o.replace(/[?&]$/, "");
    let r = {
      method: "POST",
      url: o,
      headers: {
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processCreateCurrentUserEndOfDaySubmission(s));
  }
  processCreateCurrentUserEndOfDaySubmission(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Et.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  finalizeCurrentUserEndOfDaySubmission(e, t, o) {
    let r = this.baseUrl + "/submissions/of_current_user/{id}/finalize";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processFinalizeCurrentUserEndOfDaySubmission(u));
  }
  processFinalizeCurrentUserEndOfDaySubmission(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Et.fromJS(i), Promise.resolve(s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/submissions";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Et.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/submissions/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Dr.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  listLeads(e, t) {
    let o = this.baseUrl + "/submissions/leads";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processListLeads(i));
  }
  processListLeads(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Dr.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getQuestionHeadersOfSubmissions(e, t) {
    let o = this.baseUrl + "/submissions/leads/question_titles";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGetQuestionHeadersOfSubmissions(i));
  }
  processGetQuestionHeadersOfSubmissions(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(ko.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  exportLeads(e, t) {
    let o = this.baseUrl + "/submissions/leads/export";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      responseType: "blob",
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processExportLeads(i));
  }
  processExportLeads(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200 || t === 206) {
      const r = e.headers ? e.headers["content-disposition"] : void 0;
      let s = r ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(r) : void 0, i = s && s.length > 1 ? s[3] || s[2] : void 0;
      return i ? i = decodeURIComponent(i) : (s = r ? /filename="?([^"]*?)"?(;|$)/g.exec(r) : void 0, i = s && s.length > 1 ? s[1] : void 0), Promise.resolve({ fileName: i, status: t, data: new Blob([e.data], { type: e.headers["content-type"] }), headers: o });
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  listForDate(e, t, o) {
    let r = this.baseUrl + "/submissions/submitted_at?";
    if (e === null)
      throw new globalThis.Error("The parameter 'submittedAt' cannot be null.");
    e !== void 0 && (r += "submittedAt=" + encodeURIComponent(e ? "" + e.toISOString() : "") + "&"), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processListForDate(u));
  }
  processListForDate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Dr.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  listForContact(e, t, o, r, s) {
    let i = this.baseUrl + "/submissions/for_contact?";
    if (e === null)
      throw new globalThis.Error("The parameter 'projectId' cannot be null.");
    if (e !== void 0 && (i += "projectId=" + encodeURIComponent("" + e) + "&"), t === null)
      throw new globalThis.Error("The parameter 'contactId' cannot be null.");
    t !== void 0 && (i += "contactId=" + encodeURIComponent("" + t) + "&"), o != null && (i += "finalized=" + encodeURIComponent("" + o) + "&"), i = i.replace(/[?&]$/, "");
    let d = {
      data: JSON.stringify(r),
      method: "POST",
      url: i,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: s
    };
    return this.instance.request(d).catch((m) => {
      if (O(m) && m.response)
        return m.response;
      throw m;
    }).then((m) => this.processListForContact(m));
  }
  processListForContact(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Dr.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/submissions/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 401) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 403) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/submissions/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Et.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/submissions/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Et.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class Op {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  create(e, t) {
    let o = this.baseUrl + "/tasks";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = yt.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/tasks/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = yt.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/tasks/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = yt.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/tasks/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  createFollowUp(e, t) {
    let o = this.baseUrl + "/tasks/create_follow_up";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreateFollowUp(i));
  }
  processCreateFollowUp(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = pi.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  createFollowUpWithVisit(e, t, o) {
    let r = this.baseUrl + "/tasks/create_follow_up_with_visit/{visitId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'visitId' must be defined.");
    r = r.replace("{visitId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processCreateFollowUpWithVisit(u));
  }
  processCreateFollowUpWithVisit(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = pi.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  createForMyself(e, t) {
    let o = this.baseUrl + "/tasks/create_for_myself";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreateForMyself(i));
  }
  processCreateForMyself(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = yt.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  updateMultiple(e, t, o) {
    let r = this.baseUrl + "/tasks/update_multiple_for_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      responseType: "blob",
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdateMultiple(u));
  }
  processUpdateMultiple(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200 || t === 206) {
      const r = e.headers ? e.headers["content-disposition"] : void 0;
      let s = r ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(r) : void 0, i = s && s.length > 1 ? s[3] || s[2] : void 0;
      return i ? i = decodeURIComponent(i) : (s = r ? /filename="?([^"]*?)"?(;|$)/g.exec(r) : void 0, i = s && s.length > 1 ? s[1] : void 0), Promise.resolve({ fileName: i, status: t, data: new Blob([e.data], { type: e.headers["content-type"] }), headers: o });
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  deleteMultiple(e, t, o) {
    let r = this.baseUrl + "/tasks/delete_multiple_for_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      responseType: "blob",
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processDeleteMultiple(u));
  }
  processDeleteMultiple(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200 || t === 206) {
      const r = e.headers ? e.headers["content-disposition"] : void 0;
      let s = r ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(r) : void 0, i = s && s.length > 1 ? s[3] || s[2] : void 0;
      return i ? i = decodeURIComponent(i) : (s = r ? /filename="?([^"]*?)"?(;|$)/g.exec(r) : void 0, i = s && s.length > 1 ? s[1] : void 0), Promise.resolve({ fileName: i, status: t, data: new Blob([e.data], { type: e.headers["content-type"] }), headers: o });
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  listByProjectId(e, t, o) {
    let r = this.baseUrl + "/tasks/list_by_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processListByProjectId(u));
  }
  processListByProjectId(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Do.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getCurrentUserTasks(e, t) {
    let o = this.baseUrl + "/tasks/of_current_user?";
    if (e === null)
      throw new globalThis.Error("The parameter 'date' cannot be null.");
    e !== void 0 && (o += "date=" + encodeURIComponent(e ? "" + e.toISOString() : "") + "&"), o = o.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      url: o,
      headers: {
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processGetCurrentUserTasks(s));
  }
  processGetCurrentUserTasks(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(Ci.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  import(e, t, o) {
    let r = this.baseUrl + "/tasks/import/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    const s = new FormData();
    t != null && s.append("file", t.data, t.fileName ? t.fileName : "file");
    let i = {
      data: s,
      method: "POST",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processImport(u));
  }
  processImport(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Mo.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 401) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 500) {
      const r = e.data;
      return b("A server side error occurred.", t, r, o);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getByVisitId(e, t) {
    let o = this.baseUrl + "/tasks/get_by_visit_id/{visitId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'visitId' must be defined.");
    o = o.replace("{visitId}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      url: o,
      headers: {
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processGetByVisitId(s));
  }
  processGetByVisitId(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = yt.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  updateTaskDueAtDate(e, t, o) {
    let r = this.baseUrl + "/tasks/{id}/date?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'date' cannot be null.");
    t !== void 0 && (r += "date=" + encodeURIComponent(t ? "" + t.toISOString() : "") + "&"), r = r.replace(/[?&]$/, "");
    let s = {
      method: "PUT",
      url: r,
      headers: {},
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processUpdateTaskDueAtDate(i));
  }
  processUpdateTaskDueAtDate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getOpenForContact(e, t, o) {
    let r = this.baseUrl + "/tasks/open_for_contact/{contactId}/in_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'contactId' must be defined.");
    if (r = r.replace("{contactId}", encodeURIComponent("" + e)), t == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + t)), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGetOpenForContact(i));
  }
  processGetOpenForContact(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(yt.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t === 403) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getNearbyTasks(e, t, o, r, s) {
    let i = this.baseUrl + "/tasks/nearby_tasks/{projectId}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    if (i = i.replace("{projectId}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'latitude' cannot be null.");
    if (t !== void 0 && (i += "latitude=" + encodeURIComponent("" + t) + "&"), o === null)
      throw new globalThis.Error("The parameter 'longitude' cannot be null.");
    if (o !== void 0 && (i += "longitude=" + encodeURIComponent("" + o) + "&"), r === null)
      throw new globalThis.Error("The parameter 'radiusInMeters' cannot be null.");
    r !== void 0 && (i += "radiusInMeters=" + encodeURIComponent("" + r) + "&"), i = i.replace(/[?&]$/, "");
    let u = {
      method: "GET",
      url: i,
      headers: {
        Accept: "application/json"
      },
      cancelToken: s
    };
    return this.instance.request(u).catch((d) => {
      if (O(d) && d.response)
        return d.response;
      throw d;
    }).then((d) => this.processGetNearbyTasks(d));
  }
  processGetNearbyTasks(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(yt.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class kp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  getTeamMembers(e, t, o) {
    let r = this.baseUrl + "/team_members/of_team/{teamId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'teamId' must be defined.");
    r = r.replace("{teamId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processGetTeamMembers(u));
  }
  processGetTeamMembers(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = mi.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/team_members";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = wr.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/team_members/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = wr.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/team_members/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/team_members/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = wr.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  setMonthlyTargets(e, t, o) {
    let r = this.baseUrl + "/team_members/{id}/monthly_targets";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processSetMonthlyTargets(u));
  }
  processSetMonthlyTargets(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/team_members/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = mi.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class Ip {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  getProjectTeams(e, t, o) {
    let r = this.baseUrl + "/teams/of_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    r = r.replace("{projectId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "POST",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processGetProjectTeams(u));
  }
  processGetProjectTeams(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = vi.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/teams";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Xt.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/teams/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Xt.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/teams/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/teams/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Xt.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/teams/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = vi.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class wu {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  getOwn(e) {
    let t = this.baseUrl + "/users/me";
    t = t.replace(/[?&]$/, "");
    let o = {
      method: "GET",
      url: t,
      headers: {
        Accept: "application/json"
      },
      cancelToken: e
    };
    return this.instance.request(o).catch((r) => {
      if (O(r) && r.response)
        return r.response;
      throw r;
    }).then((r) => this.processGetOwn(r));
  }
  processGetOwn(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Ze.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  create(e, t) {
    let o = this.baseUrl + "/users";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Ze.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/users/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = gi.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  listWithMissingEndOfDaySubmissionsCount(e, t) {
    let o = this.baseUrl + "/users/with-missing-end-of-day-submissions-count";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processListWithMissingEndOfDaySubmissionsCount(i));
  }
  processListWithMissingEndOfDaySubmissionsCount(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = gi.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  listDeactivated(e, t) {
    let o = this.baseUrl + "/users/deactivated";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processListDeactivated(i));
  }
  processListDeactivated(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Jo.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  listByProjectId(e, t) {
    let o = this.baseUrl + "/users/list_by_project/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    o = o.replace("{projectId}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "POST",
      url: o,
      headers: {
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processListByProjectId(s));
  }
  processListByProjectId(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(Ze.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/users/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Ze.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/users/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Ze.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  delete(e, t) {
    let o = this.baseUrl + "/users/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDelete(s));
  }
  processDelete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  reactivate(e, t) {
    let o = this.baseUrl + "/users/{userId}/reactivate";
    if (e == null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    o = o.replace("{userId}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "POST",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processReactivate(s));
  }
  processReactivate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getUsersWithoutEndOfDayQuestionnaireAssignment(e) {
    let t = this.baseUrl + "/users/without-end-of-day-questionnaire-assignment";
    t = t.replace(/[?&]$/, "");
    let o = {
      method: "GET",
      url: t,
      headers: {
        Accept: "application/json"
      },
      cancelToken: e
    };
    return this.instance.request(o).catch((r) => {
      if (O(r) && r.response)
        return r.response;
      throw r;
    }).then((r) => this.processGetUsersWithoutEndOfDayQuestionnaireAssignment(r));
  }
  processGetUsersWithoutEndOfDayQuestionnaireAssignment(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(Ze.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getMissingEndOfDaySubmissions(e, t) {
    let o = this.baseUrl + "/users/{userId}/missing-end-of-day-submissions";
    if (e == null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    o = o.replace("{userId}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      url: o,
      headers: {
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processGetMissingEndOfDaySubmissions(s));
  }
  processGetMissingEndOfDaySubmissions(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(new Date(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getResponsibilities(e, t) {
    let o = this.baseUrl + "/users/{userId}/responsibilities";
    if (e == null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    o = o.replace("{userId}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      url: o,
      headers: {
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processGetResponsibilities(s));
  }
  processGetResponsibilities(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = Bo.fromJS(i), Promise.resolve(s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  listSalesTargets(e, t, o, r) {
    let s = this.baseUrl + "/users/{userId}/sales_targets/{year}-{month}";
    if (e == null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    if (s = s.replace("{userId}", encodeURIComponent("" + e)), t == null)
      throw new globalThis.Error("The parameter 'year' must be defined.");
    if (s = s.replace("{year}", encodeURIComponent("" + t)), o == null)
      throw new globalThis.Error("The parameter 'month' must be defined.");
    s = s.replace("{month}", encodeURIComponent("" + o)), s = s.replace(/[?&]$/, "");
    let i = {
      method: "GET",
      url: s,
      headers: {
        Accept: "application/json"
      },
      cancelToken: r
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processListSalesTargets(u));
  }
  processListSalesTargets(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(Ro.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class jp {
  constructor(e, t) {
    this.jsonParseReviver = void 0, this.instance = t || ke.create(), this.baseUrl = e ?? "";
  }
  create(e, t) {
    let o = this.baseUrl + "/visits";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processCreate(i));
  }
  processCreate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = qt.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 403) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getVisitsOfDay(e, t) {
    let o = this.baseUrl + "/visits/of_day/{dateTime}";
    if (e == null)
      throw new globalThis.Error("The parameter 'dateTime' must be defined.");
    o = o.replace("{dateTime}", encodeURIComponent(e ? "" + e.toISOString() : "null")), o = o.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      url: o,
      headers: {
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processGetVisitsOfDay(s));
  }
  processGetVisitsOfDay(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(qt.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getAvailableVisitDates(e, t) {
    let o = this.baseUrl + "/visits/available_dates/{projectId}";
    if (e == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    o = o.replace("{projectId}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      url: o,
      headers: {
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processGetAvailableVisitDates(s));
  }
  processGetAvailableVisitDates(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(new Date(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getPreviousVisits(e, t, o, r) {
    let s = this.baseUrl + "/visits/previous_for_contact/{id}/in_project/{projectId}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (s = s.replace("{id}", encodeURIComponent("" + e)), t == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    s = s.replace("{projectId}", encodeURIComponent("" + t)), o != null && (s += "excludedVisitId=" + encodeURIComponent("" + o) + "&"), s = s.replace(/[?&]$/, "");
    let i = {
      method: "GET",
      url: s,
      headers: {
        Accept: "application/json"
      },
      cancelToken: r
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processGetPreviousVisits(u));
  }
  processGetPreviousVisits(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      if (Array.isArray(i)) {
        s = [];
        for (let u of i)
          s.push(qt.fromJS(u));
      } else
        s = null;
      return Promise.resolve(s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  getPreviousVisitsCount(e, t, o, r) {
    let s = this.baseUrl + "/visits/previous_count_for_contact/{id}/in_project/{projectId}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (s = s.replace("{id}", encodeURIComponent("" + e)), t == null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    s = s.replace("{projectId}", encodeURIComponent("" + t)), o != null && (s += "excludedVisitId=" + encodeURIComponent("" + o) + "&"), s = s.replace(/[?&]$/, "");
    let i = {
      method: "GET",
      url: s,
      headers: {
        Accept: "application/json"
      },
      cancelToken: r
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processGetPreviousVisitsCount(u));
  }
  processGetPreviousVisitsCount(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = i !== void 0 ? i : null, Promise.resolve(s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  complete(e, t, o) {
    let r = this.baseUrl + "/visits/{id}/complete";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processComplete(u));
  }
  processComplete(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  deleteVisitOfCurrentUser(e, t) {
    let o = this.baseUrl + "/visits/of_current_user/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    o = o.replace("{id}", encodeURIComponent("" + e)), o = o.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      url: o,
      headers: {},
      cancelToken: t
    };
    return this.instance.request(r).catch((s) => {
      if (O(s) && s.response)
        return s.response;
      throw s;
    }).then((s) => this.processDeleteVisitOfCurrentUser(s));
  }
  processDeleteVisitOfCurrentUser(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  updateVisitDate(e, t, o) {
    let r = this.baseUrl + "/visits/{id}/date?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'date' cannot be null.");
    t !== void 0 && (r += "date=" + encodeURIComponent(t ? "" + t.toISOString() : "") + "&"), r = r.replace(/[?&]$/, "");
    let s = {
      method: "PUT",
      url: r,
      headers: {},
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processUpdateVisitDate(i));
  }
  processUpdateVisitDate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200)
      return e.data, Promise.resolve(null);
    if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t === 404) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  get(e, t, o) {
    let r = this.baseUrl + "/visits/{id}?";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    if (r = r.replace("{id}", encodeURIComponent("" + e)), t === null)
      throw new globalThis.Error("The parameter 'expand' cannot be null.");
    t !== void 0 && t && t.forEach((i) => {
      r += "expand=" + encodeURIComponent("" + i) + "&";
    }), r = r.replace(/[?&]$/, "");
    let s = {
      method: "GET",
      url: r,
      headers: {
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processGet(i));
  }
  processGet(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = qt.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  update(e, t, o) {
    let r = this.baseUrl + "/visits/{id}";
    if (e == null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    r = r.replace("{id}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
    let i = {
      data: JSON.stringify(t),
      method: "PUT",
      url: r,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: o
    };
    return this.instance.request(i).catch((u) => {
      if (O(u) && u.response)
        return u.response;
      throw u;
    }).then((u) => this.processUpdate(u));
  }
  processUpdate(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = qt.fromJS(i), Promise.resolve(s);
    } else if (t === 400) {
      const r = e.data;
      let s = null, i = r;
      return s = N.fromJS(i), b("A server side error occurred.", t, r, o, s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
  list(e, t) {
    let o = this.baseUrl + "/visits/list";
    o = o.replace(/[?&]$/, "");
    let s = {
      data: JSON.stringify(e),
      method: "POST",
      url: o,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken: t
    };
    return this.instance.request(s).catch((i) => {
      if (O(i) && i.response)
        return i.response;
      throw i;
    }).then((i) => this.processList(i));
  }
  processList(e) {
    const t = e.status;
    let o = {};
    if (e.headers && typeof e.headers == "object")
      for (const r in e.headers)
        e.headers.hasOwnProperty(r) && (o[r] = e.headers[r]);
    if (t === 200) {
      const r = e.data;
      let s = null, i = r;
      return s = zo.fromJS(i), Promise.resolve(s);
    } else if (t !== 200 && t !== 204) {
      const r = e.data;
      return b("An unexpected server error occurred.", t, r, o);
    }
    return Promise.resolve(null);
  }
}
class ms {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(xi.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new ms();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class we {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.id = e.id, this.createdAt = e.createdAt ? new Date(e.createdAt.toString()) : void 0, this.updatedAt = e.updatedAt ? new Date(e.updatedAt.toString()) : void 0, this.deletedAt = e.deletedAt ? new Date(e.deletedAt.toString()) : void 0);
  }
  static fromJS(e) {
    throw new Error("The abstract class 'Record' cannot be instantiated.");
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.id = this.id, e.createdAt = this.createdAt ? this.createdAt.toISOString() : void 0, e.updatedAt = this.updatedAt ? this.updatedAt.toISOString() : void 0, e.deletedAt = this.deletedAt ? this.deletedAt.toISOString() : void 0, e;
  }
}
class xi extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.userId = e.userId, this.user = e.user ? Ze.fromJS(e.user) : void 0, this.from = e.from ? new Date(e.from.toString()) : void 0, this.to = e.to ? new Date(e.to.toString()) : void 0, this.type = e.type);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new xi();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.userId = this.userId, e.user = this.user ? this.user.toJSON() : void 0, e.from = this.from ? Dn(this.from) : void 0, e.to = this.to ? Dn(this.to) : void 0, e.type = this.type, super.toJSON(e), e;
  }
}
class Ze extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.name = e.name, this.email = e.email, this.role = e.role, this.missingEndOfDaySubmissionsCount = e.missingEndOfDaySubmissionsCount);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Ze();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.email = this.email, e.role = this.role, e.missingEndOfDaySubmissionsCount = this.missingEndOfDaySubmissionsCount, super.toJSON(e), e;
  }
}
var Pu = /* @__PURE__ */ ((a) => (a[a.Admin = 0] = "Admin", a[a.User = 1] = "User", a))(Pu || {}), Ep = /* @__PURE__ */ ((a) => (a[a.Vacation = 0] = "Vacation", a[a.SickLeave = 1] = "SickLeave", a[a.Training = 2] = "Training", a[a.Holiday = 3] = "Holiday", a))(Ep || {});
class Si {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (Array.isArray(e.expand)) {
        this.expand = [];
        for (let t of e.expand)
          this.expand.push(t);
      }
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.sortBy = e.sortBy, this.sortDescending = e.sortDescending, Array.isArray(e.searchIn)) {
        this.searchIn = [];
        for (let t of e.searchIn)
          this.searchIn.push(t);
      }
      this.searchText = e.searchText, this.filter = e.filter ? Ct.fromJS(e.filter) : void 0;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Si();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, Array.isArray(this.expand)) {
      e.expand = [];
      for (let t of this.expand)
        e.expand.push(t);
    }
    if (e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.sortBy = this.sortBy, e.sortDescending = this.sortDescending, Array.isArray(this.searchIn)) {
      e.searchIn = [];
      for (let t of this.searchIn)
        e.searchIn.push(t);
    }
    return e.searchText = this.searchText, e.filter = this.filter ? this.filter.toJSON() : void 0, e;
  }
}
class Ct {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.id = e.id, this.isGroup = e.isGroup, this.logicalOperator = e.logicalOperator, Array.isArray(e.filters)) {
        this.filters = [];
        for (let t of e.filters)
          this.filters.push(Ct.fromJS(t));
      }
      if (this.property = e.property, this.operator = e.operator, this.stringValue = e.stringValue, this.numberValue = e.numberValue, this.dateTimeValue = e.dateTimeValue ? new Date(e.dateTimeValue.toString()) : void 0, Array.isArray(e.enumValues)) {
        this.enumValues = [];
        for (let t of e.enumValues)
          this.enumValues.push(t);
      }
      this.booleanValue = e.booleanValue, this.tag = e.tag;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Ct();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.id = this.id, e.isGroup = this.isGroup, e.logicalOperator = this.logicalOperator, Array.isArray(this.filters)) {
      e.filters = [];
      for (let t of this.filters)
        e.filters.push(t ? t.toJSON() : void 0);
    }
    if (e.property = this.property, e.operator = this.operator, e.stringValue = this.stringValue, e.numberValue = this.numberValue, e.dateTimeValue = this.dateTimeValue ? this.dateTimeValue.toISOString() : void 0, Array.isArray(this.enumValues)) {
      e.enumValues = [];
      for (let t of this.enumValues)
        e.enumValues.push(t);
    }
    return e.booleanValue = this.booleanValue, e.tag = this.tag, e;
  }
}
var xu = /* @__PURE__ */ ((a) => (a[a.And = 0] = "And", a[a.Or = 1] = "Or", a))(xu || {}), vt = /* @__PURE__ */ ((a) => (a[a.Contains = 0] = "Contains", a[a.Equals = 1] = "Equals", a[a.LessThan = 2] = "LessThan", a[a.LessThanEquals = 3] = "LessThanEquals", a[a.GreaterThan = 4] = "GreaterThan", a[a.GreaterThanEquals = 5] = "GreaterThanEquals", a))(vt || {});
class Su {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e && (this.id = e.id, this.visible = e.visible, this.valueText = e.valueText, this.valueNumber = e.valueNumber, this.valueBoolean = e.valueBoolean, this.valueDate = e.valueDate ? new Date(e.valueDate.toString()) : void 0, Array.isArray(e.valueList))) {
      this.valueList = [];
      for (let t of e.valueList)
        this.valueList.push(t);
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Su();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.id = this.id, e.visible = this.visible, e.valueText = this.valueText, e.valueNumber = this.valueNumber, e.valueBoolean = this.valueBoolean, e.valueDate = this.valueDate ? this.valueDate.toISOString() : void 0, Array.isArray(this.valueList)) {
      e.valueList = [];
      for (let t of this.valueList)
        e.valueList.push(t);
    }
    return e;
  }
}
class vr extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    if (super.init(e), e) {
      if (this.title = e.title, this.description = e.description, this.placeholder = e.placeholder, this.isRequired = e.isRequired, this.order = e.order, Array.isArray(e.options)) {
        this.options = [];
        for (let t of e.options)
          this.options.push(to.fromJS(t));
      }
      if (this.dependency = e.dependency ? ro.fromJS(e.dependency) : void 0, this.type = e.type, this.visible = e.visible, this.referencedProduct = e.referencedProduct ? gr.fromJS(e.referencedProduct) : void 0, this.requiresSubsequentProductCounts = e.requiresSubsequentProductCounts, this.valueText = e.valueText, this.valueNumber = e.valueNumber, this.valueBoolean = e.valueBoolean, this.valueDate = e.valueDate ? new Date(e.valueDate.toString()) : void 0, Array.isArray(e.valueList)) {
        this.valueList = [];
        for (let t of e.valueList)
          this.valueList.push(t);
      }
      this.yesTriggerProjectStatusId = e.yesTriggerProjectStatusId, this.noTriggerProjectStatusId = e.noTriggerProjectStatusId, this.headerKey = e.headerKey;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new vr();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.title = this.title, e.description = this.description, e.placeholder = this.placeholder, e.isRequired = this.isRequired, e.order = this.order, Array.isArray(this.options)) {
      e.options = [];
      for (let t of this.options)
        e.options.push(t ? t.toJSON() : void 0);
    }
    if (e.dependency = this.dependency ? this.dependency.toJSON() : void 0, e.type = this.type, e.visible = this.visible, e.referencedProduct = this.referencedProduct ? this.referencedProduct.toJSON() : void 0, e.requiresSubsequentProductCounts = this.requiresSubsequentProductCounts, e.valueText = this.valueText, e.valueNumber = this.valueNumber, e.valueBoolean = this.valueBoolean, e.valueDate = this.valueDate ? this.valueDate.toISOString() : void 0, Array.isArray(this.valueList)) {
      e.valueList = [];
      for (let t of this.valueList)
        e.valueList.push(t);
    }
    return e.yesTriggerProjectStatusId = this.yesTriggerProjectStatusId, e.noTriggerProjectStatusId = this.noTriggerProjectStatusId, e.headerKey = this.headerKey, super.toJSON(e), e;
  }
}
class to {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.identifier = e.identifier, this.text = e.text, this.value = e.value, this.order = e.order, this.productGroupId = e.productGroupId, this.productId = e.productId, this.triggerProjectStatusId = e.triggerProjectStatusId);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new to();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.identifier = this.identifier, e.text = this.text, e.value = this.value, e.order = this.order, e.productGroupId = this.productGroupId, e.productId = this.productId, e.triggerProjectStatusId = this.triggerProjectStatusId, e;
  }
}
class ro {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e && (this.dependencyAnswerId = e.dependencyAnswerId, this.condition = e.condition, this.valueText = e.valueText, this.valueNumber = e.valueNumber, this.valueBoolean = e.valueBoolean, this.valueDate = e.valueDate ? new Date(e.valueDate.toString()) : void 0, Array.isArray(e.valueList))) {
      this.valueList = [];
      for (let t of e.valueList)
        this.valueList.push(t);
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new ro();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.dependencyAnswerId = this.dependencyAnswerId, e.condition = this.condition, e.valueText = this.valueText, e.valueNumber = this.valueNumber, e.valueBoolean = this.valueBoolean, e.valueDate = this.valueDate ? this.valueDate.toISOString() : void 0, Array.isArray(this.valueList)) {
      e.valueList = [];
      for (let t of this.valueList)
        e.valueList.push(t);
    }
    return e;
  }
}
var gt = /* @__PURE__ */ ((a) => (a[a.Equal = 0] = "Equal", a[a.GreaterThan = 1] = "GreaterThan", a[a.GreaterThanOrEqual = 2] = "GreaterThanOrEqual", a[a.LessThan = 3] = "LessThan", a[a.LessThanOrEqual = 4] = "LessThanOrEqual", a[a.After = 5] = "After", a[a.Before = 6] = "Before", a[a.Contains = 7] = "Contains", a))(gt || {}), _e = /* @__PURE__ */ ((a) => (a[a.Number = 0] = "Number", a[a.Text = 1] = "Text", a[a.Date = 2] = "Date", a[a.ThreeWayToggle = 3] = "ThreeWayToggle", a[a.Radio = 4] = "Radio", a[a.Checkbox = 5] = "Checkbox", a[a.YesNo = 6] = "YesNo", a[a.PotentialEvaluation = 7] = "PotentialEvaluation", a[a.ProductCount = 8] = "ProductCount", a))(_e || {});
class gr extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.name = e.name, this.description = e.description, this.projectId = e.projectId, this.project = e.project ? st.fromJS(e.project) : void 0, this.productGroupId = e.productGroupId, this.productGroup = e.productGroup ? $t.fromJS(e.productGroup) : void 0, this.quotaRelevant = e.quotaRelevant);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new gr();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.description = this.description, e.projectId = this.projectId, e.project = this.project ? this.project.toJSON() : void 0, e.productGroupId = this.productGroupId, e.productGroup = this.productGroup ? this.productGroup.toJSON() : void 0, e.quotaRelevant = this.quotaRelevant, super.toJSON(e), e;
  }
}
class st extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    if (super.init(e), e) {
      if (this.name = e.name, this.description = e.description, this.regionId = e.regionId, this.region = e.region ? yr.fromJS(e.region) : void 0, this.visitMaxDaysBack = e.visitMaxDaysBack, this.allowContactStatusChanges = e.allowContactStatusChanges, this.onlyAllowVisitsFromTasks = e.onlyAllowVisitsFromTasks, Array.isArray(e.members)) {
        this.members = [];
        for (let t of e.members)
          this.members.push(br.fromJS(t));
      }
      if (Array.isArray(e.teams)) {
        this.teams = [];
        for (let t of e.teams)
          this.teams.push(Xt.fromJS(t));
      }
      if (this.monthlyTargetJanuary = e.monthlyTargetJanuary, this.monthlyTargetFebruary = e.monthlyTargetFebruary, this.monthlyTargetMarch = e.monthlyTargetMarch, this.monthlyTargetApril = e.monthlyTargetApril, this.monthlyTargetMay = e.monthlyTargetMay, this.monthlyTargetJune = e.monthlyTargetJune, this.monthlyTargetJuly = e.monthlyTargetJuly, this.monthlyTargetAugust = e.monthlyTargetAugust, this.monthlyTargetSeptember = e.monthlyTargetSeptember, this.monthlyTargetOctober = e.monthlyTargetOctober, this.monthlyTargetNovember = e.monthlyTargetNovember, this.monthlyTargetDecember = e.monthlyTargetDecember, this.taskSearchRadius = e.taskSearchRadius, Array.isArray(e.taskSearchTypes)) {
        this.taskSearchTypes = [];
        for (let t of e.taskSearchTypes)
          this.taskSearchTypes.push(t);
      }
      if (Array.isArray(e.taskSearchTerms)) {
        this.taskSearchTerms = [];
        for (let t of e.taskSearchTerms)
          this.taskSearchTerms.push(t);
      }
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new st();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.name = this.name, e.description = this.description, e.regionId = this.regionId, e.region = this.region ? this.region.toJSON() : void 0, e.visitMaxDaysBack = this.visitMaxDaysBack, e.allowContactStatusChanges = this.allowContactStatusChanges, e.onlyAllowVisitsFromTasks = this.onlyAllowVisitsFromTasks, Array.isArray(this.members)) {
      e.members = [];
      for (let t of this.members)
        e.members.push(t ? t.toJSON() : void 0);
    }
    if (Array.isArray(this.teams)) {
      e.teams = [];
      for (let t of this.teams)
        e.teams.push(t ? t.toJSON() : void 0);
    }
    if (e.monthlyTargetJanuary = this.monthlyTargetJanuary, e.monthlyTargetFebruary = this.monthlyTargetFebruary, e.monthlyTargetMarch = this.monthlyTargetMarch, e.monthlyTargetApril = this.monthlyTargetApril, e.monthlyTargetMay = this.monthlyTargetMay, e.monthlyTargetJune = this.monthlyTargetJune, e.monthlyTargetJuly = this.monthlyTargetJuly, e.monthlyTargetAugust = this.monthlyTargetAugust, e.monthlyTargetSeptember = this.monthlyTargetSeptember, e.monthlyTargetOctober = this.monthlyTargetOctober, e.monthlyTargetNovember = this.monthlyTargetNovember, e.monthlyTargetDecember = this.monthlyTargetDecember, e.taskSearchRadius = this.taskSearchRadius, Array.isArray(this.taskSearchTypes)) {
      e.taskSearchTypes = [];
      for (let t of this.taskSearchTypes)
        e.taskSearchTypes.push(t);
    }
    if (Array.isArray(this.taskSearchTerms)) {
      e.taskSearchTerms = [];
      for (let t of this.taskSearchTerms)
        e.taskSearchTerms.push(t);
    }
    return super.toJSON(e), e;
  }
}
class yr extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.name = e.name, this.organisationId = e.organisationId, this.organisation = e.organisation ? _r.fromJS(e.organisation) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new yr();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.organisationId = this.organisationId, e.organisation = this.organisation ? this.organisation.toJSON() : void 0, super.toJSON(e), e;
  }
}
class _r extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.name = e.name, this.description = e.description);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new _r();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.description = this.description, super.toJSON(e), e;
  }
}
class br extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.userId = e.userId, this.user = e.user ? Ze.fromJS(e.user) : void 0, this.projectId = e.projectId, this.type = e.type, this.isLead = e.isLead, this.monthlyTargetJanuary = e.monthlyTargetJanuary, this.monthlyTargetFebruary = e.monthlyTargetFebruary, this.monthlyTargetMarch = e.monthlyTargetMarch, this.monthlyTargetApril = e.monthlyTargetApril, this.monthlyTargetMay = e.monthlyTargetMay, this.monthlyTargetJune = e.monthlyTargetJune, this.monthlyTargetJuly = e.monthlyTargetJuly, this.monthlyTargetAugust = e.monthlyTargetAugust, this.monthlyTargetSeptember = e.monthlyTargetSeptember, this.monthlyTargetOctober = e.monthlyTargetOctober, this.monthlyTargetNovember = e.monthlyTargetNovember, this.monthlyTargetDecember = e.monthlyTargetDecember);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new br();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.userId = this.userId, e.user = this.user ? this.user.toJSON() : void 0, e.projectId = this.projectId, e.type = this.type, e.isLead = this.isLead, e.monthlyTargetJanuary = this.monthlyTargetJanuary, e.monthlyTargetFebruary = this.monthlyTargetFebruary, e.monthlyTargetMarch = this.monthlyTargetMarch, e.monthlyTargetApril = this.monthlyTargetApril, e.monthlyTargetMay = this.monthlyTargetMay, e.monthlyTargetJune = this.monthlyTargetJune, e.monthlyTargetJuly = this.monthlyTargetJuly, e.monthlyTargetAugust = this.monthlyTargetAugust, e.monthlyTargetSeptember = this.monthlyTargetSeptember, e.monthlyTargetOctober = this.monthlyTargetOctober, e.monthlyTargetNovember = this.monthlyTargetNovember, e.monthlyTargetDecember = this.monthlyTargetDecember, super.toJSON(e), e;
  }
}
var Dp = /* @__PURE__ */ ((a) => (a[a.Business = 0] = "Business", a[a.BusinessAndPrivate = 1] = "BusinessAndPrivate", a[a.Private = 2] = "Private", a))(Dp || {});
class Xt extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    if (super.init(e), e && (this.name = e.name, this.description = e.description, this.projectId = e.projectId, Array.isArray(e.members))) {
      this.members = [];
      for (let t of e.members)
        this.members.push(wr.fromJS(t));
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Xt();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.name = this.name, e.description = this.description, e.projectId = this.projectId, Array.isArray(this.members)) {
      e.members = [];
      for (let t of this.members)
        e.members.push(t ? t.toJSON() : void 0);
    }
    return super.toJSON(e), e;
  }
}
class wr extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.type = e.type, this.userId = e.userId, this.user = e.user ? Ze.fromJS(e.user) : void 0, this.teamId = e.teamId, this.isLead = e.isLead, this.monthlyTargetJanuary = e.monthlyTargetJanuary, this.monthlyTargetFebruary = e.monthlyTargetFebruary, this.monthlyTargetMarch = e.monthlyTargetMarch, this.monthlyTargetApril = e.monthlyTargetApril, this.monthlyTargetMay = e.monthlyTargetMay, this.monthlyTargetJune = e.monthlyTargetJune, this.monthlyTargetJuly = e.monthlyTargetJuly, this.monthlyTargetAugust = e.monthlyTargetAugust, this.monthlyTargetSeptember = e.monthlyTargetSeptember, this.monthlyTargetOctober = e.monthlyTargetOctober, this.monthlyTargetNovember = e.monthlyTargetNovember, this.monthlyTargetDecember = e.monthlyTargetDecember);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new wr();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.type = this.type, e.userId = this.userId, e.user = this.user ? this.user.toJSON() : void 0, e.teamId = this.teamId, e.isLead = this.isLead, e.monthlyTargetJanuary = this.monthlyTargetJanuary, e.monthlyTargetFebruary = this.monthlyTargetFebruary, e.monthlyTargetMarch = this.monthlyTargetMarch, e.monthlyTargetApril = this.monthlyTargetApril, e.monthlyTargetMay = this.monthlyTargetMay, e.monthlyTargetJune = this.monthlyTargetJune, e.monthlyTargetJuly = this.monthlyTargetJuly, e.monthlyTargetAugust = this.monthlyTargetAugust, e.monthlyTargetSeptember = this.monthlyTargetSeptember, e.monthlyTargetOctober = this.monthlyTargetOctober, e.monthlyTargetNovember = this.monthlyTargetNovember, e.monthlyTargetDecember = this.monthlyTargetDecember, super.toJSON(e), e;
  }
}
var Mp = /* @__PURE__ */ ((a) => (a[a.Accounting = 0] = "Accounting", a[a.Airport = 1] = "Airport", a[a.AmusementPark = 2] = "AmusementPark", a[a.Aquarium = 3] = "Aquarium", a[a.ArtGallery = 4] = "ArtGallery", a[a.Atm = 5] = "Atm", a[a.Bakery = 6] = "Bakery", a[a.Bank = 7] = "Bank", a[a.Bar = 8] = "Bar", a[a.BeautySalon = 9] = "BeautySalon", a[a.BicycleStore = 10] = "BicycleStore", a[a.BookStore = 11] = "BookStore", a[a.BowlingAlley = 12] = "BowlingAlley", a[a.BusStation = 13] = "BusStation", a[a.Cafe = 14] = "Cafe", a[a.Campground = 15] = "Campground", a[a.CarDealer = 16] = "CarDealer", a[a.CarRental = 17] = "CarRental", a[a.CarRepair = 18] = "CarRepair", a[a.CarWash = 19] = "CarWash", a[a.Casino = 20] = "Casino", a[a.Cemetery = 21] = "Cemetery", a[a.Church = 22] = "Church", a[a.CityHall = 23] = "CityHall", a[a.ClothingStore = 24] = "ClothingStore", a[a.ConvenienceStore = 25] = "ConvenienceStore", a[a.Courthouse = 26] = "Courthouse", a[a.Dentist = 27] = "Dentist", a[a.DepartmentStore = 28] = "DepartmentStore", a[a.Doctor = 29] = "Doctor", a[a.Drugstore = 30] = "Drugstore", a[a.Electrician = 31] = "Electrician", a[a.ElectronicsStore = 32] = "ElectronicsStore", a[a.Embassy = 33] = "Embassy", a[a.FireStation = 34] = "FireStation", a[a.Florist = 35] = "Florist", a[a.FuneralHome = 36] = "FuneralHome", a[a.FurnitureStore = 37] = "FurnitureStore", a[a.GasStation = 38] = "GasStation", a[a.Gym = 39] = "Gym", a[a.HairCare = 40] = "HairCare", a[a.HardwareStore = 41] = "HardwareStore", a[a.HinduTemple = 42] = "HinduTemple", a[a.HomeGoodsStore = 43] = "HomeGoodsStore", a[a.Hospital = 44] = "Hospital", a[a.InsuranceAgency = 45] = "InsuranceAgency", a[a.JewelryStore = 46] = "JewelryStore", a[a.Laundry = 47] = "Laundry", a[a.Lawyer = 48] = "Lawyer", a[a.Library = 49] = "Library", a[a.LightRailStation = 50] = "LightRailStation", a[a.LiquorStore = 51] = "LiquorStore", a[a.LocalGovernmentOffice = 52] = "LocalGovernmentOffice", a[a.Locksmith = 53] = "Locksmith", a[a.Lodging = 54] = "Lodging", a[a.MealDelivery = 55] = "MealDelivery", a[a.MealTakeaway = 56] = "MealTakeaway", a[a.Mosque = 57] = "Mosque", a[a.MovieRental = 58] = "MovieRental", a[a.MovieTheater = 59] = "MovieTheater", a[a.MovingCompany = 60] = "MovingCompany", a[a.Museum = 61] = "Museum", a[a.NightClub = 62] = "NightClub", a[a.Painter = 63] = "Painter", a[a.Park = 64] = "Park", a[a.Parking = 65] = "Parking", a[a.PetStore = 66] = "PetStore", a[a.Pharmacy = 67] = "Pharmacy", a[a.Physiotherapist = 68] = "Physiotherapist", a[a.Plumber = 69] = "Plumber", a[a.Police = 70] = "Police", a[a.PostOffice = 71] = "PostOffice", a[a.PrimarySchool = 72] = "PrimarySchool", a[a.RealEstateAgency = 73] = "RealEstateAgency", a[a.Restaurant = 74] = "Restaurant", a[a.RoofingContractor = 75] = "RoofingContractor", a[a.RvPark = 76] = "RvPark", a[a.School = 77] = "School", a[a.SecondarySchool = 78] = "SecondarySchool", a[a.ShoeStore = 79] = "ShoeStore", a[a.ShoppingMall = 80] = "ShoppingMall", a[a.Spa = 81] = "Spa", a[a.Stadium = 82] = "Stadium", a[a.Storage = 83] = "Storage", a[a.Store = 84] = "Store", a[a.SubwayStation = 85] = "SubwayStation", a[a.Supermarket = 86] = "Supermarket", a[a.Synagogue = 87] = "Synagogue", a[a.TaxiStand = 88] = "TaxiStand", a[a.TouristAttraction = 89] = "TouristAttraction", a[a.TrainStation = 90] = "TrainStation", a[a.TransitStation = 91] = "TransitStation", a[a.TravelAgency = 92] = "TravelAgency", a[a.University = 93] = "University", a[a.VeterinaryCare = 94] = "VeterinaryCare", a[a.Zoo = 95] = "Zoo", a))(Mp || {});
class $t extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.name = e.name, this.displayName = e.displayName, this.description = e.description);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new $t();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.displayName = this.displayName, e.description = this.description, super.toJSON(e), e;
  }
}
class N {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
      this.type = e.type, this.title = e.title, this.status = e.status, this.detail = e.detail, this.instance = e.instance;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new N();
    return t.init(e), t;
  }
  toJSON(e) {
    e = typeof e == "object" ? e : {};
    for (var t in this)
      this.hasOwnProperty(t) && (e[t] = this[t]);
    return e.type = this.type, e.title = this.title, e.status = this.status, e.detail = this.detail, e.instance = this.instance, e;
  }
}
class Tu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Tu();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e;
  }
}
class so {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(vr.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new so();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class Lu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e && (this.visible = e.visible, this.valueText = e.valueText, this.valueNumber = e.valueNumber, this.valueBoolean = e.valueBoolean, this.valueDate = e.valueDate ? new Date(e.valueDate.toString()) : void 0, Array.isArray(e.valueList))) {
      this.valueList = [];
      for (let t of e.valueList)
        this.valueList.push(t);
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Lu();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.visible = this.visible, e.valueText = this.valueText, e.valueNumber = this.valueNumber, e.valueBoolean = this.valueBoolean, e.valueDate = this.valueDate ? this.valueDate.toISOString() : void 0, Array.isArray(this.valueList)) {
      e.valueList = [];
      for (let t of this.valueList)
        e.valueList.push(t);
    }
    return e;
  }
}
class io {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.id = e.id, this.email = e.email, this.name = e.name, this.role = e.role);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new io();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.id = this.id, e.email = this.email, e.name = this.name, e.role = this.role, e;
  }
}
class no extends io {
  constructor(e) {
    super(e);
  }
  init(e) {
    if (super.init(e), e) {
      if (Array.isArray(e.leadProjects)) {
        this.leadProjects = [];
        for (let t of e.leadProjects)
          this.leadProjects.push(t);
      }
      if (Array.isArray(e.leadTeams)) {
        this.leadTeams = [];
        for (let t of e.leadTeams)
          this.leadTeams.push(oo.fromJS(t));
      }
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new no();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, Array.isArray(this.leadProjects)) {
      e.leadProjects = [];
      for (let t of this.leadProjects)
        e.leadProjects.push(t);
    }
    if (Array.isArray(this.leadTeams)) {
      e.leadTeams = [];
      for (let t of this.leadTeams)
        e.leadTeams.push(t ? t.toJSON() : void 0);
    }
    return super.toJSON(e), e;
  }
}
class oo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.teamId = e.teamId, this.projectId = e.projectId);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new oo();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.teamId = this.teamId, e.projectId = this.projectId, e;
  }
}
class We extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    if (super.init(e), e && (this.name = e.name, this.street = e.street, this.details = e.details, this.country = e.country, this.zip = e.zip, this.city = e.city, this.contactName = e.contactName, this.contactRole = e.contactRole, this.email = e.email, this.phone = e.phone, this.note = e.note, this.longitude = e.longitude, this.latitude = e.latitude, this.contactType = e.contactType, this.activePotentialsCount = e.activePotentialsCount, Array.isArray(e.contactStatuses))) {
      this.contactStatuses = [];
      for (let t of e.contactStatuses)
        this.contactStatuses.push(ao.fromJS(t));
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new We();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.name = this.name, e.street = this.street, e.details = this.details, e.country = this.country, e.zip = this.zip, e.city = this.city, e.contactName = this.contactName, e.contactRole = this.contactRole, e.email = this.email, e.phone = this.phone, e.note = this.note, e.longitude = this.longitude, e.latitude = this.latitude, e.contactType = this.contactType, e.activePotentialsCount = this.activePotentialsCount, Array.isArray(this.contactStatuses)) {
      e.contactStatuses = [];
      for (let t of this.contactStatuses)
        e.contactStatuses.push(t ? t.toJSON() : void 0);
    }
    return super.toJSON(e), e;
  }
}
var ni = /* @__PURE__ */ ((a) => (a[a.Business = 0] = "Business", a[a.Private = 1] = "Private", a))(ni || {});
class ao extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.projectId = e.projectId, this.projectStatusId = e.projectStatusId, this.projectStatus = e.projectStatus ? Qt.fromJS(e.projectStatus) : void 0, this.isActive = e.isActive, this.createdBy = e.createdBy ? Ze.fromJS(e.createdBy) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new ao();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.projectId = this.projectId, e.projectStatusId = this.projectStatusId, e.projectStatus = this.projectStatus ? this.projectStatus.toJSON() : void 0, e.isActive = this.isActive, e.createdBy = this.createdBy ? this.createdBy.toJSON() : void 0, super.toJSON(e), e;
  }
}
class Qt extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.name = e.name, this.color = e.color, this.order = e.order, this.projectId = e.projectId, this.project = e.project ? st.fromJS(e.project) : void 0, this.statusGroupId = e.statusGroupId, this.statusGroup = e.statusGroup ? Br.fromJS(e.statusGroup) : void 0, this.followUpProjectStatusId = e.followUpProjectStatusId, this.followUpProjectStatusName = e.followUpProjectStatusName, this.followUpProjectStatusColor = e.followUpProjectStatusColor);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Qt();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.color = this.color, e.order = this.order, e.projectId = this.projectId, e.project = this.project ? this.project.toJSON() : void 0, e.statusGroupId = this.statusGroupId, e.statusGroup = this.statusGroup ? this.statusGroup.toJSON() : void 0, e.followUpProjectStatusId = this.followUpProjectStatusId, e.followUpProjectStatusName = this.followUpProjectStatusName, e.followUpProjectStatusColor = this.followUpProjectStatusColor, super.toJSON(e), e;
  }
}
class Br extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.name = e.name, this.label = e.label, this.color = e.color, this.isConcluding = e.isConcluding, this.order = e.order);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Br();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.label = this.label, e.color = this.color, e.isConcluding = this.isConcluding, e.order = this.order, super.toJSON(e), e;
  }
}
class lo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.name = e.name, this.street = e.street, this.details = e.details, this.country = e.country, this.zip = e.zip, this.city = e.city, this.contactName = e.contactName, this.contactRole = e.contactRole, this.email = e.email, this.phone = e.phone, this.note = e.note, this.longitude = e.longitude, this.latitude = e.latitude, this.contactType = e.contactType);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new lo();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.street = this.street, e.details = this.details, e.country = this.country, e.zip = this.zip, e.city = this.city, e.contactName = this.contactName, e.contactRole = this.contactRole, e.email = this.email, e.phone = this.phone, e.note = this.note, e.longitude = this.longitude, e.latitude = this.latitude, e.contactType = this.contactType, e;
  }
}
class Cu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (Array.isArray(e.statusGroupIds)) {
        this.statusGroupIds = [];
        for (let t of e.statusGroupIds)
          this.statusGroupIds.push(t);
      }
      if (Array.isArray(e.statusIds)) {
        this.statusIds = [];
        for (let t of e.statusIds)
          this.statusIds.push(t);
      }
      if (Array.isArray(e.associatedUserIds)) {
        this.associatedUserIds = [];
        for (let t of e.associatedUserIds)
          this.associatedUserIds.push(t);
      }
      if (this.includeWithoutAssociatedUser = e.includeWithoutAssociatedUser, this.referencedObjectMustBeFinalized = e.referencedObjectMustBeFinalized, Array.isArray(e.openPotentialIds)) {
        this.openPotentialIds = [];
        for (let t of e.openPotentialIds)
          this.openPotentialIds.push(t);
      }
      this.interactedAtFrom = e.interactedAtFrom ? new Date(e.interactedAtFrom.toString()) : void 0, this.interactedAtTo = e.interactedAtTo ? new Date(e.interactedAtTo.toString()) : void 0, this.zip = e.zip, this.city = e.city, this.street = e.street, this.country = e.country, this.latitude = e.latitude, this.longitude = e.longitude, this.radiusInMeters = e.radiusInMeters, this.contactType = e.contactType;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Cu();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, Array.isArray(this.statusGroupIds)) {
      e.statusGroupIds = [];
      for (let t of this.statusGroupIds)
        e.statusGroupIds.push(t);
    }
    if (Array.isArray(this.statusIds)) {
      e.statusIds = [];
      for (let t of this.statusIds)
        e.statusIds.push(t);
    }
    if (Array.isArray(this.associatedUserIds)) {
      e.associatedUserIds = [];
      for (let t of this.associatedUserIds)
        e.associatedUserIds.push(t);
    }
    if (e.includeWithoutAssociatedUser = this.includeWithoutAssociatedUser, e.referencedObjectMustBeFinalized = this.referencedObjectMustBeFinalized, Array.isArray(this.openPotentialIds)) {
      e.openPotentialIds = [];
      for (let t of this.openPotentialIds)
        e.openPotentialIds.push(t);
    }
    return e.interactedAtFrom = this.interactedAtFrom ? this.interactedAtFrom.toISOString() : void 0, e.interactedAtTo = this.interactedAtTo ? this.interactedAtTo.toISOString() : void 0, e.zip = this.zip, e.city = this.city, e.street = this.street, e.country = this.country, e.latitude = this.latitude, e.longitude = this.longitude, e.radiusInMeters = this.radiusInMeters, e.contactType = this.contactType, e;
  }
}
class uo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(We.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new uo();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class Au {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.name = e.name, this.street = e.street, this.details = e.details, this.country = e.country, this.zip = e.zip, this.city = e.city, this.contactName = e.contactName, this.contactRole = e.contactRole, this.email = e.email, this.phone = e.phone, this.note = e.note, this.longitude = e.longitude, this.latitude = e.latitude);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Au();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.street = this.street, e.details = this.details, e.country = this.country, e.zip = this.zip, e.city = this.city, e.contactName = this.contactName, e.contactRole = this.contactRole, e.email = this.email, e.phone = this.phone, e.note = this.note, e.longitude = this.longitude, e.latitude = this.latitude, e;
  }
}
class Dt extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.contactId = e.contactId, this.contact = e.contact ? We.fromJS(e.contact) : void 0, this.projectId = e.projectId, this.project = e.project ? st.fromJS(e.project) : void 0, this.projectStatusId = e.projectStatusId, this.projectStatus = e.projectStatus ? Qt.fromJS(e.projectStatus) : void 0, this.isActive = e.isActive, this.createdBy = e.createdBy ? Ze.fromJS(e.createdBy) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Dt();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.contactId = this.contactId, e.contact = this.contact ? this.contact.toJSON() : void 0, e.projectId = this.projectId, e.project = this.project ? this.project.toJSON() : void 0, e.projectStatusId = this.projectStatusId, e.projectStatus = this.projectStatus ? this.projectStatus.toJSON() : void 0, e.isActive = this.isActive, e.createdBy = this.createdBy ? this.createdBy.toJSON() : void 0, super.toJSON(e), e;
  }
}
class co {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(Dt.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new co();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class Nr extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.name = e.name, this.description = e.description, this.questionnaire = e.questionnaire ? Ti.fromJS(e.questionnaire) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Nr();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.description = this.description, e.questionnaire = this.questionnaire ? this.questionnaire.toJSON() : void 0, super.toJSON(e), e;
  }
}
class Ti extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.questionsCount = e.questionsCount);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Ti();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.questionsCount = this.questionsCount, super.toJSON(e), e;
  }
}
class Ou extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.name = e.name, this.description = e.description);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Ou();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.description = this.description, super.toJSON(e), e;
  }
}
class ho {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(Nr.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new ho();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class ku extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.name = e.name, this.description = e.description);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new ku();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.description = this.description, super.toJSON(e), e;
  }
}
class fo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(ys.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new fo();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class ys extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    if (super.init(e), e && (this.name = e.name, this.filter = e.filter ? Ct.fromJS(e.filter) : void 0, Array.isArray(e.columns))) {
      this.columns = [];
      for (let t of e.columns)
        this.columns.push(zr.fromJS(t));
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new ys();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.name = this.name, e.filter = this.filter ? this.filter.toJSON() : void 0, Array.isArray(this.columns)) {
      e.columns = [];
      for (let t of this.columns)
        e.columns.push(t ? t.toJSON() : void 0);
    }
    return super.toJSON(e), e;
  }
}
class zr {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.type = e.type, this.columnTitle = e.columnTitle, this.hash = e.hash, this.answerTitle = e.answerTitle);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new zr();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.type = this.type, e.columnTitle = this.columnTitle, e.hash = this.hash, e.answerTitle = this.answerTitle, e;
  }
}
var Np = /* @__PURE__ */ ((a) => (a[a.Id = 0] = "Id", a[a.Organisation = 1] = "Organisation", a[a.Region = 2] = "Region", a[a.Project = 3] = "Project", a[a.Author = 4] = "Author", a[a.Type = 5] = "Type", a[a.Contact = 6] = "Contact", a[a.ContactType = 7] = "ContactType", a[a.CreatedAt = 8] = "CreatedAt", a[a.SubmissionDate = 9] = "SubmissionDate", a[a.Answer = 10] = "Answer", a[a.ContactStreet = 11] = "ContactStreet", a[a.ContactDetails = 12] = "ContactDetails", a[a.ContactZip = 13] = "ContactZip", a[a.ContactCity = 14] = "ContactCity", a[a.ContactCountry = 15] = "ContactCountry", a[a.ContactPhone = 16] = "ContactPhone", a[a.ContactEmail = 17] = "ContactEmail", a[a.ContactPerson = 18] = "ContactPerson", a[a.ContactPersonRole = 19] = "ContactPersonRole", a[a.ContactNote = 20] = "ContactNote", a[a.ContactStatus = 21] = "ContactStatus", a[a.AssignedTask = 22] = "AssignedTask", a))(Np || {});
class Iu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e && (this.name = e.name, this.filter = e.filter ? Ct.fromJS(e.filter) : void 0, Array.isArray(e.columns))) {
      this.columns = [];
      for (let t of e.columns)
        this.columns.push(zr.fromJS(t));
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Iu();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.name = this.name, e.filter = this.filter ? this.filter.toJSON() : void 0, Array.isArray(this.columns)) {
      e.columns = [];
      for (let t of this.columns)
        e.columns.push(t ? t.toJSON() : void 0);
    }
    return e;
  }
}
class ju {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e && (this.name = e.name, this.filter = e.filter ? Ct.fromJS(e.filter) : void 0, Array.isArray(e.columns))) {
      this.columns = [];
      for (let t of e.columns)
        this.columns.push(zr.fromJS(t));
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new ju();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.name = this.name, e.filter = this.filter ? this.filter.toJSON() : void 0, Array.isArray(this.columns)) {
      e.columns = [];
      for (let t of this.columns)
        e.columns.push(t ? t.toJSON() : void 0);
    }
    return e;
  }
}
class po {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(mo.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new po();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class mo extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.projectId = e.projectId, this.fileName = e.fileName, this.successCount = e.successCount, this.failedCount = e.failedCount, this.hasFile = e.hasFile, this.hasFailedRows = e.hasFailedRows, this.createdBy = e.createdBy ? Ze.fromJS(e.createdBy) : void 0, this.deletedBy = e.deletedBy ? Ze.fromJS(e.deletedBy) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new mo();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.projectId = this.projectId, e.fileName = this.fileName, e.successCount = this.successCount, e.failedCount = this.failedCount, e.hasFile = this.hasFile, e.hasFailedRows = this.hasFailedRows, e.createdBy = this.createdBy ? this.createdBy.toJSON() : void 0, e.deletedBy = this.deletedBy ? this.deletedBy.toJSON() : void 0, super.toJSON(e), e;
  }
}
class vo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(_r.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new vo();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class qr {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.street = e.street, this.details = e.details, this.postalCode = e.postalCode, this.federalState = e.federalState, this.city = e.city, this.country = e.country, this.longitude = e.longitude, this.latitude = e.latitude);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new qr();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.street = this.street, e.details = this.details, e.postalCode = this.postalCode, e.federalState = this.federalState, e.city = this.city, e.country = this.country, e.longitude = this.longitude, e.latitude = this.latitude, e;
  }
}
class Er extends qr {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.name = e.name, this.distance = e.distance, this.phone = e.phone);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Er();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.distance = this.distance, e.phone = this.phone, super.toJSON(e), e;
  }
}
class go {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.text = e.text, this.distance = e.distance);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new go();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.text = this.text, e.distance = this.distance, e;
  }
}
class yo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.validatedAddress = e.validatedAddress ? qr.fromJS(e.validatedAddress) : void 0, this.isComplete = e.isComplete);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new yo();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.validatedAddress = this.validatedAddress ? this.validatedAddress.toJSON() : void 0, e.isComplete = this.isComplete, e;
  }
}
class vs {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(Li.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new vs();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class Li extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.contactId = e.contactId, this.contact = e.contact ? We.fromJS(e.contact) : void 0, this.productGroupId = e.productGroupId, this.productGroup = e.productGroup ? $t.fromJS(e.productGroup) : void 0, this.createdBy = e.createdBy ? Ze.fromJS(e.createdBy) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Li();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.contactId = this.contactId, e.contact = this.contact ? this.contact.toJSON() : void 0, e.productGroupId = this.productGroupId, e.productGroup = this.productGroup ? this.productGroup.toJSON() : void 0, e.createdBy = this.createdBy ? this.createdBy.toJSON() : void 0, super.toJSON(e), e;
  }
}
class _o {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push($t.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new _o();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class li {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(gr.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new li();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class Eu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.name = e.name, this.description = e.description, this.projectId = e.projectId, this.productGroupId = e.productGroupId, this.quotaRelevant = e.quotaRelevant);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Eu();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.description = this.description, e.projectId = this.projectId, e.productGroupId = this.productGroupId, e.quotaRelevant = this.quotaRelevant, e;
  }
}
class Du {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.name = e.name, this.description = e.description, this.productGroupId = e.productGroupId, this.quotaRelevant = e.quotaRelevant);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Du();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.description = this.description, e.productGroupId = this.productGroupId, e.quotaRelevant = this.quotaRelevant, e;
  }
}
class ui {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(br.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new ui();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class Mu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.userId = e.userId, this.projectId = e.projectId, this.type = e.type);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Mu();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.userId = this.userId, e.projectId = this.projectId, e.type = this.type, e;
  }
}
class Nu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.type = e.type);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Nu();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.type = this.type, e;
  }
}
class Ju {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.monthlyTargetJanuary = e.monthlyTargetJanuary, this.monthlyTargetFebruary = e.monthlyTargetFebruary, this.monthlyTargetMarch = e.monthlyTargetMarch, this.monthlyTargetApril = e.monthlyTargetApril, this.monthlyTargetMay = e.monthlyTargetMay, this.monthlyTargetJune = e.monthlyTargetJune, this.monthlyTargetJuly = e.monthlyTargetJuly, this.monthlyTargetAugust = e.monthlyTargetAugust, this.monthlyTargetSeptember = e.monthlyTargetSeptember, this.monthlyTargetOctober = e.monthlyTargetOctober, this.monthlyTargetNovember = e.monthlyTargetNovember, this.monthlyTargetDecember = e.monthlyTargetDecember);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Ju();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.monthlyTargetJanuary = this.monthlyTargetJanuary, e.monthlyTargetFebruary = this.monthlyTargetFebruary, e.monthlyTargetMarch = this.monthlyTargetMarch, e.monthlyTargetApril = this.monthlyTargetApril, e.monthlyTargetMay = this.monthlyTargetMay, e.monthlyTargetJune = this.monthlyTargetJune, e.monthlyTargetJuly = this.monthlyTargetJuly, e.monthlyTargetAugust = this.monthlyTargetAugust, e.monthlyTargetSeptember = this.monthlyTargetSeptember, e.monthlyTargetOctober = this.monthlyTargetOctober, e.monthlyTargetNovember = this.monthlyTargetNovember, e.monthlyTargetDecember = this.monthlyTargetDecember, e;
  }
}
class ci {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(Jr.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new ci();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class Jr extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.projectId = e.projectId, this.project = e.project ? st.fromJS(e.project) : void 0, this.productGroupId = e.productGroupId, this.productGroup = e.productGroup ? $t.fromJS(e.productGroup) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Jr();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.projectId = this.projectId, e.project = this.project ? this.project.toJSON() : void 0, e.productGroupId = this.productGroupId, e.productGroup = this.productGroup ? this.productGroup.toJSON() : void 0, super.toJSON(e), e;
  }
}
class Uu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.projectId = e.projectId, this.productGroupId = e.productGroupId);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Uu();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.projectId = this.projectId, e.productGroupId = this.productGroupId, e;
  }
}
class Bu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.productGroupId = e.productGroupId);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Bu();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.productGroupId = this.productGroupId, e;
  }
}
class hi extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.type = e.type, this.contactType = e.contactType, this.questionnaire = e.questionnaire ? Ti.fromJS(e.questionnaire) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new hi();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.type = this.type, e.contactType = this.contactType, e.questionnaire = this.questionnaire ? this.questionnaire.toJSON() : void 0, super.toJSON(e), e;
  }
}
var Jp = /* @__PURE__ */ ((a) => (a[a.PotentialAnalysis = 0] = "PotentialAnalysis", a[a.SuccessReport = 1] = "SuccessReport", a))(Jp || {});
class Ru {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.projectId = e.projectId, this.contactType = e.contactType);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Ru();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.projectId = this.projectId, e.contactType = this.contactType, e;
  }
}
class bo extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.project = e.project ? st.fromJS(e.project) : void 0, this.questionnaire = e.questionnaire ? wo.fromJS(e.questionnaire) : void 0, this.contactType = e.contactType, this.type = e.type);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new bo();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.project = this.project ? this.project.toJSON() : void 0, e.questionnaire = this.questionnaire ? this.questionnaire.toJSON() : void 0, e.contactType = this.contactType, e.type = this.type, super.toJSON(e), e;
  }
}
class wo extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new wo();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, super.toJSON(e), e;
  }
}
class di {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(st.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new di();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class zu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.name = e.name, this.description = e.description, this.regionId = e.regionId, this.projectLeadId = e.projectLeadId, this.allowContactStatusChanges = e.allowContactStatusChanges, this.taskSearchRadius = e.taskSearchRadius, Array.isArray(e.taskSearchTypes)) {
        this.taskSearchTypes = [];
        for (let t of e.taskSearchTypes)
          this.taskSearchTypes.push(t);
      }
      if (Array.isArray(e.taskSearchTerms)) {
        this.taskSearchTerms = [];
        for (let t of e.taskSearchTerms)
          this.taskSearchTerms.push(t);
      }
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new zu();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.name = this.name, e.description = this.description, e.regionId = this.regionId, e.projectLeadId = this.projectLeadId, e.allowContactStatusChanges = this.allowContactStatusChanges, e.taskSearchRadius = this.taskSearchRadius, Array.isArray(this.taskSearchTypes)) {
      e.taskSearchTypes = [];
      for (let t of this.taskSearchTypes)
        e.taskSearchTypes.push(t);
    }
    if (Array.isArray(this.taskSearchTerms)) {
      e.taskSearchTerms = [];
      for (let t of this.taskSearchTerms)
        e.taskSearchTerms.push(t);
    }
    return e;
  }
}
class qu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.name = e.name, this.description = e.description, this.projectLeadId = e.projectLeadId, this.visitMaxDaysBack = e.visitMaxDaysBack, this.allowContactStatusChanges = e.allowContactStatusChanges, this.onlyAllowVisitsFromTasks = e.onlyAllowVisitsFromTasks, this.taskSearchRadius = e.taskSearchRadius, Array.isArray(e.taskSearchTypes)) {
        this.taskSearchTypes = [];
        for (let t of e.taskSearchTypes)
          this.taskSearchTypes.push(t);
      }
      if (Array.isArray(e.taskSearchTerms)) {
        this.taskSearchTerms = [];
        for (let t of e.taskSearchTerms)
          this.taskSearchTerms.push(t);
      }
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new qu();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.name = this.name, e.description = this.description, e.projectLeadId = this.projectLeadId, e.visitMaxDaysBack = this.visitMaxDaysBack, e.allowContactStatusChanges = this.allowContactStatusChanges, e.onlyAllowVisitsFromTasks = this.onlyAllowVisitsFromTasks, e.taskSearchRadius = this.taskSearchRadius, Array.isArray(this.taskSearchTypes)) {
      e.taskSearchTypes = [];
      for (let t of this.taskSearchTypes)
        e.taskSearchTypes.push(t);
    }
    if (Array.isArray(this.taskSearchTerms)) {
      e.taskSearchTerms = [];
      for (let t of this.taskSearchTerms)
        e.taskSearchTerms.push(t);
    }
    return e;
  }
}
class Po {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.id = e.id, this.name = e.name, this.region = e.region, this.organisation = e.organisation, this.contactType = e.contactType, this.coldOutreachEnabled = e.coldOutreachEnabled);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Po();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.id = this.id, e.name = this.name, e.region = this.region, e.organisation = this.organisation, e.contactType = this.contactType, e.coldOutreachEnabled = this.coldOutreachEnabled, e;
  }
}
class Zu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.name = e.name, this.color = e.color, this.order = e.order, this.projectId = e.projectId, this.statusGroupId = e.statusGroupId, this.followUpProjectStatusId = e.followUpProjectStatusId, this.selfReferencedFollowUp = e.selfReferencedFollowUp);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Zu();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.color = this.color, e.order = this.order, e.projectId = this.projectId, e.statusGroupId = this.statusGroupId, e.followUpProjectStatusId = this.followUpProjectStatusId, e.selfReferencedFollowUp = this.selfReferencedFollowUp, e;
  }
}
class Vu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.name = e.name, this.color = e.color, this.order = e.order, this.statusGroupId = e.statusGroupId, this.followUpProjectStatusId = e.followUpProjectStatusId);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Vu();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.color = this.color, e.order = this.order, e.statusGroupId = this.statusGroupId, e.followUpProjectStatusId = this.followUpProjectStatusId, e;
  }
}
class $u {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e && Array.isArray(e.items)) {
      this.items = [];
      for (let t of e.items)
        this.items.push(xo.fromJS(t));
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new $u();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, Array.isArray(this.items)) {
      e.items = [];
      for (let t of this.items)
        e.items.push(t ? t.toJSON() : void 0);
    }
    return e;
  }
}
class xo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.id = e.id, this.order = e.order);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new xo();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.id = this.id, e.order = this.order, e;
  }
}
class Fu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.endpoint = e.endpoint, this.p256dh = e.p256dh, this.auth = e.auth);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Fu();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.endpoint = this.endpoint, e.p256dh = this.p256dh, e.auth = this.auth, e;
  }
}
class Gu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.title = e.title, this.body = e.body);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Gu();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.title = this.title, e.body = this.body, e;
  }
}
class So extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    if (super.init(e), e && Array.isArray(e.questions)) {
      this.questions = [];
      for (let t of e.questions)
        this.questions.push(er.fromJS(t));
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new So();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, Array.isArray(this.questions)) {
      e.questions = [];
      for (let t of this.questions)
        e.questions.push(t ? t.toJSON() : void 0);
    }
    return super.toJSON(e), e;
  }
}
class er extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    if (super.init(e), e) {
      if (this.questionnaireId = e.questionnaireId, this.type = e.type, this.title = e.title, this.description = e.description, this.placeholder = e.placeholder, this.isRequired = e.isRequired, this.order = e.order, this.requiresSubsequentProductCounts = e.requiresSubsequentProductCounts, Array.isArray(e.options)) {
        this.options = [];
        for (let t of e.options)
          this.options.push(xs.fromJS(t));
      }
      this.yesTriggerProjectStatusId = e.yesTriggerProjectStatusId, this.noTriggerProjectStatusId = e.noTriggerProjectStatusId, this.dependency = e.dependency ? To.fromJS(e.dependency) : void 0;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new er();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.questionnaireId = this.questionnaireId, e.type = this.type, e.title = this.title, e.description = this.description, e.placeholder = this.placeholder, e.isRequired = this.isRequired, e.order = this.order, e.requiresSubsequentProductCounts = this.requiresSubsequentProductCounts, Array.isArray(this.options)) {
      e.options = [];
      for (let t of this.options)
        e.options.push(t ? t.toJSON() : void 0);
    }
    return e.yesTriggerProjectStatusId = this.yesTriggerProjectStatusId, e.noTriggerProjectStatusId = this.noTriggerProjectStatusId, e.dependency = this.dependency ? this.dependency.toJSON() : void 0, super.toJSON(e), e;
  }
}
class xs extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.text = e.text, this.value = e.value, this.order = e.order, this.productId = e.productId, this.triggerProjectStatusId = e.triggerProjectStatusId);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new xs();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.text = this.text, e.value = this.value, e.order = this.order, e.productId = this.productId, e.triggerProjectStatusId = this.triggerProjectStatusId, super.toJSON(e), e;
  }
}
class To extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    if (super.init(e), e && (this.dependencyQuestion = e.dependencyQuestion ? er.fromJS(e.dependencyQuestion) : void 0, this.dependencyQuestionId = e.dependencyQuestionId, this.condition = e.condition, this.valueText = e.valueText, this.valueNumber = e.valueNumber, this.valueBoolean = e.valueBoolean, this.valueDate = e.valueDate ? new Date(e.valueDate.toString()) : void 0, Array.isArray(e.valueList))) {
      this.valueList = [];
      for (let t of e.valueList)
        this.valueList.push(t);
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new To();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.dependencyQuestion = this.dependencyQuestion ? this.dependencyQuestion.toJSON() : void 0, e.dependencyQuestionId = this.dependencyQuestionId, e.condition = this.condition, e.valueText = this.valueText, e.valueNumber = this.valueNumber, e.valueBoolean = this.valueBoolean, e.valueDate = this.valueDate ? this.valueDate.toISOString() : void 0, Array.isArray(this.valueList)) {
      e.valueList = [];
      for (let t of this.valueList)
        e.valueList.push(t);
    }
    return super.toJSON(e), e;
  }
}
class Hu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.questionnaireId = e.questionnaireId, this.type = e.type, this.title = e.title, this.description = e.description, this.placeholder = e.placeholder, this.isRequired = e.isRequired, this.order = e.order, this.requiresSubsequentProductCounts = e.requiresSubsequentProductCounts, Array.isArray(e.options)) {
        this.options = [];
        for (let t of e.options)
          this.options.push(xs.fromJS(t));
      }
      this.yesTriggerProjectStatusId = e.yesTriggerProjectStatusId, this.noTriggerProjectStatusId = e.noTriggerProjectStatusId, this.dependency = e.dependency ? Lo.fromJS(e.dependency) : void 0;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Hu();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.questionnaireId = this.questionnaireId, e.type = this.type, e.title = this.title, e.description = this.description, e.placeholder = this.placeholder, e.isRequired = this.isRequired, e.order = this.order, e.requiresSubsequentProductCounts = this.requiresSubsequentProductCounts, Array.isArray(this.options)) {
      e.options = [];
      for (let t of this.options)
        e.options.push(t ? t.toJSON() : void 0);
    }
    return e.yesTriggerProjectStatusId = this.yesTriggerProjectStatusId, e.noTriggerProjectStatusId = this.noTriggerProjectStatusId, e.dependency = this.dependency ? this.dependency.toJSON() : void 0, e;
  }
}
class Lo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e && (this.dependencyQuestionId = e.dependencyQuestionId, this.condition = e.condition, this.valueText = e.valueText, this.valueNumber = e.valueNumber, this.valueBoolean = e.valueBoolean, this.valueDate = e.valueDate ? new Date(e.valueDate.toString()) : void 0, Array.isArray(e.valueList))) {
      this.valueList = [];
      for (let t of e.valueList)
        this.valueList.push(t);
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Lo();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.dependencyQuestionId = this.dependencyQuestionId, e.condition = this.condition, e.valueText = this.valueText, e.valueNumber = this.valueNumber, e.valueBoolean = this.valueBoolean, e.valueDate = this.valueDate ? this.valueDate.toISOString() : void 0, Array.isArray(this.valueList)) {
      e.valueList = [];
      for (let t of this.valueList)
        e.valueList.push(t);
    }
    return e;
  }
}
class Wu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.questionnaireId = e.questionnaireId, this.type = e.type, this.title = e.title, this.description = e.description, this.placeholder = e.placeholder, this.isRequired = e.isRequired, this.order = e.order, this.requiresSubsequentProductCounts = e.requiresSubsequentProductCounts, Array.isArray(e.options)) {
        this.options = [];
        for (let t of e.options)
          this.options.push(xs.fromJS(t));
      }
      this.yesTriggerProjectStatusId = e.yesTriggerProjectStatusId, this.noTriggerProjectStatusId = e.noTriggerProjectStatusId, this.dependency = e.dependency ? Co.fromJS(e.dependency) : void 0;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Wu();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.questionnaireId = this.questionnaireId, e.type = this.type, e.title = this.title, e.description = this.description, e.placeholder = this.placeholder, e.isRequired = this.isRequired, e.order = this.order, e.requiresSubsequentProductCounts = this.requiresSubsequentProductCounts, Array.isArray(this.options)) {
      e.options = [];
      for (let t of this.options)
        e.options.push(t ? t.toJSON() : void 0);
    }
    return e.yesTriggerProjectStatusId = this.yesTriggerProjectStatusId, e.noTriggerProjectStatusId = this.noTriggerProjectStatusId, e.dependency = this.dependency ? this.dependency.toJSON() : void 0, e;
  }
}
class Co {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e && (this.dependencyQuestionId = e.dependencyQuestionId, this.condition = e.condition, this.valueText = e.valueText, this.valueNumber = e.valueNumber, this.valueBoolean = e.valueBoolean, this.valueDate = e.valueDate ? new Date(e.valueDate.toString()) : void 0, Array.isArray(e.valueList))) {
      this.valueList = [];
      for (let t of e.valueList)
        this.valueList.push(t);
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Co();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.dependencyQuestionId = this.dependencyQuestionId, e.condition = this.condition, e.valueText = this.valueText, e.valueNumber = this.valueNumber, e.valueBoolean = this.valueBoolean, e.valueDate = this.valueDate ? this.valueDate.toISOString() : void 0, Array.isArray(this.valueList)) {
      e.valueList = [];
      for (let t of this.valueList)
        e.valueList.push(t);
    }
    return e;
  }
}
class Ao {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(er.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Ao();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class fi {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(yr.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new fi();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class Ku {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.name = e.name, this.organisationId = e.organisationId);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Ku();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.organisationId = this.organisationId, e;
  }
}
class Qu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.name = e.name);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Qu();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e;
  }
}
class Yu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.query = e.query, this.type = e.type, this.filter = e.filter ? Ct.fromJS(e.filter) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Yu();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.query = this.query, e.type = this.type, e.filter = this.filter ? this.filter.toJSON() : void 0, e;
  }
}
var Up = /* @__PURE__ */ ((a) => (a[a.Organisation = 0] = "Organisation", a[a.Region = 1] = "Region", a[a.Project = 2] = "Project", a[a.User = 3] = "User", a[a.Contact = 4] = "Contact", a[a.AnswerTitle = 5] = "AnswerTitle", a[a.AnswerOption = 6] = "AnswerOption", a[a.AnswerText = 7] = "AnswerText", a[a.ContactStatus = 8] = "ContactStatus", a[a.TaskDescription = 9] = "TaskDescription", a[a.SoldProduct = 10] = "SoldProduct", a))(Up || {});
class Xu {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.color = e.color);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Xu();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.color = this.color, e;
  }
}
class Oo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(Br.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Oo();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class Et extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    if (super.init(e), e) {
      if (this.type = e.type, Array.isArray(e.answers)) {
        this.answers = [];
        for (let t of e.answers)
          this.answers.push(vr.fromJS(t));
      }
      this.submissionDate = e.submissionDate ? new Date(e.submissionDate.toString()) : void 0, this.finalized = e.finalized, this.createdBy = e.createdBy ? Ze.fromJS(e.createdBy) : void 0, this.visitContact = e.visitContact ? We.fromJS(e.visitContact) : void 0, this.visitProject = e.visitProject ? st.fromJS(e.visitProject) : void 0, this.latitude = e.latitude, this.longitude = e.longitude, this.organisationName = e.organisationName, this.regionName = e.regionName, this.projectName = e.projectName, this.contactType = e.contactType, this.assignedTaskDescription = e.assignedTaskDescription;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Et();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.type = this.type, Array.isArray(this.answers)) {
      e.answers = [];
      for (let t of this.answers)
        e.answers.push(t ? t.toJSON() : void 0);
    }
    return e.submissionDate = this.submissionDate ? Dn(this.submissionDate) : void 0, e.finalized = this.finalized, e.createdBy = this.createdBy ? this.createdBy.toJSON() : void 0, e.visitContact = this.visitContact ? this.visitContact.toJSON() : void 0, e.visitProject = this.visitProject ? this.visitProject.toJSON() : void 0, e.latitude = this.latitude, e.longitude = this.longitude, e.organisationName = this.organisationName, e.regionName = this.regionName, e.projectName = this.projectName, e.contactType = this.contactType, e.assignedTaskDescription = this.assignedTaskDescription, super.toJSON(e), e;
  }
}
var Bp = /* @__PURE__ */ ((a) => (a[a.PotentialAnalysis = 0] = "PotentialAnalysis", a[a.SuccessReport = 1] = "SuccessReport", a[a.DailyReport = 2] = "DailyReport", a))(Bp || {});
class ec {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.latitude = e.latitude, this.longitude = e.longitude);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new ec();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.latitude = this.latitude, e.longitude = this.longitude, e;
  }
}
class Dr {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(Et.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Dr();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class ko {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.key = e.key, this.hash = e.hash, this.level = e.level, this.referencedProductId = e.referencedProductId, this.referencedProductName = e.referencedProductName);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new ko();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.key = this.key, e.hash = this.hash, e.level = this.level, e.referencedProductId = this.referencedProductId, e.referencedProductName = this.referencedProductName, e;
  }
}
class tc {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.name = e.name, this.submissionFilter = e.submissionFilter ? Ct.fromJS(e.submissionFilter) : void 0, Array.isArray(e.columns)) {
        this.columns = [];
        for (let t of e.columns)
          this.columns.push(zr.fromJS(t));
      }
      this.sortBy = e.sortBy, this.sortDescending = e.sortDescending;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new tc();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.name = this.name, e.submissionFilter = this.submissionFilter ? this.submissionFilter.toJSON() : void 0, Array.isArray(this.columns)) {
      e.columns = [];
      for (let t of this.columns)
        e.columns.push(t ? t.toJSON() : void 0);
    }
    return e.sortBy = this.sortBy, e.sortDescending = this.sortDescending, e;
  }
}
class yt extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.projectId = e.projectId, this.project = e.project ? st.fromJS(e.project) : void 0, this.contactId = e.contactId, this.contact = e.contact ? We.fromJS(e.contact) : void 0, this.description = e.description, this.assignedUserId = e.assignedUserId, this.assignedUser = e.assignedUser ? Ze.fromJS(e.assignedUser) : void 0, this.dueAt = e.dueAt ? new Date(e.dueAt.toString()) : void 0, this.visitId = e.visitId, this.visit = e.visit ? qt.fromJS(e.visit) : void 0, this.createdBy = e.createdBy ? Ze.fromJS(e.createdBy) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new yt();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.projectId = this.projectId, e.project = this.project ? this.project.toJSON() : void 0, e.contactId = this.contactId, e.contact = this.contact ? this.contact.toJSON() : void 0, e.description = this.description, e.assignedUserId = this.assignedUserId, e.assignedUser = this.assignedUser ? this.assignedUser.toJSON() : void 0, e.dueAt = this.dueAt ? this.dueAt.toISOString() : void 0, e.visitId = this.visitId, e.visit = this.visit ? this.visit.toJSON() : void 0, e.createdBy = this.createdBy ? this.createdBy.toJSON() : void 0, super.toJSON(e), e;
  }
}
class qt extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    if (super.init(e), e) {
      if (this.projectName = e.projectName, this.contact = e.contact ? We.fromJS(e.contact) : void 0, Array.isArray(e.submissions)) {
        this.submissions = [];
        for (let t of e.submissions)
          this.submissions.push(Et.fromJS(t));
      }
      this.completed = e.completed, this.createdBy = e.createdBy ? Ze.fromJS(e.createdBy) : void 0, this.task = e.task ? Io.fromJS(e.task) : void 0, this.projectId = e.projectId;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new qt();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.projectName = this.projectName, e.contact = this.contact ? this.contact.toJSON() : void 0, Array.isArray(this.submissions)) {
      e.submissions = [];
      for (let t of this.submissions)
        e.submissions.push(t ? t.toJSON() : void 0);
    }
    return e.completed = this.completed, e.createdBy = this.createdBy ? this.createdBy.toJSON() : void 0, e.task = this.task ? this.task.toJSON() : void 0, e.projectId = this.projectId, super.toJSON(e), e;
  }
}
class Io extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.description = e.description, this.dueAt = e.dueAt ? new Date(e.dueAt.toString()) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Io();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.description = this.description, e.dueAt = this.dueAt ? this.dueAt.toISOString() : void 0, super.toJSON(e), e;
  }
}
class jo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.projectId = e.projectId, this.contactId = e.contactId, this.description = e.description, this.assignedUserId = e.assignedUserId, this.dueAt = e.dueAt ? new Date(e.dueAt.toString()) : void 0, this.projectStatusId = e.projectStatusId);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new jo();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.projectId = this.projectId, e.contactId = this.contactId, e.description = this.description, e.assignedUserId = this.assignedUserId, e.dueAt = this.dueAt ? this.dueAt.toISOString() : void 0, e.projectStatusId = this.projectStatusId, e;
  }
}
class Eo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.contactId = e.contactId, this.description = e.description, this.assignedUserId = e.assignedUserId, this.dueAt = e.dueAt ? new Date(e.dueAt.toString()) : void 0, this.projectStatusId = e.projectStatusId);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Eo();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.contactId = this.contactId, e.description = this.description, e.assignedUserId = this.assignedUserId, e.dueAt = this.dueAt ? this.dueAt.toISOString() : void 0, e.projectStatusId = this.projectStatusId, e;
  }
}
class pi {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.contactStatus = e.contactStatus ? Dt.fromJS(e.contactStatus) : void 0, this.task = e.task ? yt.fromJS(e.task) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new pi();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.contactStatus = this.contactStatus ? this.contactStatus.toJSON() : void 0, e.task = this.task ? this.task.toJSON() : void 0, e;
  }
}
class rc {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.followUpProjectStatusId = e.followUpProjectStatusId, this.contactStatus = e.contactStatus ? Dt.fromJS(e.contactStatus) : void 0, this.task = e.task ? jo.fromJS(e.task) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new rc();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.followUpProjectStatusId = this.followUpProjectStatusId, e.contactStatus = this.contactStatus ? this.contactStatus.toJSON() : void 0, e.task = this.task ? this.task.toJSON() : void 0, e;
  }
}
class sc extends Eo {
  constructor(e) {
    super(e);
  }
  init(e) {
    if (super.init(e), e && Array.isArray(e.ids)) {
      this.ids = [];
      for (let t of e.ids)
        this.ids.push(t);
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new sc();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, Array.isArray(this.ids)) {
      e.ids = [];
      for (let t of this.ids)
        e.ids.push(t);
    }
    return super.toJSON(e), e;
  }
}
class Do {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(Ci.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Do();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class Ci extends yt {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.contactStatus = e.contactStatus ? Dt.fromJS(e.contactStatus) : void 0, this.isSelfAssigned = e.isSelfAssigned);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Ci();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.contactStatus = this.contactStatus ? this.contactStatus.toJSON() : void 0, e.isSelfAssigned = this.isSelfAssigned, super.toJSON(e), e;
  }
}
class ic {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (Array.isArray(e.projectStatusIds)) {
        this.projectStatusIds = [];
        for (let t of e.projectStatusIds)
          this.projectStatusIds.push(t);
      }
      if (Array.isArray(e.assignedUserIds)) {
        this.assignedUserIds = [];
        for (let t of e.assignedUserIds)
          this.assignedUserIds.push(t);
      }
      this.params = e.params ? Si.fromJS(e.params) : void 0;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new ic();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, Array.isArray(this.projectStatusIds)) {
      e.projectStatusIds = [];
      for (let t of this.projectStatusIds)
        e.projectStatusIds.push(t);
    }
    if (Array.isArray(this.assignedUserIds)) {
      e.assignedUserIds = [];
      for (let t of this.assignedUserIds)
        e.assignedUserIds.push(t);
    }
    return e.params = this.params ? this.params.toJSON() : void 0, e;
  }
}
class Mo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.importId = e.importId, Array.isArray(e.tasks)) {
        this.tasks = [];
        for (let t of e.tasks)
          this.tasks.push(yt.fromJS(t));
      }
      if (Array.isArray(e.errors)) {
        this.errors = [];
        for (let t of e.errors)
          this.errors.push(No.fromJS(t));
      }
      this.failedRowsCsv = e.failedRowsCsv;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Mo();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.importId = this.importId, Array.isArray(this.tasks)) {
      e.tasks = [];
      for (let t of this.tasks)
        e.tasks.push(t ? t.toJSON() : void 0);
    }
    if (Array.isArray(this.errors)) {
      e.errors = [];
      for (let t of this.errors)
        e.errors.push(t ? t.toJSON() : void 0);
    }
    return e.failedRowsCsv = this.failedRowsCsv, e;
  }
}
class No {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e && (this.row = e.row, this.line = e.line, Array.isArray(e.errorCodes))) {
      this.errorCodes = [];
      for (let t of e.errorCodes)
        this.errorCodes.push(t);
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new No();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.row = this.row, e.line = this.line, Array.isArray(this.errorCodes)) {
      e.errorCodes = [];
      for (let t of this.errorCodes)
        e.errorCodes.push(t);
    }
    return e;
  }
}
var Rp = /* @__PURE__ */ ((a) => (a[a.CsvParseError = 0] = "CsvParseError", a[a.AddressValidationError = 1] = "AddressValidationError", a[a.ProjectStatusNotFound = 2] = "ProjectStatusNotFound", a[a.AssignedUserNotFound = 3] = "AssignedUserNotFound", a))(Rp || {});
class mi {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(wr.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new mi();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class nc {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.userId = e.userId, this.teamId = e.teamId, this.type = e.type);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new nc();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.userId = this.userId, e.teamId = this.teamId, e.type = this.type, e;
  }
}
class oc {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.type = e.type);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new oc();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.type = this.type, e;
  }
}
class vi {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(Xt.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new vi();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class ac {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.name = e.name, this.description = e.description, this.projectId = e.projectId, this.teamLeadId = e.teamLeadId);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new ac();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.description = this.description, e.projectId = this.projectId, e.teamLeadId = this.teamLeadId, e;
  }
}
class lc {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.name = e.name, this.description = e.description, this.teamLeadId = e.teamLeadId);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new lc();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.description = this.description, e.teamLeadId = this.teamLeadId, e;
  }
}
class gi {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(Ze.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new gi();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class Jo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(Uo.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Jo();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class Uo extends we {
  constructor(e) {
    super(e);
  }
  init(e) {
    super.init(e), e && (this.name = e.name, this.email = e.email, this.role = e.role, this.deactivatedAt = e.deactivatedAt ? new Date(e.deactivatedAt.toString()) : void 0, this.deactivatedByName = e.deactivatedByName);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Uo();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.name = this.name, e.email = this.email, e.role = this.role, e.deactivatedAt = this.deactivatedAt ? this.deactivatedAt.toISOString() : void 0, e.deactivatedByName = this.deactivatedByName, super.toJSON(e), e;
  }
}
class Bo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.name = e.name, Array.isArray(e.leadedProjects)) {
        this.leadedProjects = [];
        for (let t of e.leadedProjects)
          this.leadedProjects.push(st.fromJS(t));
      }
      if (Array.isArray(e.leadedTeams)) {
        this.leadedTeams = [];
        for (let t of e.leadedTeams)
          this.leadedTeams.push(Xt.fromJS(t));
      }
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Bo();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.name = this.name, Array.isArray(this.leadedProjects)) {
      e.leadedProjects = [];
      for (let t of this.leadedProjects)
        e.leadedProjects.push(t ? t.toJSON() : void 0);
    }
    if (Array.isArray(this.leadedTeams)) {
      e.leadedTeams = [];
      for (let t of this.leadedTeams)
        e.leadedTeams.push(t ? t.toJSON() : void 0);
    }
    return e;
  }
}
class Ro {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.projectId = e.projectId, this.project = e.project ? st.fromJS(e.project) : void 0, this.target = e.target, this.current = e.current);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new Ro();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.projectId = this.projectId, e.project = this.project ? this.project.toJSON() : void 0, e.target = this.target, e.current = this.current, e;
  }
}
class uc {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.projectId = e.projectId, this.contactType = e.contactType, this.taskId = e.taskId, this.contact = e.contact ? lo.fromJS(e.contact) : void 0);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new uc();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.projectId = this.projectId, e.contactType = this.contactType, e.taskId = this.taskId, e.contact = this.contact ? this.contact.toJSON() : void 0, e;
  }
}
class zo {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    if (e) {
      if (this.pageNumber = e.pageNumber, this.pageSize = e.pageSize, this.count = e.count, Array.isArray(e.data)) {
        this.data = [];
        for (let t of e.data)
          this.data.push(qt.fromJS(t));
      }
      this.totalPages = e.totalPages, this.hasPreviousPage = e.hasPreviousPage, this.hasNextPage = e.hasNextPage, this.from = e.from, this.to = e.to;
    }
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new zo();
    return t.init(e), t;
  }
  toJSON(e) {
    if (e = typeof e == "object" ? e : {}, e.pageNumber = this.pageNumber, e.pageSize = this.pageSize, e.count = this.count, Array.isArray(this.data)) {
      e.data = [];
      for (let t of this.data)
        e.data.push(t ? t.toJSON() : void 0);
    }
    return e.totalPages = this.totalPages, e.hasPreviousPage = this.hasPreviousPage, e.hasNextPage = this.hasNextPage, e.from = this.from, e.to = this.to, e;
  }
}
class cc {
  constructor(e) {
    if (e)
      for (var t in e)
        e.hasOwnProperty(t) && (this[t] = e[t]);
  }
  init(e) {
    e && (this.completed = e.completed);
  }
  static fromJS(e) {
    e = typeof e == "object" ? e : {};
    let t = new cc();
    return t.init(e), t;
  }
  toJSON(e) {
    return e = typeof e == "object" ? e : {}, e.completed = this.completed, e;
  }
}
function Dn(a) {
  return a.getFullYear() + "-" + (a.getMonth() < 9 ? "0" + (a.getMonth() + 1) : a.getMonth() + 1) + "-" + (a.getDate() < 10 ? "0" + a.getDate() : a.getDate());
}
class zp extends Error {
  constructor(e, t, o, r, s) {
    super(), this.isApiException = !0, this.message = e, this.status = t, this.response = o, this.headers = r, this.result = s;
  }
  static isApiException(e) {
    return e.isApiException === !0;
  }
}
function b(a, e, t, o, r) {
  throw r ?? new zp(a, e, t, o, null);
}
function O(a) {
  return a && a.isAxiosError === !0;
}
var hc = /* @__PURE__ */ ((a) => (a.Austria = "Österreich", a.Germany = "Deutschland", a))(hc || {});
const dc = af({
  locale: "de",
  messages: {
    de: pu
  },
  legacy: !1
}), vl = hu(), qo = () => ({ notify: (e, t, o, r) => {
  vl.emit("notify", { type: e, title: t, text: o, exception: r });
}, emitter: vl }), { t: Sn } = dc.global, { notify: qp } = qo(), fc = () => {
  const a = (t) => t;
  return { notifyApiException: (t, o) => {
    var m;
    console.error(t);
    const r = (m = a(t)) == null ? void 0 : m.type;
    let s = "errors.unknown";
    (t == null ? void 0 : t.code) === "ERR_NETWORK" && (s = "errors.network");
    const i = Sn(s), u = r ? Sn(`errors.${r}`) : o ?? i;
    u === i && ii.captureException(t);
    const d = `${t == null ? void 0 : t.toString()}
${t instanceof Error ? t.stack : ""}`;
    qp("error", Sn("common.error"), u, d);
  }, getProblemDetails: a };
}, Zp = () => ({ toSnakeCase: (e) => e == null ? void 0 : e.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase() }), { t: gl } = dc.global, Vp = () => {
  const { toSnakeCase: a } = Zp();
  return { enumToSelectionItems: (o, r, s = !1) => {
    const i = Object.keys(o).filter((u) => isNaN(Number(u))).map((u) => ({
      text: gl(`${r}.${a(u)}`),
      value: o[u]
    }));
    return s && i.sort((u, d) => {
      const m = (u.text ?? "").toString().toLocaleLowerCase(), v = (d.text ?? "").toString().toLocaleLowerCase();
      return m.localeCompare(v);
    }), i;
  }, enumToString: (o, r, s) => r == null ? "" : gl(`${s}.${a(o[r])}`) };
}, pc = (a, e) => {
  const t = a.__vccOpts || a;
  for (const [o, r] of e)
    t[o] = r;
  return t;
}, $p = {}, Fp = { class: "h-8 w-8 animate-[spin_0.5s_linear_infinite] rounded-full border-2 border-solid border-t-primary-500 dark:border-neutral-700 dark:border-t-primary-500" };
function Gp(a, e) {
  return j(), R("div", Fp);
}
const Ai = /* @__PURE__ */ pc($p, [["render", Gp]]), Hp = ["for"], Mt = /* @__PURE__ */ G({
  __name: "InputLabel",
  props: {
    name: {}
  },
  setup(a) {
    return (e, t) => (j(), R("label", {
      for: e.name,
      class: "block text-sm font-medium text-gray-700 dark:text-white"
    }, [
      ge(e.$slots, "default")
    ], 8, Hp));
  }
}), Wp = { class: "space-y-1" }, Kp = { class: "relative" }, Qp = { class: "dark:bg-dark-500 flex w-full items-center rounded-md border-[1px] border-gray-200 bg-gray-100 shadow-sm" }, Yp = {
  key: 0,
  class: "mx-3 flex-none sm:text-sm"
}, Xp = ["value", "type", "inputmode", "name", "id", "placeholder", "disabled", "autocomplete", "required", "readonly", "pattern", "title", "min", "max", "minlength", "maxlength"], em = { class: "absolute inset-y-0 right-0 flex items-center gap-2 pr-3" }, dt = /* @__PURE__ */ G({
  __name: "TextInput",
  props: {
    modelValue: {},
    name: {},
    type: { default: "text" },
    label: {},
    placeholder: { default: "" },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    required: { type: Boolean },
    autocomplete: {},
    pattern: {},
    title: {},
    prefix: {},
    stepSize: {},
    clearable: { type: Boolean },
    min: {},
    max: {},
    minlength: {},
    maxlength: {},
    decimals: {},
    focusClass: { default: "focus:border-primary-500 focus:ring-primary-500 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 dark:focus:border-primary-500 dark:focus:ring-primary-500" },
    inputClass: {}
  },
  emits: ["update:modelValue", "input", "focusout", "focusin"],
  setup(a, { expose: e, emit: t }) {
    const o = Gd(), r = a, s = t, i = B(), u = B(), d = U(() => {
      if (r.type === "number") return "decimal";
    }), m = U(() => {
      if (r.maxlength) return r.maxlength;
    }), v = (_) => {
      let P = _.target.value;
      s("input", P), r.type === "number" && !P.endsWith(".") && (P = parseFloat(P), isNaN(P) && (P = 0)), s("update:modelValue", P);
    }, p = () => {
      s("update:modelValue", "");
    };
    return e({ focus: () => {
      var _;
      return (_ = i.value) == null ? void 0 : _.focus();
    }, selectAll: () => {
      var _;
      return (_ = i.value) == null ? void 0 : _.select();
    } }), (_, P) => (j(), R("div", Wp, [
      _.label ? (j(), ne(Mt, {
        key: 0,
        name: _.name
      }, {
        default: ee(() => [
          Oe(V(_.label), 1)
        ]),
        _: 1
      }, 8, ["name"])) : te("", !0),
      A("div", Kp, [
        A("div", Qp, [
          A("div", {
            class: ae(["pointer-events-none absolute inset-y-0 flex items-center pl-3", [_.prefix ? "left-12" : "left-0"]])
          }, [
            ge(_.$slots, "left")
          ], 2),
          ge(_.$slots, "prefix", {}, () => [
            _.prefix ? (j(), R("div", Yp, V(_.prefix), 1)) : te("", !0)
          ]),
          A("input", {
            ref_key: "input",
            ref: i,
            value: _.modelValue,
            type: _.type,
            inputmode: d.value,
            onInput: v,
            name: _.name,
            id: _.name,
            class: ae(["placeholder:dark:text-dark-500 block max-w-full flex-1 border-none bg-white px-3 py-1.5 shadow-sm placeholder:text-gray-400 focus-visible:outline-none dark:text-white sm:text-sm", [`${_.prefix ? "rounded-r-md" : "rounded-md"}`, D(o).left ? "pl-9" : "", _.readonly ? "focus:outline-none focus:ring-0" : _.focusClass, _.inputClass]]),
            placeholder: _.placeholder,
            disabled: _.disabled,
            autocomplete: _.autocomplete,
            required: _.required,
            readonly: _.readonly,
            pattern: _.pattern,
            title: _.title,
            min: _.min,
            max: _.max,
            minlength: _.minlength,
            maxlength: m.value,
            onFocusin: P[0] || (P[0] = (T) => s("focusin")),
            onFocusout: P[1] || (P[1] = (T) => s("focusout"))
          }, null, 42, Xp)
        ]),
        A("div", em, [
          ge(_.$slots, "icon"),
          ge(_.$slots, "right", {}, () => [
            u.value ? (j(), ne(gs, {
              key: 0,
              placement: "top"
            }, {
              trigger: ee(() => [
                $(D(je), {
                  icon: ["fal", "triangle-exclamation"],
                  class: "h-3 w-3 flex-shrink-0 cursor-pointer text-white transition duration-200 ease-in-out"
                })
              ]),
              content: ee(() => [
                Oe(V(u.value), 1)
              ]),
              _: 1
            })) : te("", !0),
            _.clearable && _.modelValue ? (j(), ne(D(je), {
              key: 1,
              icon: ["fal", "xmark"],
              class: "dark:text-dark-400 h-3 w-3 flex-shrink-0 cursor-pointer text-gray-700 transition duration-200 ease-in-out",
              onClick: p
            })) : te("", !0)
          ])
        ])
      ])
    ]));
  }
}), tm = {
  key: 0,
  class: "flex w-32 justify-center py-1"
}, rm = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-500"
}, sm = ["onClick", "aria-selected"], yl = /* @__PURE__ */ G({
  __name: "AutocompleteTextInput",
  props: /* @__PURE__ */ lt({
    icon: {},
    noItemsText: {},
    name: {},
    label: {},
    disabled: { type: Boolean },
    searchFunction: {},
    required: { type: Boolean },
    autocomplete: {},
    clearable: { type: Boolean },
    minSearchLength: { default: 3 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ lt(["select", "update:modelValue"], ["update:modelValue"]),
  setup(a, { expose: e, emit: t }) {
    const { t: o } = At(), [r, s] = eo({
      placement: "bottom-start",
      strategy: "fixed",
      modifiers: [{ name: "offset", options: { offset: [0, 10] } }]
    }), i = a, u = t, d = bt(a, "modelValue"), m = B([]), v = B(!1), p = B(!1), g = B(null), w = (x) => {
      v.value && (x.key === "ArrowDown" ? (x.preventDefault(), g.value === null || g.value === m.value.length - 1 ? g.value = 0 : g.value += 1) : x.key === "ArrowUp" ? (x.preventDefault(), g.value === 0 || g.value === null ? g.value = m.value.length - 1 : g.value -= 1) : x.key === "Enter" && g.value !== null ? (x.preventDefault(), T(m.value[g.value])) : x.key === "Escape" && (v.value = !1));
    }, _ = (x) => x === g.value, P = Xn(async () => {
      var x;
      if (i.searchFunction) {
        if ((((x = d.value) == null ? void 0 : x.length) ?? 0) < i.minSearchLength) {
          m.value = [], v.value = !1;
          return;
        }
        p.value = !0;
        try {
          m.value = await i.searchFunction(d.value ?? ""), v.value = !0;
        } catch (C) {
          console.error(C);
        } finally {
          p.value = !1;
        }
      }
    }, 500), T = (x) => {
      u("select", x), v.value = !1;
    }, k = () => {
      var x;
      (x = r.value) == null || x.focus();
    };
    return du(r, () => v.value = !1), e({ focus: k }), (x, C) => (j(), R("div", { onKeydown: w }, [
      $(dt, {
        ref_key: "trigger",
        ref: r,
        name: x.name,
        modelValue: d.value,
        "onUpdate:modelValue": [
          C[0] || (C[0] = (I) => d.value = I),
          C[2] || (C[2] = (I) => u("update:modelValue", I))
        ],
        label: x.label,
        disabled: x.disabled,
        required: x.required,
        autocomplete: x.autocomplete,
        clearable: x.clearable,
        onInput: D(P),
        onFocusout: C[1] || (C[1] = (I) => v.value = !1),
        onFocusin: D(P)
      }, {
        prefix: ee(() => [
          ge(x.$slots, "prefix")
        ]),
        _: 3
      }, 8, ["name", "modelValue", "label", "disabled", "required", "autocomplete", "clearable", "onInput", "onFocusin"]),
      $(Kn, {
        "leave-active-class": "transition ease-in-out duration-100",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: ee(() => [
          v.value ? (j(), R("div", {
            key: 0,
            ref_key: "container",
            ref: s,
            class: "dark:ring-dark-700 absolute z-50 mt-2 max-h-60 min-w-max origin-top-right overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
          }, [
            p.value ? (j(), R("div", tm, [
              $(Ai, { class: "!h-6 !w-6 border-gray-400" })
            ])) : (j(), R(Se, { key: 1 }, [
              m.value.length === 0 ? (j(), R("div", rm, V(x.noItemsText ?? D(o)("autocomplete.no_results")), 1)) : (j(), R("div", {
                key: 1,
                class: "divide-y divide-gray-200",
                onMouseenter: C[3] || (C[3] = (I) => g.value = null)
              }, [
                (j(!0), R(Se, null, Ke(m.value, (I, z) => (j(), R("div", {
                  key: I == null ? void 0 : I.toString(),
                  onClick: (H) => T(I),
                  class: ae(["relative cursor-pointer select-none py-2 pl-3 pr-9 hover:bg-primary-600 hover:text-white", _(z) ? "bg-primary-600 text-white" : "text-gray-900"]),
                  tabindex: "0",
                  role: "option",
                  "aria-selected": _(z)
                }, [
                  ge(x.$slots, "item", { item: I }, () => [
                    Oe(V(I), 1)
                  ])
                ], 10, sm))), 128))
              ], 32))
            ], 64))
          ], 512)) : te("", !0)
        ]),
        _: 3
      })
    ], 32));
  }
});
function Zo(a, e, t) {
  let o = B(t == null ? void 0 : t.value), r = U(() => a.value !== void 0);
  return [U(() => r.value ? a.value : o.value), function(s) {
    return r.value || (o.value = s), e == null ? void 0 : e(s);
  }];
}
function Vo(a) {
  typeof queueMicrotask == "function" ? queueMicrotask(a) : Promise.resolve().then(a).catch((e) => setTimeout(() => {
    throw e;
  }));
}
function Ss() {
  let a = [], e = { addEventListener(t, o, r, s) {
    return t.addEventListener(o, r, s), e.add(() => t.removeEventListener(o, r, s));
  }, requestAnimationFrame(...t) {
    let o = requestAnimationFrame(...t);
    e.add(() => cancelAnimationFrame(o));
  }, nextFrame(...t) {
    e.requestAnimationFrame(() => {
      e.requestAnimationFrame(...t);
    });
  }, setTimeout(...t) {
    let o = setTimeout(...t);
    e.add(() => clearTimeout(o));
  }, microTask(...t) {
    let o = { current: !0 };
    return Vo(() => {
      o.current && t[0]();
    }), e.add(() => {
      o.current = !1;
    });
  }, style(t, o, r) {
    let s = t.style.getPropertyValue(o);
    return Object.assign(t.style, { [o]: r }), this.add(() => {
      Object.assign(t.style, { [o]: s });
    });
  }, group(t) {
    let o = Ss();
    return t(o), this.add(() => o.dispose());
  }, add(t) {
    return a.push(t), () => {
      let o = a.indexOf(t);
      if (o >= 0) for (let r of a.splice(o, 1)) r();
    };
  }, dispose() {
    for (let t of a.splice(0)) t();
  } };
  return e;
}
let im = Symbol("headlessui.useid"), nm = 0;
function et() {
  return Fe(im, () => `${++nm}`)();
}
function ie(a) {
  var e;
  if (a == null || a.value == null) return null;
  let t = (e = a.value.$el) != null ? e : a.value;
  return t instanceof Node ? t : null;
}
function Ye(a, e, ...t) {
  if (a in e) {
    let r = e[a];
    return typeof r == "function" ? r(...t) : r;
  }
  let o = new Error(`Tried to handle "${a}" but there is no handler defined. Only defined handlers are: ${Object.keys(e).map((r) => `"${r}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(o, Ye), o;
}
var om = Object.defineProperty, am = (a, e, t) => e in a ? om(a, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[e] = t, _l = (a, e, t) => (am(a, typeof e != "symbol" ? e + "" : e, t), t);
let lm = class {
  constructor() {
    _l(this, "current", this.detect()), _l(this, "currentId", 0);
  }
  set(e) {
    this.current !== e && (this.currentId = 0, this.current = e);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, Ts = new lm();
function Lt(a) {
  if (Ts.isServer) return null;
  if (a instanceof Node) return a.ownerDocument;
  if (a != null && a.hasOwnProperty("value")) {
    let e = ie(a);
    if (e) return e.ownerDocument;
  }
  return document;
}
let Mn = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((a) => `${a}:not([tabindex='-1'])`).join(",");
var ct = ((a) => (a[a.First = 1] = "First", a[a.Previous = 2] = "Previous", a[a.Next = 4] = "Next", a[a.Last = 8] = "Last", a[a.WrapAround = 16] = "WrapAround", a[a.NoScroll = 32] = "NoScroll", a))(ct || {}), yi = ((a) => (a[a.Error = 0] = "Error", a[a.Overflow = 1] = "Overflow", a[a.Success = 2] = "Success", a[a.Underflow = 3] = "Underflow", a))(yi || {}), um = ((a) => (a[a.Previous = -1] = "Previous", a[a.Next = 1] = "Next", a))(um || {});
function mc(a = document.body) {
  return a == null ? [] : Array.from(a.querySelectorAll(Mn)).sort((e, t) => Math.sign((e.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var Oi = ((a) => (a[a.Strict = 0] = "Strict", a[a.Loose = 1] = "Loose", a))(Oi || {});
function ki(a, e = 0) {
  var t;
  return a === ((t = Lt(a)) == null ? void 0 : t.body) ? !1 : Ye(e, { 0() {
    return a.matches(Mn);
  }, 1() {
    let o = a;
    for (; o !== null; ) {
      if (o.matches(Mn)) return !0;
      o = o.parentElement;
    }
    return !1;
  } });
}
function vc(a) {
  let e = Lt(a);
  it(() => {
    e && !ki(e.activeElement, 0) && tr(a);
  });
}
var cm = ((a) => (a[a.Keyboard = 0] = "Keyboard", a[a.Mouse = 1] = "Mouse", a))(cm || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (a) => {
  a.metaKey || a.altKey || a.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (a) => {
  a.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : a.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function tr(a) {
  a == null || a.focus({ preventScroll: !0 });
}
let hm = ["textarea", "input"].join(",");
function dm(a) {
  var e, t;
  return (t = (e = a == null ? void 0 : a.matches) == null ? void 0 : e.call(a, hm)) != null ? t : !1;
}
function Ii(a, e = (t) => t) {
  return a.slice().sort((t, o) => {
    let r = e(t), s = e(o);
    if (r === null || s === null) return 0;
    let i = r.compareDocumentPosition(s);
    return i & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : i & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function fm(a, e) {
  return Pr(mc(), e, { relativeTo: a });
}
function Pr(a, e, { sorted: t = !0, relativeTo: o = null, skipElements: r = [] } = {}) {
  var s;
  let i = (s = Array.isArray(a) ? a.length > 0 ? a[0].ownerDocument : document : a == null ? void 0 : a.ownerDocument) != null ? s : document, u = Array.isArray(a) ? t ? Ii(a) : a : mc(a);
  r.length > 0 && u.length > 1 && (u = u.filter((_) => !r.includes(_))), o = o ?? i.activeElement;
  let d = (() => {
    if (e & 5) return 1;
    if (e & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), m = (() => {
    if (e & 1) return 0;
    if (e & 2) return Math.max(0, u.indexOf(o)) - 1;
    if (e & 4) return Math.max(0, u.indexOf(o)) + 1;
    if (e & 8) return u.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), v = e & 32 ? { preventScroll: !0 } : {}, p = 0, g = u.length, w;
  do {
    if (p >= g || p + g <= 0) return 0;
    let _ = m + p;
    if (e & 16) _ = (_ + g) % g;
    else {
      if (_ < 0) return 3;
      if (_ >= g) return 1;
    }
    w = u[_], w == null || w.focus(v), p += d;
  } while (w !== i.activeElement);
  return e & 6 && dm(w) && w.select(), 2;
}
function gc() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function pm() {
  return /Android/gi.test(window.navigator.userAgent);
}
function mm() {
  return gc() || pm();
}
function Qs(a, e, t) {
  Ts.isServer || nt((o) => {
    document.addEventListener(a, e, t), o(() => document.removeEventListener(a, e, t));
  });
}
function yc(a, e, t) {
  Ts.isServer || nt((o) => {
    window.addEventListener(a, e, t), o(() => window.removeEventListener(a, e, t));
  });
}
function $o(a, e, t = U(() => !0)) {
  function o(s, i) {
    if (!t.value || s.defaultPrevented) return;
    let u = i(s);
    if (u === null || !u.getRootNode().contains(u)) return;
    let d = function m(v) {
      return typeof v == "function" ? m(v()) : Array.isArray(v) || v instanceof Set ? v : [v];
    }(a);
    for (let m of d) {
      if (m === null) continue;
      let v = m instanceof HTMLElement ? m : ie(m);
      if (v != null && v.contains(u) || s.composed && s.composedPath().includes(v)) return;
    }
    return !ki(u, Oi.Loose) && u.tabIndex !== -1 && s.preventDefault(), e(s, u);
  }
  let r = B(null);
  Qs("pointerdown", (s) => {
    var i, u;
    t.value && (r.value = ((u = (i = s.composedPath) == null ? void 0 : i.call(s)) == null ? void 0 : u[0]) || s.target);
  }, !0), Qs("mousedown", (s) => {
    var i, u;
    t.value && (r.value = ((u = (i = s.composedPath) == null ? void 0 : i.call(s)) == null ? void 0 : u[0]) || s.target);
  }, !0), Qs("click", (s) => {
    mm() || r.value && (o(s, () => r.value), r.value = null);
  }, !0), Qs("touchend", (s) => o(s, () => s.target instanceof HTMLElement ? s.target : null), !0), yc("blur", (s) => o(s, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function bl(a, e) {
  if (a) return a;
  let t = e ?? "button";
  if (typeof t == "string" && t.toLowerCase() === "button") return "button";
}
function Fo(a, e) {
  let t = B(bl(a.value.type, a.value.as));
  return Ee(() => {
    t.value = bl(a.value.type, a.value.as);
  }), nt(() => {
    var o;
    t.value || ie(e) && ie(e) instanceof HTMLButtonElement && !((o = ie(e)) != null && o.hasAttribute("type")) && (t.value = "button");
  }), t;
}
function wl(a) {
  return [a.screenX, a.screenY];
}
function _c() {
  let a = B([-1, -1]);
  return { wasMoved(e) {
    let t = wl(e);
    return a.value[0] === t[0] && a.value[1] === t[1] ? !1 : (a.value = t, !0);
  }, update(e) {
    a.value = wl(e);
  } };
}
function bc({ container: a, accept: e, walk: t, enabled: o }) {
  nt(() => {
    let r = a.value;
    if (!r || o !== void 0 && !o.value) return;
    let s = Lt(a);
    if (!s) return;
    let i = Object.assign((d) => e(d), { acceptNode: e }), u = s.createTreeWalker(r, NodeFilter.SHOW_ELEMENT, i, !1);
    for (; u.nextNode(); ) t(u.currentNode);
  });
}
var rr = ((a) => (a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a))(rr || {}), Yt = ((a) => (a[a.Unmount = 0] = "Unmount", a[a.Hidden = 1] = "Hidden", a))(Yt || {});
function Ne({ visible: a = !0, features: e = 0, ourProps: t, theirProps: o, ...r }) {
  var s;
  let i = Pc(o, t), u = Object.assign(r, { props: i });
  if (a || e & 2 && i.static) return Tn(u);
  if (e & 1) {
    let d = (s = i.unmount) == null || s ? 0 : 1;
    return Ye(d, { 0() {
      return null;
    }, 1() {
      return Tn({ ...r, props: { ...i, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Tn(u);
}
function Tn({ props: a, attrs: e, slots: t, slot: o, name: r }) {
  var s, i;
  let { as: u, ...d } = Ls(a, ["unmount", "static"]), m = (s = t.default) == null ? void 0 : s.call(t, o), v = {};
  if (o) {
    let p = !1, g = [];
    for (let [w, _] of Object.entries(o)) typeof _ == "boolean" && (p = !0), _ === !0 && g.push(w);
    p && (v["data-headlessui-state"] = g.join(" "));
  }
  if (u === "template") {
    if (m = wc(m ?? []), Object.keys(d).length > 0 || Object.keys(e).length > 0) {
      let [p, ...g] = m ?? [];
      if (!vm(p) || g.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${r} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(d).concat(Object.keys(e)).map((P) => P.trim()).filter((P, T, k) => k.indexOf(P) === T).sort((P, T) => P.localeCompare(T)).map((P) => `  - ${P}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((P) => `  - ${P}`).join(`
`)].join(`
`));
      let w = Pc((i = p.props) != null ? i : {}, d, v), _ = Hd(p, w, !0);
      for (let P in w) P.startsWith("on") && (_.props || (_.props = {}), _.props[P] = w[P]);
      return _;
    }
    return Array.isArray(m) && m.length === 1 ? m[0] : m;
  }
  return qe(u, Object.assign({}, d, v), { default: () => m });
}
function wc(a) {
  return a.flatMap((e) => e.type === Se ? wc(e.children) : [e]);
}
function Pc(...a) {
  if (a.length === 0) return {};
  if (a.length === 1) return a[0];
  let e = {}, t = {};
  for (let o of a) for (let r in o) r.startsWith("on") && typeof o[r] == "function" ? (t[r] != null || (t[r] = []), t[r].push(o[r])) : e[r] = o[r];
  if (e.disabled || e["aria-disabled"]) return Object.assign(e, Object.fromEntries(Object.keys(t).map((o) => [o, void 0])));
  for (let o in t) Object.assign(e, { [o](r, ...s) {
    let i = t[o];
    for (let u of i) {
      if (r instanceof Event && r.defaultPrevented) return;
      u(r, ...s);
    }
  } });
  return e;
}
function Go(a) {
  let e = Object.assign({}, a);
  for (let t in e) e[t] === void 0 && delete e[t];
  return e;
}
function Ls(a, e = []) {
  let t = Object.assign({}, a);
  for (let o of e) o in t && delete t[o];
  return t;
}
function vm(a) {
  return a == null ? !1 : typeof a.type == "string" || typeof a.type == "object" || typeof a.type == "function";
}
var xr = ((a) => (a[a.None = 1] = "None", a[a.Focusable = 2] = "Focusable", a[a.Hidden = 4] = "Hidden", a))(xr || {});
let Rr = G({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(a, { slots: e, attrs: t }) {
  return () => {
    var o;
    let { features: r, ...s } = a, i = { "aria-hidden": (r & 2) === 2 ? !0 : (o = s["aria-hidden"]) != null ? o : void 0, hidden: (r & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
    return Ne({ ourProps: i, theirProps: s, slot: {}, attrs: t, slots: e, name: "Hidden" });
  };
} }), xc = Symbol("Context");
var $e = ((a) => (a[a.Open = 1] = "Open", a[a.Closed = 2] = "Closed", a[a.Closing = 4] = "Closing", a[a.Opening = 8] = "Opening", a))($e || {});
function gm() {
  return Cs() !== null;
}
function Cs() {
  return Fe(xc, null);
}
function Ho(a) {
  Qe(xc, a);
}
var de = ((a) => (a.Space = " ", a.Enter = "Enter", a.Escape = "Escape", a.Backspace = "Backspace", a.Delete = "Delete", a.ArrowLeft = "ArrowLeft", a.ArrowUp = "ArrowUp", a.ArrowRight = "ArrowRight", a.ArrowDown = "ArrowDown", a.Home = "Home", a.End = "End", a.PageUp = "PageUp", a.PageDown = "PageDown", a.Tab = "Tab", a))(de || {});
function ym(a) {
  function e() {
    document.readyState !== "loading" && (a(), document.removeEventListener("DOMContentLoaded", e));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", e), e());
}
let fr = [];
ym(() => {
  function a(e) {
    e.target instanceof HTMLElement && e.target !== document.body && fr[0] !== e.target && (fr.unshift(e.target), fr = fr.filter((t) => t != null && t.isConnected), fr.splice(10));
  }
  window.addEventListener("click", a, { capture: !0 }), window.addEventListener("mousedown", a, { capture: !0 }), window.addEventListener("focus", a, { capture: !0 }), document.body.addEventListener("click", a, { capture: !0 }), document.body.addEventListener("mousedown", a, { capture: !0 }), document.body.addEventListener("focus", a, { capture: !0 });
});
function _m(a) {
  throw new Error("Unexpected object: " + a);
}
var Me = ((a) => (a[a.First = 0] = "First", a[a.Previous = 1] = "Previous", a[a.Next = 2] = "Next", a[a.Last = 3] = "Last", a[a.Specific = 4] = "Specific", a[a.Nothing = 5] = "Nothing", a))(Me || {});
function Sc(a, e) {
  let t = e.resolveItems();
  if (t.length <= 0) return null;
  let o = e.resolveActiveIndex(), r = o ?? -1;
  switch (a.focus) {
    case 0: {
      for (let s = 0; s < t.length; ++s) if (!e.resolveDisabled(t[s], s, t)) return s;
      return o;
    }
    case 1: {
      r === -1 && (r = t.length);
      for (let s = r - 1; s >= 0; --s) if (!e.resolveDisabled(t[s], s, t)) return s;
      return o;
    }
    case 2: {
      for (let s = r + 1; s < t.length; ++s) if (!e.resolveDisabled(t[s], s, t)) return s;
      return o;
    }
    case 3: {
      for (let s = t.length - 1; s >= 0; --s) if (!e.resolveDisabled(t[s], s, t)) return s;
      return o;
    }
    case 4: {
      for (let s = 0; s < t.length; ++s) if (e.resolveId(t[s], s, t) === a.id) return s;
      return o;
    }
    case 5:
      return null;
    default:
      _m(a);
  }
}
function Wo(a = {}, e = null, t = []) {
  for (let [o, r] of Object.entries(a)) Lc(t, Tc(e, o), r);
  return t;
}
function Tc(a, e) {
  return a ? a + "[" + e + "]" : e;
}
function Lc(a, e, t) {
  if (Array.isArray(t)) for (let [o, r] of t.entries()) Lc(a, Tc(e, o.toString()), r);
  else t instanceof Date ? a.push([e, t.toISOString()]) : typeof t == "boolean" ? a.push([e, t ? "1" : "0"]) : typeof t == "string" ? a.push([e, t]) : typeof t == "number" ? a.push([e, `${t}`]) : t == null ? a.push([e, ""]) : Wo(t, e, a);
}
function Cc(a) {
  var e, t;
  let o = (e = a == null ? void 0 : a.form) != null ? e : a.closest("form");
  if (o) {
    for (let r of o.elements) if (r !== a && (r.tagName === "INPUT" && r.type === "submit" || r.tagName === "BUTTON" && r.type === "submit" || r.nodeName === "INPUT" && r.type === "image")) {
      r.click();
      return;
    }
    (t = o.requestSubmit) == null || t.call(o);
  }
}
function Ac(a, e, t, o) {
  Ts.isServer || nt((r) => {
    a = a ?? window, a.addEventListener(e, t, o), r(() => a.removeEventListener(e, t, o));
  });
}
var fs = ((a) => (a[a.Forwards = 0] = "Forwards", a[a.Backwards = 1] = "Backwards", a))(fs || {});
function bm() {
  let a = B(0);
  return yc("keydown", (e) => {
    e.key === "Tab" && (a.value = e.shiftKey ? 1 : 0);
  }), a;
}
function Oc(a) {
  if (!a) return /* @__PURE__ */ new Set();
  if (typeof a == "function") return new Set(a());
  let e = /* @__PURE__ */ new Set();
  for (let t of a.value) {
    let o = ie(t);
    o instanceof HTMLElement && e.add(o);
  }
  return e;
}
var kc = ((a) => (a[a.None = 1] = "None", a[a.InitialFocus = 2] = "InitialFocus", a[a.TabLock = 4] = "TabLock", a[a.FocusLock = 8] = "FocusLock", a[a.RestoreFocus = 16] = "RestoreFocus", a[a.All = 30] = "All", a))(kc || {});
let us = Object.assign(G({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: B(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(a, { attrs: e, slots: t, expose: o }) {
  let r = B(null);
  o({ el: r, $el: r });
  let s = U(() => Lt(r)), i = B(!1);
  Ee(() => i.value = !0), rt(() => i.value = !1), Pm({ ownerDocument: s }, U(() => i.value && !!(a.features & 16)));
  let u = xm({ ownerDocument: s, container: r, initialFocus: U(() => a.initialFocus) }, U(() => i.value && !!(a.features & 2)));
  Sm({ ownerDocument: s, container: r, containers: a.containers, previousActiveElement: u }, U(() => i.value && !!(a.features & 8)));
  let d = bm();
  function m(w) {
    let _ = ie(r);
    _ && ((P) => P())(() => {
      Ye(d.value, { [fs.Forwards]: () => {
        Pr(_, ct.First, { skipElements: [w.relatedTarget] });
      }, [fs.Backwards]: () => {
        Pr(_, ct.Last, { skipElements: [w.relatedTarget] });
      } });
    });
  }
  let v = B(!1);
  function p(w) {
    w.key === "Tab" && (v.value = !0, requestAnimationFrame(() => {
      v.value = !1;
    }));
  }
  function g(w) {
    if (!i.value) return;
    let _ = Oc(a.containers);
    ie(r) instanceof HTMLElement && _.add(ie(r));
    let P = w.relatedTarget;
    P instanceof HTMLElement && P.dataset.headlessuiFocusGuard !== "true" && (Ic(_, P) || (v.value ? Pr(ie(r), Ye(d.value, { [fs.Forwards]: () => ct.Next, [fs.Backwards]: () => ct.Previous }) | ct.WrapAround, { relativeTo: w.target }) : w.target instanceof HTMLElement && tr(w.target)));
  }
  return () => {
    let w = {}, _ = { ref: r, onKeydown: p, onFocusout: g }, { features: P, initialFocus: T, containers: k, ...x } = a;
    return qe(Se, [!!(P & 4) && qe(Rr, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: m, features: xr.Focusable }), Ne({ ourProps: _, theirProps: { ...e, ...x }, slot: w, attrs: e, slots: t, name: "FocusTrap" }), !!(P & 4) && qe(Rr, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: m, features: xr.Focusable })]);
  };
} }), { features: kc });
function wm(a) {
  let e = B(fr.slice());
  return Ie([a], ([t], [o]) => {
    o === !0 && t === !1 ? Vo(() => {
      e.value.splice(0);
    }) : o === !1 && t === !0 && (e.value = fr.slice());
  }, { flush: "post" }), () => {
    var t;
    return (t = e.value.find((o) => o != null && o.isConnected)) != null ? t : null;
  };
}
function Pm({ ownerDocument: a }, e) {
  let t = wm(e);
  Ee(() => {
    nt(() => {
      var o, r;
      e.value || ((o = a.value) == null ? void 0 : o.activeElement) === ((r = a.value) == null ? void 0 : r.body) && tr(t());
    }, { flush: "post" });
  }), rt(() => {
    e.value && tr(t());
  });
}
function xm({ ownerDocument: a, container: e, initialFocus: t }, o) {
  let r = B(null), s = B(!1);
  return Ee(() => s.value = !0), rt(() => s.value = !1), Ee(() => {
    Ie([e, t, o], (i, u) => {
      if (i.every((m, v) => (u == null ? void 0 : u[v]) === m) || !o.value) return;
      let d = ie(e);
      d && Vo(() => {
        var m, v;
        if (!s.value) return;
        let p = ie(t), g = (m = a.value) == null ? void 0 : m.activeElement;
        if (p) {
          if (p === g) {
            r.value = g;
            return;
          }
        } else if (d.contains(g)) {
          r.value = g;
          return;
        }
        p ? tr(p) : Pr(d, ct.First | ct.NoScroll) === yi.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), r.value = (v = a.value) == null ? void 0 : v.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), r;
}
function Sm({ ownerDocument: a, container: e, containers: t, previousActiveElement: o }, r) {
  var s;
  Ac((s = a.value) == null ? void 0 : s.defaultView, "focus", (i) => {
    if (!r.value) return;
    let u = Oc(t);
    ie(e) instanceof HTMLElement && u.add(ie(e));
    let d = o.value;
    if (!d) return;
    let m = i.target;
    m && m instanceof HTMLElement ? Ic(u, m) ? (o.value = m, tr(m)) : (i.preventDefault(), i.stopPropagation(), tr(d)) : tr(o.value);
  }, !0);
}
function Ic(a, e) {
  for (let t of a) if (t.contains(e)) return !0;
  return !1;
}
function Tm(a) {
  let e = Wd(a.getSnapshot());
  return rt(a.subscribe(() => {
    e.value = a.getSnapshot();
  })), e;
}
function Lm(a, e) {
  let t = a(), o = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return t;
  }, subscribe(r) {
    return o.add(r), () => o.delete(r);
  }, dispatch(r, ...s) {
    let i = e[r].call(t, ...s);
    i && (t = i, o.forEach((u) => u()));
  } };
}
function Cm() {
  let a;
  return { before({ doc: e }) {
    var t;
    let o = e.documentElement;
    a = ((t = e.defaultView) != null ? t : window).innerWidth - o.clientWidth;
  }, after({ doc: e, d: t }) {
    let o = e.documentElement, r = o.clientWidth - o.offsetWidth, s = a - r;
    t.style(o, "paddingRight", `${s}px`);
  } };
}
function Am() {
  return gc() ? { before({ doc: a, d: e, meta: t }) {
    function o(r) {
      return t.containers.flatMap((s) => s()).some((s) => s.contains(r));
    }
    e.microTask(() => {
      var r;
      if (window.getComputedStyle(a.documentElement).scrollBehavior !== "auto") {
        let u = Ss();
        u.style(a.documentElement, "scrollBehavior", "auto"), e.add(() => e.microTask(() => u.dispose()));
      }
      let s = (r = window.scrollY) != null ? r : window.pageYOffset, i = null;
      e.addEventListener(a, "click", (u) => {
        if (u.target instanceof HTMLElement) try {
          let d = u.target.closest("a");
          if (!d) return;
          let { hash: m } = new URL(d.href), v = a.querySelector(m);
          v && !o(v) && (i = v);
        } catch {
        }
      }, !0), e.addEventListener(a, "touchstart", (u) => {
        if (u.target instanceof HTMLElement) if (o(u.target)) {
          let d = u.target;
          for (; d.parentElement && o(d.parentElement); ) d = d.parentElement;
          e.style(d, "overscrollBehavior", "contain");
        } else e.style(u.target, "touchAction", "none");
      }), e.addEventListener(a, "touchmove", (u) => {
        if (u.target instanceof HTMLElement) {
          if (u.target.tagName === "INPUT") return;
          if (o(u.target)) {
            let d = u.target;
            for (; d.parentElement && d.dataset.headlessuiPortal !== "" && !(d.scrollHeight > d.clientHeight || d.scrollWidth > d.clientWidth); ) d = d.parentElement;
            d.dataset.headlessuiPortal === "" && u.preventDefault();
          } else u.preventDefault();
        }
      }, { passive: !1 }), e.add(() => {
        var u;
        let d = (u = window.scrollY) != null ? u : window.pageYOffset;
        s !== d && window.scrollTo(0, s), i && i.isConnected && (i.scrollIntoView({ block: "nearest" }), i = null);
      });
    });
  } } : {};
}
function Om() {
  return { before({ doc: a, d: e }) {
    e.style(a.documentElement, "overflow", "hidden");
  } };
}
function km(a) {
  let e = {};
  for (let t of a) Object.assign(e, t(e));
  return e;
}
let mr = Lm(() => /* @__PURE__ */ new Map(), { PUSH(a, e) {
  var t;
  let o = (t = this.get(a)) != null ? t : { doc: a, count: 0, d: Ss(), meta: /* @__PURE__ */ new Set() };
  return o.count++, o.meta.add(e), this.set(a, o), this;
}, POP(a, e) {
  let t = this.get(a);
  return t && (t.count--, t.meta.delete(e)), this;
}, SCROLL_PREVENT({ doc: a, d: e, meta: t }) {
  let o = { doc: a, d: e, meta: km(t) }, r = [Am(), Cm(), Om()];
  r.forEach(({ before: s }) => s == null ? void 0 : s(o)), r.forEach(({ after: s }) => s == null ? void 0 : s(o));
}, SCROLL_ALLOW({ d: a }) {
  a.dispose();
}, TEARDOWN({ doc: a }) {
  this.delete(a);
} });
mr.subscribe(() => {
  let a = mr.getSnapshot(), e = /* @__PURE__ */ new Map();
  for (let [t] of a) e.set(t, t.documentElement.style.overflow);
  for (let t of a.values()) {
    let o = e.get(t.doc) === "hidden", r = t.count !== 0;
    (r && !o || !r && o) && mr.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && mr.dispatch("TEARDOWN", t);
  }
});
function Im(a, e, t) {
  let o = Tm(mr), r = U(() => {
    let s = a.value ? o.value.get(a.value) : void 0;
    return s ? s.count > 0 : !1;
  });
  return Ie([a, e], ([s, i], [u], d) => {
    if (!s || !i) return;
    mr.dispatch("PUSH", s, t);
    let m = !1;
    d(() => {
      m || (mr.dispatch("POP", u ?? s, t), m = !0);
    });
  }, { immediate: !0 }), r;
}
let Ln = /* @__PURE__ */ new Map(), cs = /* @__PURE__ */ new Map();
function Pl(a, e = B(!0)) {
  nt((t) => {
    var o;
    if (!e.value) return;
    let r = ie(a);
    if (!r) return;
    t(function() {
      var i;
      if (!r) return;
      let u = (i = cs.get(r)) != null ? i : 1;
      if (u === 1 ? cs.delete(r) : cs.set(r, u - 1), u !== 1) return;
      let d = Ln.get(r);
      d && (d["aria-hidden"] === null ? r.removeAttribute("aria-hidden") : r.setAttribute("aria-hidden", d["aria-hidden"]), r.inert = d.inert, Ln.delete(r));
    });
    let s = (o = cs.get(r)) != null ? o : 0;
    cs.set(r, s + 1), s === 0 && (Ln.set(r, { "aria-hidden": r.getAttribute("aria-hidden"), inert: r.inert }), r.setAttribute("aria-hidden", "true"), r.inert = !0);
  });
}
function jm({ defaultContainers: a = [], portals: e, mainTreeNodeRef: t } = {}) {
  let o = B(null), r = Lt(o);
  function s() {
    var i, u, d;
    let m = [];
    for (let v of a) v !== null && (v instanceof HTMLElement ? m.push(v) : "value" in v && v.value instanceof HTMLElement && m.push(v.value));
    if (e != null && e.value) for (let v of e.value) m.push(v);
    for (let v of (i = r == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? i : []) v !== document.body && v !== document.head && v instanceof HTMLElement && v.id !== "headlessui-portal-root" && (v.contains(ie(o)) || v.contains((d = (u = ie(o)) == null ? void 0 : u.getRootNode()) == null ? void 0 : d.host) || m.some((p) => v.contains(p)) || m.push(v));
    return m;
  }
  return { resolveContainers: s, contains(i) {
    return s().some((u) => u.contains(i));
  }, mainTreeNodeRef: o, MainTreeNode() {
    return t != null ? null : qe(Rr, { features: xr.Hidden, ref: o });
  } };
}
let jc = Symbol("ForcePortalRootContext");
function Em() {
  return Fe(jc, !1);
}
let Nn = G({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(a, { slots: e, attrs: t }) {
  return Qe(jc, a.force), () => {
    let { force: o, ...r } = a;
    return Ne({ theirProps: r, ourProps: {}, slot: {}, slots: e, attrs: t, name: "ForcePortalRoot" });
  };
} }), Ec = Symbol("StackContext");
var Jn = ((a) => (a[a.Add = 0] = "Add", a[a.Remove = 1] = "Remove", a))(Jn || {});
function Dm() {
  return Fe(Ec, () => {
  });
}
function Mm({ type: a, enabled: e, element: t, onUpdate: o }) {
  let r = Dm();
  function s(...i) {
    o == null || o(...i), r(...i);
  }
  Ee(() => {
    Ie(e, (i, u) => {
      i ? s(0, a, t) : u === !0 && s(1, a, t);
    }, { immediate: !0, flush: "sync" });
  }), rt(() => {
    e.value && s(1, a, t);
  }), Qe(Ec, s);
}
let Dc = Symbol("DescriptionContext");
function Nm() {
  let a = Fe(Dc, null);
  if (a === null) throw new Error("Missing parent");
  return a;
}
function ji({ slot: a = B({}), name: e = "Description", props: t = {} } = {}) {
  let o = B([]);
  function r(s) {
    return o.value.push(s), () => {
      let i = o.value.indexOf(s);
      i !== -1 && o.value.splice(i, 1);
    };
  }
  return Qe(Dc, { register: r, slot: a, name: e, props: t }), U(() => o.value.length > 0 ? o.value.join(" ") : void 0);
}
G({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(a, { attrs: e, slots: t }) {
  var o;
  let r = (o = a.id) != null ? o : `headlessui-description-${et()}`, s = Nm();
  return Ee(() => rt(s.register(r))), () => {
    let { name: i = "Description", slot: u = B({}), props: d = {} } = s, { ...m } = a, v = { ...Object.entries(d).reduce((p, [g, w]) => Object.assign(p, { [g]: D(w) }), {}), id: r };
    return Ne({ ourProps: v, theirProps: m, slot: u.value, attrs: e, slots: t, name: i });
  };
} });
function Jm(a) {
  let e = Lt(a);
  if (!e) {
    if (a === null) return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${a}`);
  }
  let t = e.getElementById("headlessui-portal-root");
  if (t) return t;
  let o = e.createElement("div");
  return o.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(o);
}
const Un = /* @__PURE__ */ new WeakMap();
function Um(a) {
  var e;
  return (e = Un.get(a)) != null ? e : 0;
}
function xl(a, e) {
  let t = e(Um(a));
  return t <= 0 ? Un.delete(a) : Un.set(a, t), t;
}
let Mc = G({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(a, { slots: e, attrs: t }) {
  let o = B(null), r = U(() => Lt(o)), s = Em(), i = Fe(Nc, null), u = B(s === !0 || i == null ? Jm(o.value) : i.resolveTarget());
  u.value && xl(u.value, (g) => g + 1);
  let d = B(!1);
  Ee(() => {
    d.value = !0;
  }), nt(() => {
    s || i != null && (u.value = i.resolveTarget());
  });
  let m = Fe(Bn, null), v = !1, p = Kd();
  return Ie(o, () => {
    if (v || !m) return;
    let g = ie(o);
    g && (rt(m.register(g), p), v = !0);
  }), rt(() => {
    var g, w;
    let _ = (g = r.value) == null ? void 0 : g.getElementById("headlessui-portal-root");
    !_ || u.value !== _ || xl(u.value, (P) => P - 1) || u.value.children.length > 0 || (w = u.value.parentElement) == null || w.removeChild(u.value);
  }), () => {
    if (!d.value || u.value === null) return null;
    let g = { ref: o, "data-headlessui-portal": "" };
    return qe(Qn, { to: u.value }, Ne({ ourProps: g, theirProps: a, slot: {}, attrs: t, slots: e, name: "Portal" }));
  };
} }), Bn = Symbol("PortalParentContext");
function Bm() {
  let a = Fe(Bn, null), e = B([]);
  function t(s) {
    return e.value.push(s), a && a.register(s), () => o(s);
  }
  function o(s) {
    let i = e.value.indexOf(s);
    i !== -1 && e.value.splice(i, 1), a && a.unregister(s);
  }
  let r = { register: t, unregister: o, portals: e };
  return [e, G({ name: "PortalWrapper", setup(s, { slots: i }) {
    return Qe(Bn, r), () => {
      var u;
      return (u = i.default) == null ? void 0 : u.call(i);
    };
  } })];
}
let Nc = Symbol("PortalGroupContext"), Rm = G({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(a, { attrs: e, slots: t }) {
  let o = Qd({ resolveTarget() {
    return a.target;
  } });
  return Qe(Nc, o), () => {
    let { target: r, ...s } = a;
    return Ne({ theirProps: s, ourProps: {}, slot: {}, attrs: e, slots: t, name: "PortalGroup" });
  };
} });
var zm = ((a) => (a[a.Open = 0] = "Open", a[a.Closed = 1] = "Closed", a))(zm || {});
let Rn = Symbol("DialogContext");
function As(a) {
  let e = Fe(Rn, null);
  if (e === null) {
    let t = new Error(`<${a} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, As), t;
  }
  return e;
}
let Ys = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", Jc = G({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: Ys }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (a) => !0 }, setup(a, { emit: e, attrs: t, slots: o, expose: r }) {
  var s, i;
  let u = (s = a.id) != null ? s : `headlessui-dialog-${et()}`, d = B(!1);
  Ee(() => {
    d.value = !0;
  });
  let m = !1, v = U(() => a.role === "dialog" || a.role === "alertdialog" ? a.role : (m || (m = !0, console.warn(`Invalid role [${v}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), p = B(0), g = Cs(), w = U(() => a.open === Ys && g !== null ? (g.value & $e.Open) === $e.Open : a.open), _ = B(null), P = U(() => Lt(_));
  if (r({ el: _, $el: _ }), !(a.open !== Ys || g !== null)) throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof w.value != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${w.value === Ys ? void 0 : a.open}`);
  let T = U(() => d.value && w.value ? 0 : 1), k = U(() => T.value === 0), x = U(() => p.value > 1), C = Fe(Rn, null) !== null, [I, z] = Bm(), { resolveContainers: H, mainTreeNodeRef: F, MainTreeNode: se } = jm({ portals: I, defaultContainers: [U(() => {
    var Q;
    return (Q = ot.panelRef.value) != null ? Q : _.value;
  })] }), pe = U(() => x.value ? "parent" : "leaf"), Te = U(() => g !== null ? (g.value & $e.Closing) === $e.Closing : !1), W = U(() => C || Te.value ? !1 : k.value), Y = U(() => {
    var Q, be, De;
    return (De = Array.from((be = (Q = P.value) == null ? void 0 : Q.querySelectorAll("body > *")) != null ? be : []).find((Le) => Le.id === "headlessui-portal-root" ? !1 : Le.contains(ie(F)) && Le instanceof HTMLElement)) != null ? De : null;
  });
  Pl(Y, W);
  let X = U(() => x.value ? !0 : k.value), Z = U(() => {
    var Q, be, De;
    return (De = Array.from((be = (Q = P.value) == null ? void 0 : Q.querySelectorAll("[data-headlessui-portal]")) != null ? be : []).find((Le) => Le.contains(ie(F)) && Le instanceof HTMLElement)) != null ? De : null;
  });
  Pl(Z, X), Mm({ type: "Dialog", enabled: U(() => T.value === 0), element: _, onUpdate: (Q, be) => {
    if (be === "Dialog") return Ye(Q, { [Jn.Add]: () => p.value += 1, [Jn.Remove]: () => p.value -= 1 });
  } });
  let he = ji({ name: "DialogDescription", slot: U(() => ({ open: w.value })) }), Pe = B(null), ot = { titleId: Pe, panelRef: B(null), dialogState: T, setTitleId(Q) {
    Pe.value !== Q && (Pe.value = Q);
  }, close() {
    e("close", !1);
  } };
  Qe(Rn, ot);
  let ue = U(() => !(!k.value || x.value));
  $o(H, (Q, be) => {
    Q.preventDefault(), ot.close(), it(() => be == null ? void 0 : be.focus());
  }, ue);
  let Gt = U(() => !(x.value || T.value !== 0));
  Ac((i = P.value) == null ? void 0 : i.defaultView, "keydown", (Q) => {
    Gt.value && (Q.defaultPrevented || Q.key === de.Escape && (Q.preventDefault(), Q.stopPropagation(), ot.close()));
  });
  let J = U(() => !(Te.value || T.value !== 0 || C));
  return Im(P, J, (Q) => {
    var be;
    return { containers: [...(be = Q.containers) != null ? be : [], H] };
  }), nt((Q) => {
    if (T.value !== 0) return;
    let be = ie(_);
    if (!be) return;
    let De = new ResizeObserver((Le) => {
      for (let Ce of Le) {
        let ve = Ce.target.getBoundingClientRect();
        ve.x === 0 && ve.y === 0 && ve.width === 0 && ve.height === 0 && ot.close();
      }
    });
    De.observe(be), Q(() => De.disconnect());
  }), () => {
    let { open: Q, initialFocus: be, ...De } = a, Le = { ...t, ref: _, id: u, role: v.value, "aria-modal": T.value === 0 ? !0 : void 0, "aria-labelledby": Pe.value, "aria-describedby": he.value }, Ce = { open: T.value === 0 };
    return qe(Nn, { force: !0 }, () => [qe(Mc, () => qe(Rm, { target: _.value }, () => qe(Nn, { force: !1 }, () => qe(us, { initialFocus: be, containers: H, features: k.value ? Ye(pe.value, { parent: us.features.RestoreFocus, leaf: us.features.All & ~us.features.FocusLock }) : us.features.None }, () => qe(z, {}, () => Ne({ ourProps: Le, theirProps: { ...De, ...t }, slot: Ce, attrs: t, slots: o, visible: T.value === 0, features: rr.RenderStrategy | rr.Static, name: "Dialog" })))))), qe(se)]);
  };
} });
G({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(a, { attrs: e, slots: t }) {
  var o;
  let r = (o = a.id) != null ? o : `headlessui-dialog-overlay-${et()}`, s = As("DialogOverlay");
  function i(u) {
    u.target === u.currentTarget && (u.preventDefault(), u.stopPropagation(), s.close());
  }
  return () => {
    let { ...u } = a;
    return Ne({ ourProps: { id: r, "aria-hidden": !0, onClick: i }, theirProps: u, slot: { open: s.dialogState.value === 0 }, attrs: e, slots: t, name: "DialogOverlay" });
  };
} });
G({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(a, { attrs: e, slots: t, expose: o }) {
  var r;
  let s = (r = a.id) != null ? r : `headlessui-dialog-backdrop-${et()}`, i = As("DialogBackdrop"), u = B(null);
  return o({ el: u, $el: u }), Ee(() => {
    if (i.panelRef.value === null) throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...d } = a, m = { id: s, ref: u, "aria-hidden": !0 };
    return qe(Nn, { force: !0 }, () => qe(Mc, () => Ne({ ourProps: m, theirProps: { ...e, ...d }, slot: { open: i.dialogState.value === 0 }, attrs: e, slots: t, name: "DialogBackdrop" })));
  };
} });
let Uc = G({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(a, { attrs: e, slots: t, expose: o }) {
  var r;
  let s = (r = a.id) != null ? r : `headlessui-dialog-panel-${et()}`, i = As("DialogPanel");
  o({ el: i.panelRef, $el: i.panelRef });
  function u(d) {
    d.stopPropagation();
  }
  return () => {
    let { ...d } = a, m = { id: s, ref: i.panelRef, onClick: u };
    return Ne({ ourProps: m, theirProps: d, slot: { open: i.dialogState.value === 0 }, attrs: e, slots: t, name: "DialogPanel" });
  };
} }), Bc = G({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(a, { attrs: e, slots: t }) {
  var o;
  let r = (o = a.id) != null ? o : `headlessui-dialog-title-${et()}`, s = As("DialogTitle");
  return Ee(() => {
    s.setTitleId(r), rt(() => s.setTitleId(null));
  }), () => {
    let { ...i } = a;
    return Ne({ ourProps: { id: r }, theirProps: i, slot: { open: s.dialogState.value === 0 }, attrs: e, slots: t, name: "DialogTitle" });
  };
} }), Sl = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function Tl(a) {
  var e, t;
  let o = (e = a.innerText) != null ? e : "", r = a.cloneNode(!0);
  if (!(r instanceof HTMLElement)) return o;
  let s = !1;
  for (let u of r.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) u.remove(), s = !0;
  let i = s ? (t = r.innerText) != null ? t : "" : o;
  return Sl.test(i) && (i = i.replace(Sl, "")), i;
}
function qm(a) {
  let e = a.getAttribute("aria-label");
  if (typeof e == "string") return e.trim();
  let t = a.getAttribute("aria-labelledby");
  if (t) {
    let o = t.split(" ").map((r) => {
      let s = document.getElementById(r);
      if (s) {
        let i = s.getAttribute("aria-label");
        return typeof i == "string" ? i.trim() : Tl(s).trim();
      }
      return null;
    }).filter(Boolean);
    if (o.length > 0) return o.join(", ");
  }
  return Tl(a).trim();
}
function Rc(a) {
  let e = B(""), t = B("");
  return () => {
    let o = ie(a);
    if (!o) return "";
    let r = o.innerText;
    if (e.value === r) return t.value;
    let s = qm(o).trim().toLowerCase();
    return e.value = r, t.value = s, s;
  };
}
function Zm(a, e) {
  return a === e;
}
var Vm = ((a) => (a[a.Open = 0] = "Open", a[a.Closed = 1] = "Closed", a))(Vm || {}), $m = ((a) => (a[a.Single = 0] = "Single", a[a.Multi = 1] = "Multi", a))($m || {}), Fm = ((a) => (a[a.Pointer = 0] = "Pointer", a[a.Other = 1] = "Other", a))(Fm || {});
function Gm(a) {
  requestAnimationFrame(() => requestAnimationFrame(a));
}
let zc = Symbol("ListboxContext");
function Os(a) {
  let e = Fe(zc, null);
  if (e === null) {
    let t = new Error(`<${a} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, Os), t;
  }
  return e;
}
let Hm = G({ name: "Listbox", emits: { "update:modelValue": (a) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => Zm }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(a, { slots: e, attrs: t, emit: o }) {
  let r = B(1), s = B(null), i = B(null), u = B(null), d = B([]), m = B(""), v = B(null), p = B(1);
  function g(C = (I) => I) {
    let I = v.value !== null ? d.value[v.value] : null, z = Ii(C(d.value.slice()), (F) => ie(F.dataRef.domRef)), H = I ? z.indexOf(I) : null;
    return H === -1 && (H = null), { options: z, activeOptionIndex: H };
  }
  let w = U(() => a.multiple ? 1 : 0), [_, P] = Zo(U(() => a.modelValue), (C) => o("update:modelValue", C), U(() => a.defaultValue)), T = U(() => _.value === void 0 ? Ye(w.value, { 1: [], 0: void 0 }) : _.value), k = { listboxState: r, value: T, mode: w, compare(C, I) {
    if (typeof a.by == "string") {
      let z = a.by;
      return (C == null ? void 0 : C[z]) === (I == null ? void 0 : I[z]);
    }
    return a.by(C, I);
  }, orientation: U(() => a.horizontal ? "horizontal" : "vertical"), labelRef: s, buttonRef: i, optionsRef: u, disabled: U(() => a.disabled), options: d, searchQuery: m, activeOptionIndex: v, activationTrigger: p, closeListbox() {
    a.disabled || r.value !== 1 && (r.value = 1, v.value = null);
  }, openListbox() {
    a.disabled || r.value !== 0 && (r.value = 0);
  }, goToOption(C, I, z) {
    if (a.disabled || r.value === 1) return;
    let H = g(), F = Sc(C === Me.Specific ? { focus: Me.Specific, id: I } : { focus: C }, { resolveItems: () => H.options, resolveActiveIndex: () => H.activeOptionIndex, resolveId: (se) => se.id, resolveDisabled: (se) => se.dataRef.disabled });
    m.value = "", v.value = F, p.value = z ?? 1, d.value = H.options;
  }, search(C) {
    if (a.disabled || r.value === 1) return;
    let I = m.value !== "" ? 0 : 1;
    m.value += C.toLowerCase();
    let z = (v.value !== null ? d.value.slice(v.value + I).concat(d.value.slice(0, v.value + I)) : d.value).find((F) => F.dataRef.textValue.startsWith(m.value) && !F.dataRef.disabled), H = z ? d.value.indexOf(z) : -1;
    H === -1 || H === v.value || (v.value = H, p.value = 1);
  }, clearSearch() {
    a.disabled || r.value !== 1 && m.value !== "" && (m.value = "");
  }, registerOption(C, I) {
    let z = g((H) => [...H, { id: C, dataRef: I }]);
    d.value = z.options, v.value = z.activeOptionIndex;
  }, unregisterOption(C) {
    let I = g((z) => {
      let H = z.findIndex((F) => F.id === C);
      return H !== -1 && z.splice(H, 1), z;
    });
    d.value = I.options, v.value = I.activeOptionIndex, p.value = 1;
  }, theirOnChange(C) {
    a.disabled || P(C);
  }, select(C) {
    a.disabled || P(Ye(w.value, { 0: () => C, 1: () => {
      let I = ze(k.value.value).slice(), z = ze(C), H = I.findIndex((F) => k.compare(z, ze(F)));
      return H === -1 ? I.push(z) : I.splice(H, 1), I;
    } }));
  } };
  $o([i, u], (C, I) => {
    var z;
    k.closeListbox(), ki(I, Oi.Loose) || (C.preventDefault(), (z = ie(i)) == null || z.focus());
  }, U(() => r.value === 0)), Qe(zc, k), Ho(U(() => Ye(r.value, { 0: $e.Open, 1: $e.Closed })));
  let x = U(() => {
    var C;
    return (C = ie(i)) == null ? void 0 : C.closest("form");
  });
  return Ee(() => {
    Ie([x], () => {
      if (!x.value || a.defaultValue === void 0) return;
      function C() {
        k.theirOnChange(a.defaultValue);
      }
      return x.value.addEventListener("reset", C), () => {
        var I;
        (I = x.value) == null || I.removeEventListener("reset", C);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: C, modelValue: I, disabled: z, form: H, ...F } = a, se = { open: r.value === 0, disabled: z, value: T.value };
    return qe(Se, [...C != null && T.value != null ? Wo({ [C]: T.value }).map(([pe, Te]) => qe(Rr, Go({ features: xr.Hidden, key: pe, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: H, disabled: z, name: pe, value: Te }))) : [], Ne({ ourProps: {}, theirProps: { ...t, ...Ls(F, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: se, slots: e, attrs: t, name: "Listbox" })]);
  };
} }), Wm = G({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(a, { attrs: e, slots: t }) {
  var o;
  let r = (o = a.id) != null ? o : `headlessui-listbox-label-${et()}`, s = Os("ListboxLabel");
  function i() {
    var u;
    (u = ie(s.buttonRef)) == null || u.focus({ preventScroll: !0 });
  }
  return () => {
    let u = { open: s.listboxState.value === 0, disabled: s.disabled.value }, { ...d } = a, m = { id: r, ref: s.labelRef, onClick: i };
    return Ne({ ourProps: m, theirProps: d, slot: u, attrs: e, slots: t, name: "ListboxLabel" });
  };
} }), Km = G({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(a, { attrs: e, slots: t, expose: o }) {
  var r;
  let s = (r = a.id) != null ? r : `headlessui-listbox-button-${et()}`, i = Os("ListboxButton");
  o({ el: i.buttonRef, $el: i.buttonRef });
  function u(p) {
    switch (p.key) {
      case de.Space:
      case de.Enter:
      case de.ArrowDown:
        p.preventDefault(), i.openListbox(), it(() => {
          var g;
          (g = ie(i.optionsRef)) == null || g.focus({ preventScroll: !0 }), i.value.value || i.goToOption(Me.First);
        });
        break;
      case de.ArrowUp:
        p.preventDefault(), i.openListbox(), it(() => {
          var g;
          (g = ie(i.optionsRef)) == null || g.focus({ preventScroll: !0 }), i.value.value || i.goToOption(Me.Last);
        });
        break;
    }
  }
  function d(p) {
    switch (p.key) {
      case de.Space:
        p.preventDefault();
        break;
    }
  }
  function m(p) {
    i.disabled.value || (i.listboxState.value === 0 ? (i.closeListbox(), it(() => {
      var g;
      return (g = ie(i.buttonRef)) == null ? void 0 : g.focus({ preventScroll: !0 });
    })) : (p.preventDefault(), i.openListbox(), Gm(() => {
      var g;
      return (g = ie(i.optionsRef)) == null ? void 0 : g.focus({ preventScroll: !0 });
    })));
  }
  let v = Fo(U(() => ({ as: a.as, type: e.type })), i.buttonRef);
  return () => {
    var p, g;
    let w = { open: i.listboxState.value === 0, disabled: i.disabled.value, value: i.value.value }, { ..._ } = a, P = { ref: i.buttonRef, id: s, type: v.value, "aria-haspopup": "listbox", "aria-controls": (p = ie(i.optionsRef)) == null ? void 0 : p.id, "aria-expanded": i.listboxState.value === 0, "aria-labelledby": i.labelRef.value ? [(g = ie(i.labelRef)) == null ? void 0 : g.id, s].join(" ") : void 0, disabled: i.disabled.value === !0 ? !0 : void 0, onKeydown: u, onKeyup: d, onClick: m };
    return Ne({ ourProps: P, theirProps: _, slot: w, attrs: e, slots: t, name: "ListboxButton" });
  };
} }), Qm = G({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(a, { attrs: e, slots: t, expose: o }) {
  var r;
  let s = (r = a.id) != null ? r : `headlessui-listbox-options-${et()}`, i = Os("ListboxOptions"), u = B(null);
  o({ el: i.optionsRef, $el: i.optionsRef });
  function d(p) {
    switch (u.value && clearTimeout(u.value), p.key) {
      case de.Space:
        if (i.searchQuery.value !== "") return p.preventDefault(), p.stopPropagation(), i.search(p.key);
      case de.Enter:
        if (p.preventDefault(), p.stopPropagation(), i.activeOptionIndex.value !== null) {
          let g = i.options.value[i.activeOptionIndex.value];
          i.select(g.dataRef.value);
        }
        i.mode.value === 0 && (i.closeListbox(), it(() => {
          var g;
          return (g = ie(i.buttonRef)) == null ? void 0 : g.focus({ preventScroll: !0 });
        }));
        break;
      case Ye(i.orientation.value, { vertical: de.ArrowDown, horizontal: de.ArrowRight }):
        return p.preventDefault(), p.stopPropagation(), i.goToOption(Me.Next);
      case Ye(i.orientation.value, { vertical: de.ArrowUp, horizontal: de.ArrowLeft }):
        return p.preventDefault(), p.stopPropagation(), i.goToOption(Me.Previous);
      case de.Home:
      case de.PageUp:
        return p.preventDefault(), p.stopPropagation(), i.goToOption(Me.First);
      case de.End:
      case de.PageDown:
        return p.preventDefault(), p.stopPropagation(), i.goToOption(Me.Last);
      case de.Escape:
        p.preventDefault(), p.stopPropagation(), i.closeListbox(), it(() => {
          var g;
          return (g = ie(i.buttonRef)) == null ? void 0 : g.focus({ preventScroll: !0 });
        });
        break;
      case de.Tab:
        p.preventDefault(), p.stopPropagation();
        break;
      default:
        p.key.length === 1 && (i.search(p.key), u.value = setTimeout(() => i.clearSearch(), 350));
        break;
    }
  }
  let m = Cs(), v = U(() => m !== null ? (m.value & $e.Open) === $e.Open : i.listboxState.value === 0);
  return () => {
    var p, g;
    let w = { open: i.listboxState.value === 0 }, { ..._ } = a, P = { "aria-activedescendant": i.activeOptionIndex.value === null || (p = i.options.value[i.activeOptionIndex.value]) == null ? void 0 : p.id, "aria-multiselectable": i.mode.value === 1 ? !0 : void 0, "aria-labelledby": (g = ie(i.buttonRef)) == null ? void 0 : g.id, "aria-orientation": i.orientation.value, id: s, onKeydown: d, role: "listbox", tabIndex: 0, ref: i.optionsRef };
    return Ne({ ourProps: P, theirProps: _, slot: w, attrs: e, slots: t, features: rr.RenderStrategy | rr.Static, visible: v.value, name: "ListboxOptions" });
  };
} }), Ll = G({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(a, { slots: e, attrs: t, expose: o }) {
  var r;
  let s = (r = a.id) != null ? r : `headlessui-listbox-option-${et()}`, i = Os("ListboxOption"), u = B(null);
  o({ el: u, $el: u });
  let d = U(() => i.activeOptionIndex.value !== null ? i.options.value[i.activeOptionIndex.value].id === s : !1), m = U(() => Ye(i.mode.value, { 0: () => i.compare(ze(i.value.value), ze(a.value)), 1: () => ze(i.value.value).some((C) => i.compare(ze(C), ze(a.value))) })), v = U(() => Ye(i.mode.value, { 1: () => {
    var C;
    let I = ze(i.value.value);
    return ((C = i.options.value.find((z) => I.some((H) => i.compare(ze(H), ze(z.dataRef.value))))) == null ? void 0 : C.id) === s;
  }, 0: () => m.value })), p = Rc(u), g = U(() => ({ disabled: a.disabled, value: a.value, get textValue() {
    return p();
  }, domRef: u }));
  Ee(() => i.registerOption(s, g)), rt(() => i.unregisterOption(s)), Ee(() => {
    Ie([i.listboxState, m], () => {
      i.listboxState.value === 0 && m.value && Ye(i.mode.value, { 1: () => {
        v.value && i.goToOption(Me.Specific, s);
      }, 0: () => {
        i.goToOption(Me.Specific, s);
      } });
    }, { immediate: !0 });
  }), nt(() => {
    i.listboxState.value === 0 && d.value && i.activationTrigger.value !== 0 && it(() => {
      var C, I;
      return (I = (C = ie(u)) == null ? void 0 : C.scrollIntoView) == null ? void 0 : I.call(C, { block: "nearest" });
    });
  });
  function w(C) {
    if (a.disabled) return C.preventDefault();
    i.select(a.value), i.mode.value === 0 && (i.closeListbox(), it(() => {
      var I;
      return (I = ie(i.buttonRef)) == null ? void 0 : I.focus({ preventScroll: !0 });
    }));
  }
  function _() {
    if (a.disabled) return i.goToOption(Me.Nothing);
    i.goToOption(Me.Specific, s);
  }
  let P = _c();
  function T(C) {
    P.update(C);
  }
  function k(C) {
    P.wasMoved(C) && (a.disabled || d.value || i.goToOption(Me.Specific, s, 0));
  }
  function x(C) {
    P.wasMoved(C) && (a.disabled || d.value && i.goToOption(Me.Nothing));
  }
  return () => {
    let { disabled: C } = a, I = { active: d.value, selected: m.value, disabled: C }, { value: z, disabled: H, ...F } = a, se = { id: s, ref: u, role: "option", tabIndex: C === !0 ? void 0 : -1, "aria-disabled": C === !0 ? !0 : void 0, "aria-selected": m.value, disabled: void 0, onClick: w, onFocus: _, onPointerenter: T, onMouseenter: T, onPointermove: k, onMousemove: k, onPointerleave: x, onMouseleave: x };
    return Ne({ ourProps: se, theirProps: F, slot: I, attrs: t, slots: e, name: "ListboxOption" });
  };
} });
var Ym = ((a) => (a[a.Open = 0] = "Open", a[a.Closed = 1] = "Closed", a))(Ym || {}), Xm = ((a) => (a[a.Pointer = 0] = "Pointer", a[a.Other = 1] = "Other", a))(Xm || {});
function e0(a) {
  requestAnimationFrame(() => requestAnimationFrame(a));
}
let qc = Symbol("MenuContext");
function Ei(a) {
  let e = Fe(qc, null);
  if (e === null) {
    let t = new Error(`<${a} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, Ei), t;
  }
  return e;
}
let t0 = G({ name: "Menu", props: { as: { type: [Object, String], default: "template" } }, setup(a, { slots: e, attrs: t }) {
  let o = B(1), r = B(null), s = B(null), i = B([]), u = B(""), d = B(null), m = B(1);
  function v(g = (w) => w) {
    let w = d.value !== null ? i.value[d.value] : null, _ = Ii(g(i.value.slice()), (T) => ie(T.dataRef.domRef)), P = w ? _.indexOf(w) : null;
    return P === -1 && (P = null), { items: _, activeItemIndex: P };
  }
  let p = { menuState: o, buttonRef: r, itemsRef: s, items: i, searchQuery: u, activeItemIndex: d, activationTrigger: m, closeMenu: () => {
    o.value = 1, d.value = null;
  }, openMenu: () => o.value = 0, goToItem(g, w, _) {
    let P = v(), T = Sc(g === Me.Specific ? { focus: Me.Specific, id: w } : { focus: g }, { resolveItems: () => P.items, resolveActiveIndex: () => P.activeItemIndex, resolveId: (k) => k.id, resolveDisabled: (k) => k.dataRef.disabled });
    u.value = "", d.value = T, m.value = _ ?? 1, i.value = P.items;
  }, search(g) {
    let w = u.value !== "" ? 0 : 1;
    u.value += g.toLowerCase();
    let _ = (d.value !== null ? i.value.slice(d.value + w).concat(i.value.slice(0, d.value + w)) : i.value).find((T) => T.dataRef.textValue.startsWith(u.value) && !T.dataRef.disabled), P = _ ? i.value.indexOf(_) : -1;
    P === -1 || P === d.value || (d.value = P, m.value = 1);
  }, clearSearch() {
    u.value = "";
  }, registerItem(g, w) {
    let _ = v((P) => [...P, { id: g, dataRef: w }]);
    i.value = _.items, d.value = _.activeItemIndex, m.value = 1;
  }, unregisterItem(g) {
    let w = v((_) => {
      let P = _.findIndex((T) => T.id === g);
      return P !== -1 && _.splice(P, 1), _;
    });
    i.value = w.items, d.value = w.activeItemIndex, m.value = 1;
  } };
  return $o([r, s], (g, w) => {
    var _;
    p.closeMenu(), ki(w, Oi.Loose) || (g.preventDefault(), (_ = ie(r)) == null || _.focus());
  }, U(() => o.value === 0)), Qe(qc, p), Ho(U(() => Ye(o.value, { 0: $e.Open, 1: $e.Closed }))), () => {
    let g = { open: o.value === 0, close: p.closeMenu };
    return Ne({ ourProps: {}, theirProps: a, slot: g, slots: e, attrs: t, name: "Menu" });
  };
} }), r0 = G({ name: "MenuButton", props: { disabled: { type: Boolean, default: !1 }, as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(a, { attrs: e, slots: t, expose: o }) {
  var r;
  let s = (r = a.id) != null ? r : `headlessui-menu-button-${et()}`, i = Ei("MenuButton");
  o({ el: i.buttonRef, $el: i.buttonRef });
  function u(p) {
    switch (p.key) {
      case de.Space:
      case de.Enter:
      case de.ArrowDown:
        p.preventDefault(), p.stopPropagation(), i.openMenu(), it(() => {
          var g;
          (g = ie(i.itemsRef)) == null || g.focus({ preventScroll: !0 }), i.goToItem(Me.First);
        });
        break;
      case de.ArrowUp:
        p.preventDefault(), p.stopPropagation(), i.openMenu(), it(() => {
          var g;
          (g = ie(i.itemsRef)) == null || g.focus({ preventScroll: !0 }), i.goToItem(Me.Last);
        });
        break;
    }
  }
  function d(p) {
    switch (p.key) {
      case de.Space:
        p.preventDefault();
        break;
    }
  }
  function m(p) {
    a.disabled || (i.menuState.value === 0 ? (i.closeMenu(), it(() => {
      var g;
      return (g = ie(i.buttonRef)) == null ? void 0 : g.focus({ preventScroll: !0 });
    })) : (p.preventDefault(), i.openMenu(), e0(() => {
      var g;
      return (g = ie(i.itemsRef)) == null ? void 0 : g.focus({ preventScroll: !0 });
    })));
  }
  let v = Fo(U(() => ({ as: a.as, type: e.type })), i.buttonRef);
  return () => {
    var p;
    let g = { open: i.menuState.value === 0 }, { ...w } = a, _ = { ref: i.buttonRef, id: s, type: v.value, "aria-haspopup": "menu", "aria-controls": (p = ie(i.itemsRef)) == null ? void 0 : p.id, "aria-expanded": i.menuState.value === 0, onKeydown: u, onKeyup: d, onClick: m };
    return Ne({ ourProps: _, theirProps: w, slot: g, attrs: e, slots: t, name: "MenuButton" });
  };
} }), s0 = G({ name: "MenuItems", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(a, { attrs: e, slots: t, expose: o }) {
  var r;
  let s = (r = a.id) != null ? r : `headlessui-menu-items-${et()}`, i = Ei("MenuItems"), u = B(null);
  o({ el: i.itemsRef, $el: i.itemsRef }), bc({ container: U(() => ie(i.itemsRef)), enabled: U(() => i.menuState.value === 0), accept(g) {
    return g.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : g.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(g) {
    g.setAttribute("role", "none");
  } });
  function d(g) {
    var w;
    switch (u.value && clearTimeout(u.value), g.key) {
      case de.Space:
        if (i.searchQuery.value !== "") return g.preventDefault(), g.stopPropagation(), i.search(g.key);
      case de.Enter:
        if (g.preventDefault(), g.stopPropagation(), i.activeItemIndex.value !== null) {
          let _ = i.items.value[i.activeItemIndex.value];
          (w = ie(_.dataRef.domRef)) == null || w.click();
        }
        i.closeMenu(), vc(ie(i.buttonRef));
        break;
      case de.ArrowDown:
        return g.preventDefault(), g.stopPropagation(), i.goToItem(Me.Next);
      case de.ArrowUp:
        return g.preventDefault(), g.stopPropagation(), i.goToItem(Me.Previous);
      case de.Home:
      case de.PageUp:
        return g.preventDefault(), g.stopPropagation(), i.goToItem(Me.First);
      case de.End:
      case de.PageDown:
        return g.preventDefault(), g.stopPropagation(), i.goToItem(Me.Last);
      case de.Escape:
        g.preventDefault(), g.stopPropagation(), i.closeMenu(), it(() => {
          var _;
          return (_ = ie(i.buttonRef)) == null ? void 0 : _.focus({ preventScroll: !0 });
        });
        break;
      case de.Tab:
        g.preventDefault(), g.stopPropagation(), i.closeMenu(), it(() => fm(ie(i.buttonRef), g.shiftKey ? ct.Previous : ct.Next));
        break;
      default:
        g.key.length === 1 && (i.search(g.key), u.value = setTimeout(() => i.clearSearch(), 350));
        break;
    }
  }
  function m(g) {
    switch (g.key) {
      case de.Space:
        g.preventDefault();
        break;
    }
  }
  let v = Cs(), p = U(() => v !== null ? (v.value & $e.Open) === $e.Open : i.menuState.value === 0);
  return () => {
    var g, w;
    let _ = { open: i.menuState.value === 0 }, { ...P } = a, T = { "aria-activedescendant": i.activeItemIndex.value === null || (g = i.items.value[i.activeItemIndex.value]) == null ? void 0 : g.id, "aria-labelledby": (w = ie(i.buttonRef)) == null ? void 0 : w.id, id: s, onKeydown: d, onKeyup: m, role: "menu", tabIndex: 0, ref: i.itemsRef };
    return Ne({ ourProps: T, theirProps: P, slot: _, attrs: e, slots: t, features: rr.RenderStrategy | rr.Static, visible: p.value, name: "MenuItems" });
  };
} }), i0 = G({ name: "MenuItem", inheritAttrs: !1, props: { as: { type: [Object, String], default: "template" }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(a, { slots: e, attrs: t, expose: o }) {
  var r;
  let s = (r = a.id) != null ? r : `headlessui-menu-item-${et()}`, i = Ei("MenuItem"), u = B(null);
  o({ el: u, $el: u });
  let d = U(() => i.activeItemIndex.value !== null ? i.items.value[i.activeItemIndex.value].id === s : !1), m = Rc(u), v = U(() => ({ disabled: a.disabled, get textValue() {
    return m();
  }, domRef: u }));
  Ee(() => i.registerItem(s, v)), rt(() => i.unregisterItem(s)), nt(() => {
    i.menuState.value === 0 && d.value && i.activationTrigger.value !== 0 && it(() => {
      var k, x;
      return (x = (k = ie(u)) == null ? void 0 : k.scrollIntoView) == null ? void 0 : x.call(k, { block: "nearest" });
    });
  });
  function p(k) {
    if (a.disabled) return k.preventDefault();
    i.closeMenu(), vc(ie(i.buttonRef));
  }
  function g() {
    if (a.disabled) return i.goToItem(Me.Nothing);
    i.goToItem(Me.Specific, s);
  }
  let w = _c();
  function _(k) {
    w.update(k);
  }
  function P(k) {
    w.wasMoved(k) && (a.disabled || d.value || i.goToItem(Me.Specific, s, 0));
  }
  function T(k) {
    w.wasMoved(k) && (a.disabled || d.value && i.goToItem(Me.Nothing));
  }
  return () => {
    let { disabled: k, ...x } = a, C = { active: d.value, disabled: k, close: i.closeMenu };
    return Ne({ ourProps: { id: s, ref: u, role: "menuitem", tabIndex: k === !0 ? void 0 : -1, "aria-disabled": k === !0 ? !0 : void 0, onClick: p, onFocus: g, onPointerenter: _, onMouseenter: _, onPointermove: P, onMousemove: P, onPointerleave: T, onMouseleave: T }, theirProps: { ...t, ...x }, slot: C, attrs: t, slots: e, name: "MenuItem" });
  };
} }), Zc = Symbol("LabelContext");
function Vc() {
  let a = Fe(Zc, null);
  if (a === null) {
    let e = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, Vc), e;
  }
  return a;
}
function Ko({ slot: a = {}, name: e = "Label", props: t = {} } = {}) {
  let o = B([]);
  function r(s) {
    return o.value.push(s), () => {
      let i = o.value.indexOf(s);
      i !== -1 && o.value.splice(i, 1);
    };
  }
  return Qe(Zc, { register: r, slot: a, name: e, props: t }), U(() => o.value.length > 0 ? o.value.join(" ") : void 0);
}
let n0 = G({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(a, { slots: e, attrs: t }) {
  var o;
  let r = (o = a.id) != null ? o : `headlessui-label-${et()}`, s = Vc();
  return Ee(() => rt(s.register(r))), () => {
    let { name: i = "Label", slot: u = {}, props: d = {} } = s, { passive: m, ...v } = a, p = { ...Object.entries(d).reduce((g, [w, _]) => Object.assign(g, { [w]: D(_) }), {}), id: r };
    return m && (delete p.onClick, delete p.htmlFor, delete v.onClick), Ne({ ourProps: p, theirProps: v, slot: u, attrs: t, slots: e, name: i });
  };
} });
function o0(a, e) {
  return a === e;
}
let $c = Symbol("RadioGroupContext");
function Fc(a) {
  let e = Fe($c, null);
  if (e === null) {
    let t = new Error(`<${a} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, Fc), t;
  }
  return e;
}
let a0 = G({ name: "RadioGroup", emits: { "update:modelValue": (a) => !0 }, props: { as: { type: [Object, String], default: "div" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => o0 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(a, { emit: e, attrs: t, slots: o, expose: r }) {
  var s;
  let i = (s = a.id) != null ? s : `headlessui-radiogroup-${et()}`, u = B(null), d = B([]), m = Ko({ name: "RadioGroupLabel" }), v = ji({ name: "RadioGroupDescription" });
  r({ el: u, $el: u });
  let [p, g] = Zo(U(() => a.modelValue), (T) => e("update:modelValue", T), U(() => a.defaultValue)), w = { options: d, value: p, disabled: U(() => a.disabled), firstOption: U(() => d.value.find((T) => !T.propsRef.disabled)), containsCheckedOption: U(() => d.value.some((T) => w.compare(ze(T.propsRef.value), ze(a.modelValue)))), compare(T, k) {
    if (typeof a.by == "string") {
      let x = a.by;
      return (T == null ? void 0 : T[x]) === (k == null ? void 0 : k[x]);
    }
    return a.by(T, k);
  }, change(T) {
    var k;
    if (a.disabled || w.compare(ze(p.value), ze(T))) return !1;
    let x = (k = d.value.find((C) => w.compare(ze(C.propsRef.value), ze(T)))) == null ? void 0 : k.propsRef;
    return x != null && x.disabled ? !1 : (g(T), !0);
  }, registerOption(T) {
    d.value.push(T), d.value = Ii(d.value, (k) => k.element);
  }, unregisterOption(T) {
    let k = d.value.findIndex((x) => x.id === T);
    k !== -1 && d.value.splice(k, 1);
  } };
  Qe($c, w), bc({ container: U(() => ie(u)), accept(T) {
    return T.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : T.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(T) {
    T.setAttribute("role", "none");
  } });
  function _(T) {
    if (!u.value || !u.value.contains(T.target)) return;
    let k = d.value.filter((x) => x.propsRef.disabled === !1).map((x) => x.element);
    switch (T.key) {
      case de.Enter:
        Cc(T.currentTarget);
        break;
      case de.ArrowLeft:
      case de.ArrowUp:
        if (T.preventDefault(), T.stopPropagation(), Pr(k, ct.Previous | ct.WrapAround) === yi.Success) {
          let x = d.value.find((C) => {
            var I;
            return C.element === ((I = Lt(u)) == null ? void 0 : I.activeElement);
          });
          x && w.change(x.propsRef.value);
        }
        break;
      case de.ArrowRight:
      case de.ArrowDown:
        if (T.preventDefault(), T.stopPropagation(), Pr(k, ct.Next | ct.WrapAround) === yi.Success) {
          let x = d.value.find((C) => {
            var I;
            return C.element === ((I = Lt(C.element)) == null ? void 0 : I.activeElement);
          });
          x && w.change(x.propsRef.value);
        }
        break;
      case de.Space:
        {
          T.preventDefault(), T.stopPropagation();
          let x = d.value.find((C) => {
            var I;
            return C.element === ((I = Lt(C.element)) == null ? void 0 : I.activeElement);
          });
          x && w.change(x.propsRef.value);
        }
        break;
    }
  }
  let P = U(() => {
    var T;
    return (T = ie(u)) == null ? void 0 : T.closest("form");
  });
  return Ee(() => {
    Ie([P], () => {
      if (!P.value || a.defaultValue === void 0) return;
      function T() {
        w.change(a.defaultValue);
      }
      return P.value.addEventListener("reset", T), () => {
        var k;
        (k = P.value) == null || k.removeEventListener("reset", T);
      };
    }, { immediate: !0 });
  }), () => {
    let { disabled: T, name: k, form: x, ...C } = a, I = { ref: u, id: i, role: "radiogroup", "aria-labelledby": m.value, "aria-describedby": v.value, onKeydown: _ };
    return qe(Se, [...k != null && p.value != null ? Wo({ [k]: p.value }).map(([z, H]) => qe(Rr, Go({ features: xr.Hidden, key: z, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: x, disabled: T, name: z, value: H }))) : [], Ne({ ourProps: I, theirProps: { ...t, ...Ls(C, ["modelValue", "defaultValue", "by"]) }, slot: {}, attrs: t, slots: o, name: "RadioGroup" })]);
  };
} });
var l0 = ((a) => (a[a.Empty = 1] = "Empty", a[a.Active = 2] = "Active", a))(l0 || {});
let u0 = G({ name: "RadioGroupOption", props: { as: { type: [Object, String], default: "div" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(a, { attrs: e, slots: t, expose: o }) {
  var r;
  let s = (r = a.id) != null ? r : `headlessui-radiogroup-option-${et()}`, i = Fc("RadioGroupOption"), u = Ko({ name: "RadioGroupLabel" }), d = ji({ name: "RadioGroupDescription" }), m = B(null), v = U(() => ({ value: a.value, disabled: a.disabled })), p = B(1);
  o({ el: m, $el: m });
  let g = U(() => ie(m));
  Ee(() => i.registerOption({ id: s, element: g, propsRef: v })), rt(() => i.unregisterOption(s));
  let w = U(() => {
    var I;
    return ((I = i.firstOption.value) == null ? void 0 : I.id) === s;
  }), _ = U(() => i.disabled.value || a.disabled), P = U(() => i.compare(ze(i.value.value), ze(a.value))), T = U(() => _.value ? -1 : P.value || !i.containsCheckedOption.value && w.value ? 0 : -1);
  function k() {
    var I;
    i.change(a.value) && (p.value |= 2, (I = ie(m)) == null || I.focus());
  }
  function x() {
    p.value |= 2;
  }
  function C() {
    p.value &= -3;
  }
  return () => {
    let { value: I, disabled: z, ...H } = a, F = { checked: P.value, disabled: _.value, active: !!(p.value & 2) }, se = { id: s, ref: m, role: "radio", "aria-checked": P.value ? "true" : "false", "aria-labelledby": u.value, "aria-describedby": d.value, "aria-disabled": _.value ? !0 : void 0, tabIndex: T.value, onClick: _.value ? void 0 : k, onFocus: _.value ? void 0 : x, onBlur: _.value ? void 0 : C };
    return Ne({ ourProps: se, theirProps: H, slot: F, attrs: e, slots: t, name: "RadioGroupOption" });
  };
} }), Gc = Symbol("GroupContext"), c0 = G({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(a, { slots: e, attrs: t }) {
  let o = B(null), r = Ko({ name: "SwitchLabel", props: { htmlFor: U(() => {
    var i;
    return (i = o.value) == null ? void 0 : i.id;
  }), onClick(i) {
    o.value && (i.currentTarget.tagName === "LABEL" && i.preventDefault(), o.value.click(), o.value.focus({ preventScroll: !0 }));
  } } }), s = ji({ name: "SwitchDescription" });
  return Qe(Gc, { switchRef: o, labelledby: r, describedby: s }), () => Ne({ theirProps: a, ourProps: {}, slot: {}, slots: e, attrs: t, name: "SwitchGroup" });
} }), h0 = G({ name: "Switch", emits: { "update:modelValue": (a) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: void 0 }, defaultChecked: { type: Boolean, optional: !0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 }, id: { type: String, default: null }, disabled: { type: Boolean, default: !1 }, tabIndex: { type: Number, default: 0 } }, inheritAttrs: !1, setup(a, { emit: e, attrs: t, slots: o, expose: r }) {
  var s;
  let i = (s = a.id) != null ? s : `headlessui-switch-${et()}`, u = Fe(Gc, null), [d, m] = Zo(U(() => a.modelValue), (x) => e("update:modelValue", x), U(() => a.defaultChecked));
  function v() {
    m(!d.value);
  }
  let p = B(null), g = u === null ? p : u.switchRef, w = Fo(U(() => ({ as: a.as, type: t.type })), g);
  r({ el: g, $el: g });
  function _(x) {
    x.preventDefault(), v();
  }
  function P(x) {
    x.key === de.Space ? (x.preventDefault(), v()) : x.key === de.Enter && Cc(x.currentTarget);
  }
  function T(x) {
    x.preventDefault();
  }
  let k = U(() => {
    var x, C;
    return (C = (x = ie(g)) == null ? void 0 : x.closest) == null ? void 0 : C.call(x, "form");
  });
  return Ee(() => {
    Ie([k], () => {
      if (!k.value || a.defaultChecked === void 0) return;
      function x() {
        m(a.defaultChecked);
      }
      return k.value.addEventListener("reset", x), () => {
        var C;
        (C = k.value) == null || C.removeEventListener("reset", x);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: x, value: C, form: I, tabIndex: z, ...H } = a, F = { checked: d.value }, se = { id: i, ref: g, role: "switch", type: w.value, tabIndex: z === -1 ? 0 : z, "aria-checked": d.value, "aria-labelledby": u == null ? void 0 : u.labelledby.value, "aria-describedby": u == null ? void 0 : u.describedby.value, onClick: _, onKeyup: P, onKeypress: T };
    return qe(Se, [x != null && d.value != null ? qe(Rr, Go({ features: xr.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: d.value, form: I, disabled: H.disabled, name: x, value: C })) : null, Ne({ ourProps: se, theirProps: { ...t, ...Ls(H, ["modelValue", "defaultChecked"]) }, slot: F, attrs: t, slots: o, name: "Switch" })]);
  };
} }), d0 = n0;
function f0(a) {
  let e = { called: !1 };
  return (...t) => {
    if (!e.called) return e.called = !0, a(...t);
  };
}
function Cn(a, ...e) {
  a && e.length > 0 && a.classList.add(...e);
}
function Xs(a, ...e) {
  a && e.length > 0 && a.classList.remove(...e);
}
var zn = ((a) => (a.Finished = "finished", a.Cancelled = "cancelled", a))(zn || {});
function p0(a, e) {
  let t = Ss();
  if (!a) return t.dispose;
  let { transitionDuration: o, transitionDelay: r } = getComputedStyle(a), [s, i] = [o, r].map((u) => {
    let [d = 0] = u.split(",").filter(Boolean).map((m) => m.includes("ms") ? parseFloat(m) : parseFloat(m) * 1e3).sort((m, v) => v - m);
    return d;
  });
  return s !== 0 ? t.setTimeout(() => e("finished"), s + i) : e("finished"), t.add(() => e("cancelled")), t.dispose;
}
function Cl(a, e, t, o, r, s) {
  let i = Ss(), u = s !== void 0 ? f0(s) : () => {
  };
  return Xs(a, ...r), Cn(a, ...e, ...t), i.nextFrame(() => {
    Xs(a, ...t), Cn(a, ...o), i.add(p0(a, (d) => (Xs(a, ...o, ...e), Cn(a, ...r), u(d))));
  }), i.add(() => Xs(a, ...e, ...t, ...o, ...r)), i.add(() => u("cancelled")), i.dispose;
}
function lr(a = "") {
  return a.split(/\s+/).filter((e) => e.length > 1);
}
let Qo = Symbol("TransitionContext");
var m0 = ((a) => (a.Visible = "visible", a.Hidden = "hidden", a))(m0 || {});
function v0() {
  return Fe(Qo, null) !== null;
}
function g0() {
  let a = Fe(Qo, null);
  if (a === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return a;
}
function y0() {
  let a = Fe(Yo, null);
  if (a === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return a;
}
let Yo = Symbol("NestingContext");
function Di(a) {
  return "children" in a ? Di(a.children) : a.value.filter(({ state: e }) => e === "visible").length > 0;
}
function Hc(a) {
  let e = B([]), t = B(!1);
  Ee(() => t.value = !0), rt(() => t.value = !1);
  function o(s, i = Yt.Hidden) {
    let u = e.value.findIndex(({ id: d }) => d === s);
    u !== -1 && (Ye(i, { [Yt.Unmount]() {
      e.value.splice(u, 1);
    }, [Yt.Hidden]() {
      e.value[u].state = "hidden";
    } }), !Di(e) && t.value && (a == null || a()));
  }
  function r(s) {
    let i = e.value.find(({ id: u }) => u === s);
    return i ? i.state !== "visible" && (i.state = "visible") : e.value.push({ id: s, state: "visible" }), () => o(s, Yt.Unmount);
  }
  return { children: e, register: r, unregister: o };
}
let Wc = rr.RenderStrategy, _s = G({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(a, { emit: e, attrs: t, slots: o, expose: r }) {
  let s = B(0);
  function i() {
    s.value |= $e.Opening, e("beforeEnter");
  }
  function u() {
    s.value &= ~$e.Opening, e("afterEnter");
  }
  function d() {
    s.value |= $e.Closing, e("beforeLeave");
  }
  function m() {
    s.value &= ~$e.Closing, e("afterLeave");
  }
  if (!v0() && gm()) return () => qe(Xo, { ...a, onBeforeEnter: i, onAfterEnter: u, onBeforeLeave: d, onAfterLeave: m }, o);
  let v = B(null), p = U(() => a.unmount ? Yt.Unmount : Yt.Hidden);
  r({ el: v, $el: v });
  let { show: g, appear: w } = g0(), { register: _, unregister: P } = y0(), T = B(g.value ? "visible" : "hidden"), k = { value: !0 }, x = et(), C = { value: !1 }, I = Hc(() => {
    !C.value && T.value !== "hidden" && (T.value = "hidden", P(x), m());
  });
  Ee(() => {
    let X = _(x);
    rt(X);
  }), nt(() => {
    if (p.value === Yt.Hidden && x) {
      if (g.value && T.value !== "visible") {
        T.value = "visible";
        return;
      }
      Ye(T.value, { hidden: () => P(x), visible: () => _(x) });
    }
  });
  let z = lr(a.enter), H = lr(a.enterFrom), F = lr(a.enterTo), se = lr(a.entered), pe = lr(a.leave), Te = lr(a.leaveFrom), W = lr(a.leaveTo);
  Ee(() => {
    nt(() => {
      if (T.value === "visible") {
        let X = ie(v);
        if (X instanceof Comment && X.data === "") throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function Y(X) {
    let Z = k.value && !w.value, he = ie(v);
    !he || !(he instanceof HTMLElement) || Z || (C.value = !0, g.value && i(), g.value || d(), X(g.value ? Cl(he, z, H, F, se, (Pe) => {
      C.value = !1, Pe === zn.Finished && u();
    }) : Cl(he, pe, Te, W, se, (Pe) => {
      C.value = !1, Pe === zn.Finished && (Di(I) || (T.value = "hidden", P(x), m()));
    })));
  }
  return Ee(() => {
    Ie([g], (X, Z, he) => {
      Y(he), k.value = !1;
    }, { immediate: !0 });
  }), Qe(Yo, I), Ho(U(() => Ye(T.value, { visible: $e.Open, hidden: $e.Closed }) | s.value)), () => {
    let { appear: X, show: Z, enter: he, enterFrom: Pe, enterTo: ot, entered: ue, leave: Gt, leaveFrom: J, leaveTo: Q, ...be } = a, De = { ref: v }, Le = { ...be, ...w.value && g.value && Ts.isServer ? { class: ae([t.class, be.class, ...z, ...H]) } : {} };
    return Ne({ theirProps: Le, ourProps: De, slot: {}, slots: o, attrs: t, features: Wc, visible: T.value === "visible", name: "TransitionChild" });
  };
} }), _0 = _s, Xo = G({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(a, { emit: e, attrs: t, slots: o }) {
  let r = Cs(), s = U(() => a.show === null && r !== null ? (r.value & $e.Open) === $e.Open : a.show);
  nt(() => {
    if (![!0, !1].includes(s.value)) throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let i = B(s.value ? "visible" : "hidden"), u = Hc(() => {
    i.value = "hidden";
  }), d = B(!0), m = { show: s, appear: U(() => a.appear || !d.value) };
  return Ee(() => {
    nt(() => {
      d.value = !1, s.value ? i.value = "visible" : Di(u) || (i.value = "hidden");
    });
  }), Qe(Yo, u), Qe(Qo, m), () => {
    let v = Ls(a, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), p = { unmount: a.unmount };
    return Ne({ ourProps: { ...p, as: "template" }, theirProps: {}, slot: {}, slots: { ...o, default: () => [qe(_0, { onBeforeEnter: () => e("beforeEnter"), onAfterEnter: () => e("afterEnter"), onBeforeLeave: () => e("beforeLeave"), onAfterLeave: () => e("afterLeave"), ...t, ...p, ...v }, o.default)] }, attrs: {}, features: Wc, visible: i.value === "visible", name: "Transition" });
  };
} });
var Mr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ea(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
function b0() {
  this.__data__ = [], this.size = 0;
}
var w0 = b0;
function P0(a, e) {
  return a === e || a !== a && e !== e;
}
var Kc = P0, x0 = Kc;
function S0(a, e) {
  for (var t = a.length; t--; )
    if (x0(a[t][0], e))
      return t;
  return -1;
}
var Mi = S0, T0 = Mi, L0 = Array.prototype, C0 = L0.splice;
function A0(a) {
  var e = this.__data__, t = T0(e, a);
  if (t < 0)
    return !1;
  var o = e.length - 1;
  return t == o ? e.pop() : C0.call(e, t, 1), --this.size, !0;
}
var O0 = A0, k0 = Mi;
function I0(a) {
  var e = this.__data__, t = k0(e, a);
  return t < 0 ? void 0 : e[t][1];
}
var j0 = I0, E0 = Mi;
function D0(a) {
  return E0(this.__data__, a) > -1;
}
var M0 = D0, N0 = Mi;
function J0(a, e) {
  var t = this.__data__, o = N0(t, a);
  return o < 0 ? (++this.size, t.push([a, e])) : t[o][1] = e, this;
}
var U0 = J0, B0 = w0, R0 = O0, z0 = j0, q0 = M0, Z0 = U0;
function Zr(a) {
  var e = -1, t = a == null ? 0 : a.length;
  for (this.clear(); ++e < t; ) {
    var o = a[e];
    this.set(o[0], o[1]);
  }
}
Zr.prototype.clear = B0;
Zr.prototype.delete = R0;
Zr.prototype.get = z0;
Zr.prototype.has = q0;
Zr.prototype.set = Z0;
var Ni = Zr, V0 = Ni;
function $0() {
  this.__data__ = new V0(), this.size = 0;
}
var F0 = $0;
function G0(a) {
  var e = this.__data__, t = e.delete(a);
  return this.size = e.size, t;
}
var H0 = G0;
function W0(a) {
  return this.__data__.get(a);
}
var K0 = W0;
function Q0(a) {
  return this.__data__.has(a);
}
var Y0 = Q0, X0 = typeof Mr == "object" && Mr && Mr.Object === Object && Mr, Qc = X0, ev = Qc, tv = typeof self == "object" && self && self.Object === Object && self, rv = ev || tv || Function("return this")(), Ft = rv, sv = Ft, iv = sv.Symbol, ta = iv, Al = ta, Yc = Object.prototype, nv = Yc.hasOwnProperty, ov = Yc.toString, hs = Al ? Al.toStringTag : void 0;
function av(a) {
  var e = nv.call(a, hs), t = a[hs];
  try {
    a[hs] = void 0;
    var o = !0;
  } catch {
  }
  var r = ov.call(a);
  return o && (e ? a[hs] = t : delete a[hs]), r;
}
var lv = av, uv = Object.prototype, cv = uv.toString;
function hv(a) {
  return cv.call(a);
}
var dv = hv, Ol = ta, fv = lv, pv = dv, mv = "[object Null]", vv = "[object Undefined]", kl = Ol ? Ol.toStringTag : void 0;
function gv(a) {
  return a == null ? a === void 0 ? vv : mv : kl && kl in Object(a) ? fv(a) : pv(a);
}
var Ji = gv;
function yv(a) {
  var e = typeof a;
  return a != null && (e == "object" || e == "function");
}
var Xc = yv, _v = Ji, bv = Xc, wv = "[object AsyncFunction]", Pv = "[object Function]", xv = "[object GeneratorFunction]", Sv = "[object Proxy]";
function Tv(a) {
  if (!bv(a))
    return !1;
  var e = _v(a);
  return e == Pv || e == xv || e == wv || e == Sv;
}
var eh = Tv, Lv = Ft, Cv = Lv["__core-js_shared__"], Av = Cv, An = Av, Il = function() {
  var a = /[^.]+$/.exec(An && An.keys && An.keys.IE_PROTO || "");
  return a ? "Symbol(src)_1." + a : "";
}();
function Ov(a) {
  return !!Il && Il in a;
}
var kv = Ov, Iv = Function.prototype, jv = Iv.toString;
function Ev(a) {
  if (a != null) {
    try {
      return jv.call(a);
    } catch {
    }
    try {
      return a + "";
    } catch {
    }
  }
  return "";
}
var th = Ev, Dv = eh, Mv = kv, Nv = Xc, Jv = th, Uv = /[\\^$.*+?()[\]{}|]/g, Bv = /^\[object .+?Constructor\]$/, Rv = Function.prototype, zv = Object.prototype, qv = Rv.toString, Zv = zv.hasOwnProperty, Vv = RegExp(
  "^" + qv.call(Zv).replace(Uv, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function $v(a) {
  if (!Nv(a) || Mv(a))
    return !1;
  var e = Dv(a) ? Vv : Bv;
  return e.test(Jv(a));
}
var Fv = $v;
function Gv(a, e) {
  return a == null ? void 0 : a[e];
}
var Hv = Gv, Wv = Fv, Kv = Hv;
function Qv(a, e) {
  var t = Kv(a, e);
  return Wv(t) ? t : void 0;
}
var Vr = Qv, Yv = Vr, Xv = Ft, eg = Yv(Xv, "Map"), ra = eg, tg = Vr, rg = tg(Object, "create"), Ui = rg, jl = Ui;
function sg() {
  this.__data__ = jl ? jl(null) : {}, this.size = 0;
}
var ig = sg;
function ng(a) {
  var e = this.has(a) && delete this.__data__[a];
  return this.size -= e ? 1 : 0, e;
}
var og = ng, ag = Ui, lg = "__lodash_hash_undefined__", ug = Object.prototype, cg = ug.hasOwnProperty;
function hg(a) {
  var e = this.__data__;
  if (ag) {
    var t = e[a];
    return t === lg ? void 0 : t;
  }
  return cg.call(e, a) ? e[a] : void 0;
}
var dg = hg, fg = Ui, pg = Object.prototype, mg = pg.hasOwnProperty;
function vg(a) {
  var e = this.__data__;
  return fg ? e[a] !== void 0 : mg.call(e, a);
}
var gg = vg, yg = Ui, _g = "__lodash_hash_undefined__";
function bg(a, e) {
  var t = this.__data__;
  return this.size += this.has(a) ? 0 : 1, t[a] = yg && e === void 0 ? _g : e, this;
}
var wg = bg, Pg = ig, xg = og, Sg = dg, Tg = gg, Lg = wg;
function $r(a) {
  var e = -1, t = a == null ? 0 : a.length;
  for (this.clear(); ++e < t; ) {
    var o = a[e];
    this.set(o[0], o[1]);
  }
}
$r.prototype.clear = Pg;
$r.prototype.delete = xg;
$r.prototype.get = Sg;
$r.prototype.has = Tg;
$r.prototype.set = Lg;
var Cg = $r, El = Cg, Ag = Ni, Og = ra;
function kg() {
  this.size = 0, this.__data__ = {
    hash: new El(),
    map: new (Og || Ag)(),
    string: new El()
  };
}
var Ig = kg;
function jg(a) {
  var e = typeof a;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? a !== "__proto__" : a === null;
}
var Eg = jg, Dg = Eg;
function Mg(a, e) {
  var t = a.__data__;
  return Dg(e) ? t[typeof e == "string" ? "string" : "hash"] : t.map;
}
var Bi = Mg, Ng = Bi;
function Jg(a) {
  var e = Ng(this, a).delete(a);
  return this.size -= e ? 1 : 0, e;
}
var Ug = Jg, Bg = Bi;
function Rg(a) {
  return Bg(this, a).get(a);
}
var zg = Rg, qg = Bi;
function Zg(a) {
  return qg(this, a).has(a);
}
var Vg = Zg, $g = Bi;
function Fg(a, e) {
  var t = $g(this, a), o = t.size;
  return t.set(a, e), this.size += t.size == o ? 0 : 1, this;
}
var Gg = Fg, Hg = Ig, Wg = Ug, Kg = zg, Qg = Vg, Yg = Gg;
function Fr(a) {
  var e = -1, t = a == null ? 0 : a.length;
  for (this.clear(); ++e < t; ) {
    var o = a[e];
    this.set(o[0], o[1]);
  }
}
Fr.prototype.clear = Hg;
Fr.prototype.delete = Wg;
Fr.prototype.get = Kg;
Fr.prototype.has = Qg;
Fr.prototype.set = Yg;
var rh = Fr, Xg = Ni, e2 = ra, t2 = rh, r2 = 200;
function s2(a, e) {
  var t = this.__data__;
  if (t instanceof Xg) {
    var o = t.__data__;
    if (!e2 || o.length < r2 - 1)
      return o.push([a, e]), this.size = ++t.size, this;
    t = this.__data__ = new t2(o);
  }
  return t.set(a, e), this.size = t.size, this;
}
var i2 = s2, n2 = Ni, o2 = F0, a2 = H0, l2 = K0, u2 = Y0, c2 = i2;
function Gr(a) {
  var e = this.__data__ = new n2(a);
  this.size = e.size;
}
Gr.prototype.clear = o2;
Gr.prototype.delete = a2;
Gr.prototype.get = l2;
Gr.prototype.has = u2;
Gr.prototype.set = c2;
var h2 = Gr, d2 = "__lodash_hash_undefined__";
function f2(a) {
  return this.__data__.set(a, d2), this;
}
var p2 = f2;
function m2(a) {
  return this.__data__.has(a);
}
var v2 = m2, g2 = rh, y2 = p2, _2 = v2;
function _i(a) {
  var e = -1, t = a == null ? 0 : a.length;
  for (this.__data__ = new g2(); ++e < t; )
    this.add(a[e]);
}
_i.prototype.add = _i.prototype.push = y2;
_i.prototype.has = _2;
var b2 = _i;
function w2(a, e) {
  for (var t = -1, o = a == null ? 0 : a.length; ++t < o; )
    if (e(a[t], t, a))
      return !0;
  return !1;
}
var P2 = w2;
function x2(a, e) {
  return a.has(e);
}
var S2 = x2, T2 = b2, L2 = P2, C2 = S2, A2 = 1, O2 = 2;
function k2(a, e, t, o, r, s) {
  var i = t & A2, u = a.length, d = e.length;
  if (u != d && !(i && d > u))
    return !1;
  var m = s.get(a), v = s.get(e);
  if (m && v)
    return m == e && v == a;
  var p = -1, g = !0, w = t & O2 ? new T2() : void 0;
  for (s.set(a, e), s.set(e, a); ++p < u; ) {
    var _ = a[p], P = e[p];
    if (o)
      var T = i ? o(P, _, p, e, a, s) : o(_, P, p, a, e, s);
    if (T !== void 0) {
      if (T)
        continue;
      g = !1;
      break;
    }
    if (w) {
      if (!L2(e, function(k, x) {
        if (!C2(w, x) && (_ === k || r(_, k, t, o, s)))
          return w.push(x);
      })) {
        g = !1;
        break;
      }
    } else if (!(_ === P || r(_, P, t, o, s))) {
      g = !1;
      break;
    }
  }
  return s.delete(a), s.delete(e), g;
}
var sh = k2, I2 = Ft, j2 = I2.Uint8Array, E2 = j2;
function D2(a) {
  var e = -1, t = Array(a.size);
  return a.forEach(function(o, r) {
    t[++e] = [r, o];
  }), t;
}
var M2 = D2;
function N2(a) {
  var e = -1, t = Array(a.size);
  return a.forEach(function(o) {
    t[++e] = o;
  }), t;
}
var J2 = N2, Dl = ta, Ml = E2, U2 = Kc, B2 = sh, R2 = M2, z2 = J2, q2 = 1, Z2 = 2, V2 = "[object Boolean]", $2 = "[object Date]", F2 = "[object Error]", G2 = "[object Map]", H2 = "[object Number]", W2 = "[object RegExp]", K2 = "[object Set]", Q2 = "[object String]", Y2 = "[object Symbol]", X2 = "[object ArrayBuffer]", ey = "[object DataView]", Nl = Dl ? Dl.prototype : void 0, On = Nl ? Nl.valueOf : void 0;
function ty(a, e, t, o, r, s, i) {
  switch (t) {
    case ey:
      if (a.byteLength != e.byteLength || a.byteOffset != e.byteOffset)
        return !1;
      a = a.buffer, e = e.buffer;
    case X2:
      return !(a.byteLength != e.byteLength || !s(new Ml(a), new Ml(e)));
    case V2:
    case $2:
    case H2:
      return U2(+a, +e);
    case F2:
      return a.name == e.name && a.message == e.message;
    case W2:
    case Q2:
      return a == e + "";
    case G2:
      var u = R2;
    case K2:
      var d = o & q2;
      if (u || (u = z2), a.size != e.size && !d)
        return !1;
      var m = i.get(a);
      if (m)
        return m == e;
      o |= Z2, i.set(a, e);
      var v = B2(u(a), u(e), o, r, s, i);
      return i.delete(a), v;
    case Y2:
      if (On)
        return On.call(a) == On.call(e);
  }
  return !1;
}
var ry = ty;
function sy(a, e) {
  for (var t = -1, o = e.length, r = a.length; ++t < o; )
    a[r + t] = e[t];
  return a;
}
var iy = sy, ny = Array.isArray, Ri = ny;
const kn = /* @__PURE__ */ ea(Ri);
var oy = iy, ay = Ri;
function ly(a, e, t) {
  var o = e(a);
  return ay(a) ? o : oy(o, t(a));
}
var uy = ly;
function cy(a, e) {
  for (var t = -1, o = a == null ? 0 : a.length, r = 0, s = []; ++t < o; ) {
    var i = a[t];
    e(i, t, a) && (s[r++] = i);
  }
  return s;
}
var hy = cy;
function dy() {
  return [];
}
var fy = dy, py = hy, my = fy, vy = Object.prototype, gy = vy.propertyIsEnumerable, Jl = Object.getOwnPropertySymbols, yy = Jl ? function(a) {
  return a == null ? [] : (a = Object(a), py(Jl(a), function(e) {
    return gy.call(a, e);
  }));
} : my, _y = yy;
function by(a, e) {
  for (var t = -1, o = Array(a); ++t < a; )
    o[t] = e(t);
  return o;
}
var wy = by;
function Py(a) {
  return a != null && typeof a == "object";
}
var zi = Py, xy = Ji, Sy = zi, Ty = "[object Arguments]";
function Ly(a) {
  return Sy(a) && xy(a) == Ty;
}
var Cy = Ly, Ul = Cy, Ay = zi, ih = Object.prototype, Oy = ih.hasOwnProperty, ky = ih.propertyIsEnumerable, Iy = Ul(/* @__PURE__ */ function() {
  return arguments;
}()) ? Ul : function(a) {
  return Ay(a) && Oy.call(a, "callee") && !ky.call(a, "callee");
}, jy = Iy, bi = { exports: {} };
function Ey() {
  return !1;
}
var Dy = Ey;
bi.exports;
(function(a, e) {
  var t = Ft, o = Dy, r = e && !e.nodeType && e, s = r && !0 && a && !a.nodeType && a, i = s && s.exports === r, u = i ? t.Buffer : void 0, d = u ? u.isBuffer : void 0, m = d || o;
  a.exports = m;
})(bi, bi.exports);
var nh = bi.exports, My = 9007199254740991, Ny = /^(?:0|[1-9]\d*)$/;
function Jy(a, e) {
  var t = typeof a;
  return e = e ?? My, !!e && (t == "number" || t != "symbol" && Ny.test(a)) && a > -1 && a % 1 == 0 && a < e;
}
var Uy = Jy, By = 9007199254740991;
function Ry(a) {
  return typeof a == "number" && a > -1 && a % 1 == 0 && a <= By;
}
var oh = Ry, zy = Ji, qy = oh, Zy = zi, Vy = "[object Arguments]", $y = "[object Array]", Fy = "[object Boolean]", Gy = "[object Date]", Hy = "[object Error]", Wy = "[object Function]", Ky = "[object Map]", Qy = "[object Number]", Yy = "[object Object]", Xy = "[object RegExp]", e_ = "[object Set]", t_ = "[object String]", r_ = "[object WeakMap]", s_ = "[object ArrayBuffer]", i_ = "[object DataView]", n_ = "[object Float32Array]", o_ = "[object Float64Array]", a_ = "[object Int8Array]", l_ = "[object Int16Array]", u_ = "[object Int32Array]", c_ = "[object Uint8Array]", h_ = "[object Uint8ClampedArray]", d_ = "[object Uint16Array]", f_ = "[object Uint32Array]", Ue = {};
Ue[n_] = Ue[o_] = Ue[a_] = Ue[l_] = Ue[u_] = Ue[c_] = Ue[h_] = Ue[d_] = Ue[f_] = !0;
Ue[Vy] = Ue[$y] = Ue[s_] = Ue[Fy] = Ue[i_] = Ue[Gy] = Ue[Hy] = Ue[Wy] = Ue[Ky] = Ue[Qy] = Ue[Yy] = Ue[Xy] = Ue[e_] = Ue[t_] = Ue[r_] = !1;
function p_(a) {
  return Zy(a) && qy(a.length) && !!Ue[zy(a)];
}
var m_ = p_;
function v_(a) {
  return function(e) {
    return a(e);
  };
}
var g_ = v_, wi = { exports: {} };
wi.exports;
(function(a, e) {
  var t = Qc, o = e && !e.nodeType && e, r = o && !0 && a && !a.nodeType && a, s = r && r.exports === o, i = s && t.process, u = function() {
    try {
      var d = r && r.require && r.require("util").types;
      return d || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  a.exports = u;
})(wi, wi.exports);
var y_ = wi.exports, __ = m_, b_ = g_, Bl = y_, Rl = Bl && Bl.isTypedArray, w_ = Rl ? b_(Rl) : __, ah = w_, P_ = wy, x_ = jy, S_ = Ri, T_ = nh, L_ = Uy, C_ = ah, A_ = Object.prototype, O_ = A_.hasOwnProperty;
function k_(a, e) {
  var t = S_(a), o = !t && x_(a), r = !t && !o && T_(a), s = !t && !o && !r && C_(a), i = t || o || r || s, u = i ? P_(a.length, String) : [], d = u.length;
  for (var m in a)
    (e || O_.call(a, m)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (m == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (m == "offset" || m == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (m == "buffer" || m == "byteLength" || m == "byteOffset") || // Skip index properties.
    L_(m, d))) && u.push(m);
  return u;
}
var I_ = k_, j_ = Object.prototype;
function E_(a) {
  var e = a && a.constructor, t = typeof e == "function" && e.prototype || j_;
  return a === t;
}
var D_ = E_;
function M_(a, e) {
  return function(t) {
    return a(e(t));
  };
}
var N_ = M_, J_ = N_, U_ = J_(Object.keys, Object), B_ = U_, R_ = D_, z_ = B_, q_ = Object.prototype, Z_ = q_.hasOwnProperty;
function V_(a) {
  if (!R_(a))
    return z_(a);
  var e = [];
  for (var t in Object(a))
    Z_.call(a, t) && t != "constructor" && e.push(t);
  return e;
}
var $_ = V_, F_ = eh, G_ = oh;
function H_(a) {
  return a != null && G_(a.length) && !F_(a);
}
var W_ = H_, K_ = I_, Q_ = $_, Y_ = W_;
function X_(a) {
  return Y_(a) ? K_(a) : Q_(a);
}
var eb = X_, tb = uy, rb = _y, sb = eb;
function ib(a) {
  return tb(a, sb, rb);
}
var nb = ib, zl = nb, ob = 1, ab = Object.prototype, lb = ab.hasOwnProperty;
function ub(a, e, t, o, r, s) {
  var i = t & ob, u = zl(a), d = u.length, m = zl(e), v = m.length;
  if (d != v && !i)
    return !1;
  for (var p = d; p--; ) {
    var g = u[p];
    if (!(i ? g in e : lb.call(e, g)))
      return !1;
  }
  var w = s.get(a), _ = s.get(e);
  if (w && _)
    return w == e && _ == a;
  var P = !0;
  s.set(a, e), s.set(e, a);
  for (var T = i; ++p < d; ) {
    g = u[p];
    var k = a[g], x = e[g];
    if (o)
      var C = i ? o(x, k, g, e, a, s) : o(k, x, g, a, e, s);
    if (!(C === void 0 ? k === x || r(k, x, t, o, s) : C)) {
      P = !1;
      break;
    }
    T || (T = g == "constructor");
  }
  if (P && !T) {
    var I = a.constructor, z = e.constructor;
    I != z && "constructor" in a && "constructor" in e && !(typeof I == "function" && I instanceof I && typeof z == "function" && z instanceof z) && (P = !1);
  }
  return s.delete(a), s.delete(e), P;
}
var cb = ub, hb = Vr, db = Ft, fb = hb(db, "DataView"), pb = fb, mb = Vr, vb = Ft, gb = mb(vb, "Promise"), yb = gb, _b = Vr, bb = Ft, wb = _b(bb, "Set"), Pb = wb, xb = Vr, Sb = Ft, Tb = xb(Sb, "WeakMap"), Lb = Tb, qn = pb, Zn = ra, Vn = yb, $n = Pb, Fn = Lb, lh = Ji, Hr = th, ql = "[object Map]", Cb = "[object Object]", Zl = "[object Promise]", Vl = "[object Set]", $l = "[object WeakMap]", Fl = "[object DataView]", Ab = Hr(qn), Ob = Hr(Zn), kb = Hr(Vn), Ib = Hr($n), jb = Hr(Fn), hr = lh;
(qn && hr(new qn(new ArrayBuffer(1))) != Fl || Zn && hr(new Zn()) != ql || Vn && hr(Vn.resolve()) != Zl || $n && hr(new $n()) != Vl || Fn && hr(new Fn()) != $l) && (hr = function(a) {
  var e = lh(a), t = e == Cb ? a.constructor : void 0, o = t ? Hr(t) : "";
  if (o)
    switch (o) {
      case Ab:
        return Fl;
      case Ob:
        return ql;
      case kb:
        return Zl;
      case Ib:
        return Vl;
      case jb:
        return $l;
    }
  return e;
});
var Eb = hr, In = h2, Db = sh, Mb = ry, Nb = cb, Gl = Eb, Hl = Ri, Wl = nh, Jb = ah, Ub = 1, Kl = "[object Arguments]", Ql = "[object Array]", ei = "[object Object]", Bb = Object.prototype, Yl = Bb.hasOwnProperty;
function Rb(a, e, t, o, r, s) {
  var i = Hl(a), u = Hl(e), d = i ? Ql : Gl(a), m = u ? Ql : Gl(e);
  d = d == Kl ? ei : d, m = m == Kl ? ei : m;
  var v = d == ei, p = m == ei, g = d == m;
  if (g && Wl(a)) {
    if (!Wl(e))
      return !1;
    i = !0, v = !1;
  }
  if (g && !v)
    return s || (s = new In()), i || Jb(a) ? Db(a, e, t, o, r, s) : Mb(a, e, d, t, o, r, s);
  if (!(t & Ub)) {
    var w = v && Yl.call(a, "__wrapped__"), _ = p && Yl.call(e, "__wrapped__");
    if (w || _) {
      var P = w ? a.value() : a, T = _ ? e.value() : e;
      return s || (s = new In()), r(P, T, t, o, s);
    }
  }
  return g ? (s || (s = new In()), Nb(a, e, t, o, r, s)) : !1;
}
var zb = Rb, qb = zb, Xl = zi;
function uh(a, e, t, o, r) {
  return a === e ? !0 : a == null || e == null || !Xl(a) && !Xl(e) ? a !== a && e !== e : qb(a, e, t, o, uh, r);
}
var Zb = uh, Vb = Zb;
function $b(a, e) {
  return Vb(a, e);
}
var Fb = $b;
const bs = /* @__PURE__ */ ea(Fb), Gb = { class: "relative" }, Hb = ["value", "required", "name"], Wb = { class: "flex flex-row items-center gap-2" }, Kb = { class: "text-gray-900" }, ch = /* @__PURE__ */ G({
  __name: "RadioInput",
  props: /* @__PURE__ */ lt({
    items: {},
    name: {},
    required: { type: Boolean },
    readonly: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a) {
    const e = a, t = U(() => {
      var i;
      const s = ze(r.value);
      return (i = e.items) == null ? void 0 : i.find((u) => bs(s, u.value));
    }), o = (s) => {
      e.readonly || (r.value = s == null ? void 0 : s.value);
    }, r = bt(a, "modelValue");
    return (s, i) => (j(), R("fieldset", Gb, [
      A("input", {
        type: "text",
        value: r.value !== void 0 ? r.value : "",
        required: s.required,
        name: s.name,
        class: "pointer-events-none absolute h-full opacity-0"
      }, null, 8, Hb),
      $(D(a0), {
        modelValue: t.value,
        "onUpdate:modelValue": o,
        class: "flex flex-col gap-2",
        disabled: s.readonly
      }, {
        default: ee(() => [
          (j(!0), R(Se, null, Ke(s.items, (u) => (j(), ne(D(u0), {
            as: "template",
            key: u.text,
            value: u,
            "aria-label": u.text
          }, {
            default: ee(({ checked: d }) => [
              A("div", Wb, [
                A("div", {
                  class: ae(["relative h-6 w-6 flex-shrink-0 rounded-full border-2", [d ? "border-primary-500 bg-primary-500" : "border-gray-600", s.readonly ? "cursor-not-allowed" : "cursor-pointer"]])
                }, [
                  d ? (j(), ne(D(je), {
                    key: 0,
                    class: "absolute left-1/2 top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 text-white",
                    icon: ["fal", "check"]
                  })) : te("", !0)
                ], 2),
                A("label", Kb, V(u.text), 1)
              ])
            ]),
            _: 2
          }, 1032, ["value", "aria-label"]))), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]));
  }
}), Qb = { class: "relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 dark:text-white" }, Yb = /* @__PURE__ */ G({
  __name: "SelectInputItems",
  props: {
    category: {}
  },
  setup(a) {
    const e = Fe("level", 0);
    Qe("level", e + 1);
    const t = Fe("expanded"), o = Fe("toggleExpanded");
    return (r, s) => {
      const i = Yn("SelectInputItems", !0);
      return j(), R(Se, null, [
        r.category.category !== "" ? (j(), ne(D(Ll), {
          key: 0,
          as: "template",
          disabled: !0
        }, {
          default: ee(() => [
            A("li", Qb, [
              A("span", {
                class: "flex cursor-pointer items-center gap-2 text-xs font-semibold uppercase text-gray-400",
                style: _t(`padding-left: ${D(e) * 0.5}rem`),
                onClick: s[0] || (s[0] = St((u) => D(o)(r.category.path), ["stop"]))
              }, [
                $(D(je), {
                  icon: ["fal", "chevron-right"],
                  class: ae(["h-3 w-3 transition", D(t)[r.category.path] ? "rotate-90" : void 0])
                }, null, 8, ["class"]),
                r.category.icon ? (j(), R(Se, { key: 0 }, [
                  r.category.icon ? (j(), ne(D(je), {
                    key: 0,
                    icon: ["fal", r.category.icon],
                    class: "h-4 w-4"
                  }, null, 8, ["icon"])) : te("", !0)
                ], 64)) : te("", !0),
                A("span", null, V(r.category.category), 1)
              ], 4)
            ])
          ]),
          _: 1
        })) : te("", !0),
        r.category.category === "" || D(t)[r.category.path] ? (j(), R(Se, { key: 1 }, [
          r.category.subCategories ? (j(!0), R(Se, { key: 0 }, Ke(r.category.subCategories, (u) => (j(), ne(i, {
            category: u,
            key: u.category
          }, null, 8, ["category"]))), 128)) : te("", !0),
          (j(!0), R(Se, null, Ke(r.category.items, (u) => (j(), ne(D(Ll), {
            as: "template",
            key: u.text,
            value: u
          }, {
            default: ee(({ active: d, selected: m }) => [
              A("li", {
                class: ae([d ? "bg-primary-600 text-white" : "text-gray-900 dark:text-white", "relative cursor-default select-none py-2 pl-3 pr-9"]),
                style: _t(r.category.category !== "" ? `padding-left: ${(D(e) + 1) * 1.4}rem` : "")
              }, [
                A("span", {
                  class: ae([m ? "font-semibold" : "font-normal", "block cursor-pointer truncate"])
                }, [
                  ge(r.$slots, "item", {
                    item: u,
                    active: d
                  }, () => [
                    Oe(V(u.text), 1)
                  ])
                ], 2),
                m ? (j(), R("span", {
                  key: 0,
                  class: ae([d ? "text-white" : "text-primary-600", "absolute inset-y-0 right-0 flex items-center pr-4"])
                }, [
                  $(D(je), {
                    icon: ["fal", "check"],
                    class: "h-4 w-4",
                    "aria-hidden": "true"
                  })
                ], 2)) : te("", !0)
              ], 6)
            ]),
            _: 2
          }, 1032, ["value"]))), 128))
        ], 64)) : te("", !0)
      ], 64);
    };
  }
}), Xb = { class: "relative min-w-0" }, e1 = {
  key: 0,
  class: "flex flex-wrap gap-1 overflow-hidden"
}, t1 = {
  key: 2,
  class: "dark:text-dark-500 truncate text-gray-400"
}, r1 = {
  key: 3,
  class: "dark:text-dark-500 truncate text-gray-400"
}, s1 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2" }, Zt = /* @__PURE__ */ G({
  __name: "SelectInput",
  props: {
    items: {},
    modelValue: {},
    name: {},
    label: {},
    disabled: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    placeholder: {},
    noItemsText: {},
    dropdownClass: { default: "w-44" },
    buttonFocusClass: { default: "focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:border-primary-500 dark:focus:ring-primary-500" },
    buttonClass: {},
    clearable: { type: Boolean, default: !1 },
    clearText: {}
  },
  emits: ["update:modelValue"],
  setup(a, { emit: e }) {
    const [t, o] = eo({
      placement: "bottom-start",
      strategy: "fixed",
      modifiers: [{ name: "offset", options: { offset: [0, 10] } }]
    }), { t: r } = At(), s = a, i = e, u = B({}), d = U(() => {
      const x = s.items ?? [];
      return s.clearable ? [{ value: void 0, text: s.clearText ?? "" }, ...x] : x;
    }), m = (x) => s.clearable && (x == null ? void 0 : x.value) === void 0, v = U(() => {
      if (s.multiple && Array.isArray(s.modelValue)) {
        const C = s.modelValue;
        return d.value.filter((I) => C.find((z) => bs(z, I.value)) !== void 0);
      }
      const x = ze(s.modelValue);
      return x instanceof Vt ? d.value.find((C) => C.value.toISO() === x.toISO()) : d.value.find((C) => bs(x, C.value));
    }), p = U(() => v.value), g = U(() => v.value), w = U(() => {
      const x = (C, I) => {
        let z, H = "";
        for (const F of C)
          if (H += "/" + F.name, z) {
            z.subCategories ?? (z.subCategories = []);
            let se = z.subCategories.find((pe) => pe.category === F.name);
            se || (se = {
              path: H,
              category: F.name,
              icon: F.icon
            }, z.subCategories.push(se)), z = se;
          } else {
            if (z = I.find((se) => se.category === F.name), z) continue;
            z = {
              path: H,
              category: F.name,
              icon: F.icon
            }, I.push(z);
          }
        return z;
      };
      return d.value.reduce((C, I) => {
        var H, F;
        const z = x(
          kn(I.category) ? I.category.map((se) => ({ name: se.name, icon: se.icon ?? "" })) : [{ name: ((H = I == null ? void 0 : I.category) == null ? void 0 : H.name) ?? "", icon: ((F = I == null ? void 0 : I.category) == null ? void 0 : F.icon) ?? "" }],
          C
        );
        return z && (z.items ?? (z.items = []), z.items.push(I)), C;
      }, []);
    });
    Ie(
      () => w.value,
      () => {
        var I, z, H;
        const x = kn((I = p.value) == null ? void 0 : I.category) ? (z = p.value) == null ? void 0 : z.category : [((H = p.value) == null ? void 0 : H.category) ?? ""];
        u.value = {};
        let C = "";
        for (const F of x)
          C += "/" + F, u.value[C] = !0;
      },
      { immediate: !0 }
    );
    const _ = (x) => {
      u.value[x] = !u.value[x];
    }, P = (x) => {
      s.multiple && Array.isArray(x) ? i(
        "update:modelValue",
        x.map((C) => C.value)
      ) : i("update:modelValue", x.value);
    }, T = U(() => {
      var x, C, I, z, H, F;
      return (x = p.value) != null && x.category ? kn((C = p.value) == null ? void 0 : C.category) ? `${((I = p.value) == null ? void 0 : I.category.map((pe) => pe.name)).join(" > ")} - ${p.value.text}` : `${(z = p.value) == null ? void 0 : z.category.name} - ${(H = p.value) == null ? void 0 : H.text}` : (F = p.value) == null ? void 0 : F.text;
    }), k = () => {
      setTimeout(() => {
        var x;
        return (x = t.value) == null ? void 0 : x.el.focus();
      }, 10);
    };
    return Qe("level", 0), Qe("expanded", u), Qe("toggleExpanded", _), (x, C) => (j(), ne(D(Hm), {
      class: "space-y-1",
      as: "div",
      "model-value": v.value,
      "onUpdate:modelValue": P,
      disabled: x.disabled || d.value.length === 0,
      multiple: x.multiple
    }, {
      default: ee(() => [
        x.label ? (j(), ne(D(Wm), {
          key: 0,
          class: "block text-sm font-medium text-gray-700 dark:text-white"
        }, {
          default: ee(() => [
            Oe(V(x.label), 1)
          ]),
          _: 1
        })) : te("", !0),
        A("div", Xb, [
          $(D(Km), {
            ref_key: "trigger",
            ref: t,
            class: ae([[x.buttonClass, x.buttonFocusClass, x.disabled ? "cursor-not-allowed" : "cursor-pointer"], "relative min-h-[34px] w-full min-w-0 rounded-md border border-gray-200 bg-transparent bg-white px-3 py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-inset focus-visible:outline-none dark:text-white sm:text-sm"]),
            onClick: k
          }, {
            default: ee(() => {
              var I;
              return [
                x.multiple ? (j(), R("div", e1, [
                  (j(!0), R(Se, null, Ke(g.value, (z) => (j(), R("span", {
                    key: `item-${z.value}`,
                    class: "dark:bg-dark-700 inline-flex items-center truncate whitespace-nowrap rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-800 dark:text-white"
                  }, [
                    ge(x.$slots, "item", { item: z }, () => [
                      Oe(V(z.text), 1)
                    ])
                  ]))), 128))
                ])) : (j(), R("span", {
                  key: 1,
                  class: ae(["block min-w-0 truncate", { "italic text-gray-400": m(p.value) }])
                }, [
                  ge(x.$slots, "item", { item: p.value }, () => [
                    Oe(V(T.value), 1)
                  ])
                ], 2)),
                d.value.length ? te("", !0) : (j(), R("span", t1, V(x.noItemsText ?? D(r)("common.no_items_available")), 1)),
                d.value.length && (!p.value && !x.multiple || !((I = g.value) != null && I.length) && x.multiple) && x.placeholder ? (j(), R("span", r1, V(x.placeholder), 1)) : te("", !0),
                A("span", s1, [
                  $(D(je), {
                    icon: ["fal", "caret-down"],
                    class: "h-4 w-4 text-gray-400",
                    "aria-hidden": "true"
                  })
                ])
              ];
            }),
            _: 3
          }, 8, ["class"]),
          (j(), ne(Qn, { to: "body" }, [
            $(D(Qm), {
              ref_key: "container",
              ref: o,
              class: ae(["dark:ring-dark-700 absolute right-0 z-50 mt-1 max-h-60 min-w-max origin-top-right overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", [x.dropdownClass]])
            }, {
              default: ee(() => [
                (j(!0), R(Se, null, Ke(w.value, (I) => (j(), ne(Yb, {
                  category: I,
                  key: I.category
                }, {
                  item: ee(({ item: z, active: H }) => [
                    ge(x.$slots, "item", {
                      item: z,
                      active: H
                    }, () => [
                      A("span", {
                        class: ae(m(z) ? H ? "italic" : "italic text-gray-400 opacity-75" : "")
                      }, V(z == null ? void 0 : z.text), 3)
                    ])
                  ]),
                  _: 2
                }, 1032, ["category"]))), 128))
              ]),
              _: 3
            }, 8, ["class"])
          ]))
        ])
      ]),
      _: 3
    }, 8, ["model-value", "disabled", "multiple"]));
  }
}), i1 = { class: "text-lg font-medium" }, n1 = { class: "grid gap-2" }, o1 = { class: "leading-tight text-gray-900" }, a1 = { class: "font-semibold" }, l1 = { class: "text-sm" }, u1 = { class: "text-sm" }, c1 = { class: "flex min-w-full gap-2" }, qP = /* @__PURE__ */ G({
  __name: "AddressInputGroup",
  props: {
    contactType: {},
    contact: {},
    hideContactType: { type: Boolean, default: !1 }
  },
  emits: ["update"],
  setup(a, { emit: e }) {
    const { t } = At(), { enumToSelectionItems: o } = Vp(), { notifyApiException: r } = fc(), [s] = pr(vu.name), [i] = pr(gu.name), u = a, d = e, m = B(new We({})), v = o(hc, "address_details.countries"), p = B([]), g = async (T) => {
      try {
        return await s.search(T, m.value.contactType);
      } catch (k) {
        return r(k), [];
      }
    }, w = (T) => {
      m.value.id || (m.value = { ...m.value, ...T });
    }, _ = async () => {
      if (!(!m.value.zip || !m.value.country))
        try {
          p.value = await i.getCities(m.value.zip, m.value.country);
        } catch (T) {
          r(T);
        }
    }, P = async (T) => p.value.filter((k) => k.toLowerCase().includes(T.toLowerCase())) ?? [];
    return Ie(
      () => [u.contact],
      () => {
        u.contact ? m.value = u.contact : m.value = new We({
          country: v[0].value,
          contactType: u.contactType
        });
      },
      { immediate: !0 }
    ), Ie(
      () => u.contactType,
      (T, k) => {
        T !== k && (u.contact ? m.value = { ...m.value, contactType: T } : m.value = new We({
          country: v[0].value,
          contactType: T
        }));
      }
    ), Ie(
      () => [
        m.value,
        m.value.name,
        m.value.country,
        m.value.street,
        m.value.details,
        m.value.zip,
        m.value.city,
        m.value.contactType
      ],
      () => d("update", m.value)
    ), (T, k) => (j(), R("div", null, [
      A("h3", i1, V(D(t)("address_details.address")), 1),
      A("div", n1, [
        T.hideContactType ? te("", !0) : (j(), R("div", {
          key: 0,
          class: ae(T.contactType !== void 0 && "cursor-not-allowed opacity-25")
        }, [
          $(Mt, { name: "contactType" }, {
            default: ee(() => [
              Oe(V(D(t)("contact_types.contact_type", 1)), 1)
            ]),
            _: 1
          }),
          $(ch, {
            name: "contactType",
            modelValue: m.value.contactType,
            "onUpdate:modelValue": k[0] || (k[0] = (x) => m.value.contactType = x),
            items: [
              { value: D(ni).Business, text: D(t)("contact_types.business") },
              { value: D(ni).Private, text: D(t)("contact_types.private") }
            ],
            required: !0,
            readonly: T.contactType !== void 0
          }, null, 8, ["modelValue", "items", "readonly"])
        ], 2)),
        $(yl, {
          name: "name",
          modelValue: m.value.name,
          "onUpdate:modelValue": k[1] || (k[1] = (x) => m.value.name = x),
          label: D(t)(m.value.contactType == D(ni).Business ? "address_details.company_name" : "address_details.name"),
          "search-function": m.value.id ? void 0 : g,
          required: !0,
          autocomplete: "off",
          onSelect: w
        }, {
          item: ee(({ item: x }) => [
            A("div", o1, [
              A("p", a1, V(x.name), 1),
              A("p", l1, V(x.street), 1),
              A("p", u1, V(x.zip) + " " + V(x.city), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "label", "search-function"]),
        $(Zt, {
          items: D(v),
          modelValue: m.value.country,
          "onUpdate:modelValue": k[2] || (k[2] = (x) => m.value.country = x),
          label: D(t)("address_details.country"),
          name: "country"
        }, null, 8, ["items", "modelValue", "label"]),
        $(dt, {
          name: "street",
          label: D(t)("address_details.street"),
          modelValue: m.value.street,
          "onUpdate:modelValue": k[3] || (k[3] = (x) => m.value.street = x),
          required: !0,
          autocomplete: "off"
        }, null, 8, ["label", "modelValue"]),
        $(dt, {
          name: "details",
          label: D(t)("address_details.details"),
          modelValue: m.value.details,
          "onUpdate:modelValue": k[4] || (k[4] = (x) => m.value.details = x),
          autocomplete: "off"
        }, null, 8, ["label", "modelValue"]),
        A("div", c1, [
          $(dt, {
            class: "w-28",
            name: "zip",
            label: D(t)("address_details.zip"),
            modelValue: m.value.zip,
            "onUpdate:modelValue": k[5] || (k[5] = (x) => m.value.zip = x),
            required: !0,
            autocomplete: "off",
            onFocusout: _
          }, null, 8, ["label", "modelValue"]),
          $(yl, {
            class: "w-0 flex-1",
            required: !0,
            autocomplete: "off",
            name: "city",
            modelValue: m.value.city,
            "onUpdate:modelValue": k[6] || (k[6] = (x) => m.value.city = x),
            label: D(t)("address_details.city"),
            "min-search-length": 0,
            "search-function": P,
            onSelect: k[7] || (k[7] = (x) => m.value.city = x)
          }, null, 8, ["modelValue", "label"])
        ])
      ])
    ]));
  }
}), h1 = ["name"], ZP = /* @__PURE__ */ G({
  __name: "Badge",
  props: {
    name: {},
    color: { default: "#000000" }
  },
  setup(a) {
    const e = a, t = U(() => {
      const r = e.color.replace("#", "");
      if (r.length !== 3 && r.length !== 6)
        return "#000000";
      const s = parseInt(r.length === 3 ? r[0] + r[0] : r.substring(0, 2), 16), i = parseInt(r.length === 3 ? r[1] + r[1] : r.substring(2, 4), 16), u = parseInt(r.length === 3 ? r[2] + r[2] : r.substring(4, 6), 16);
      return Number.isNaN(s) || Number.isNaN(i) || Number.isNaN(u) || (s * 299 + i * 587 + u * 114) / 1e3 >= 128 ? "#000000" : "#ffffff";
    });
    return (o, r) => (j(), R("span", {
      name: e.name,
      class: "inline-flex items-center gap-x-1.5 rounded-md border border-transparent px-1.5 py-0.5 text-sm/5 font-medium sm:text-xs/5 forced-colors:outline",
      style: _t({
        backgroundColor: `color-mix(in srgb, ${e.color}, transparent 15%)`,
        color: t.value
      })
    }, [
      ge(o.$slots, "default")
    ], 12, h1));
  }
}), d1 = ["disabled"], f1 = { class: "flex items-center gap-2" }, ws = /* @__PURE__ */ G({
  __name: "Button",
  props: {
    variant: { default: "primary" },
    loading: { type: Boolean, default: !1 },
    icon: {},
    disabled: { type: Boolean }
  },
  setup(a) {
    return (e, t) => (j(), R("button", {
      class: ae(["dark:ring-offset-dark-800 inline-flex min-h-[34px] shrink-0 items-center justify-center rounded-md border px-3 py-1.5 text-sm font-medium shadow-sm ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-opacity-25", {
        "border-transparent bg-primary-500 text-white lg:enabled:hover:bg-primary-700": e.variant === "primary",
        "dark:border-dark-700 dark:bg-dark-800 dark:hover:border-dark-500 dark:hover:bg-dark-900 border-gray-300 border-transparent bg-gray-100 text-gray-700 dark:text-white dark:hover:text-white": e.variant === "default",
        "border-gray-300 bg-white text-gray-700 disabled:text-gray-500": e.variant === "outline",
        "border-none !p-0 text-primary-600 !shadow-none disabled:text-gray-500": e.variant === "text"
      }]),
      type: "button",
      disabled: e.loading || e.disabled
    }, [
      e.loading ? (j(), ne(Ai, {
        key: 0,
        class: "mr-2 !h-4 !w-4 !border dark:border-white"
      })) : te("", !0),
      A("div", f1, [
        e.icon ? (j(), ne(D(je), {
          key: 0,
          icon: ["fal", e.icon],
          class: "h-3 w-3",
          "aria-hidden": "true"
        }, null, 8, ["icon"])) : te("", !0),
        ge(e.$slots, "default")
      ])
    ], 10, d1));
  }
}), p1 = { class: "relative" }, m1 = ["value", "required", "name"], v1 = {
  key: 0,
  class: "space-y-1"
}, g1 = { class: "z-0 inline-flex rounded-md shadow-sm sm:h-12 md:h-[34px]" }, y1 = ["onClick"], hh = /* @__PURE__ */ G({
  __name: "ButtonSelection",
  props: {
    items: {},
    modelValue: {},
    name: {},
    label: {},
    disabled: { type: Boolean, default: !1 },
    indeterminable: { type: Boolean },
    required: { type: Boolean },
    readonly: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: e }) {
    const t = a, o = e, r = (s) => {
      if (!(t.disabled || t.readonly)) {
        if (t.modelValue === s.value) {
          t.indeterminable && o("update:modelValue", void 0);
          return;
        }
        o("update:modelValue", s.value);
      }
    };
    return (s, i) => (j(), R("div", p1, [
      A("input", {
        type: "text",
        value: s.modelValue !== void 0 ? s.modelValue : "",
        required: s.required,
        name: s.name,
        class: "pointer-events-none absolute h-full opacity-0"
      }, null, 8, m1),
      s.label ? (j(), R("div", v1, [
        s.label ? (j(), ne(Mt, {
          key: 0,
          name: s.name
        }, {
          default: ee(() => [
            Oe(V(s.label), 1)
          ]),
          _: 1
        }, 8, ["name"])) : te("", !0)
      ])) : te("", !0),
      A("span", g1, [
        (j(!0), R(Se, null, Ke(s.items, (u) => (j(), R("button", {
          key: u.text,
          type: "button",
          onClick: (d) => !s.disabled && r(u),
          class: ae([
            u.value === s.modelValue ? "!bg-primary-500 text-white" : "dark:bg-dark-800 bg-white",
            s.disabled ? "bg-dark-300 dark:bg-dark-600 cursor-default text-gray-800 opacity-40 dark:text-white" : s.readonly ? "cursor-default" : "cursor-pointer focus:z-10 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500",
            "dark:border-dark-600 relative -ml-px inline-flex items-center border border-gray-300 px-6 py-3 text-base font-medium text-gray-800 first:rounded-l-md last:rounded-r-md dark:text-white md:px-3 md:py-1.5"
          ])
        }, [
          ge(s.$slots, "item", { item: u }, () => [
            Oe(V(u.text), 1)
          ])
        ], 10, y1))), 128))
      ])
    ]));
  }
}), _1 = {}, b1 = { class: "rounded-lg border bg-white px-5 py-2 shadow-sm" };
function w1(a, e) {
  return j(), R("div", b1, [
    ge(a.$slots, "default")
  ]);
}
const VP = /* @__PURE__ */ pc(_1, [["render", w1]]), P1 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let x1 = (a = 21) => {
  let e = "", t = crypto.getRandomValues(new Uint8Array(a |= 0));
  for (; a--; )
    e += P1[t[a] & 63];
  return e;
};
const S1 = { class: "relative flex flex-col gap-2" }, T1 = ["value", "required", "name"], L1 = { class: "relative" }, C1 = ["checked", "id", "disabled", "onChange"], A1 = ["for"], O1 = /* @__PURE__ */ G({
  __name: "CheckboxInput",
  props: /* @__PURE__ */ lt({
    items: {},
    name: {},
    required: { type: Boolean },
    readonly: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a) {
    const e = a, t = x1(), o = U(() => {
      var u;
      let i = [];
      return s.value !== void 0 && (i = s.value), (u = e.items) == null ? void 0 : u.map((d) => ({ selected: i.find((v) => bs(v, d.value)) !== void 0, item: d }));
    }), r = (i, u) => {
      if (!e.readonly && !(!(i.target instanceof HTMLInputElement) || i.target.checked === void 0))
        if (i.target.checked) {
          const d = s.value === void 0 ? [] : s.value;
          d.push(u == null ? void 0 : u.value), s.value = d;
        } else
          s.value = (s.value === void 0 ? [] : s.value).filter((d) => !bs(d, u == null ? void 0 : u.value));
    }, s = bt(a, "modelValue");
    return (i, u) => (j(), R("fieldset", S1, [
      A("input", {
        type: "text",
        value: s.value !== void 0 ? s.value : "",
        required: i.required,
        name: i.name,
        class: "pointer-events-none absolute h-full opacity-0"
      }, null, 8, T1),
      (j(!0), R(Se, null, Ke(o.value, (d, m) => (j(), R("div", {
        class: "flex items-center gap-2",
        key: m
      }, [
        A("div", L1, [
          A("input", {
            type: "checkbox",
            class: "h-6 w-6 cursor-pointer appearance-none rounded-sm border-2 border-gray-600 outline-none checked:border-primary-500 checked:bg-primary-500 hover:text-primary-600 focus:text-primary-600 focus:ring-2 focus:ring-primary-600",
            checked: d.selected,
            id: `${D(t)}-${d.item.text}`,
            disabled: i.readonly,
            onChange: (v) => r(v, d.item)
          }, null, 40, C1)
        ]),
        A("label", {
          class: "text-gray-900",
          for: `${D(t)}-${d.item.text}`
        }, V(d.item.text), 9, A1)
      ]))), 128))
    ]));
  }
}), k1 = { class: "flex flex-col gap-y-2" }, I1 = { class: "flex flex-col gap-y-1" }, j1 = { class: "relative" }, E1 = { class: "shadow-xs flex w-full items-center rounded-md border-[1px] border-gray-200 bg-gray-100" }, D1 = ["type", "name", "id", "placeholder", "disabled", "autocomplete", "readonly", "pattern", "title"], M1 = { class: "absolute inset-y-0 right-0 flex items-center pr-3" }, N1 = {
  key: 0,
  class: "flex flex-row flex-wrap gap-2 overflow-x-auto"
}, J1 = "Enter", $P = /* @__PURE__ */ G({
  __name: "ChipsInput",
  props: {
    modelValue: {},
    name: {},
    type: { default: "text" },
    label: {},
    placeholder: { default: "" },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    required: { type: Boolean },
    autocomplete: {},
    pattern: {},
    title: {},
    delimiter: { default: () => [";", ","] }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: e }) {
    const t = a, o = e, r = B(""), s = B(), i = (d) => {
      var m, v;
      !((m = s.value) != null && m.validity.valid) || r.value === "" || (d.key === J1 || t.delimiter.includes(d.key)) && (d.preventDefault(), (v = t.modelValue) != null && v.includes(r.value) || o("update:modelValue", (t.modelValue ?? []).concat([r.value])), r.value = "");
    };
    du(s, () => {
      var d, m;
      !((d = s.value) != null && d.validity.valid) || r.value === "" || ((m = t.modelValue) != null && m.includes(r.value) || o("update:modelValue", (t.modelValue ?? []).concat([r.value])), r.value = "");
    });
    const u = (d) => {
      !t.modelValue || t.modelValue.length === 0 || o(
        "update:modelValue",
        t.modelValue.filter((m) => m !== d)
      );
    };
    return (d, m) => (j(), R("div", k1, [
      A("div", I1, [
        d.label ? (j(), ne(Mt, {
          key: 0,
          name: d.name
        }, {
          default: ee(() => [
            Oe(V(d.label), 1)
          ]),
          _: 1
        }, 8, ["name"])) : te("", !0),
        A("div", j1, [
          A("div", E1, [
            Ur(A("input", {
              ref_key: "input",
              ref: s,
              "onUpdate:modelValue": m[0] || (m[0] = (v) => r.value = v),
              type: d.type,
              name: d.name,
              id: d.name,
              class: "placeholder:dark:text-dark-500 dark:read-only:text-dark-400 shadow-xs block max-w-full flex-1 rounded-md border-none bg-white px-3 py-1.5 placeholder:text-gray-400 read-only:text-gray-500 focus:border-primary-500 focus:ring-primary-500 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 dark:text-white dark:focus:border-primary-500 dark:focus:ring-primary-500 sm:text-sm",
              placeholder: d.placeholder,
              disabled: d.disabled,
              autocomplete: d.autocomplete,
              readonly: d.readonly,
              pattern: d.pattern,
              title: d.title,
              onKeydown: i
            }, null, 40, D1), [
              [Yd, r.value]
            ])
          ]),
          A("div", M1, [
            ge(d.$slots, "right")
          ])
        ])
      ]),
      d.modelValue && d.modelValue.length > 0 ? (j(), R("div", N1, [
        (j(!0), R(Se, null, Ke(d.modelValue, (v) => (j(), R("span", {
          class: "inline-flex w-auto items-center gap-1 whitespace-nowrap rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-900",
          key: v
        }, [
          Oe(V(v) + " ", 1),
          $(D(je), {
            class: "cursor-pointer align-middle",
            icon: ["fal", "xmark"],
            onClick: (p) => u(v)
          }, null, 8, ["onClick"])
        ]))), 128))
      ])) : ge(d.$slots, "placeholder", { key: 1 })
    ]));
  }
});
function Pi(a) {
  "@babel/helpers - typeof";
  return Pi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Pi(a);
}
var U1 = /^\s+/, B1 = /\s+$/;
function re(a, e) {
  if (a = a || "", e = e || {}, a instanceof re)
    return a;
  if (!(this instanceof re))
    return new re(a, e);
  var t = R1(a);
  this._originalInput = a, this._r = t.r, this._g = t.g, this._b = t.b, this._a = t.a, this._roundA = Math.round(100 * this._a) / 100, this._format = e.format || t.format, this._gradientType = e.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = t.ok;
}
re.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var a = this.toRgb();
    return (a.r * 299 + a.g * 587 + a.b * 114) / 1e3;
  },
  getLuminance: function() {
    var a = this.toRgb(), e, t, o, r, s, i;
    return e = a.r / 255, t = a.g / 255, o = a.b / 255, e <= 0.03928 ? r = e / 12.92 : r = Math.pow((e + 0.055) / 1.055, 2.4), t <= 0.03928 ? s = t / 12.92 : s = Math.pow((t + 0.055) / 1.055, 2.4), o <= 0.03928 ? i = o / 12.92 : i = Math.pow((o + 0.055) / 1.055, 2.4), 0.2126 * r + 0.7152 * s + 0.0722 * i;
  },
  setAlpha: function(a) {
    return this._a = dh(a), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var a = tu(this._r, this._g, this._b);
    return {
      h: a.h * 360,
      s: a.s,
      v: a.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var a = tu(this._r, this._g, this._b), e = Math.round(a.h * 360), t = Math.round(a.s * 100), o = Math.round(a.v * 100);
    return this._a == 1 ? "hsv(" + e + ", " + t + "%, " + o + "%)" : "hsva(" + e + ", " + t + "%, " + o + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var a = eu(this._r, this._g, this._b);
    return {
      h: a.h * 360,
      s: a.s,
      l: a.l,
      a: this._a
    };
  },
  toHslString: function() {
    var a = eu(this._r, this._g, this._b), e = Math.round(a.h * 360), t = Math.round(a.s * 100), o = Math.round(a.l * 100);
    return this._a == 1 ? "hsl(" + e + ", " + t + "%, " + o + "%)" : "hsla(" + e + ", " + t + "%, " + o + "%, " + this._roundA + ")";
  },
  toHex: function(a) {
    return ru(this._r, this._g, this._b, a);
  },
  toHexString: function(a) {
    return "#" + this.toHex(a);
  },
  toHex8: function(a) {
    return V1(this._r, this._g, this._b, this._a, a);
  },
  toHex8String: function(a) {
    return "#" + this.toHex8(a);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(Be(this._r, 255) * 100) + "%",
      g: Math.round(Be(this._g, 255) * 100) + "%",
      b: Math.round(Be(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(Be(this._r, 255) * 100) + "%, " + Math.round(Be(this._g, 255) * 100) + "%, " + Math.round(Be(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(Be(this._r, 255) * 100) + "%, " + Math.round(Be(this._g, 255) * 100) + "%, " + Math.round(Be(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : rw[ru(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(a) {
    var e = "#" + su(this._r, this._g, this._b, this._a), t = e, o = this._gradientType ? "GradientType = 1, " : "";
    if (a) {
      var r = re(a);
      t = "#" + su(r._r, r._g, r._b, r._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + o + "startColorstr=" + e + ",endColorstr=" + t + ")";
  },
  toString: function(a) {
    var e = !!a;
    a = a || this._format;
    var t = !1, o = this._a < 1 && this._a >= 0, r = !e && o && (a === "hex" || a === "hex6" || a === "hex3" || a === "hex4" || a === "hex8" || a === "name");
    return r ? a === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (a === "rgb" && (t = this.toRgbString()), a === "prgb" && (t = this.toPercentageRgbString()), (a === "hex" || a === "hex6") && (t = this.toHexString()), a === "hex3" && (t = this.toHexString(!0)), a === "hex4" && (t = this.toHex8String(!0)), a === "hex8" && (t = this.toHex8String()), a === "name" && (t = this.toName()), a === "hsl" && (t = this.toHslString()), a === "hsv" && (t = this.toHsvString()), t || this.toHexString());
  },
  clone: function() {
    return re(this.toString());
  },
  _applyModification: function(a, e) {
    var t = a.apply(null, [this].concat([].slice.call(e)));
    return this._r = t._r, this._g = t._g, this._b = t._b, this.setAlpha(t._a), this;
  },
  lighten: function() {
    return this._applyModification(H1, arguments);
  },
  brighten: function() {
    return this._applyModification(W1, arguments);
  },
  darken: function() {
    return this._applyModification(K1, arguments);
  },
  desaturate: function() {
    return this._applyModification($1, arguments);
  },
  saturate: function() {
    return this._applyModification(F1, arguments);
  },
  greyscale: function() {
    return this._applyModification(G1, arguments);
  },
  spin: function() {
    return this._applyModification(Q1, arguments);
  },
  _applyCombination: function(a, e) {
    return a.apply(null, [this].concat([].slice.call(e)));
  },
  analogous: function() {
    return this._applyCombination(ew, arguments);
  },
  complement: function() {
    return this._applyCombination(Y1, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(tw, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(X1, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(iu, [3]);
  },
  tetrad: function() {
    return this._applyCombination(iu, [4]);
  }
};
re.fromRatio = function(a, e) {
  if (Pi(a) == "object") {
    var t = {};
    for (var o in a)
      a.hasOwnProperty(o) && (o === "a" ? t[o] = a[o] : t[o] = ps(a[o]));
    a = t;
  }
  return re(a, e);
};
function R1(a) {
  var e = {
    r: 0,
    g: 0,
    b: 0
  }, t = 1, o = null, r = null, s = null, i = !1, u = !1;
  return typeof a == "string" && (a = ow(a)), Pi(a) == "object" && (zt(a.r) && zt(a.g) && zt(a.b) ? (e = z1(a.r, a.g, a.b), i = !0, u = String(a.r).substr(-1) === "%" ? "prgb" : "rgb") : zt(a.h) && zt(a.s) && zt(a.v) ? (o = ps(a.s), r = ps(a.v), e = Z1(a.h, o, r), i = !0, u = "hsv") : zt(a.h) && zt(a.s) && zt(a.l) && (o = ps(a.s), s = ps(a.l), e = q1(a.h, o, s), i = !0, u = "hsl"), a.hasOwnProperty("a") && (t = a.a)), t = dh(t), {
    ok: i,
    format: a.format || u,
    r: Math.min(255, Math.max(e.r, 0)),
    g: Math.min(255, Math.max(e.g, 0)),
    b: Math.min(255, Math.max(e.b, 0)),
    a: t
  };
}
function z1(a, e, t) {
  return {
    r: Be(a, 255) * 255,
    g: Be(e, 255) * 255,
    b: Be(t, 255) * 255
  };
}
function eu(a, e, t) {
  a = Be(a, 255), e = Be(e, 255), t = Be(t, 255);
  var o = Math.max(a, e, t), r = Math.min(a, e, t), s, i, u = (o + r) / 2;
  if (o == r)
    s = i = 0;
  else {
    var d = o - r;
    switch (i = u > 0.5 ? d / (2 - o - r) : d / (o + r), o) {
      case a:
        s = (e - t) / d + (e < t ? 6 : 0);
        break;
      case e:
        s = (t - a) / d + 2;
        break;
      case t:
        s = (a - e) / d + 4;
        break;
    }
    s /= 6;
  }
  return {
    h: s,
    s: i,
    l: u
  };
}
function q1(a, e, t) {
  var o, r, s;
  a = Be(a, 360), e = Be(e, 100), t = Be(t, 100);
  function i(m, v, p) {
    return p < 0 && (p += 1), p > 1 && (p -= 1), p < 1 / 6 ? m + (v - m) * 6 * p : p < 1 / 2 ? v : p < 2 / 3 ? m + (v - m) * (2 / 3 - p) * 6 : m;
  }
  if (e === 0)
    o = r = s = t;
  else {
    var u = t < 0.5 ? t * (1 + e) : t + e - t * e, d = 2 * t - u;
    o = i(d, u, a + 1 / 3), r = i(d, u, a), s = i(d, u, a - 1 / 3);
  }
  return {
    r: o * 255,
    g: r * 255,
    b: s * 255
  };
}
function tu(a, e, t) {
  a = Be(a, 255), e = Be(e, 255), t = Be(t, 255);
  var o = Math.max(a, e, t), r = Math.min(a, e, t), s, i, u = o, d = o - r;
  if (i = o === 0 ? 0 : d / o, o == r)
    s = 0;
  else {
    switch (o) {
      case a:
        s = (e - t) / d + (e < t ? 6 : 0);
        break;
      case e:
        s = (t - a) / d + 2;
        break;
      case t:
        s = (a - e) / d + 4;
        break;
    }
    s /= 6;
  }
  return {
    h: s,
    s: i,
    v: u
  };
}
function Z1(a, e, t) {
  a = Be(a, 360) * 6, e = Be(e, 100), t = Be(t, 100);
  var o = Math.floor(a), r = a - o, s = t * (1 - e), i = t * (1 - r * e), u = t * (1 - (1 - r) * e), d = o % 6, m = [t, i, s, s, u, t][d], v = [u, t, t, i, s, s][d], p = [s, s, u, t, t, i][d];
  return {
    r: m * 255,
    g: v * 255,
    b: p * 255
  };
}
function ru(a, e, t, o) {
  var r = [Tt(Math.round(a).toString(16)), Tt(Math.round(e).toString(16)), Tt(Math.round(t).toString(16))];
  return o && r[0].charAt(0) == r[0].charAt(1) && r[1].charAt(0) == r[1].charAt(1) && r[2].charAt(0) == r[2].charAt(1) ? r[0].charAt(0) + r[1].charAt(0) + r[2].charAt(0) : r.join("");
}
function V1(a, e, t, o, r) {
  var s = [Tt(Math.round(a).toString(16)), Tt(Math.round(e).toString(16)), Tt(Math.round(t).toString(16)), Tt(fh(o))];
  return r && s[0].charAt(0) == s[0].charAt(1) && s[1].charAt(0) == s[1].charAt(1) && s[2].charAt(0) == s[2].charAt(1) && s[3].charAt(0) == s[3].charAt(1) ? s[0].charAt(0) + s[1].charAt(0) + s[2].charAt(0) + s[3].charAt(0) : s.join("");
}
function su(a, e, t, o) {
  var r = [Tt(fh(o)), Tt(Math.round(a).toString(16)), Tt(Math.round(e).toString(16)), Tt(Math.round(t).toString(16))];
  return r.join("");
}
re.equals = function(a, e) {
  return !a || !e ? !1 : re(a).toRgbString() == re(e).toRgbString();
};
re.random = function() {
  return re.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function $1(a, e) {
  e = e === 0 ? 0 : e || 10;
  var t = re(a).toHsl();
  return t.s -= e / 100, t.s = qi(t.s), re(t);
}
function F1(a, e) {
  e = e === 0 ? 0 : e || 10;
  var t = re(a).toHsl();
  return t.s += e / 100, t.s = qi(t.s), re(t);
}
function G1(a) {
  return re(a).desaturate(100);
}
function H1(a, e) {
  e = e === 0 ? 0 : e || 10;
  var t = re(a).toHsl();
  return t.l += e / 100, t.l = qi(t.l), re(t);
}
function W1(a, e) {
  e = e === 0 ? 0 : e || 10;
  var t = re(a).toRgb();
  return t.r = Math.max(0, Math.min(255, t.r - Math.round(255 * -(e / 100)))), t.g = Math.max(0, Math.min(255, t.g - Math.round(255 * -(e / 100)))), t.b = Math.max(0, Math.min(255, t.b - Math.round(255 * -(e / 100)))), re(t);
}
function K1(a, e) {
  e = e === 0 ? 0 : e || 10;
  var t = re(a).toHsl();
  return t.l -= e / 100, t.l = qi(t.l), re(t);
}
function Q1(a, e) {
  var t = re(a).toHsl(), o = (t.h + e) % 360;
  return t.h = o < 0 ? 360 + o : o, re(t);
}
function Y1(a) {
  var e = re(a).toHsl();
  return e.h = (e.h + 180) % 360, re(e);
}
function iu(a, e) {
  if (isNaN(e) || e <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var t = re(a).toHsl(), o = [re(a)], r = 360 / e, s = 1; s < e; s++)
    o.push(re({
      h: (t.h + s * r) % 360,
      s: t.s,
      l: t.l
    }));
  return o;
}
function X1(a) {
  var e = re(a).toHsl(), t = e.h;
  return [re(a), re({
    h: (t + 72) % 360,
    s: e.s,
    l: e.l
  }), re({
    h: (t + 216) % 360,
    s: e.s,
    l: e.l
  })];
}
function ew(a, e, t) {
  e = e || 6, t = t || 30;
  var o = re(a).toHsl(), r = 360 / t, s = [re(a)];
  for (o.h = (o.h - (r * e >> 1) + 720) % 360; --e; )
    o.h = (o.h + r) % 360, s.push(re(o));
  return s;
}
function tw(a, e) {
  e = e || 6;
  for (var t = re(a).toHsv(), o = t.h, r = t.s, s = t.v, i = [], u = 1 / e; e--; )
    i.push(re({
      h: o,
      s: r,
      v: s
    })), s = (s + u) % 1;
  return i;
}
re.mix = function(a, e, t) {
  t = t === 0 ? 0 : t || 50;
  var o = re(a).toRgb(), r = re(e).toRgb(), s = t / 100, i = {
    r: (r.r - o.r) * s + o.r,
    g: (r.g - o.g) * s + o.g,
    b: (r.b - o.b) * s + o.b,
    a: (r.a - o.a) * s + o.a
  };
  return re(i);
};
re.readability = function(a, e) {
  var t = re(a), o = re(e);
  return (Math.max(t.getLuminance(), o.getLuminance()) + 0.05) / (Math.min(t.getLuminance(), o.getLuminance()) + 0.05);
};
re.isReadable = function(a, e, t) {
  var o = re.readability(a, e), r, s;
  switch (s = !1, r = aw(t), r.level + r.size) {
    case "AAsmall":
    case "AAAlarge":
      s = o >= 4.5;
      break;
    case "AAlarge":
      s = o >= 3;
      break;
    case "AAAsmall":
      s = o >= 7;
      break;
  }
  return s;
};
re.mostReadable = function(a, e, t) {
  var o = null, r = 0, s, i, u, d;
  t = t || {}, i = t.includeFallbackColors, u = t.level, d = t.size;
  for (var m = 0; m < e.length; m++)
    s = re.readability(a, e[m]), s > r && (r = s, o = re(e[m]));
  return re.isReadable(a, o, {
    level: u,
    size: d
  }) || !i ? o : (t.includeFallbackColors = !1, re.mostReadable(a, ["#fff", "#000"], t));
};
var Gn = re.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, rw = re.hexNames = sw(Gn);
function sw(a) {
  var e = {};
  for (var t in a)
    a.hasOwnProperty(t) && (e[a[t]] = t);
  return e;
}
function dh(a) {
  return a = parseFloat(a), (isNaN(a) || a < 0 || a > 1) && (a = 1), a;
}
function Be(a, e) {
  iw(a) && (a = "100%");
  var t = nw(a);
  return a = Math.min(e, Math.max(0, parseFloat(a))), t && (a = parseInt(a * e, 10) / 100), Math.abs(a - e) < 1e-6 ? 1 : a % e / parseFloat(e);
}
function qi(a) {
  return Math.min(1, Math.max(0, a));
}
function ht(a) {
  return parseInt(a, 16);
}
function iw(a) {
  return typeof a == "string" && a.indexOf(".") != -1 && parseFloat(a) === 1;
}
function nw(a) {
  return typeof a == "string" && a.indexOf("%") != -1;
}
function Tt(a) {
  return a.length == 1 ? "0" + a : "" + a;
}
function ps(a) {
  return a <= 1 && (a = a * 100 + "%"), a;
}
function fh(a) {
  return Math.round(parseFloat(a) * 255).toString(16);
}
function nu(a) {
  return ht(a) / 255;
}
var xt = function() {
  var a = "[-\\+]?\\d+%?", e = "[-\\+]?\\d*\\.\\d+%?", t = "(?:" + e + ")|(?:" + a + ")", o = "[\\s|\\(]+(" + t + ")[,|\\s]+(" + t + ")[,|\\s]+(" + t + ")\\s*\\)?", r = "[\\s|\\(]+(" + t + ")[,|\\s]+(" + t + ")[,|\\s]+(" + t + ")[,|\\s]+(" + t + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(t),
    rgb: new RegExp("rgb" + o),
    rgba: new RegExp("rgba" + r),
    hsl: new RegExp("hsl" + o),
    hsla: new RegExp("hsla" + r),
    hsv: new RegExp("hsv" + o),
    hsva: new RegExp("hsva" + r),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function zt(a) {
  return !!xt.CSS_UNIT.exec(a);
}
function ow(a) {
  a = a.replace(U1, "").replace(B1, "").toLowerCase();
  var e = !1;
  if (Gn[a])
    a = Gn[a], e = !0;
  else if (a == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var t;
  return (t = xt.rgb.exec(a)) ? {
    r: t[1],
    g: t[2],
    b: t[3]
  } : (t = xt.rgba.exec(a)) ? {
    r: t[1],
    g: t[2],
    b: t[3],
    a: t[4]
  } : (t = xt.hsl.exec(a)) ? {
    h: t[1],
    s: t[2],
    l: t[3]
  } : (t = xt.hsla.exec(a)) ? {
    h: t[1],
    s: t[2],
    l: t[3],
    a: t[4]
  } : (t = xt.hsv.exec(a)) ? {
    h: t[1],
    s: t[2],
    v: t[3]
  } : (t = xt.hsva.exec(a)) ? {
    h: t[1],
    s: t[2],
    v: t[3],
    a: t[4]
  } : (t = xt.hex8.exec(a)) ? {
    r: ht(t[1]),
    g: ht(t[2]),
    b: ht(t[3]),
    a: nu(t[4]),
    format: e ? "name" : "hex8"
  } : (t = xt.hex6.exec(a)) ? {
    r: ht(t[1]),
    g: ht(t[2]),
    b: ht(t[3]),
    format: e ? "name" : "hex"
  } : (t = xt.hex4.exec(a)) ? {
    r: ht(t[1] + "" + t[1]),
    g: ht(t[2] + "" + t[2]),
    b: ht(t[3] + "" + t[3]),
    a: nu(t[4] + "" + t[4]),
    format: e ? "name" : "hex8"
  } : (t = xt.hex3.exec(a)) ? {
    r: ht(t[1] + "" + t[1]),
    g: ht(t[2] + "" + t[2]),
    b: ht(t[3] + "" + t[3]),
    format: e ? "name" : "hex"
  } : !1;
}
function aw(a) {
  var e, t;
  return a = a || {
    level: "AA",
    size: "small"
  }, e = (a.level || "AA").toUpperCase(), t = (a.size || "small").toLowerCase(), e !== "AA" && e !== "AAA" && (e = "AA"), t !== "small" && t !== "large" && (t = "small"), {
    level: e,
    size: t
  };
}
const ou = (a, e, t = !1) => {
  if (t)
    switch (e) {
      case "rgb":
        return a.toRgb();
      case "prgb":
        return a.toPercentageRgb();
      case "hsl":
        return a.toHsl();
      case "hsv":
        return a.toHsv();
      default:
        return null;
    }
  else {
    let o = e;
    e === "hex" && a.getAlpha() < 1 && (o = "hex8");
    let r = a.toString(o);
    try {
      r = JSON.parse(r);
    } catch {
    }
    return r;
  }
}, jn = (a, e) => !!(Object.prototype.hasOwnProperty.call(a, e) && typeof a[e] < "u"), ti = (a) => typeof a > "u", sa = ["update:tinyColor", "update:modelValue", "input"];
function ia(a, e, t) {
  let o, r;
  const s = U({
    get: () => {
      const { modelValue: u, tinyColor: d, value: m } = a, v = d ?? u ?? m;
      return ti(r) && (ti(m) || (r = re(m).getFormat()), ti(u) || (r = re(u).getFormat())), ti(o) && (typeof m == "object" && !(m instanceof re) && (o = !0), typeof u == "object" && (o = !0)), re(v);
    },
    set: (u) => {
      i(u);
    }
  }), i = (u) => {
    const d = re(u);
    if (jn(a, "tinyColor") && e("update:tinyColor", d), jn(a, "modelValue")) {
      const m = ou(d, r, o);
      e("update:modelValue", m);
    }
    if (jn(a, "value")) {
      const m = ou(d, r, o);
      e("input", m);
    }
  };
  return s;
}
const ph = (a) => {
  var t, o, r, s;
  const e = { x: 0, y: 0 };
  return a instanceof MouseEvent && (e.x = a.pageX, e.y = a.pageY), typeof TouchEvent < "u" && a instanceof TouchEvent && (e.x = (t = a.touches) != null && t[0] ? a.touches[0].pageX : (o = a.changedTouches) != null && o[0] ? a.changedTouches[0].pageX : 0, e.y = (r = a.touches) != null && r[0] ? a.touches[0].pageY : (s = a.changedTouches) != null && s[0] ? a.changedTouches[0].pageY : 0), e;
}, lw = () => {
  const a = window.scrollX || window.pageXOffset || document.documentElement.scrollLeft || 0, e = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
  return { x: a, y: e };
}, mh = (a) => {
  const { x: e, y: t } = lw(), o = a.getBoundingClientRect();
  return {
    x: o.left + e,
    y: o.top + t
  };
}, na = (a) => a.code === "ArrowUp" || a.keyCode === 38 ? "up" : a.code === "ArrowDown" || a.keyCode === 40 ? "down" : a.code === "ArrowLeft" || a.keyCode === 37 ? "left" : a.code === "ArrowRight" || a.keyCode === 39 ? "right" : null;
function uw(a) {
  const e = a.toString();
  return e.indexOf(".") !== -1 ? e.split(".")[1].length : 0;
}
function En(a, e, t) {
  return Math.min(Math.max(a, e), t);
}
const vh = (a, e = 20) => {
  let t, o, r;
  return (...s) => {
    t ? (clearTimeout(o), o = setTimeout(() => {
      Date.now() - r >= e && (a(...s), r = Date.now());
    }, Math.max(e - (Date.now() - r), 0))) : (a(...s), r = Date.now(), t = !0);
  };
}, cw = ["aria-valuetext"], hw = /* @__PURE__ */ G({
  __name: "SaturationSlider",
  props: {
    hue: {},
    tinyColor: {},
    modelValue: {},
    value: {}
  },
  emits: ["change"].concat(sa),
  setup(a, { emit: e }) {
    const t = e, o = a, r = B(0), s = ia(o, t), i = U(() => s.value.toHsv()), u = U(() => o.hue ?? i.value.h), d = U(() => `hsl(${u.value}, 100%, 50%)`), m = U(() => -(i.value.v * 100) + 1 + 100 + "%"), v = U(() => i.value.v <= 0.01 ? r.value * 100 + "%" : i.value.s * 100 + "%"), p = B(null);
    function g(C) {
      const I = p.value;
      if (!I)
        return;
      const z = I.clientWidth, H = I.clientHeight, { x: F, y: se } = mh(I), { x: pe, y: Te } = ph(C), W = En(pe - F, 0, z), Y = En(Te - se, 0, H), X = W / z, Z = En(1 - Y / H, 0, 1);
      r.value = X;
      let he = Math.round(X * 100), Pe = Math.round(Z * 100);
      he === 1 && (he = 0.01), Pe === 1 && (Pe = 0.01), w({
        h: u.value,
        s: he,
        v: Pe,
        a: i.value.a
      });
    }
    function w(C) {
      s.value = C;
    }
    const _ = vh(g, 20);
    function P(C) {
      C.preventDefault(), C.type.startsWith("mouse") ? (window.addEventListener("mousemove", _), window.addEventListener("mouseup", _), window.addEventListener("mouseup", T)) : C.type.startsWith("touch") && (window.addEventListener("touchmove", _), window.addEventListener("touchend", _), window.addEventListener("touchend", T));
    }
    function T() {
      k();
    }
    function k() {
      window.removeEventListener("mousemove", _), window.removeEventListener("mouseup", _), window.removeEventListener("mouseup", T), window.removeEventListener("touchmove", _), window.removeEventListener("touchend", _), window.removeEventListener("touchend", T);
    }
    function x(C) {
      switch (C.preventDefault(), na(C)) {
        case "left": {
          const I = i.value.s - 0.01;
          w({
            ...i.value,
            s: I >= 0 ? I : 0
          });
          break;
        }
        case "right": {
          const I = i.value.s + 0.01;
          w({
            ...i.value,
            s: I > 1 ? 1 : I
          });
          break;
        }
        case "up": {
          const I = i.value.v + 0.01;
          w({
            ...i.value,
            v: I > 1 ? 1 : I
          });
          break;
        }
        case "down": {
          const I = i.value.v - 0.01;
          w({
            ...i.value,
            v: I < 0 ? 0 : I
          });
          break;
        }
      }
    }
    return rt(() => {
      k();
    }), (C, I) => (j(), R("div", {
      class: "vc-saturation-slider bg",
      style: _t({ background: d.value }),
      ref_key: "containerRef",
      ref: p,
      onMousedown: P,
      onTouchstart: P,
      role: "application",
      "aria-label": "Saturation and brightness picker"
    }, [
      I[1] || (I[1] = A("div", { class: "bg white" }, null, -1)),
      I[2] || (I[2] = A("div", { class: "bg black" }, null, -1)),
      A("div", {
        class: "picker-wrap",
        style: _t({ top: m.value, left: v.value }),
        role: "slider",
        tabindex: "0",
        "aria-valuemin": "0",
        "aria-valuemax": "1",
        "aria-label": "press arrow to change saturation or brightness",
        "aria-valuenow": "?",
        "aria-valuetext": `saturation: ${i.value.s.toFixed(0)}%, brightness: ${i.value.v.toFixed(0)}%`,
        onKeydown: x
      }, I[0] || (I[0] = [
        A("div", { class: "picker" }, null, -1)
      ]), 44, cw)
    ], 36));
  }
}), ks = (a, e) => {
  const t = a.__vccOpts || a;
  for (const [o, r] of e)
    t[o] = r;
  return t;
}, dw = /* @__PURE__ */ ks(hw, [["__scopeId", "data-v-4d048d6e"]]), Hn = (a) => typeof a < "u", fw = { class: "vc-base-slider" }, pw = {
  key: 0,
  class: "background"
}, mw = ["aria-label", "aria-valuemax", "aria-valuenow"], vw = /* @__PURE__ */ G({
  __name: "BaseSlider",
  props: {
    direction: { default: "horizontal" },
    modelValue: { default: 0 },
    value: { default: 0 },
    max: { default: 100 },
    step: {},
    ariaLabel: { default: "slider" }
  },
  emits: ["input", "update:modelValue"],
  setup(a, { emit: e }) {
    const t = a, o = e, r = U(() => t.modelValue ?? t.value), s = U(() => {
      let _ = r.value / t.max;
      return t.direction === "vertical" && (_ = 1 - _), 100 * _ + "%";
    }), i = B(null);
    function u(_) {
      Hn(_) && (o("input", _), o("update:modelValue", _));
    }
    function d(_) {
      const { direction: P, max: T } = t, k = i.value;
      if (!k)
        return;
      const x = k.clientWidth, C = k.clientHeight, { x: I, y: z } = mh(k), { x: H, y: F } = ph(_), se = H - I, pe = F - z;
      let Te;
      P === "vertical" ? pe < 0 ? Te = T : pe > C ? Te = 0 : Te = (1 - pe / C) * T : se < 0 ? Te = 0 : se > x ? Te = T : Te = se / x * T, u(Te);
    }
    const m = vh(d);
    function v(_) {
      d(_), _.type.startsWith("mouse") ? (window.addEventListener("mousemove", m), window.addEventListener("mouseup", p)) : (window.addEventListener("touchmove", m), window.addEventListener("touchend", p));
    }
    function p() {
      g();
    }
    function g() {
      window.removeEventListener("mousemove", m), window.removeEventListener("mouseup", p), window.removeEventListener("touchmove", m), window.removeEventListener("touchend", p);
    }
    function w(_) {
      _.preventDefault();
      const { direction: P, max: T } = t, k = na(_), x = t.step ?? T / 100, C = r.value;
      let I;
      switch (k) {
        case "left": {
          if (P !== "horizontal")
            return;
          I = C - x < 0 ? 0 : C - x;
          break;
        }
        case "right": {
          if (P !== "horizontal")
            return;
          I = C + x > T ? T : C + x;
          break;
        }
        case "down": {
          if (P !== "vertical")
            return;
          I = C - x < 0 ? 0 : C - x;
          break;
        }
        case "up": {
          if (P !== "vertical")
            return;
          I = C + x > T ? T : C + x;
          break;
        }
      }
      u(I);
    }
    return rt(() => {
      g();
    }), (_, P) => (j(), R("div", fw, [
      _.$slots.background ? (j(), R("div", pw, [
        ge(_.$slots, "background", {}, void 0, !0)
      ])) : te("", !0),
      A("div", {
        class: ae({
          slider: !0,
          horizontal: _.direction === "horizontal",
          vertical: _.direction === "vertical"
        }),
        ref_key: "containerRef",
        ref: i,
        onMousedown: v,
        onTouchstart: v,
        role: "slider",
        "aria-label": _.ariaLabel,
        "aria-valuemax": _.max,
        "aria-valuemin": "0",
        "aria-valuenow": r.value.toFixed(1),
        tabindex: "0",
        onKeydown: w
      }, [
        A("div", {
          class: "picker-wrap",
          style: _t({
            left: _.direction === "horizontal" ? s.value : 0,
            top: _.direction === "vertical" ? s.value : 0
          }),
          role: "presentation"
        }, [
          ge(_.$slots, "picker", {}, () => [
            P[0] || (P[0] = A("div", { class: "picker" }, null, -1))
          ], !0)
        ], 4)
      ], 42, mw)
    ]));
  }
}), gw = /* @__PURE__ */ ks(vw, [["__scopeId", "data-v-972b0fad"]]), yw = /* @__PURE__ */ G({
  __name: "HueSlider",
  props: {
    direction: { default: "horizontal" },
    modelValue: { default: 0 }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: e }) {
    ef((v) => ({
      "2f44f39d": r.value
    }));
    const t = a, o = e, r = U(() => `linear-gradient(to ${t.direction === "horizontal" ? "right" : "top"}, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)`), s = U(() => {
      const v = Number(t.modelValue);
      return Number.isNaN(v) ? 0 : v;
    }), i = B();
    Ie(s, (v, p) => {
      v !== 0 && v - p > 0 && (i.value = "right"), v !== 0 && v - p < 0 && (i.value = "left");
    });
    const u = U(() => t.direction === "vertical" ? s.value === 0 && i.value === "right" ? 0 : s.value : t.direction === "horizontal" ? s.value === 0 && i.value === "right" ? 360 : s.value : 0);
    function d(v) {
      m(Math.round(v));
    }
    function m(v) {
      o("update:modelValue", v);
    }
    return (v, p) => (j(), ne(gw, {
      class: "vc-hue-slider",
      max: 360,
      step: 1,
      modelValue: u.value,
      direction: v.direction,
      "onUpdate:modelValue": d,
      "aria-label": "Hue"
    }, {
      background: ee(() => p[0] || (p[0] = [
        A("div", { class: "gradient" }, null, -1)
      ])),
      picker: ee(() => [
        ge(v.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["modelValue", "direction"]));
  }
}), _w = /* @__PURE__ */ ks(yw, [["__scopeId", "data-v-5367c985"]]), bw = { class: "vc-editable-input" }, ww = ["value", "aria-label"], Pw = {
  key: 0,
  class: "vc-input-desc",
  "aria-hidden": "true"
}, xw = /* @__PURE__ */ G({
  __name: "EditableInput",
  props: {
    value: {},
    label: {},
    desc: {},
    max: {},
    min: {},
    step: { default: 1 },
    a11y: {}
  },
  emits: ["change", "blur"],
  setup(a, { emit: e }) {
    var v;
    const t = a, o = e, r = ((v = t.a11y) == null ? void 0 : v.label) ?? t.label, s = `input__label__${r}__${Math.random().toString().slice(2, 5)}`;
    function i(p) {
      const { min: g, max: w } = t;
      if (Hn(w) && +p > w) {
        o("change", w);
        return;
      }
      if (Hn(g) && +p < g) {
        o("change", g);
        return;
      }
      o("change", p);
    }
    function u(p) {
      var g;
      i((g = p.target) == null ? void 0 : g.value);
    }
    function d(p) {
      o("blur", p);
    }
    function m(p) {
      let g = Number(t.value);
      if (!isNaN(g)) {
        let w = t.step;
        const _ = uw(w), P = na(p);
        P === "up" && (i((g + w).toFixed(_)), p.preventDefault()), P === "down" && (i((g - w).toFixed(_)), p.preventDefault());
      }
    }
    return (p, g) => (j(), R("div", bw, [
      A("input", {
        class: "vc-input-input",
        value: t.value,
        onKeydown: m,
        onInput: u,
        onBlur: d,
        "aria-label": D(r),
        id: s
      }, null, 40, ww),
      A("label", {
        for: s,
        class: "vc-input-label",
        "aria-hidden": "true"
      }, V(t.label), 1),
      p.desc ? (j(), R("span", Pw, V(p.desc), 1)) : te("", !0)
    ]));
  }
}), dr = /* @__PURE__ */ ks(xw, [["__scopeId", "data-v-9c267b2b"]]), au = (a) => re(a).isValid(), Sw = /* @__PURE__ */ G({
  __name: "HexInput",
  props: {
    value: {},
    label: {},
    desc: {},
    a11y: {},
    type: { default: "hex" },
    withHash: { type: Boolean, default: !1 }
  },
  emits: ["change"],
  setup(a, { emit: e }) {
    const t = a, o = e, r = {
      label: t.type === "hex" ? "Hex" : "Hex with transparency",
      ...t.a11y
    }, s = (m, v = "hex") => {
      let p = "";
      return v === "hex" && (p = re(m).toHexString()), v === "hex8" && (p = re(m).toHex8String()), t.withHash !== !0 && (p = p.replace("#", "")), p;
    }, i = B(s(t.value, t.type));
    Ie(
      () => t.value,
      (m) => {
        re.equals(m, i.value) || (i.value = s(m, t.type));
      }
    );
    const u = (m) => {
      if (!m)
        return;
      i.value = m;
      let v = m.length;
      m[0] === "#" && (v = v - 1), !(t.type === "hex" && v % 3 !== 0 && v !== 8) && (t.type === "hex8" && v !== 8 || au(m) && o("change", m));
    }, d = () => {
      let m = i.value.length;
      i.value[0] === "#" && (m = m - 1), !(au(i.value) && (t.type === "hex" && m === 6 || t.type === "hex8" && m === 8)) && (i.value = s(t.value, t.type));
    };
    return (m, v) => (j(), ne(dr, {
      label: t.label,
      a11y: r,
      value: i.value,
      onChange: u,
      onBlur: d
    }, null, 8, ["label", "value"]));
  }
});
function Tw() {
  const a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  return a.charAt(Math.floor(Math.random() * a.length)) + a.charAt(Math.floor(Math.random() * a.length));
}
const Lw = (a) => {
  const e = B(0), t = `__from__vc__hue__${Tw()}`;
  return Ie(a, (o) => {
    if (o[t])
      return;
    const r = o.toHsl().h;
    r === 0 && e.value !== 0 || (e.value = r);
  }, { immediate: !0 }), { hueRef: e, updateHueRef: (o) => {
    const r = re({
      ...a.value.toHsl(),
      h: o
    });
    r[t] = !0, a.value = r, e.value = o;
  } };
}, Cw = {
  class: "vc-compact-picker",
  role: "application",
  "aria-label": "Compact color picker",
  tabindex: "0"
}, Aw = {
  class: "colors",
  role: "listbox",
  "aria-label": "Pick a color"
}, Ow = ["onClick", "aria-label", "aria-selected", "title", "onKeydown"], kw = { class: "dot" }, Iw = [
  "#4D4D4D",
  "#999999",
  "#FFFFFF",
  "#F44E3B",
  "#FE9200",
  "#FCDC00",
  "#DBDF00",
  "#A4DD00",
  "#68CCCA",
  "#73D8FF",
  "#AEA1FF",
  "#FDA1FF",
  "#333333",
  "#808080",
  "#CCCCCC",
  "#D33115",
  "#E27300",
  "#FCC400",
  "#B0BC00",
  "#68BC00",
  "#16A5A5",
  "#009CE0",
  "#7B64FF",
  "#FA28FF",
  "#000000",
  "#666666",
  "#B3B3B3",
  "#9F0500",
  "#C45100",
  "#FB9E00",
  "#808900",
  "#194D33",
  "#0C797D",
  "#0062B1",
  "#653294",
  "#AB149E"
], jw = /* @__PURE__ */ G({
  __name: "CompactPicker",
  props: {
    palette: { default: () => Iw },
    tinyColor: {},
    modelValue: {},
    value: {}
  },
  emits: ["change"].concat(sa),
  setup(a, { emit: e }) {
    const t = a, o = ia(t, e), r = U(() => o.value.toHexString().toUpperCase()), s = (i) => {
      o.value = i;
    };
    return (i, u) => (j(), R("div", Cw, [
      A("ul", Aw, [
        (j(!0), R(Se, null, Ke(t.palette, (d) => (j(), R("li", {
          key: d,
          class: ae({ "color-item_white": d === "#FFFFFF", "color-item": !0 }),
          style: _t({ background: d }),
          onClick: (m) => s(d),
          role: "option",
          "aria-label": "color:" + d,
          "aria-selected": d.toUpperCase() === r.value,
          title: d,
          onKeydown: ds((m) => s(d), ["space"]),
          tabindex: "0"
        }, [
          Ur(A("div", kw, null, 512), [
            [ai, d.toUpperCase() === r.value]
          ])
        ], 46, Ow))), 128))
      ])
    ]));
  }
}), Ew = /* @__PURE__ */ ks(jw, [["__scopeId", "data-v-91d11fa7"]]), Dw = {
  class: "title",
  "aria-hidden": "true"
}, Mw = { class: "body" }, Nw = { class: "saturation" }, Jw = { class: "hue" }, Uw = { class: "preview" }, Bw = {
  class: "preview-label",
  "aria-hidden": "true"
}, Rw = { class: "preview-swatches" }, zw = ["aria-label"], qw = ["aria-label"], Zw = {
  class: "preview-label",
  "aria-hidden": "true"
}, Vw = {
  key: 0,
  class: "actions"
}, $w = ["aria-label"], Fw = { class: "fields" }, Gw = ["aria-label"];
sa.concat(["ok", "cancel", "reset"]);
const Hw = { class: "flex flex-col gap-y-1" }, FP = /* @__PURE__ */ G({
  __name: "ColorInput",
  props: /* @__PURE__ */ lt({
    name: {},
    label: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a) {
    const e = B(!1), t = bt(a, "modelValue"), o = B(t.value ?? "#000000");
    return Ie(t, (r) => {
      if (!r) {
        o.value = "#000000";
        return;
      }
      r && r !== o.value && (o.value = r);
    }, { immediate: !0 }), Ie(o, (r) => {
      r !== t.value && (t.value = r);
    }), (r, s) => (j(), R("div", Hw, [
      r.label ? (j(), ne(Mt, {
        key: 0,
        name: r.name
      }, {
        default: ee(() => [
          Oe(V(r.label), 1)
        ]),
        _: 1
      }, 8, ["name"])) : te("", !0),
      A("div", {
        style: _t(`background-color: ${t.value}`),
        class: ae(["flex h-6 w-20 cursor-pointer items-center justify-center rounded-md", t.value ? "" : "dark:border-dark-600 border border-dashed border-gray-200"]),
        onClick: s[0] || (s[0] = (i) => e.value = !e.value)
      }, null, 6),
      e.value ? (j(), ne(D(Ew), {
        key: 1,
        modelValue: o.value,
        "onUpdate:modelValue": s[1] || (s[1] = (i) => o.value = i)
      }, null, 8, ["modelValue"])) : te("", !0)
    ]));
  }
}), ri = hu(), gh = () => ({ confirm: async (o, r, s, i) => new Promise((u) => {
  ri.emit("confirm", { title: o, subtitle: r, confirmButtonText: s, cancelButtonText: i, resolve: u });
}), promptText: async (o, r, s, i) => new Promise((u) => {
  ri.emit("promptText", { title: o, subtitle: r, confirmButtonText: s, cancelButtonText: i, resolve: u });
}), promptSelection: async (o, r, s, i, u) => new Promise((d) => {
  ri.emit("promptSelection", { title: o, subtitle: r, confirmButtonText: s, cancelButtonText: i, resolve: d, items: u });
}), emitter: ri }), Ww = /* @__PURE__ */ A("div", { class: "fixed inset-0 bg-gray-300 bg-opacity-75 transition-opacity" }, null, -1), Kw = { class: "fixed inset-0 z-30 overflow-y-auto" }, Qw = {
  key: 0,
  class: "sm:flex sm:items-start"
}, Yw = {
  key: 0,
  class: "mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10"
}, Xw = {
  key: 0,
  class: "mt-2"
}, e4 = { class: "text-sm text-gray-500 dark:text-gray-200" }, t4 = { class: "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end" }, r4 = /* @__PURE__ */ G({
  __name: "Dialog",
  props: {
    modelValue: { type: Boolean },
    title: {},
    subtitle: {},
    icon: {},
    panelClasses: {},
    position: { default: "center" },
    persistent: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: e }) {
    const t = e, o = () => t("update:modelValue", !1);
    return (r, s) => (j(), ne(D(Xo), {
      as: "template",
      show: r.modelValue
    }, {
      default: ee(() => [
        $(D(Jc), {
          as: "div",
          class: "relative z-30",
          onClose: s[0] || (s[0] = (i) => !r.persistent && o())
        }, {
          default: ee(() => [
            $(D(_s), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: ee(() => [
                Ww
              ]),
              _: 1
            }),
            A("div", Kw, [
              A("div", {
                class: ae(`flex min-h-full items-end justify-center p-4 text-center ${r.position === "start" ? "sm:items-start" : "sm:items-center"} sm:p-0`)
              }, [
                $(D(_s), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: ee(() => [
                    $(D(Uc), {
                      class: ae(["relative transform space-y-4 overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6", r.panelClasses])
                    }, {
                      default: ee(() => [
                        r.title ? (j(), R("div", Qw, [
                          r.icon ? (j(), R("div", Yw, [
                            $(D(je), {
                              class: "h-6 w-6 text-red-600",
                              "aria-hidden": "true",
                              icon: r.icon
                            }, null, 8, ["icon"])
                          ])) : te("", !0),
                          A("div", {
                            class: ae(["mt-1 text-center sm:mt-0 sm:text-left", r.icon ? "sm:ml-4" : void 0])
                          }, [
                            ge(r.$slots, "title", {}, () => [
                              $(D(Bc), {
                                as: "h3",
                                class: "text-lg font-medium leading-6 text-gray-900 dark:text-white"
                              }, {
                                default: ee(() => [
                                  Oe(V(r.title), 1)
                                ]),
                                _: 1
                              }),
                              r.subtitle ? (j(), R("div", Xw, [
                                A("p", e4, V(r.subtitle), 1)
                              ])) : te("", !0)
                            ])
                          ], 2)
                        ])) : te("", !0),
                        ge(r.$slots, "content"),
                        A("div", t4, [
                          ge(r.$slots, "actions")
                        ])
                      ]),
                      _: 3
                    }, 8, ["class"])
                  ]),
                  _: 3
                })
              ], 2)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), GP = /* @__PURE__ */ G({
  __name: "ConfirmDialog",
  setup(a) {
    const { emitter: e } = gh(), t = B(!1), o = B(""), r = B(""), s = B(""), i = B(""), u = B(""), d = B([]), m = B();
    let v, p, g;
    e.on("confirm", (P) => {
      p = g = void 0, v = P.resolve, o.value = P.title, r.value = P.subtitle, s.value = P.confirmButtonText, i.value = P.cancelButtonText, t.value = !0;
    }), e.on("promptText", (P) => {
      v = g = void 0, p = P.resolve, o.value = P.title, r.value = P.subtitle, s.value = P.confirmButtonText, i.value = P.cancelButtonText, u.value = "", t.value = !0;
    }), e.on("promptSelection", (P) => {
      var T;
      v = p = void 0, g = P.resolve, o.value = P.title, r.value = P.subtitle, s.value = P.confirmButtonText, i.value = P.cancelButtonText, d.value = P.items, m.value = (T = d.value) == null ? void 0 : T[0].value, t.value = !0;
    });
    const w = () => {
      v && v(!1), p && p(void 0), g && g(void 0), t.value = !1;
    }, _ = () => {
      v && v(!0), p && p(u.value), g && g(m.value), t.value = !1;
    };
    return (P, T) => (j(), ne(r4, {
      modelValue: t.value,
      "onUpdate:modelValue": T[2] || (T[2] = (k) => t.value = k),
      title: o.value,
      subtitle: r.value,
      icon: ["fal", "circle-exclamation"]
    }, {
      content: ee(() => [
        D(p) ? (j(), ne(dt, {
          key: 0,
          name: "text",
          modelValue: u.value,
          "onUpdate:modelValue": T[0] || (T[0] = (k) => u.value = k)
        }, null, 8, ["modelValue"])) : te("", !0),
        D(g) ? (j(), ne(Zt, {
          key: 1,
          name: "selection",
          modelValue: m.value,
          "onUpdate:modelValue": T[1] || (T[1] = (k) => m.value = k),
          items: d.value
        }, null, 8, ["modelValue", "items"])) : te("", !0)
      ]),
      actions: ee(() => [
        $(ws, {
          variant: "default",
          class: "w-full sm:w-auto",
          type: "button",
          onClick: w
        }, {
          default: ee(() => [
            Oe(V(i.value), 1)
          ]),
          _: 1
        }),
        $(ws, {
          class: "w-full sm:w-auto",
          type: "button",
          onClick: _
        }, {
          default: ee(() => [
            Oe(V(s.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title", "subtitle"]));
  }
}), s4 = { class: "space-y-1" }, i4 = { class: "relative" }, Ps = /* @__PURE__ */ G({
  __name: "DateInput",
  props: {
    modelValue: {},
    format: {},
    enableTimePicker: { type: Boolean, default: !1 },
    autoApply: { type: Boolean, default: !0 },
    placeholder: {},
    disabled: { type: Boolean, default: !1 },
    minDate: {},
    maxDate: {},
    locale: { default: "de" },
    required: { type: Boolean, default: !1 },
    position: { default: "left" },
    label: {},
    name: {},
    range: { type: Boolean, default: !1 },
    monthPicker: { type: Boolean, default: !1 },
    yearPicker: { type: Boolean, default: !1 },
    timePicker: { type: Boolean, default: !1 },
    allowedDates: {},
    readonly: { type: Boolean },
    clearable: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: e }) {
    const t = a, o = e, r = (i) => {
      o("update:modelValue", i);
    }, s = U(() => t.format ? t.format : t.monthPicker ? "MM/yy" : t.yearPicker ? "yyyy" : t.timePicker ? "HH:mm" : "dd.MM.yyyy");
    return (i, u) => (j(), R("div", s4, [
      i.label ? (j(), ne(Mt, {
        key: 0,
        name: `dp-input-${i.name}`
      }, {
        default: ee(() => [
          Oe(V(i.label), 1)
        ]),
        _: 1
      }, 8, ["name"])) : te("", !0),
      A("div", i4, [
        $(D(cf), {
          teleport: !0,
          clearable: i.clearable,
          position: i.position,
          "model-value": i.modelValue,
          "onUpdate:modelValue": r,
          format: s.value,
          "enable-time-picker": i.enableTimePicker,
          "auto-apply": i.autoApply,
          placeholder: i.placeholder,
          disabled: i.disabled,
          "min-date": i.minDate,
          "max-date": i.maxDate,
          locale: i.locale,
          required: i.required,
          name: i.name,
          uid: i.name,
          range: i.range,
          "month-picker": i.monthPicker,
          "year-picker": i.yearPicker,
          "time-picker": i.timePicker,
          "allowed-dates": i.allowedDates,
          readonly: i.readonly
        }, null, 8, ["clearable", "position", "model-value", "format", "enable-time-picker", "auto-apply", "placeholder", "disabled", "min-date", "max-date", "locale", "required", "name", "uid", "range", "month-picker", "year-picker", "time-picker", "allowed-dates", "readonly"])
      ])
    ]));
  }
}), n4 = { class: "space-y-1" }, HP = /* @__PURE__ */ G({
  __name: "DateTimeInput",
  props: /* @__PURE__ */ lt({
    name: {},
    label: {},
    inline: { type: Boolean },
    minDate: {},
    maxDate: {},
    clearable: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a) {
    const e = bt(a, "modelValue"), t = B(), o = (r) => {
      if (!r) {
        e.value = void 0, t.value = void 0;
        return;
      }
      const s = r;
      let i = /* @__PURE__ */ new Date();
      e.value && (i = new Date(e.value)), i.setHours(s.hours, s.minutes, 0, 0), e.value = i;
    };
    return Ie(e, (r) => {
      if (!r) {
        t.value = void 0;
        return;
      }
      t.value = {
        hours: r.getHours(),
        minutes: r.getMinutes()
      };
    }, { immediate: !0 }), (r, s) => (j(), R("div", n4, [
      r.label ? (j(), ne(Mt, {
        key: 0,
        name: r.name + "Date"
      }, {
        default: ee(() => [
          Oe(V(r.label), 1)
        ]),
        _: 1
      }, 8, ["name"])) : te("", !0),
      A("div", {
        class: ae(["flex items-center gap-2", r.inline ? "flex-row" : "flex-col"])
      }, [
        $(Ps, {
          name: r.name + "Date",
          modelValue: e.value,
          "onUpdate:modelValue": s[0] || (s[0] = (i) => e.value = i),
          "min-date": r.minDate,
          "max-date": r.maxDate,
          clearable: r.clearable
        }, null, 8, ["name", "modelValue", "min-date", "max-date", "clearable"]),
        $(Ps, {
          name: r.name + "Time",
          modelValue: t.value,
          "onUpdate:modelValue": [
            s[1] || (s[1] = (i) => t.value = i),
            o
          ],
          "time-picker": !0,
          format: "HH:mm",
          clearable: r.clearable
        }, null, 8, ["name", "modelValue", "clearable"])
      ], 2)
    ]));
  }
}), o4 = /* @__PURE__ */ A("span", { class: "sr-only" }, "Open options", -1), a4 = { class: "py-1" }, l4 = {
  key: 0,
  class: "border-b"
}, u4 = ["onClick"], WP = /* @__PURE__ */ G({
  __name: "DropdownMenu",
  props: {
    actions: {},
    dropdownClass: { default: "w-56" },
    direction: { default: "left" }
  },
  setup(a) {
    const e = a, t = (r) => r.disabled ? r.disabled() : !1, o = (r) => {
      const s = e.actions.indexOf(r);
      return e.actions.slice(0, s).filter((i) => i.visible ?? !0).length > 0;
    };
    return (r, s) => (j(), ne(D(t0), {
      as: "div",
      class: "relative inline-block text-left"
    }, {
      default: ee(({ open: i }) => [
        $(D(r0), {
          onClick: s[0] || (s[0] = St(() => {
          }, ["prevent", "stop"])),
          class: "flex items-center rounded-md bg-transparent text-gray-400 hover:text-gray-600 focus:outline-none"
        }, {
          default: ee(() => [
            o4,
            ge(r.$slots, "button", { open: i }, () => [
              $(D(je), {
                icon: ["fal", "ellipsis-vertical"],
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ])
          ]),
          _: 2
        }, 1024),
        $(Kn, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: ee(() => [
            $(D(s0), {
              class: ae(["absolute z-50 mt-2 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none", [r.dropdownClass, r.direction === "left" ? "left-0" : "right-0"]])
            }, {
              default: ee(() => [
                A("div", a4, [
                  (j(!0), R(Se, null, Ke(r.actions.filter((u) => u.visible ?? !0), (u) => (j(), R(Se, {
                    key: u.text
                  }, [
                    u.separator ? (j(), R(Se, { key: 0 }, [
                      o(u) ? (j(), R("div", l4)) : te("", !0)
                    ], 64)) : (j(), ne(D(i0), {
                      key: 1,
                      disabled: t(u),
                      class: ae([t(u) ? "cursor-default text-gray-500" : "cursor-pointer text-gray-900"])
                    }, {
                      default: ee(({ active: d }) => [
                        A("a", {
                          href: "#",
                          class: ae([d ? "bg-gray-100" : "", "group flex items-center px-4 py-1.5 text-sm"]),
                          onClick: St(() => u.action && u.action(), ["stop"])
                        }, [
                          u.icon ? (j(), ne(D(je), {
                            key: 0,
                            class: "mr-3 h-3.5 w-3.5",
                            "aria-hidden": "true",
                            icon: u.icon
                          }, null, 8, ["icon"])) : te("", !0),
                          Oe(" " + V(u.text), 1)
                        ], 10, u4)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "class"]))
                  ], 64))), 128))
                ])
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 3
    }));
  }
}), c4 = { class: "space-y-1" }, h4 = { class: "relative" }, d4 = ["for"], f4 = { class: "flex flex-col items-center justify-center space-y-2 p-4" }, p4 = { class: "text-sm" }, m4 = ["id", "accept"], v4 = {
  key: 0,
  class: "absolute left-0 top-0 flex h-full w-full items-center justify-center rounded-lg bg-gray-500 bg-opacity-75 dark:bg-dark-800 dark:bg-opacity-75"
}, KP = /* @__PURE__ */ G({
  __name: "Dropzone",
  props: {
    modelValue: {},
    name: {},
    instructions: {},
    loading: { type: Boolean, default: !1 },
    label: {},
    accept: {},
    solidBorder: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change"],
  setup(a, { expose: e, emit: t }) {
    const o = t, r = B(), s = B(!1), i = (p) => o("update:modelValue", p), u = () => s.value = !s.value, d = (p) => {
      var g;
      i((g = p.dataTransfer) == null ? void 0 : g.files[0]), s.value = !1;
    }, m = (p) => {
      const g = p.target, w = g.files;
      w != null && w.length && i(w[0]), g.value = "";
    };
    return e({ open: () => {
      var p;
      (p = r.value) == null || p.click();
    } }), (p, g) => {
      const w = Yn("font-awesome-icon");
      return j(), R("div", c4, [
        p.label ? (j(), ne(Mt, {
          key: 0,
          name: p.name
        }, {
          default: ee(() => [
            Oe(V(p.label), 1)
          ]),
          _: 1
        }, 8, ["name"])) : te("", !0),
        A("div", h4, [
          A("label", {
            onDragenter: St(u, ["prevent"]),
            onDragleave: St(u, ["prevent"]),
            onDragover: g[0] || (g[0] = St(() => {
            }, ["prevent"])),
            onDrop: St(d, ["prevent"]),
            class: ae([[
              { "bg-gray-100 dark:bg-dark-700": s.value },
              p.solidBorder ? "border-gray-300 border-transparent bg-gray-50 text-gray-700 dark:border-dark-700 dark:bg-dark-800 dark:text-white dark:hover:border-dark-500 dark:hover:bg-dark-900 dark:hover:text-white" : "border-dashed border-gray-200 text-gray-900 hover:bg-gray-100 dark:border-dark-600 dark:bg-dark-800 dark:text-white dark:hover:bg-dark-700"
            ], "flex cursor-pointer flex-col items-center justify-center space-y-3 rounded-lg border"]),
            for: p.name
          }, [
            ge(p.$slots, "content", {}, () => [
              A("div", f4, [
                $(w, {
                  icon: ["fal", "file-arrow-up"],
                  class: "h-10 w-10"
                }),
                A("span", p4, V(p.instructions), 1)
              ])
            ]),
            A("input", {
              ref_key: "input",
              ref: r,
              id: p.name,
              type: "file",
              onChange: m,
              class: "hidden",
              accept: p.accept
            }, null, 40, m4)
          ], 42, d4),
          p.loading ? (j(), R("div", v4, [
            $(Ai)
          ])) : te("", !0)
        ])
      ]);
    };
  }
}), g4 = ["disabled"], QP = /* @__PURE__ */ G({
  __name: "IconButton",
  props: {
    icon: {},
    disabled: { type: Boolean }
  },
  setup(a) {
    return (e, t) => (j(), R("button", {
      class: "flex shrink-0 items-center justify-center rounded-md border border-gray-300 border-transparent bg-gray-100 px-2 py-1.5 text-gray-700 shadow-sm ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-opacity-25",
      type: "button",
      disabled: e.disabled
    }, [
      e.icon ? (j(), ne(D(je), {
        key: 0,
        icon: ["fal", e.icon],
        class: "h-3 w-3",
        "aria-hidden": "true"
      }, null, 8, ["icon"])) : te("", !0)
    ], 8, g4));
  }
}), y4 = /* @__PURE__ */ A("div", { class: "dark:border-dark-600 h-96 rounded-lg border border-dashed border-gray-200 shadow-xl" }, null, -1), YP = /* @__PURE__ */ G({
  __name: "Layout",
  props: {
    useFullscreen: { type: Boolean, default: !1 }
  },
  setup(a) {
    return (e, t) => (j(), R("div", {
      class: ae(["mx-auto flex min-h-full flex-1 flex-col overflow-auto", e.useFullscreen ? "" : "px-4 py-4 sm:px-6 md:px-8 md:py-6"])
    }, [
      ge(e.$slots, "default", {}, () => [
        y4
      ])
    ], 2));
  }
}), _4 = "data:image/svg+xml,%3csvg%20width='500'%20height='820'%20viewBox='0%200%20500%20820'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='path-1-inside-1_1_27'%20fill='white'%3e%3cpath%20d='M249%2017C385.414%2017%20496%20127.586%20496%20264C496%20306.343%20485.345%20346.197%20466.57%20381.029C466.455%20381.242%20466.61%20381.5%20466.852%20381.5C467.09%20381.5%20467.244%20381.752%20467.136%20381.964L258.914%20791.469C255.207%20798.759%20244.793%20798.759%20241.086%20791.469L39.1816%20394.39C15.6147%20356.547%202%20311.863%202%20264C2%20127.586%20112.586%2017%20249%2017ZM391.572%20138.092C391.59%20138.073%20391.588%20138.042%20391.567%20138.027C381.425%20130.685%20367.266%20132.962%20359.898%20143.093L200.788%20361.836C197.173%20366.805%20189.975%20367.369%20185.63%20363.024L121.902%20299.297C113.035%20290.43%2098.6356%20290.43%2089.7686%20299.297C80.9014%20308.164%2080.9014%20322.564%2089.7686%20331.432L180.568%20422.231C185.25%20426.913%20191.705%20429.396%20198.373%20428.829C205.041%20428.262%20211.071%20424.927%20214.973%20419.536L396.573%20169.836C403.941%20159.705%20401.686%20145.542%20391.577%20138.157C391.556%20138.141%20391.553%20138.11%20391.572%20138.092Z'/%3e%3c/mask%3e%3cpath%20d='M249%2017C385.414%2017%20496%20127.586%20496%20264C496%20306.343%20485.345%20346.197%20466.57%20381.029C466.455%20381.242%20466.61%20381.5%20466.852%20381.5C467.09%20381.5%20467.244%20381.752%20467.136%20381.964L258.914%20791.469C255.207%20798.759%20244.793%20798.759%20241.086%20791.469L39.1816%20394.39C15.6147%20356.547%202%20311.863%202%20264C2%20127.586%20112.586%2017%20249%2017ZM391.572%20138.092C391.59%20138.073%20391.588%20138.042%20391.567%20138.027C381.425%20130.685%20367.266%20132.962%20359.898%20143.093L200.788%20361.836C197.173%20366.805%20189.975%20367.369%20185.63%20363.024L121.902%20299.297C113.035%20290.43%2098.6356%20290.43%2089.7686%20299.297C80.9014%20308.164%2080.9014%20322.564%2089.7686%20331.432L180.568%20422.231C185.25%20426.913%20191.705%20429.396%20198.373%20428.829C205.041%20428.262%20211.071%20424.927%20214.973%20419.536L396.573%20169.836C403.941%20159.705%20401.686%20145.542%20391.577%20138.157C391.556%20138.141%20391.553%20138.11%20391.572%20138.092Z'%20fill='{{fill}}'/%3e%3cpath%20d='M39.1816%20394.39L57.0093%20385.325L56.6167%20384.552L56.1587%20383.817L39.1816%20394.39ZM359.898%20143.093L376.072%20154.857L376.073%20154.856L359.898%20143.093ZM121.902%20299.297L136.044%20285.155L136.044%20285.154L121.902%20299.297ZM89.7686%20299.297L75.6267%20285.154L75.6264%20285.155L89.7686%20299.297ZM180.568%20422.231L194.71%20408.089L180.568%20422.231ZM198.373%20428.829L200.069%20448.757L200.069%20448.757L198.373%20428.829ZM214.973%20419.536L198.798%20407.773L198.784%20407.792L198.77%20407.811L214.973%20419.536ZM396.573%20169.836L412.748%20181.599L412.748%20181.599L396.573%20169.836ZM391.577%20138.157L403.375%20122.007L391.577%20138.157ZM200.788%20361.836L184.614%20350.071L200.788%20361.836ZM258.914%20791.469L276.742%20800.534L258.914%20791.469ZM241.086%20791.469L223.258%20800.534L241.086%20791.469ZM467.136%20381.964L449.308%20372.899L467.136%20381.964ZM391.567%20138.027L379.838%20154.227L391.567%20138.027ZM466.57%20381.029L484.176%20390.518L466.57%20381.029ZM249%2017V37C374.369%2037%20476%20138.631%20476%20264H496H516C516%20116.54%20396.46%20-3%20249%20-3V17ZM496%20264H476C476%20302.949%20466.207%20339.552%20448.965%20371.539L466.57%20381.029L484.176%20390.518C504.483%20352.843%20516%20309.737%20516%20264H496ZM467.136%20381.964L449.308%20372.899L241.086%20782.404L258.914%20791.469L276.742%20800.534L484.964%20391.029L467.136%20381.964ZM241.086%20791.469L258.914%20782.404L57.0093%20385.325L39.1816%20394.39L21.3539%20403.455L223.258%20800.534L241.086%20791.469ZM39.1816%20394.39L56.1587%20383.817C34.5099%20349.054%2022%20308.019%2022%20264H2H-18C-18%20315.708%20-3.28058%20364.039%2022.2046%20404.962L39.1816%20394.39ZM2%20264H22C22%20138.631%20123.631%2037%20249%2037V17V-3C101.54%20-3%20-18%20116.54%20-18%20264H2ZM391.567%20138.027L403.295%20121.827C384.184%20107.991%20357.552%20112.316%20343.724%20131.329L359.898%20143.093L376.073%20154.856C376.98%20153.609%20378.667%20153.379%20379.838%20154.227L391.567%20138.027ZM359.898%20143.093L343.725%20131.328L184.614%20350.071L200.788%20361.836L216.962%20373.6L376.072%20154.857L359.898%20143.093ZM185.63%20363.024L199.772%20348.882L136.044%20285.155L121.902%20299.297L107.76%20313.439L171.488%20377.166L185.63%20363.024ZM121.902%20299.297L136.044%20285.154C119.367%20268.478%2092.3043%20268.478%2075.6267%20285.154L89.7686%20299.297L103.91%20313.439C104.967%20312.383%20106.704%20312.383%20107.761%20313.439L121.902%20299.297ZM89.7686%20299.297L75.6264%20285.155C58.9487%20301.832%2058.9487%20328.896%2075.6264%20345.574L89.7686%20331.432L103.911%20317.289C102.854%20316.233%20102.854%20314.496%20103.911%20313.439L89.7686%20299.297ZM89.7686%20331.432L75.6264%20345.574L166.426%20436.374L180.568%20422.231L194.71%20408.089L103.911%20317.289L89.7686%20331.432ZM180.568%20422.231L166.426%20436.374C175.11%20445.058%20187.297%20449.844%20200.069%20448.757L198.373%20428.829L196.677%20408.901C196.113%20408.949%20195.39%20408.769%20194.71%20408.089L180.568%20422.231ZM198.373%20428.829L200.069%20448.757C212.369%20447.71%20223.765%20441.501%20231.175%20431.262L214.973%20419.536L198.77%20407.811C198.377%20408.354%20197.713%20408.813%20196.677%20408.901L198.373%20428.829ZM214.973%20419.536L231.147%20431.3L412.748%20181.599L396.573%20169.836L380.399%20158.072L198.798%20407.773L214.973%20419.536ZM396.573%20169.836L412.748%20181.599C426.632%20162.508%20422.349%20135.869%20403.375%20122.007L391.577%20138.157L379.778%20154.306C381.023%20155.215%20381.249%20156.903%20380.398%20158.073L396.573%20169.836ZM391.577%20138.157L403.375%20122.007C413.138%20129.14%20414.524%20143.545%20405.616%20152.331L391.572%20138.092L377.527%20123.852C368.582%20132.675%20369.974%20147.143%20379.778%20154.306L391.577%20138.157ZM200.788%20361.836L184.614%20350.071C188.228%20345.102%20195.427%20344.537%20199.772%20348.882L185.63%20363.024L171.488%20377.166C184.522%20390.201%20206.118%20388.507%20216.962%20373.6L200.788%20361.836ZM258.914%20791.469L241.086%20782.404C244.793%20775.114%20255.207%20775.114%20258.914%20782.404L241.086%20791.469L223.258%20800.534C234.379%20822.404%20265.621%20822.404%20276.742%20800.534L258.914%20791.469ZM466.852%20381.5V401.5C452.163%20401.5%20442.651%20385.992%20449.308%20372.899L467.136%20381.964L484.964%20391.029C491.837%20377.511%20482.017%20361.5%20466.852%20361.5V381.5ZM391.567%20138.027L379.838%20154.227C369.971%20147.084%20368.634%20132.624%20377.527%20123.852L391.572%20138.092L405.616%20152.331C414.547%20143.522%20413.204%20129.001%20403.295%20121.827L391.567%20138.027ZM466.57%20381.029L448.965%20371.539C441.675%20385.064%20451.457%20401.5%20466.852%20401.5V381.5V361.5C481.762%20361.5%20491.236%20377.419%20484.176%20390.518L466.57%20381.029Z'%20fill='{{stroke}}'%20mask='url(%23path-1-inside-1_1_27)'/%3e%3c/svg%3e", yh = "data:image/svg+xml,%3csvg%20width='500'%20height='820'%20viewBox='0%200%20500%20820'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='path-1-inside-1_1_36'%20fill='white'%3e%3cpath%20d='M249%2017C385.414%2017%20496%20127.586%20496%20264C496%20306.343%20485.345%20346.197%20466.57%20381.029C466.455%20381.242%20466.61%20381.5%20466.852%20381.5C467.09%20381.5%20467.244%20381.752%20467.136%20381.964L258.914%20791.469C255.207%20798.759%20244.793%20798.759%20241.086%20791.469L39.1816%20394.39C15.6147%20356.547%202%20311.863%202%20264C2%20127.586%20112.586%2017%20249%2017ZM378.17%20137.11C369.42%20128.36%20355.21%20128.36%20346.46%20137.11L257.418%20226.216C253.514%20230.123%20247.183%20230.125%20243.276%20226.222L154.17%20137.18C145.42%20128.43%20131.21%20128.43%20122.46%20137.18C113.71%20145.93%20113.71%20160.14%20122.46%20168.89L211.566%20257.932C215.473%20261.835%20215.475%20268.167%20211.571%20272.074L122.53%20361.18C113.78%20369.93%20113.78%20384.14%20122.53%20392.89C131.28%20401.64%20145.49%20401.64%20154.24%20392.89L243.281%20303.784C247.185%20299.877%20253.517%20299.875%20257.423%20303.778L346.53%20392.82C355.28%20401.57%20369.49%20401.57%20378.24%20392.82C386.99%20384.07%20386.99%20369.86%20378.24%20361.11L289.133%20272.069C285.227%20268.165%20285.224%20261.833%20289.128%20257.926L378.17%20168.82C386.92%20160.07%20386.92%20145.86%20378.17%20137.11Z'/%3e%3c/mask%3e%3cpath%20d='M249%2017C385.414%2017%20496%20127.586%20496%20264C496%20306.343%20485.345%20346.197%20466.57%20381.029C466.455%20381.242%20466.61%20381.5%20466.852%20381.5C467.09%20381.5%20467.244%20381.752%20467.136%20381.964L258.914%20791.469C255.207%20798.759%20244.793%20798.759%20241.086%20791.469L39.1816%20394.39C15.6147%20356.547%202%20311.863%202%20264C2%20127.586%20112.586%2017%20249%2017ZM378.17%20137.11C369.42%20128.36%20355.21%20128.36%20346.46%20137.11L257.418%20226.216C253.514%20230.123%20247.183%20230.125%20243.276%20226.222L154.17%20137.18C145.42%20128.43%20131.21%20128.43%20122.46%20137.18C113.71%20145.93%20113.71%20160.14%20122.46%20168.89L211.566%20257.932C215.473%20261.835%20215.475%20268.167%20211.571%20272.074L122.53%20361.18C113.78%20369.93%20113.78%20384.14%20122.53%20392.89C131.28%20401.64%20145.49%20401.64%20154.24%20392.89L243.281%20303.784C247.185%20299.877%20253.517%20299.875%20257.423%20303.778L346.53%20392.82C355.28%20401.57%20369.49%20401.57%20378.24%20392.82C386.99%20384.07%20386.99%20369.86%20378.24%20361.11L289.133%20272.069C285.227%20268.165%20285.224%20261.833%20289.128%20257.926L378.17%20168.82C386.92%20160.07%20386.92%20145.86%20378.17%20137.11Z'%20fill='{{fill}}'/%3e%3cpath%20d='M39.1816%20394.39L57.0093%20385.325L56.6167%20384.552L56.1587%20383.817L39.1816%20394.39ZM378.17%20137.11L392.312%20122.968L392.312%20122.968L378.17%20137.11ZM346.46%20137.11L332.318%20122.968L332.313%20122.973L346.46%20137.11ZM154.17%20137.18L140.028%20151.322L140.033%20151.327L154.17%20137.18ZM122.46%20137.18L108.318%20123.037L108.318%20123.038L122.46%20137.18ZM122.46%20168.89L108.318%20183.032L108.323%20183.037L122.46%20168.89ZM122.53%20361.18L136.672%20375.322L136.678%20375.317L122.53%20361.18ZM122.53%20392.89L108.388%20407.032L108.388%20407.032L122.53%20392.89ZM154.24%20392.89L168.382%20407.032L168.388%20407.027L154.24%20392.89ZM346.53%20392.82L360.672%20378.678L360.667%20378.673L346.53%20392.82ZM378.24%20392.82L392.382%20406.962L392.382%20406.962L378.24%20392.82ZM378.24%20361.11L392.383%20346.968L392.377%20346.963L378.24%20361.11ZM378.17%20168.82L364.028%20154.678L364.023%20154.683L378.17%20168.82ZM289.133%20272.069L274.996%20286.216L289.133%20272.069ZM289.128%20257.926L274.981%20243.789L289.128%20257.926ZM257.423%20303.778L271.56%20289.631L257.423%20303.778ZM258.914%20791.469L276.742%20800.534L258.914%20791.469ZM241.086%20791.469L223.258%20800.534L241.086%20791.469ZM466.57%20381.029L484.176%20390.518L466.57%20381.029ZM211.566%20257.932L225.703%20243.784L211.566%20257.932ZM211.571%20272.074L197.424%20257.937L211.571%20272.074ZM467.136%20381.964L449.308%20372.899L467.136%20381.964ZM249%2017V37C374.369%2037%20476%20138.631%20476%20264H496H516C516%20116.54%20396.46%20-3%20249%20-3V17ZM496%20264H476C476%20302.949%20466.207%20339.552%20448.965%20371.539L466.57%20381.029L484.176%20390.518C504.483%20352.843%20516%20309.737%20516%20264H496ZM467.136%20381.964L449.308%20372.899L241.086%20782.404L258.914%20791.469L276.742%20800.534L484.964%20391.029L467.136%20381.964ZM241.086%20791.469L258.914%20782.404L57.0093%20385.325L39.1816%20394.39L21.3539%20403.455L223.258%20800.534L241.086%20791.469ZM39.1816%20394.39L56.1587%20383.817C34.5099%20349.054%2022%20308.019%2022%20264H2H-18C-18%20315.708%20-3.28058%20364.039%2022.2046%20404.962L39.1816%20394.39ZM2%20264H22C22%20138.631%20123.631%2037%20249%2037V17V-3C101.54%20-3%20-18%20116.54%20-18%20264H2ZM378.17%20137.11L392.312%20122.968C375.752%20106.408%20348.878%20106.408%20332.318%20122.968L346.46%20137.11L360.602%20151.252C361.542%20150.313%20363.088%20150.313%20364.028%20151.252L378.17%20137.11ZM346.46%20137.11L332.313%20122.973L243.271%20212.079L257.418%20226.216L271.565%20240.353L360.607%20151.247L346.46%20137.11ZM243.276%20226.222L257.413%20212.074L168.307%20123.032L154.17%20137.18L140.033%20151.327L229.139%20240.369L243.276%20226.222ZM154.17%20137.18L168.312%20123.037C151.752%20106.477%20124.878%20106.477%20108.318%20123.037L122.46%20137.18L136.602%20151.322C137.541%20150.383%20139.088%20150.382%20140.028%20151.322L154.17%20137.18ZM122.46%20137.18L108.318%20123.038C91.7572%20139.598%2091.7578%20166.471%20108.318%20183.032L122.46%20168.89L136.602%20154.748C135.663%20153.808%20135.663%20152.261%20136.602%20151.322L122.46%20137.18ZM122.46%20168.89L108.323%20183.037L197.429%20272.079L211.566%20257.932L225.703%20243.784L136.597%20154.742L122.46%20168.89ZM211.571%20272.074L197.424%20257.937L108.383%20347.043L122.53%20361.18L136.678%20375.317L225.719%20286.211L211.571%20272.074ZM122.53%20361.18L108.388%20347.038C91.8276%20363.598%2091.8278%20390.471%20108.388%20407.032L122.53%20392.89L136.672%20378.748C135.733%20377.808%20135.733%20376.261%20136.672%20375.322L122.53%20361.18ZM122.53%20392.89L108.388%20407.032C124.949%20423.592%20151.822%20423.592%20168.382%20407.032L154.24%20392.89L140.098%20378.747C139.159%20379.687%20137.612%20379.687%20136.672%20378.747L122.53%20392.89ZM154.24%20392.89L168.388%20407.027L257.428%20317.921L243.281%20303.784L229.134%20289.647L140.093%20378.753L154.24%20392.89ZM257.423%20303.778L243.286%20317.926L332.393%20406.968L346.53%20392.82L360.667%20378.673L271.56%20289.631L257.423%20303.778ZM346.53%20392.82L332.388%20406.963C348.949%20423.522%20375.822%20423.523%20392.382%20406.962L378.24%20392.82L364.098%20378.678C363.159%20379.617%20361.612%20379.618%20360.672%20378.678L346.53%20392.82ZM378.24%20392.82L392.382%20406.962C408.943%20390.402%20408.942%20363.529%20392.383%20346.968L378.24%20361.11L364.098%20375.252C365.038%20376.192%20365.037%20377.739%20364.098%20378.678L378.24%20392.82ZM378.24%20361.11L392.377%20346.963L303.27%20257.921L289.133%20272.069L274.996%20286.216L364.103%20375.258L378.24%20361.11ZM289.128%20257.926L303.275%20272.063L392.317%20182.957L378.17%20168.82L364.023%20154.683L274.981%20243.789L289.128%20257.926ZM378.17%20168.82L392.312%20182.962C408.873%20166.402%20408.872%20139.529%20392.312%20122.968L378.17%20137.11L364.028%20151.252C364.967%20152.192%20364.967%20153.739%20364.028%20154.678L378.17%20168.82ZM289.133%20272.069L303.27%20257.921C307.177%20261.825%20307.179%20268.157%20303.275%20272.063L289.128%20257.926L274.981%20243.789C263.269%20255.509%20263.276%20274.504%20274.996%20286.216L289.133%20272.069ZM243.281%20303.784L257.428%20317.921C253.525%20321.827%20247.193%20321.83%20243.286%20317.926L257.423%20303.778L271.56%20289.631C259.84%20277.92%20240.845%20277.927%20229.134%20289.647L243.281%20303.784ZM257.418%20226.216L243.271%20212.079C247.175%20208.173%20253.506%20208.17%20257.413%20212.074L243.276%20226.222L229.139%20240.369C240.859%20252.08%20259.854%20252.073%20271.565%20240.353L257.418%20226.216ZM258.914%20791.469L241.086%20782.404C244.793%20775.114%20255.207%20775.114%20258.914%20782.404L241.086%20791.469L223.258%20800.534C234.379%20822.404%20265.621%20822.404%20276.742%20800.534L258.914%20791.469ZM466.57%20381.029L448.965%20371.539C441.675%20385.064%20451.457%20401.5%20466.852%20401.5V381.5V361.5C481.762%20361.5%20491.236%20377.419%20484.176%20390.518L466.57%20381.029ZM211.566%20257.932L197.429%20272.079C193.522%20268.175%20193.52%20261.843%20197.424%20257.937L211.571%20272.074L225.719%20286.211C237.43%20274.491%20237.423%20255.496%20225.703%20243.784L211.566%20257.932ZM466.852%20381.5V401.5C452.163%20401.5%20442.651%20385.992%20449.308%20372.899L467.136%20381.964L484.964%20391.029C491.837%20377.511%20482.017%20361.5%20466.852%20361.5V381.5Z'%20fill='{{stroke}}'%20mask='url(%23path-1-inside-1_1_36)'/%3e%3c/svg%3e", oi = "data:image/svg+xml,%3csvg%20width='500'%20height='820'%20viewBox='0%200%20500%20820'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='path-1-inside-1_1_2'%20fill='white'%3e%3cpath%20d='M249%2017C385.414%2017%20496%20127.586%20496%20264C496%20306.343%20485.345%20346.197%20466.57%20381.029C466.455%20381.242%20466.61%20381.5%20466.852%20381.5C467.09%20381.5%20467.244%20381.752%20467.136%20381.964L258.914%20791.469C255.207%20798.759%20244.793%20798.759%20241.086%20791.469L39.1816%20394.39C15.6147%20356.547%202%20311.863%202%20264C2%20127.586%20112.586%2017%20249%2017ZM249.5%20151C189.025%20151%20140%20200.025%20140%20260.5C140%20320.975%20189.025%20370%20249.5%20370C309.975%20370%20359%20320.975%20359%20260.5C359%20200.025%20309.975%20151%20249.5%20151Z'/%3e%3c/mask%3e%3cpath%20d='M249%2017C385.414%2017%20496%20127.586%20496%20264C496%20306.343%20485.345%20346.197%20466.57%20381.029C466.455%20381.242%20466.61%20381.5%20466.852%20381.5C467.09%20381.5%20467.244%20381.752%20467.136%20381.964L258.914%20791.469C255.207%20798.759%20244.793%20798.759%20241.086%20791.469L39.1816%20394.39C15.6147%20356.547%202%20311.863%202%20264C2%20127.586%20112.586%2017%20249%2017ZM249.5%20151C189.025%20151%20140%20200.025%20140%20260.5C140%20320.975%20189.025%20370%20249.5%20370C309.975%20370%20359%20320.975%20359%20260.5C359%20200.025%20309.975%20151%20249.5%20151Z'%20fill='{{fill}}'/%3e%3cpath%20d='M39.1816%20394.39L57.0093%20385.325L56.6167%20384.552L56.1587%20383.817L39.1816%20394.39ZM258.914%20791.469L276.742%20800.534L258.914%20791.469ZM241.086%20791.469L223.258%20800.534L241.086%20791.469ZM467.136%20381.964L449.308%20372.899L467.136%20381.964ZM466.57%20381.029L484.176%20390.518L466.57%20381.029ZM249%2017V37C374.369%2037%20476%20138.631%20476%20264H496H516C516%20116.54%20396.46%20-3%20249%20-3V17ZM496%20264H476C476%20302.949%20466.207%20339.552%20448.965%20371.539L466.57%20381.029L484.176%20390.518C504.483%20352.843%20516%20309.737%20516%20264H496ZM467.136%20381.964L449.308%20372.899L241.086%20782.404L258.914%20791.469L276.742%20800.534L484.964%20391.029L467.136%20381.964ZM241.086%20791.469L258.914%20782.404L57.0093%20385.325L39.1816%20394.39L21.3539%20403.455L223.258%20800.534L241.086%20791.469ZM39.1816%20394.39L56.1587%20383.817C34.5099%20349.054%2022%20308.019%2022%20264H2H-18C-18%20315.708%20-3.28058%20364.039%2022.2046%20404.962L39.1816%20394.39ZM2%20264H22C22%20138.631%20123.631%2037%20249%2037V17V-3C101.54%20-3%20-18%20116.54%20-18%20264H2ZM249.5%20151V131C177.979%20131%20120%20188.979%20120%20260.5H140H160C160%20211.071%20200.071%20171%20249.5%20171V151ZM140%20260.5H120C120%20332.021%20177.979%20390%20249.5%20390V370V350C200.071%20350%20160%20309.929%20160%20260.5H140ZM249.5%20370V390C321.021%20390%20379%20332.021%20379%20260.5H359H339C339%20309.929%20298.929%20350%20249.5%20350V370ZM359%20260.5H379C379%20188.979%20321.021%20131%20249.5%20131V151V171C298.929%20171%20339%20211.071%20339%20260.5H359ZM258.914%20791.469L241.086%20782.404C244.793%20775.114%20255.207%20775.114%20258.914%20782.404L241.086%20791.469L223.258%20800.534C234.379%20822.404%20265.621%20822.404%20276.742%20800.534L258.914%20791.469ZM466.852%20381.5V401.5C452.163%20401.5%20442.651%20385.992%20449.308%20372.899L467.136%20381.964L484.964%20391.029C491.837%20377.511%20482.017%20361.5%20466.852%20361.5V381.5ZM466.57%20381.029L448.965%20371.539C441.675%20385.064%20451.457%20401.5%20466.852%20401.5V381.5V361.5C481.762%20361.5%20491.236%20377.419%20484.176%20390.518L466.57%20381.029Z'%20fill='{{stroke}}'%20mask='url(%23path-1-inside-1_1_2)'/%3e%3c/svg%3e", _h = "data:image/svg+xml,%3csvg%20width='500'%20height='820'%20viewBox='0%200%20500%20820'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='path-1-inside-1_1_12'%20fill='white'%3e%3cpath%20d='M249%2017C385.414%2017%20496%20127.586%20496%20264C496%20306.343%20485.345%20346.197%20466.57%20381.029C466.455%20381.242%20466.61%20381.5%20466.852%20381.5C467.09%20381.5%20467.244%20381.752%20467.136%20381.964L258.914%20791.469C255.207%20798.759%20244.793%20798.759%20241.086%20791.469L39.1816%20394.39C15.6147%20356.547%202%20311.863%202%20264C2%20127.586%20112.586%2017%20249%2017ZM211.894%20216.74C210.555%20220.86%20206.715%20223.649%20202.383%20223.649H111.464C101.777%20223.649%2097.7493%20236.046%20105.586%20241.74L179.142%20295.181C182.647%20297.727%20184.113%20302.241%20182.774%20306.361L154.679%20392.83C151.685%20402.043%20162.23%20409.704%20170.067%20404.01L243.622%20350.569C247.127%20348.023%20251.873%20348.023%20255.378%20350.569L328.933%20404.01C336.77%20409.704%20347.315%20402.043%20344.321%20392.83L316.226%20306.361C314.887%20302.241%20316.353%20297.727%20319.858%20295.181L393.414%20241.74C401.251%20236.046%20397.223%20223.649%20387.536%20223.649H296.617C292.285%20223.649%20288.445%20220.86%20287.106%20216.74L259.011%20130.27C256.017%20121.057%20242.983%20121.057%20239.989%20130.27L211.894%20216.74Z'/%3e%3c/mask%3e%3cpath%20d='M249%2017C385.414%2017%20496%20127.586%20496%20264C496%20306.343%20485.345%20346.197%20466.57%20381.029C466.455%20381.242%20466.61%20381.5%20466.852%20381.5C467.09%20381.5%20467.244%20381.752%20467.136%20381.964L258.914%20791.469C255.207%20798.759%20244.793%20798.759%20241.086%20791.469L39.1816%20394.39C15.6147%20356.547%202%20311.863%202%20264C2%20127.586%20112.586%2017%20249%2017ZM211.894%20216.74C210.555%20220.86%20206.715%20223.649%20202.383%20223.649H111.464C101.777%20223.649%2097.7493%20236.046%20105.586%20241.74L179.142%20295.181C182.647%20297.727%20184.113%20302.241%20182.774%20306.361L154.679%20392.83C151.685%20402.043%20162.23%20409.704%20170.067%20404.01L243.622%20350.569C247.127%20348.023%20251.873%20348.023%20255.378%20350.569L328.933%20404.01C336.77%20409.704%20347.315%20402.043%20344.321%20392.83L316.226%20306.361C314.887%20302.241%20316.353%20297.727%20319.858%20295.181L393.414%20241.74C401.251%20236.046%20397.223%20223.649%20387.536%20223.649H296.617C292.285%20223.649%20288.445%20220.86%20287.106%20216.74L259.011%20130.27C256.017%20121.057%20242.983%20121.057%20239.989%20130.27L211.894%20216.74Z'%20fill='{{fill}}'/%3e%3cpath%20d='M39.1816%20394.39L57.0093%20385.325L56.6167%20384.552L56.1587%20383.817L39.1816%20394.39ZM239.989%20130.27L259.011%20136.451L239.989%20130.27ZM243.622%20350.569L231.866%20334.389L243.622%20350.569ZM255.378%20350.569L267.134%20334.389L255.378%20350.569ZM154.679%20392.83L135.658%20386.65L154.679%20392.83ZM179.142%20295.181L167.386%20311.361L179.142%20295.181ZM182.774%20306.361L163.753%20300.181L182.774%20306.361ZM258.914%20791.469L276.742%20800.534L258.914%20791.469ZM241.086%20791.469L223.258%20800.534L241.086%20791.469ZM105.586%20241.74L93.8307%20257.92L105.586%20241.74ZM467.136%20381.964L449.308%20372.899L467.136%20381.964ZM211.894%20216.74L192.872%20210.559L211.894%20216.74ZM316.226%20306.361L335.247%20300.181L316.226%20306.361ZM319.858%20295.181L331.614%20311.361L319.858%20295.181ZM466.57%20381.029L484.176%20390.518L466.57%20381.029ZM249%2017V37C374.369%2037%20476%20138.631%20476%20264H496H516C516%20116.54%20396.46%20-3%20249%20-3V17ZM496%20264H476C476%20302.949%20466.207%20339.552%20448.965%20371.539L466.57%20381.029L484.176%20390.518C504.483%20352.843%20516%20309.737%20516%20264H496ZM467.136%20381.964L449.308%20372.899L241.086%20782.404L258.914%20791.469L276.742%20800.534L484.964%20391.029L467.136%20381.964ZM241.086%20791.469L258.914%20782.404L57.0093%20385.325L39.1816%20394.39L21.3539%20403.455L223.258%20800.534L241.086%20791.469ZM39.1816%20394.39L56.1587%20383.817C34.5099%20349.054%2022%20308.019%2022%20264H2H-18C-18%20315.708%20-3.28058%20364.039%2022.2046%20404.962L39.1816%20394.39ZM2%20264H22C22%20138.631%20123.631%2037%20249%2037V17V-3C101.54%20-3%20-18%20116.54%20-18%20264H2ZM202.383%20223.649V203.649H111.464V223.649V243.649H202.383V223.649ZM105.586%20241.74L93.8307%20257.92L167.386%20311.361L179.142%20295.181L190.897%20279L117.342%20225.559L105.586%20241.74ZM182.774%20306.361L163.753%20300.181L135.658%20386.65L154.679%20392.83L173.7%20399.01L201.795%20312.541L182.774%20306.361ZM170.067%20404.01L181.823%20420.191L255.378%20366.75L243.622%20350.569L231.866%20334.389L158.311%20387.83L170.067%20404.01ZM255.378%20350.569L243.622%20366.75L317.177%20420.191L328.933%20404.01L340.689%20387.83L267.134%20334.389L255.378%20350.569ZM344.321%20392.83L363.342%20386.65L335.247%20300.181L316.226%20306.361L297.205%20312.541L325.3%20399.01L344.321%20392.83ZM319.858%20295.181L331.614%20311.361L405.169%20257.92L393.414%20241.74L381.658%20225.559L308.103%20279L319.858%20295.181ZM387.536%20223.649V203.649H296.617V223.649V243.649H387.536V223.649ZM287.106%20216.74L306.128%20210.559L278.032%20124.09L259.011%20130.27L239.989%20136.451L268.085%20222.92L287.106%20216.74ZM239.989%20130.27L220.968%20124.09L192.872%20210.559L211.894%20216.74L230.915%20222.92L259.011%20136.451L239.989%20130.27ZM259.011%20130.27L278.032%20124.09C269.051%2096.4505%20229.949%2096.4507%20220.968%20124.09L239.989%20130.27L259.011%20136.451C256.017%20145.664%20242.983%20145.664%20239.989%20136.451L259.011%20130.27ZM296.617%20223.649V203.649C300.949%20203.649%20304.789%20206.439%20306.128%20210.559L287.106%20216.74L268.085%20222.92C272.102%20235.281%20283.62%20243.649%20296.617%20243.649V223.649ZM328.933%20404.01L317.177%20420.191C340.688%20437.273%20372.323%20414.289%20363.342%20386.65L344.321%20392.83L325.3%20399.01C322.307%20389.797%20332.852%20382.136%20340.689%20387.83L328.933%20404.01ZM243.622%20350.569L255.378%20366.75C251.873%20369.296%20247.127%20369.296%20243.622%20366.75L255.378%20350.569L267.134%20334.389C256.619%20326.75%20242.381%20326.75%20231.866%20334.389L243.622%20350.569ZM154.679%20392.83L135.658%20386.65C126.677%20414.289%20158.311%20437.273%20181.823%20420.191L170.067%20404.01L158.311%20387.83C166.148%20382.136%20176.693%20389.797%20173.7%20399.01L154.679%20392.83ZM179.142%20295.181L167.386%20311.361C163.881%20308.815%20162.414%20304.301%20163.753%20300.181L182.774%20306.361L201.795%20312.541C205.812%20300.181%20201.412%20286.64%20190.897%20279L179.142%20295.181ZM258.914%20791.469L241.086%20782.404C244.793%20775.114%20255.207%20775.114%20258.914%20782.404L241.086%20791.469L223.258%20800.534C234.379%20822.404%20265.621%20822.404%20276.742%20800.534L258.914%20791.469ZM111.464%20223.649V203.649C82.4026%20203.649%2070.3193%20240.838%2093.8307%20257.92L105.586%20241.74L117.342%20225.559C125.179%20231.253%20121.152%20243.649%20111.464%20243.649V223.649ZM393.414%20241.74L405.169%20257.92C428.681%20240.838%20416.598%20203.649%20387.536%20203.649V223.649V243.649C377.848%20243.649%20373.821%20231.253%20381.658%20225.559L393.414%20241.74ZM466.852%20381.5V401.5C452.163%20401.5%20442.651%20385.992%20449.308%20372.899L467.136%20381.964L484.964%20391.029C491.837%20377.511%20482.017%20361.5%20466.852%20361.5V381.5ZM202.383%20223.649V243.649C215.38%20243.649%20226.898%20235.281%20230.915%20222.92L211.894%20216.74L192.872%20210.559C194.211%20206.439%20198.051%20203.649%20202.383%20203.649V223.649ZM316.226%20306.361L335.247%20300.181C336.586%20304.301%20335.119%20308.815%20331.614%20311.361L319.858%20295.181L308.103%20279C297.588%20286.64%20293.188%20300.181%20297.205%20312.541L316.226%20306.361ZM466.57%20381.029L448.965%20371.539C441.675%20385.064%20451.457%20401.5%20466.852%20401.5V381.5V361.5C481.762%20361.5%20491.236%20377.419%20484.176%20390.518L466.57%20381.029Z'%20fill='{{stroke}}'%20mask='url(%23path-1-inside-1_1_12)'/%3e%3c/svg%3e";
var Wn = { exports: {} };
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
(function(a, e) {
  (function(t, o) {
    o(e);
  })(Mr, function(t) {
    var o = "1.9.4";
    function r(n) {
      var l, c, h, f;
      for (c = 1, h = arguments.length; c < h; c++) {
        f = arguments[c];
        for (l in f)
          n[l] = f[l];
      }
      return n;
    }
    var s = Object.create || /* @__PURE__ */ function() {
      function n() {
      }
      return function(l) {
        return n.prototype = l, new n();
      };
    }();
    function i(n, l) {
      var c = Array.prototype.slice;
      if (n.bind)
        return n.bind.apply(n, c.call(arguments, 1));
      var h = c.call(arguments, 2);
      return function() {
        return n.apply(l, h.length ? h.concat(c.call(arguments)) : arguments);
      };
    }
    var u = 0;
    function d(n) {
      return "_leaflet_id" in n || (n._leaflet_id = ++u), n._leaflet_id;
    }
    function m(n, l, c) {
      var h, f, y, S;
      return S = function() {
        h = !1, f && (y.apply(c, f), f = !1);
      }, y = function() {
        h ? f = arguments : (n.apply(c, arguments), setTimeout(S, l), h = !0);
      }, y;
    }
    function v(n, l, c) {
      var h = l[1], f = l[0], y = h - f;
      return n === h && c ? n : ((n - f) % y + y) % y + f;
    }
    function p() {
      return !1;
    }
    function g(n, l) {
      if (l === !1)
        return n;
      var c = Math.pow(10, l === void 0 ? 6 : l);
      return Math.round(n * c) / c;
    }
    function w(n) {
      return n.trim ? n.trim() : n.replace(/^\s+|\s+$/g, "");
    }
    function _(n) {
      return w(n).split(/\s+/);
    }
    function P(n, l) {
      Object.prototype.hasOwnProperty.call(n, "options") || (n.options = n.options ? s(n.options) : {});
      for (var c in l)
        n.options[c] = l[c];
      return n.options;
    }
    function T(n, l, c) {
      var h = [];
      for (var f in n)
        h.push(encodeURIComponent(c ? f.toUpperCase() : f) + "=" + encodeURIComponent(n[f]));
      return (!l || l.indexOf("?") === -1 ? "?" : "&") + h.join("&");
    }
    var k = /\{ *([\w_ -]+) *\}/g;
    function x(n, l) {
      return n.replace(k, function(c, h) {
        var f = l[h];
        if (f === void 0)
          throw new Error("No value provided for variable " + c);
        return typeof f == "function" && (f = f(l)), f;
      });
    }
    var C = Array.isArray || function(n) {
      return Object.prototype.toString.call(n) === "[object Array]";
    };
    function I(n, l) {
      for (var c = 0; c < n.length; c++)
        if (n[c] === l)
          return c;
      return -1;
    }
    var z = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    function H(n) {
      return window["webkit" + n] || window["moz" + n] || window["ms" + n];
    }
    var F = 0;
    function se(n) {
      var l = +/* @__PURE__ */ new Date(), c = Math.max(0, 16 - (l - F));
      return F = l + c, window.setTimeout(n, c);
    }
    var pe = window.requestAnimationFrame || H("RequestAnimationFrame") || se, Te = window.cancelAnimationFrame || H("CancelAnimationFrame") || H("CancelRequestAnimationFrame") || function(n) {
      window.clearTimeout(n);
    };
    function W(n, l, c) {
      if (c && pe === se)
        n.call(l);
      else
        return pe.call(window, i(n, l));
    }
    function Y(n) {
      n && Te.call(window, n);
    }
    var X = {
      __proto__: null,
      extend: r,
      create: s,
      bind: i,
      get lastId() {
        return u;
      },
      stamp: d,
      throttle: m,
      wrapNum: v,
      falseFn: p,
      formatNum: g,
      trim: w,
      splitWords: _,
      setOptions: P,
      getParamString: T,
      template: x,
      isArray: C,
      indexOf: I,
      emptyImageUrl: z,
      requestFn: pe,
      cancelFn: Te,
      requestAnimFrame: W,
      cancelAnimFrame: Y
    };
    function Z() {
    }
    Z.extend = function(n) {
      var l = function() {
        P(this), this.initialize && this.initialize.apply(this, arguments), this.callInitHooks();
      }, c = l.__super__ = this.prototype, h = s(c);
      h.constructor = l, l.prototype = h;
      for (var f in this)
        Object.prototype.hasOwnProperty.call(this, f) && f !== "prototype" && f !== "__super__" && (l[f] = this[f]);
      return n.statics && r(l, n.statics), n.includes && (he(n.includes), r.apply(null, [h].concat(n.includes))), r(h, n), delete h.statics, delete h.includes, h.options && (h.options = c.options ? s(c.options) : {}, r(h.options, n.options)), h._initHooks = [], h.callInitHooks = function() {
        if (!this._initHooksCalled) {
          c.callInitHooks && c.callInitHooks.call(this), this._initHooksCalled = !0;
          for (var y = 0, S = h._initHooks.length; y < S; y++)
            h._initHooks[y].call(this);
        }
      }, l;
    }, Z.include = function(n) {
      var l = this.prototype.options;
      return r(this.prototype, n), n.options && (this.prototype.options = l, this.mergeOptions(n.options)), this;
    }, Z.mergeOptions = function(n) {
      return r(this.prototype.options, n), this;
    }, Z.addInitHook = function(n) {
      var l = Array.prototype.slice.call(arguments, 1), c = typeof n == "function" ? n : function() {
        this[n].apply(this, l);
      };
      return this.prototype._initHooks = this.prototype._initHooks || [], this.prototype._initHooks.push(c), this;
    };
    function he(n) {
      if (!(typeof L > "u" || !L || !L.Mixin)) {
        n = C(n) ? n : [n];
        for (var l = 0; l < n.length; l++)
          n[l] === L.Mixin.Events && console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
      }
    }
    var Pe = {
      /* @method on(type: String, fn: Function, context?: Object): this
       * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
       *
       * @alternative
       * @method on(eventMap: Object): this
       * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
       */
      on: function(n, l, c) {
        if (typeof n == "object")
          for (var h in n)
            this._on(h, n[h], l);
        else {
          n = _(n);
          for (var f = 0, y = n.length; f < y; f++)
            this._on(n[f], l, c);
        }
        return this;
      },
      /* @method off(type: String, fn?: Function, context?: Object): this
       * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
       *
       * @alternative
       * @method off(eventMap: Object): this
       * Removes a set of type/listener pairs.
       *
       * @alternative
       * @method off: this
       * Removes all listeners to all events on the object. This includes implicitly attached events.
       */
      off: function(n, l, c) {
        if (!arguments.length)
          delete this._events;
        else if (typeof n == "object")
          for (var h in n)
            this._off(h, n[h], l);
        else {
          n = _(n);
          for (var f = arguments.length === 1, y = 0, S = n.length; y < S; y++)
            f ? this._off(n[y]) : this._off(n[y], l, c);
        }
        return this;
      },
      // attach listener (without syntactic sugar now)
      _on: function(n, l, c, h) {
        if (typeof l != "function") {
          console.warn("wrong listener type: " + typeof l);
          return;
        }
        if (this._listens(n, l, c) === !1) {
          c === this && (c = void 0);
          var f = { fn: l, ctx: c };
          h && (f.once = !0), this._events = this._events || {}, this._events[n] = this._events[n] || [], this._events[n].push(f);
        }
      },
      _off: function(n, l, c) {
        var h, f, y;
        if (this._events && (h = this._events[n], !!h)) {
          if (arguments.length === 1) {
            if (this._firingCount)
              for (f = 0, y = h.length; f < y; f++)
                h[f].fn = p;
            delete this._events[n];
            return;
          }
          if (typeof l != "function") {
            console.warn("wrong listener type: " + typeof l);
            return;
          }
          var S = this._listens(n, l, c);
          if (S !== !1) {
            var E = h[S];
            this._firingCount && (E.fn = p, this._events[n] = h = h.slice()), h.splice(S, 1);
          }
        }
      },
      // @method fire(type: String, data?: Object, propagate?: Boolean): this
      // Fires an event of the specified type. You can optionally provide a data
      // object — the first argument of the listener function will contain its
      // properties. The event can optionally be propagated to event parents.
      fire: function(n, l, c) {
        if (!this.listens(n, c))
          return this;
        var h = r({}, l, {
          type: n,
          target: this,
          sourceTarget: l && l.sourceTarget || this
        });
        if (this._events) {
          var f = this._events[n];
          if (f) {
            this._firingCount = this._firingCount + 1 || 1;
            for (var y = 0, S = f.length; y < S; y++) {
              var E = f[y], M = E.fn;
              E.once && this.off(n, M, E.ctx), M.call(E.ctx || this, h);
            }
            this._firingCount--;
          }
        }
        return c && this._propagateEvent(h), this;
      },
      // @method listens(type: String, propagate?: Boolean): Boolean
      // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
      // Returns `true` if a particular event type has any listeners attached to it.
      // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
      listens: function(n, l, c, h) {
        typeof n != "string" && console.warn('"string" type argument expected');
        var f = l;
        typeof l != "function" && (h = !!l, f = void 0, c = void 0);
        var y = this._events && this._events[n];
        if (y && y.length && this._listens(n, f, c) !== !1)
          return !0;
        if (h) {
          for (var S in this._eventParents)
            if (this._eventParents[S].listens(n, l, c, h))
              return !0;
        }
        return !1;
      },
      // returns the index (number) or false
      _listens: function(n, l, c) {
        if (!this._events)
          return !1;
        var h = this._events[n] || [];
        if (!l)
          return !!h.length;
        c === this && (c = void 0);
        for (var f = 0, y = h.length; f < y; f++)
          if (h[f].fn === l && h[f].ctx === c)
            return f;
        return !1;
      },
      // @method once(…): this
      // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
      once: function(n, l, c) {
        if (typeof n == "object")
          for (var h in n)
            this._on(h, n[h], l, !0);
        else {
          n = _(n);
          for (var f = 0, y = n.length; f < y; f++)
            this._on(n[f], l, c, !0);
        }
        return this;
      },
      // @method addEventParent(obj: Evented): this
      // Adds an event parent - an `Evented` that will receive propagated events
      addEventParent: function(n) {
        return this._eventParents = this._eventParents || {}, this._eventParents[d(n)] = n, this;
      },
      // @method removeEventParent(obj: Evented): this
      // Removes an event parent, so it will stop receiving propagated events
      removeEventParent: function(n) {
        return this._eventParents && delete this._eventParents[d(n)], this;
      },
      _propagateEvent: function(n) {
        for (var l in this._eventParents)
          this._eventParents[l].fire(n.type, r({
            layer: n.target,
            propagatedFrom: n.target
          }, n), !0);
      }
    };
    Pe.addEventListener = Pe.on, Pe.removeEventListener = Pe.clearAllEventListeners = Pe.off, Pe.addOneTimeEventListener = Pe.once, Pe.fireEvent = Pe.fire, Pe.hasEventListeners = Pe.listens;
    var ot = Z.extend(Pe);
    function ue(n, l, c) {
      this.x = c ? Math.round(n) : n, this.y = c ? Math.round(l) : l;
    }
    var Gt = Math.trunc || function(n) {
      return n > 0 ? Math.floor(n) : Math.ceil(n);
    };
    ue.prototype = {
      // @method clone(): Point
      // Returns a copy of the current point.
      clone: function() {
        return new ue(this.x, this.y);
      },
      // @method add(otherPoint: Point): Point
      // Returns the result of addition of the current and the given points.
      add: function(n) {
        return this.clone()._add(J(n));
      },
      _add: function(n) {
        return this.x += n.x, this.y += n.y, this;
      },
      // @method subtract(otherPoint: Point): Point
      // Returns the result of subtraction of the given point from the current.
      subtract: function(n) {
        return this.clone()._subtract(J(n));
      },
      _subtract: function(n) {
        return this.x -= n.x, this.y -= n.y, this;
      },
      // @method divideBy(num: Number): Point
      // Returns the result of division of the current point by the given number.
      divideBy: function(n) {
        return this.clone()._divideBy(n);
      },
      _divideBy: function(n) {
        return this.x /= n, this.y /= n, this;
      },
      // @method multiplyBy(num: Number): Point
      // Returns the result of multiplication of the current point by the given number.
      multiplyBy: function(n) {
        return this.clone()._multiplyBy(n);
      },
      _multiplyBy: function(n) {
        return this.x *= n, this.y *= n, this;
      },
      // @method scaleBy(scale: Point): Point
      // Multiply each coordinate of the current point by each coordinate of
      // `scale`. In linear algebra terms, multiply the point by the
      // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
      // defined by `scale`.
      scaleBy: function(n) {
        return new ue(this.x * n.x, this.y * n.y);
      },
      // @method unscaleBy(scale: Point): Point
      // Inverse of `scaleBy`. Divide each coordinate of the current point by
      // each coordinate of `scale`.
      unscaleBy: function(n) {
        return new ue(this.x / n.x, this.y / n.y);
      },
      // @method round(): Point
      // Returns a copy of the current point with rounded coordinates.
      round: function() {
        return this.clone()._round();
      },
      _round: function() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
      },
      // @method floor(): Point
      // Returns a copy of the current point with floored coordinates (rounded down).
      floor: function() {
        return this.clone()._floor();
      },
      _floor: function() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
      },
      // @method ceil(): Point
      // Returns a copy of the current point with ceiled coordinates (rounded up).
      ceil: function() {
        return this.clone()._ceil();
      },
      _ceil: function() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
      },
      // @method trunc(): Point
      // Returns a copy of the current point with truncated coordinates (rounded towards zero).
      trunc: function() {
        return this.clone()._trunc();
      },
      _trunc: function() {
        return this.x = Gt(this.x), this.y = Gt(this.y), this;
      },
      // @method distanceTo(otherPoint: Point): Number
      // Returns the cartesian distance between the current and the given points.
      distanceTo: function(n) {
        n = J(n);
        var l = n.x - this.x, c = n.y - this.y;
        return Math.sqrt(l * l + c * c);
      },
      // @method equals(otherPoint: Point): Boolean
      // Returns `true` if the given point has the same coordinates.
      equals: function(n) {
        return n = J(n), n.x === this.x && n.y === this.y;
      },
      // @method contains(otherPoint: Point): Boolean
      // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
      contains: function(n) {
        return n = J(n), Math.abs(n.x) <= Math.abs(this.x) && Math.abs(n.y) <= Math.abs(this.y);
      },
      // @method toString(): String
      // Returns a string representation of the point for debugging purposes.
      toString: function() {
        return "Point(" + g(this.x) + ", " + g(this.y) + ")";
      }
    };
    function J(n, l, c) {
      return n instanceof ue ? n : C(n) ? new ue(n[0], n[1]) : n == null ? n : typeof n == "object" && "x" in n && "y" in n ? new ue(n.x, n.y) : new ue(n, l, c);
    }
    function Q(n, l) {
      if (n)
        for (var c = l ? [n, l] : n, h = 0, f = c.length; h < f; h++)
          this.extend(c[h]);
    }
    Q.prototype = {
      // @method extend(point: Point): this
      // Extends the bounds to contain the given point.
      // @alternative
      // @method extend(otherBounds: Bounds): this
      // Extend the bounds to contain the given bounds
      extend: function(n) {
        var l, c;
        if (!n)
          return this;
        if (n instanceof ue || typeof n[0] == "number" || "x" in n)
          l = c = J(n);
        else if (n = be(n), l = n.min, c = n.max, !l || !c)
          return this;
        return !this.min && !this.max ? (this.min = l.clone(), this.max = c.clone()) : (this.min.x = Math.min(l.x, this.min.x), this.max.x = Math.max(c.x, this.max.x), this.min.y = Math.min(l.y, this.min.y), this.max.y = Math.max(c.y, this.max.y)), this;
      },
      // @method getCenter(round?: Boolean): Point
      // Returns the center point of the bounds.
      getCenter: function(n) {
        return J(
          (this.min.x + this.max.x) / 2,
          (this.min.y + this.max.y) / 2,
          n
        );
      },
      // @method getBottomLeft(): Point
      // Returns the bottom-left point of the bounds.
      getBottomLeft: function() {
        return J(this.min.x, this.max.y);
      },
      // @method getTopRight(): Point
      // Returns the top-right point of the bounds.
      getTopRight: function() {
        return J(this.max.x, this.min.y);
      },
      // @method getTopLeft(): Point
      // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
      getTopLeft: function() {
        return this.min;
      },
      // @method getBottomRight(): Point
      // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
      getBottomRight: function() {
        return this.max;
      },
      // @method getSize(): Point
      // Returns the size of the given bounds
      getSize: function() {
        return this.max.subtract(this.min);
      },
      // @method contains(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle contains the given one.
      // @alternative
      // @method contains(point: Point): Boolean
      // Returns `true` if the rectangle contains the given point.
      contains: function(n) {
        var l, c;
        return typeof n[0] == "number" || n instanceof ue ? n = J(n) : n = be(n), n instanceof Q ? (l = n.min, c = n.max) : l = c = n, l.x >= this.min.x && c.x <= this.max.x && l.y >= this.min.y && c.y <= this.max.y;
      },
      // @method intersects(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle intersects the given bounds. Two bounds
      // intersect if they have at least one point in common.
      intersects: function(n) {
        n = be(n);
        var l = this.min, c = this.max, h = n.min, f = n.max, y = f.x >= l.x && h.x <= c.x, S = f.y >= l.y && h.y <= c.y;
        return y && S;
      },
      // @method overlaps(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle overlaps the given bounds. Two bounds
      // overlap if their intersection is an area.
      overlaps: function(n) {
        n = be(n);
        var l = this.min, c = this.max, h = n.min, f = n.max, y = f.x > l.x && h.x < c.x, S = f.y > l.y && h.y < c.y;
        return y && S;
      },
      // @method isValid(): Boolean
      // Returns `true` if the bounds are properly initialized.
      isValid: function() {
        return !!(this.min && this.max);
      },
      // @method pad(bufferRatio: Number): Bounds
      // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
      // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
      // Negative values will retract the bounds.
      pad: function(n) {
        var l = this.min, c = this.max, h = Math.abs(l.x - c.x) * n, f = Math.abs(l.y - c.y) * n;
        return be(
          J(l.x - h, l.y - f),
          J(c.x + h, c.y + f)
        );
      },
      // @method equals(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle is equivalent to the given bounds.
      equals: function(n) {
        return n ? (n = be(n), this.min.equals(n.getTopLeft()) && this.max.equals(n.getBottomRight())) : !1;
      }
    };
    function be(n, l) {
      return !n || n instanceof Q ? n : new Q(n, l);
    }
    function De(n, l) {
      if (n)
        for (var c = l ? [n, l] : n, h = 0, f = c.length; h < f; h++)
          this.extend(c[h]);
    }
    De.prototype = {
      // @method extend(latlng: LatLng): this
      // Extend the bounds to contain the given point
      // @alternative
      // @method extend(otherBounds: LatLngBounds): this
      // Extend the bounds to contain the given bounds
      extend: function(n) {
        var l = this._southWest, c = this._northEast, h, f;
        if (n instanceof Ce)
          h = n, f = n;
        else if (n instanceof De) {
          if (h = n._southWest, f = n._northEast, !h || !f)
            return this;
        } else
          return n ? this.extend(ve(n) || Le(n)) : this;
        return !l && !c ? (this._southWest = new Ce(h.lat, h.lng), this._northEast = new Ce(f.lat, f.lng)) : (l.lat = Math.min(h.lat, l.lat), l.lng = Math.min(h.lng, l.lng), c.lat = Math.max(f.lat, c.lat), c.lng = Math.max(f.lng, c.lng)), this;
      },
      // @method pad(bufferRatio: Number): LatLngBounds
      // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
      // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
      // Negative values will retract the bounds.
      pad: function(n) {
        var l = this._southWest, c = this._northEast, h = Math.abs(l.lat - c.lat) * n, f = Math.abs(l.lng - c.lng) * n;
        return new De(
          new Ce(l.lat - h, l.lng - f),
          new Ce(c.lat + h, c.lng + f)
        );
      },
      // @method getCenter(): LatLng
      // Returns the center point of the bounds.
      getCenter: function() {
        return new Ce(
          (this._southWest.lat + this._northEast.lat) / 2,
          (this._southWest.lng + this._northEast.lng) / 2
        );
      },
      // @method getSouthWest(): LatLng
      // Returns the south-west point of the bounds.
      getSouthWest: function() {
        return this._southWest;
      },
      // @method getNorthEast(): LatLng
      // Returns the north-east point of the bounds.
      getNorthEast: function() {
        return this._northEast;
      },
      // @method getNorthWest(): LatLng
      // Returns the north-west point of the bounds.
      getNorthWest: function() {
        return new Ce(this.getNorth(), this.getWest());
      },
      // @method getSouthEast(): LatLng
      // Returns the south-east point of the bounds.
      getSouthEast: function() {
        return new Ce(this.getSouth(), this.getEast());
      },
      // @method getWest(): Number
      // Returns the west longitude of the bounds
      getWest: function() {
        return this._southWest.lng;
      },
      // @method getSouth(): Number
      // Returns the south latitude of the bounds
      getSouth: function() {
        return this._southWest.lat;
      },
      // @method getEast(): Number
      // Returns the east longitude of the bounds
      getEast: function() {
        return this._northEast.lng;
      },
      // @method getNorth(): Number
      // Returns the north latitude of the bounds
      getNorth: function() {
        return this._northEast.lat;
      },
      // @method contains(otherBounds: LatLngBounds): Boolean
      // Returns `true` if the rectangle contains the given one.
      // @alternative
      // @method contains (latlng: LatLng): Boolean
      // Returns `true` if the rectangle contains the given point.
      contains: function(n) {
        typeof n[0] == "number" || n instanceof Ce || "lat" in n ? n = ve(n) : n = Le(n);
        var l = this._southWest, c = this._northEast, h, f;
        return n instanceof De ? (h = n.getSouthWest(), f = n.getNorthEast()) : h = f = n, h.lat >= l.lat && f.lat <= c.lat && h.lng >= l.lng && f.lng <= c.lng;
      },
      // @method intersects(otherBounds: LatLngBounds): Boolean
      // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
      intersects: function(n) {
        n = Le(n);
        var l = this._southWest, c = this._northEast, h = n.getSouthWest(), f = n.getNorthEast(), y = f.lat >= l.lat && h.lat <= c.lat, S = f.lng >= l.lng && h.lng <= c.lng;
        return y && S;
      },
      // @method overlaps(otherBounds: LatLngBounds): Boolean
      // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
      overlaps: function(n) {
        n = Le(n);
        var l = this._southWest, c = this._northEast, h = n.getSouthWest(), f = n.getNorthEast(), y = f.lat > l.lat && h.lat < c.lat, S = f.lng > l.lng && h.lng < c.lng;
        return y && S;
      },
      // @method toBBoxString(): String
      // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
      toBBoxString: function() {
        return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(",");
      },
      // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
      // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
      equals: function(n, l) {
        return n ? (n = Le(n), this._southWest.equals(n.getSouthWest(), l) && this._northEast.equals(n.getNorthEast(), l)) : !1;
      },
      // @method isValid(): Boolean
      // Returns `true` if the bounds are properly initialized.
      isValid: function() {
        return !!(this._southWest && this._northEast);
      }
    };
    function Le(n, l) {
      return n instanceof De ? n : new De(n, l);
    }
    function Ce(n, l, c) {
      if (isNaN(n) || isNaN(l))
        throw new Error("Invalid LatLng object: (" + n + ", " + l + ")");
      this.lat = +n, this.lng = +l, c !== void 0 && (this.alt = +c);
    }
    Ce.prototype = {
      // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
      // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
      equals: function(n, l) {
        if (!n)
          return !1;
        n = ve(n);
        var c = Math.max(
          Math.abs(this.lat - n.lat),
          Math.abs(this.lng - n.lng)
        );
        return c <= (l === void 0 ? 1e-9 : l);
      },
      // @method toString(): String
      // Returns a string representation of the point (for debugging purposes).
      toString: function(n) {
        return "LatLng(" + g(this.lat, n) + ", " + g(this.lng, n) + ")";
      },
      // @method distanceTo(otherLatLng: LatLng): Number
      // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
      distanceTo: function(n) {
        return Ht.distance(this, ve(n));
      },
      // @method wrap(): LatLng
      // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
      wrap: function() {
        return Ht.wrapLatLng(this);
      },
      // @method toBounds(sizeInMeters: Number): LatLngBounds
      // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
      toBounds: function(n) {
        var l = 180 * n / 40075017, c = l / Math.cos(Math.PI / 180 * this.lat);
        return Le(
          [this.lat - l, this.lng - c],
          [this.lat + l, this.lng + c]
        );
      },
      clone: function() {
        return new Ce(this.lat, this.lng, this.alt);
      }
    };
    function ve(n, l, c) {
      return n instanceof Ce ? n : C(n) && typeof n[0] != "object" ? n.length === 3 ? new Ce(n[0], n[1], n[2]) : n.length === 2 ? new Ce(n[0], n[1]) : null : n == null ? n : typeof n == "object" && "lat" in n ? new Ce(n.lat, "lng" in n ? n.lng : n.lon, n.alt) : l === void 0 ? null : new Ce(n, l, c);
    }
    var Nt = {
      // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
      // Projects geographical coordinates into pixel coordinates for a given zoom.
      latLngToPoint: function(n, l) {
        var c = this.projection.project(n), h = this.scale(l);
        return this.transformation._transform(c, h);
      },
      // @method pointToLatLng(point: Point, zoom: Number): LatLng
      // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
      // zoom into geographical coordinates.
      pointToLatLng: function(n, l) {
        var c = this.scale(l), h = this.transformation.untransform(n, c);
        return this.projection.unproject(h);
      },
      // @method project(latlng: LatLng): Point
      // Projects geographical coordinates into coordinates in units accepted for
      // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
      project: function(n) {
        return this.projection.project(n);
      },
      // @method unproject(point: Point): LatLng
      // Given a projected coordinate returns the corresponding LatLng.
      // The inverse of `project`.
      unproject: function(n) {
        return this.projection.unproject(n);
      },
      // @method scale(zoom: Number): Number
      // Returns the scale used when transforming projected coordinates into
      // pixel coordinates for a particular zoom. For example, it returns
      // `256 * 2^zoom` for Mercator-based CRS.
      scale: function(n) {
        return 256 * Math.pow(2, n);
      },
      // @method zoom(scale: Number): Number
      // Inverse of `scale()`, returns the zoom level corresponding to a scale
      // factor of `scale`.
      zoom: function(n) {
        return Math.log(n / 256) / Math.LN2;
      },
      // @method getProjectedBounds(zoom: Number): Bounds
      // Returns the projection's bounds scaled and transformed for the provided `zoom`.
      getProjectedBounds: function(n) {
        if (this.infinite)
          return null;
        var l = this.projection.bounds, c = this.scale(n), h = this.transformation.transform(l.min, c), f = this.transformation.transform(l.max, c);
        return new Q(h, f);
      },
      // @method distance(latlng1: LatLng, latlng2: LatLng): Number
      // Returns the distance between two geographical coordinates.
      // @property code: String
      // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
      //
      // @property wrapLng: Number[]
      // An array of two numbers defining whether the longitude (horizontal) coordinate
      // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
      // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
      //
      // @property wrapLat: Number[]
      // Like `wrapLng`, but for the latitude (vertical) axis.
      // wrapLng: [min, max],
      // wrapLat: [min, max],
      // @property infinite: Boolean
      // If true, the coordinate space will be unbounded (infinite in both axes)
      infinite: !1,
      // @method wrapLatLng(latlng: LatLng): LatLng
      // Returns a `LatLng` where lat and lng has been wrapped according to the
      // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
      wrapLatLng: function(n) {
        var l = this.wrapLng ? v(n.lng, this.wrapLng, !0) : n.lng, c = this.wrapLat ? v(n.lat, this.wrapLat, !0) : n.lat, h = n.alt;
        return new Ce(c, l, h);
      },
      // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
      // Returns a `LatLngBounds` with the same size as the given one, ensuring
      // that its center is within the CRS's bounds.
      // Only accepts actual `L.LatLngBounds` instances, not arrays.
      wrapLatLngBounds: function(n) {
        var l = n.getCenter(), c = this.wrapLatLng(l), h = l.lat - c.lat, f = l.lng - c.lng;
        if (h === 0 && f === 0)
          return n;
        var y = n.getSouthWest(), S = n.getNorthEast(), E = new Ce(y.lat - h, y.lng - f), M = new Ce(S.lat - h, S.lng - f);
        return new De(E, M);
      }
    }, Ht = r({}, Nt, {
      wrapLng: [-180, 180],
      // Mean Earth Radius, as recommended for use by
      // the International Union of Geodesy and Geophysics,
      // see https://rosettacode.org/wiki/Haversine_formula
      R: 6371e3,
      // distance between two geographical points using spherical law of cosines approximation
      distance: function(n, l) {
        var c = Math.PI / 180, h = n.lat * c, f = l.lat * c, y = Math.sin((l.lat - n.lat) * c / 2), S = Math.sin((l.lng - n.lng) * c / 2), E = y * y + Math.cos(h) * Math.cos(f) * S * S, M = 2 * Math.atan2(Math.sqrt(E), Math.sqrt(1 - E));
        return this.R * M;
      }
    }), oa = 6378137, Zi = {
      R: oa,
      MAX_LATITUDE: 85.0511287798,
      project: function(n) {
        var l = Math.PI / 180, c = this.MAX_LATITUDE, h = Math.max(Math.min(c, n.lat), -c), f = Math.sin(h * l);
        return new ue(
          this.R * n.lng * l,
          this.R * Math.log((1 + f) / (1 - f)) / 2
        );
      },
      unproject: function(n) {
        var l = 180 / Math.PI;
        return new Ce(
          (2 * Math.atan(Math.exp(n.y / this.R)) - Math.PI / 2) * l,
          n.x * l / this.R
        );
      },
      bounds: function() {
        var n = oa * Math.PI;
        return new Q([-n, -n], [n, n]);
      }()
    };
    function Vi(n, l, c, h) {
      if (C(n)) {
        this._a = n[0], this._b = n[1], this._c = n[2], this._d = n[3];
        return;
      }
      this._a = n, this._b = l, this._c = c, this._d = h;
    }
    Vi.prototype = {
      // @method transform(point: Point, scale?: Number): Point
      // Returns a transformed point, optionally multiplied by the given scale.
      // Only accepts actual `L.Point` instances, not arrays.
      transform: function(n, l) {
        return this._transform(n.clone(), l);
      },
      // destructive transform (faster)
      _transform: function(n, l) {
        return l = l || 1, n.x = l * (this._a * n.x + this._b), n.y = l * (this._c * n.y + this._d), n;
      },
      // @method untransform(point: Point, scale?: Number): Point
      // Returns the reverse transformation of the given point, optionally divided
      // by the given scale. Only accepts actual `L.Point` instances, not arrays.
      untransform: function(n, l) {
        return l = l || 1, new ue(
          (n.x / l - this._b) / this._a,
          (n.y / l - this._d) / this._c
        );
      }
    };
    function Wr(n, l, c, h) {
      return new Vi(n, l, c, h);
    }
    var $i = r({}, Ht, {
      code: "EPSG:3857",
      projection: Zi,
      transformation: function() {
        var n = 0.5 / (Math.PI * Zi.R);
        return Wr(n, 0.5, -n, 0.5);
      }()
    }), xh = r({}, $i, {
      code: "EPSG:900913"
    });
    function aa(n) {
      return document.createElementNS("http://www.w3.org/2000/svg", n);
    }
    function la(n, l) {
      var c = "", h, f, y, S, E, M;
      for (h = 0, y = n.length; h < y; h++) {
        for (E = n[h], f = 0, S = E.length; f < S; f++)
          M = E[f], c += (f ? "L" : "M") + M.x + " " + M.y;
        c += l ? oe.svg ? "z" : "x" : "";
      }
      return c || "M0 0";
    }
    var Fi = document.documentElement.style, Is = "ActiveXObject" in window, Sh = Is && !document.addEventListener, ua = "msLaunchUri" in navigator && !("documentMode" in document), Gi = Ot("webkit"), ca = Ot("android"), ha = Ot("android 2") || Ot("android 3"), Th = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10), Lh = ca && Ot("Google") && Th < 537 && !("AudioNode" in window), Hi = !!window.opera, da = !ua && Ot("chrome"), fa = Ot("gecko") && !Gi && !Hi && !Is, Ch = !da && Ot("safari"), pa = Ot("phantom"), ma = "OTransition" in Fi, Ah = navigator.platform.indexOf("Win") === 0, va = Is && "transition" in Fi, Wi = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !ha, ga = "MozPerspective" in Fi, Oh = !window.L_DISABLE_3D && (va || Wi || ga) && !ma && !pa, Kr = typeof orientation < "u" || Ot("mobile"), kh = Kr && Gi, Ih = Kr && Wi, ya = !window.PointerEvent && window.MSPointerEvent, _a = !!(window.PointerEvent || ya), ba = "ontouchstart" in window || !!window.TouchEvent, jh = !window.L_NO_TOUCH && (ba || _a), Eh = Kr && Hi, Dh = Kr && fa, Mh = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1, Nh = function() {
      var n = !1;
      try {
        var l = Object.defineProperty({}, "passive", {
          get: function() {
            n = !0;
          }
        });
        window.addEventListener("testPassiveEventSupport", p, l), window.removeEventListener("testPassiveEventSupport", p, l);
      } catch {
      }
      return n;
    }(), Jh = function() {
      return !!document.createElement("canvas").getContext;
    }(), Ki = !!(document.createElementNS && aa("svg").createSVGRect), Uh = !!Ki && function() {
      var n = document.createElement("div");
      return n.innerHTML = "<svg/>", (n.firstChild && n.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }(), Bh = !Ki && function() {
      try {
        var n = document.createElement("div");
        n.innerHTML = '<v:shape adj="1"/>';
        var l = n.firstChild;
        return l.style.behavior = "url(#default#VML)", l && typeof l.adj == "object";
      } catch {
        return !1;
      }
    }(), Rh = navigator.platform.indexOf("Mac") === 0, zh = navigator.platform.indexOf("Linux") === 0;
    function Ot(n) {
      return navigator.userAgent.toLowerCase().indexOf(n) >= 0;
    }
    var oe = {
      ie: Is,
      ielt9: Sh,
      edge: ua,
      webkit: Gi,
      android: ca,
      android23: ha,
      androidStock: Lh,
      opera: Hi,
      chrome: da,
      gecko: fa,
      safari: Ch,
      phantom: pa,
      opera12: ma,
      win: Ah,
      ie3d: va,
      webkit3d: Wi,
      gecko3d: ga,
      any3d: Oh,
      mobile: Kr,
      mobileWebkit: kh,
      mobileWebkit3d: Ih,
      msPointer: ya,
      pointer: _a,
      touch: jh,
      touchNative: ba,
      mobileOpera: Eh,
      mobileGecko: Dh,
      retina: Mh,
      passiveEvents: Nh,
      canvas: Jh,
      svg: Ki,
      vml: Bh,
      inlineSvg: Uh,
      mac: Rh,
      linux: zh
    }, wa = oe.msPointer ? "MSPointerDown" : "pointerdown", Pa = oe.msPointer ? "MSPointerMove" : "pointermove", xa = oe.msPointer ? "MSPointerUp" : "pointerup", Sa = oe.msPointer ? "MSPointerCancel" : "pointercancel", Qi = {
      touchstart: wa,
      touchmove: Pa,
      touchend: xa,
      touchcancel: Sa
    }, Ta = {
      touchstart: Gh,
      touchmove: js,
      touchend: js,
      touchcancel: js
    }, Sr = {}, La = !1;
    function qh(n, l, c) {
      return l === "touchstart" && Fh(), Ta[l] ? (c = Ta[l].bind(this, c), n.addEventListener(Qi[l], c, !1), c) : (console.warn("wrong event specified:", l), p);
    }
    function Zh(n, l, c) {
      if (!Qi[l]) {
        console.warn("wrong event specified:", l);
        return;
      }
      n.removeEventListener(Qi[l], c, !1);
    }
    function Vh(n) {
      Sr[n.pointerId] = n;
    }
    function $h(n) {
      Sr[n.pointerId] && (Sr[n.pointerId] = n);
    }
    function Ca(n) {
      delete Sr[n.pointerId];
    }
    function Fh() {
      La || (document.addEventListener(wa, Vh, !0), document.addEventListener(Pa, $h, !0), document.addEventListener(xa, Ca, !0), document.addEventListener(Sa, Ca, !0), La = !0);
    }
    function js(n, l) {
      if (l.pointerType !== (l.MSPOINTER_TYPE_MOUSE || "mouse")) {
        l.touches = [];
        for (var c in Sr)
          l.touches.push(Sr[c]);
        l.changedTouches = [l], n(l);
      }
    }
    function Gh(n, l) {
      l.MSPOINTER_TYPE_TOUCH && l.pointerType === l.MSPOINTER_TYPE_TOUCH && tt(l), js(n, l);
    }
    function Hh(n) {
      var l = {}, c, h;
      for (h in n)
        c = n[h], l[h] = c && c.bind ? c.bind(n) : c;
      return n = l, l.type = "dblclick", l.detail = 2, l.isTrusted = !1, l._simulated = !0, l;
    }
    var Wh = 200;
    function Kh(n, l) {
      n.addEventListener("dblclick", l);
      var c = 0, h;
      function f(y) {
        if (y.detail !== 1) {
          h = y.detail;
          return;
        }
        if (!(y.pointerType === "mouse" || y.sourceCapabilities && !y.sourceCapabilities.firesTouchEvents)) {
          var S = ja(y);
          if (!(S.some(function(M) {
            return M instanceof HTMLLabelElement && M.attributes.for;
          }) && !S.some(function(M) {
            return M instanceof HTMLInputElement || M instanceof HTMLSelectElement;
          }))) {
            var E = Date.now();
            E - c <= Wh ? (h++, h === 2 && l(Hh(y))) : h = 1, c = E;
          }
        }
      }
      return n.addEventListener("click", f), {
        dblclick: l,
        simDblclick: f
      };
    }
    function Qh(n, l) {
      n.removeEventListener("dblclick", l.dblclick), n.removeEventListener("click", l.simDblclick);
    }
    var Yi = Ms(
      ["transform", "webkitTransform", "OTransform", "MozTransform", "msTransform"]
    ), Qr = Ms(
      ["webkitTransition", "transition", "OTransition", "MozTransition", "msTransition"]
    ), Aa = Qr === "webkitTransition" || Qr === "OTransition" ? Qr + "End" : "transitionend";
    function Oa(n) {
      return typeof n == "string" ? document.getElementById(n) : n;
    }
    function Yr(n, l) {
      var c = n.style[l] || n.currentStyle && n.currentStyle[l];
      if ((!c || c === "auto") && document.defaultView) {
        var h = document.defaultView.getComputedStyle(n, null);
        c = h ? h[l] : null;
      }
      return c === "auto" ? null : c;
    }
    function Ae(n, l, c) {
      var h = document.createElement(n);
      return h.className = l || "", c && c.appendChild(h), h;
    }
    function Re(n) {
      var l = n.parentNode;
      l && l.removeChild(n);
    }
    function Es(n) {
      for (; n.firstChild; )
        n.removeChild(n.firstChild);
    }
    function Tr(n) {
      var l = n.parentNode;
      l && l.lastChild !== n && l.appendChild(n);
    }
    function Lr(n) {
      var l = n.parentNode;
      l && l.firstChild !== n && l.insertBefore(n, l.firstChild);
    }
    function Xi(n, l) {
      if (n.classList !== void 0)
        return n.classList.contains(l);
      var c = Ds(n);
      return c.length > 0 && new RegExp("(^|\\s)" + l + "(\\s|$)").test(c);
    }
    function me(n, l) {
      if (n.classList !== void 0)
        for (var c = _(l), h = 0, f = c.length; h < f; h++)
          n.classList.add(c[h]);
      else if (!Xi(n, l)) {
        var y = Ds(n);
        en(n, (y ? y + " " : "") + l);
      }
    }
    function Ve(n, l) {
      n.classList !== void 0 ? n.classList.remove(l) : en(n, w((" " + Ds(n) + " ").replace(" " + l + " ", " ")));
    }
    function en(n, l) {
      n.className.baseVal === void 0 ? n.className = l : n.className.baseVal = l;
    }
    function Ds(n) {
      return n.correspondingElement && (n = n.correspondingElement), n.className.baseVal === void 0 ? n.className : n.className.baseVal;
    }
    function ft(n, l) {
      "opacity" in n.style ? n.style.opacity = l : "filter" in n.style && Yh(n, l);
    }
    function Yh(n, l) {
      var c = !1, h = "DXImageTransform.Microsoft.Alpha";
      try {
        c = n.filters.item(h);
      } catch {
        if (l === 1)
          return;
      }
      l = Math.round(l * 100), c ? (c.Enabled = l !== 100, c.Opacity = l) : n.style.filter += " progid:" + h + "(opacity=" + l + ")";
    }
    function Ms(n) {
      for (var l = document.documentElement.style, c = 0; c < n.length; c++)
        if (n[c] in l)
          return n[c];
      return !1;
    }
    function sr(n, l, c) {
      var h = l || new ue(0, 0);
      n.style[Yi] = (oe.ie3d ? "translate(" + h.x + "px," + h.y + "px)" : "translate3d(" + h.x + "px," + h.y + "px,0)") + (c ? " scale(" + c + ")" : "");
    }
    function Ge(n, l) {
      n._leaflet_pos = l, oe.any3d ? sr(n, l) : (n.style.left = l.x + "px", n.style.top = l.y + "px");
    }
    function ir(n) {
      return n._leaflet_pos || new ue(0, 0);
    }
    var Xr, es, tn;
    if ("onselectstart" in document)
      Xr = function() {
        fe(window, "selectstart", tt);
      }, es = function() {
        Je(window, "selectstart", tt);
      };
    else {
      var ts = Ms(
        ["userSelect", "WebkitUserSelect", "OUserSelect", "MozUserSelect", "msUserSelect"]
      );
      Xr = function() {
        if (ts) {
          var n = document.documentElement.style;
          tn = n[ts], n[ts] = "none";
        }
      }, es = function() {
        ts && (document.documentElement.style[ts] = tn, tn = void 0);
      };
    }
    function rn() {
      fe(window, "dragstart", tt);
    }
    function sn() {
      Je(window, "dragstart", tt);
    }
    var Ns, nn;
    function on(n) {
      for (; n.tabIndex === -1; )
        n = n.parentNode;
      n.style && (Js(), Ns = n, nn = n.style.outlineStyle, n.style.outlineStyle = "none", fe(window, "keydown", Js));
    }
    function Js() {
      Ns && (Ns.style.outlineStyle = nn, Ns = void 0, nn = void 0, Je(window, "keydown", Js));
    }
    function ka(n) {
      do
        n = n.parentNode;
      while ((!n.offsetWidth || !n.offsetHeight) && n !== document.body);
      return n;
    }
    function an(n) {
      var l = n.getBoundingClientRect();
      return {
        x: l.width / n.offsetWidth || 1,
        y: l.height / n.offsetHeight || 1,
        boundingClientRect: l
      };
    }
    var Xh = {
      __proto__: null,
      TRANSFORM: Yi,
      TRANSITION: Qr,
      TRANSITION_END: Aa,
      get: Oa,
      getStyle: Yr,
      create: Ae,
      remove: Re,
      empty: Es,
      toFront: Tr,
      toBack: Lr,
      hasClass: Xi,
      addClass: me,
      removeClass: Ve,
      setClass: en,
      getClass: Ds,
      setOpacity: ft,
      testProp: Ms,
      setTransform: sr,
      setPosition: Ge,
      getPosition: ir,
      get disableTextSelection() {
        return Xr;
      },
      get enableTextSelection() {
        return es;
      },
      disableImageDrag: rn,
      enableImageDrag: sn,
      preventOutline: on,
      restoreOutline: Js,
      getSizedParentNode: ka,
      getScale: an
    };
    function fe(n, l, c, h) {
      if (l && typeof l == "object")
        for (var f in l)
          un(n, f, l[f], c);
      else {
        l = _(l);
        for (var y = 0, S = l.length; y < S; y++)
          un(n, l[y], c, h);
      }
      return this;
    }
    var kt = "_leaflet_events";
    function Je(n, l, c, h) {
      if (arguments.length === 1)
        Ia(n), delete n[kt];
      else if (l && typeof l == "object")
        for (var f in l)
          cn(n, f, l[f], c);
      else if (l = _(l), arguments.length === 2)
        Ia(n, function(E) {
          return I(l, E) !== -1;
        });
      else
        for (var y = 0, S = l.length; y < S; y++)
          cn(n, l[y], c, h);
      return this;
    }
    function Ia(n, l) {
      for (var c in n[kt]) {
        var h = c.split(/\d/)[0];
        (!l || l(h)) && cn(n, h, null, null, c);
      }
    }
    var ln = {
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      wheel: !("onwheel" in window) && "mousewheel"
    };
    function un(n, l, c, h) {
      var f = l + d(c) + (h ? "_" + d(h) : "");
      if (n[kt] && n[kt][f])
        return this;
      var y = function(E) {
        return c.call(h || n, E || window.event);
      }, S = y;
      !oe.touchNative && oe.pointer && l.indexOf("touch") === 0 ? y = qh(n, l, y) : oe.touch && l === "dblclick" ? y = Kh(n, y) : "addEventListener" in n ? l === "touchstart" || l === "touchmove" || l === "wheel" || l === "mousewheel" ? n.addEventListener(ln[l] || l, y, oe.passiveEvents ? { passive: !1 } : !1) : l === "mouseenter" || l === "mouseleave" ? (y = function(E) {
        E = E || window.event, dn(n, E) && S(E);
      }, n.addEventListener(ln[l], y, !1)) : n.addEventListener(l, S, !1) : n.attachEvent("on" + l, y), n[kt] = n[kt] || {}, n[kt][f] = y;
    }
    function cn(n, l, c, h, f) {
      f = f || l + d(c) + (h ? "_" + d(h) : "");
      var y = n[kt] && n[kt][f];
      if (!y)
        return this;
      !oe.touchNative && oe.pointer && l.indexOf("touch") === 0 ? Zh(n, l, y) : oe.touch && l === "dblclick" ? Qh(n, y) : "removeEventListener" in n ? n.removeEventListener(ln[l] || l, y, !1) : n.detachEvent("on" + l, y), n[kt][f] = null;
    }
    function nr(n) {
      return n.stopPropagation ? n.stopPropagation() : n.originalEvent ? n.originalEvent._stopped = !0 : n.cancelBubble = !0, this;
    }
    function hn(n) {
      return un(n, "wheel", nr), this;
    }
    function rs(n) {
      return fe(n, "mousedown touchstart dblclick contextmenu", nr), n._leaflet_disable_click = !0, this;
    }
    function tt(n) {
      return n.preventDefault ? n.preventDefault() : n.returnValue = !1, this;
    }
    function or(n) {
      return tt(n), nr(n), this;
    }
    function ja(n) {
      if (n.composedPath)
        return n.composedPath();
      for (var l = [], c = n.target; c; )
        l.push(c), c = c.parentNode;
      return l;
    }
    function Ea(n, l) {
      if (!l)
        return new ue(n.clientX, n.clientY);
      var c = an(l), h = c.boundingClientRect;
      return new ue(
        // offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (n.clientX - h.left) / c.x - l.clientLeft,
        (n.clientY - h.top) / c.y - l.clientTop
      );
    }
    var ed = oe.linux && oe.chrome ? window.devicePixelRatio : oe.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    function Da(n) {
      return oe.edge ? n.wheelDeltaY / 2 : (
        // Don't trust window-geometry-based delta
        n.deltaY && n.deltaMode === 0 ? -n.deltaY / ed : (
          // Pixels
          n.deltaY && n.deltaMode === 1 ? -n.deltaY * 20 : (
            // Lines
            n.deltaY && n.deltaMode === 2 ? -n.deltaY * 60 : (
              // Pages
              n.deltaX || n.deltaZ ? 0 : (
                // Skip horizontal/depth wheel events
                n.wheelDelta ? (n.wheelDeltaY || n.wheelDelta) / 2 : (
                  // Legacy IE pixels
                  n.detail && Math.abs(n.detail) < 32765 ? -n.detail * 20 : (
                    // Legacy Moz lines
                    n.detail ? n.detail / -32765 * 60 : (
                      // Legacy Moz pages
                      0
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    function dn(n, l) {
      var c = l.relatedTarget;
      if (!c)
        return !0;
      try {
        for (; c && c !== n; )
          c = c.parentNode;
      } catch {
        return !1;
      }
      return c !== n;
    }
    var td = {
      __proto__: null,
      on: fe,
      off: Je,
      stopPropagation: nr,
      disableScrollPropagation: hn,
      disableClickPropagation: rs,
      preventDefault: tt,
      stop: or,
      getPropagationPath: ja,
      getMousePosition: Ea,
      getWheelDelta: Da,
      isExternalTarget: dn,
      addListener: fe,
      removeListener: Je
    }, Ma = ot.extend({
      // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
      // Run an animation of a given element to a new position, optionally setting
      // duration in seconds (`0.25` by default) and easing linearity factor (3rd
      // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
      // `0.5` by default).
      run: function(n, l, c, h) {
        this.stop(), this._el = n, this._inProgress = !0, this._duration = c || 0.25, this._easeOutPower = 1 / Math.max(h || 0.5, 0.2), this._startPos = ir(n), this._offset = l.subtract(this._startPos), this._startTime = +/* @__PURE__ */ new Date(), this.fire("start"), this._animate();
      },
      // @method stop()
      // Stops the animation (if currently running).
      stop: function() {
        this._inProgress && (this._step(!0), this._complete());
      },
      _animate: function() {
        this._animId = W(this._animate, this), this._step();
      },
      _step: function(n) {
        var l = +/* @__PURE__ */ new Date() - this._startTime, c = this._duration * 1e3;
        l < c ? this._runFrame(this._easeOut(l / c), n) : (this._runFrame(1), this._complete());
      },
      _runFrame: function(n, l) {
        var c = this._startPos.add(this._offset.multiplyBy(n));
        l && c._round(), Ge(this._el, c), this.fire("step");
      },
      _complete: function() {
        Y(this._animId), this._inProgress = !1, this.fire("end");
      },
      _easeOut: function(n) {
        return 1 - Math.pow(1 - n, this._easeOutPower);
      }
    }), xe = ot.extend({
      options: {
        // @section Map State Options
        // @option crs: CRS = L.CRS.EPSG3857
        // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
        // sure what it means.
        crs: $i,
        // @option center: LatLng = undefined
        // Initial geographic center of the map
        center: void 0,
        // @option zoom: Number = undefined
        // Initial map zoom level
        zoom: void 0,
        // @option minZoom: Number = *
        // Minimum zoom level of the map.
        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
        // the lowest of their `minZoom` options will be used instead.
        minZoom: void 0,
        // @option maxZoom: Number = *
        // Maximum zoom level of the map.
        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
        // the highest of their `maxZoom` options will be used instead.
        maxZoom: void 0,
        // @option layers: Layer[] = []
        // Array of layers that will be added to the map initially
        layers: [],
        // @option maxBounds: LatLngBounds = null
        // When this option is set, the map restricts the view to the given
        // geographical bounds, bouncing the user back if the user tries to pan
        // outside the view. To set the restriction dynamically, use
        // [`setMaxBounds`](#map-setmaxbounds) method.
        maxBounds: void 0,
        // @option renderer: Renderer = *
        // The default method for drawing vector layers on the map. `L.SVG`
        // or `L.Canvas` by default depending on browser support.
        renderer: void 0,
        // @section Animation Options
        // @option zoomAnimation: Boolean = true
        // Whether the map zoom animation is enabled. By default it's enabled
        // in all browsers that support CSS3 Transitions except Android.
        zoomAnimation: !0,
        // @option zoomAnimationThreshold: Number = 4
        // Won't animate zoom if the zoom difference exceeds this value.
        zoomAnimationThreshold: 4,
        // @option fadeAnimation: Boolean = true
        // Whether the tile fade animation is enabled. By default it's enabled
        // in all browsers that support CSS3 Transitions except Android.
        fadeAnimation: !0,
        // @option markerZoomAnimation: Boolean = true
        // Whether markers animate their zoom with the zoom animation, if disabled
        // they will disappear for the length of the animation. By default it's
        // enabled in all browsers that support CSS3 Transitions except Android.
        markerZoomAnimation: !0,
        // @option transform3DLimit: Number = 2^23
        // Defines the maximum size of a CSS translation transform. The default
        // value should not be changed unless a web browser positions layers in
        // the wrong place after doing a large `panBy`.
        transform3DLimit: 8388608,
        // Precision limit of a 32-bit float
        // @section Interaction Options
        // @option zoomSnap: Number = 1
        // Forces the map's zoom level to always be a multiple of this, particularly
        // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
        // By default, the zoom level snaps to the nearest integer; lower values
        // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
        // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
        zoomSnap: 1,
        // @option zoomDelta: Number = 1
        // Controls how much the map's zoom level will change after a
        // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
        // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
        // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
        zoomDelta: 1,
        // @option trackResize: Boolean = true
        // Whether the map automatically handles browser window resize to update itself.
        trackResize: !0
      },
      initialize: function(n, l) {
        l = P(this, l), this._handlers = [], this._layers = {}, this._zoomBoundLayers = {}, this._sizeChanged = !0, this._initContainer(n), this._initLayout(), this._onResize = i(this._onResize, this), this._initEvents(), l.maxBounds && this.setMaxBounds(l.maxBounds), l.zoom !== void 0 && (this._zoom = this._limitZoom(l.zoom)), l.center && l.zoom !== void 0 && this.setView(ve(l.center), l.zoom, { reset: !0 }), this.callInitHooks(), this._zoomAnimated = Qr && oe.any3d && !oe.mobileOpera && this.options.zoomAnimation, this._zoomAnimated && (this._createAnimProxy(), fe(this._proxy, Aa, this._catchTransitionEnd, this)), this._addLayers(this.options.layers);
      },
      // @section Methods for modifying map state
      // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
      // Sets the view of the map (geographical center and zoom) with the given
      // animation options.
      setView: function(n, l, c) {
        if (l = l === void 0 ? this._zoom : this._limitZoom(l), n = this._limitCenter(ve(n), l, this.options.maxBounds), c = c || {}, this._stop(), this._loaded && !c.reset && c !== !0) {
          c.animate !== void 0 && (c.zoom = r({ animate: c.animate }, c.zoom), c.pan = r({ animate: c.animate, duration: c.duration }, c.pan));
          var h = this._zoom !== l ? this._tryAnimatedZoom && this._tryAnimatedZoom(n, l, c.zoom) : this._tryAnimatedPan(n, c.pan);
          if (h)
            return clearTimeout(this._sizeTimer), this;
        }
        return this._resetView(n, l, c.pan && c.pan.noMoveStart), this;
      },
      // @method setZoom(zoom: Number, options?: Zoom/pan options): this
      // Sets the zoom of the map.
      setZoom: function(n, l) {
        return this._loaded ? this.setView(this.getCenter(), n, { zoom: l }) : (this._zoom = n, this);
      },
      // @method zoomIn(delta?: Number, options?: Zoom options): this
      // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
      zoomIn: function(n, l) {
        return n = n || (oe.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom + n, l);
      },
      // @method zoomOut(delta?: Number, options?: Zoom options): this
      // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
      zoomOut: function(n, l) {
        return n = n || (oe.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom - n, l);
      },
      // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
      // Zooms the map while keeping a specified geographical point on the map
      // stationary (e.g. used internally for scroll zoom and double-click zoom).
      // @alternative
      // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
      // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
      setZoomAround: function(n, l, c) {
        var h = this.getZoomScale(l), f = this.getSize().divideBy(2), y = n instanceof ue ? n : this.latLngToContainerPoint(n), S = y.subtract(f).multiplyBy(1 - 1 / h), E = this.containerPointToLatLng(f.add(S));
        return this.setView(E, l, { zoom: c });
      },
      _getBoundsCenterZoom: function(n, l) {
        l = l || {}, n = n.getBounds ? n.getBounds() : Le(n);
        var c = J(l.paddingTopLeft || l.padding || [0, 0]), h = J(l.paddingBottomRight || l.padding || [0, 0]), f = this.getBoundsZoom(n, !1, c.add(h));
        if (f = typeof l.maxZoom == "number" ? Math.min(l.maxZoom, f) : f, f === 1 / 0)
          return {
            center: n.getCenter(),
            zoom: f
          };
        var y = h.subtract(c).divideBy(2), S = this.project(n.getSouthWest(), f), E = this.project(n.getNorthEast(), f), M = this.unproject(S.add(E).divideBy(2).add(y), f);
        return {
          center: M,
          zoom: f
        };
      },
      // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
      // Sets a map view that contains the given geographical bounds with the
      // maximum zoom level possible.
      fitBounds: function(n, l) {
        if (n = Le(n), !n.isValid())
          throw new Error("Bounds are not valid.");
        var c = this._getBoundsCenterZoom(n, l);
        return this.setView(c.center, c.zoom, l);
      },
      // @method fitWorld(options?: fitBounds options): this
      // Sets a map view that mostly contains the whole world with the maximum
      // zoom level possible.
      fitWorld: function(n) {
        return this.fitBounds([[-90, -180], [90, 180]], n);
      },
      // @method panTo(latlng: LatLng, options?: Pan options): this
      // Pans the map to a given center.
      panTo: function(n, l) {
        return this.setView(n, this._zoom, { pan: l });
      },
      // @method panBy(offset: Point, options?: Pan options): this
      // Pans the map by a given number of pixels (animated).
      panBy: function(n, l) {
        if (n = J(n).round(), l = l || {}, !n.x && !n.y)
          return this.fire("moveend");
        if (l.animate !== !0 && !this.getSize().contains(n))
          return this._resetView(this.unproject(this.project(this.getCenter()).add(n)), this.getZoom()), this;
        if (this._panAnim || (this._panAnim = new Ma(), this._panAnim.on({
          step: this._onPanTransitionStep,
          end: this._onPanTransitionEnd
        }, this)), l.noMoveStart || this.fire("movestart"), l.animate !== !1) {
          me(this._mapPane, "leaflet-pan-anim");
          var c = this._getMapPanePos().subtract(n).round();
          this._panAnim.run(this._mapPane, c, l.duration || 0.25, l.easeLinearity);
        } else
          this._rawPanBy(n), this.fire("move").fire("moveend");
        return this;
      },
      // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
      // Sets the view of the map (geographical center and zoom) performing a smooth
      // pan-zoom animation.
      flyTo: function(n, l, c) {
        if (c = c || {}, c.animate === !1 || !oe.any3d)
          return this.setView(n, l, c);
        this._stop();
        var h = this.project(this.getCenter()), f = this.project(n), y = this.getSize(), S = this._zoom;
        n = ve(n), l = l === void 0 ? S : l;
        var E = Math.max(y.x, y.y), M = E * this.getZoomScale(S, l), q = f.distanceTo(h) || 1, K = 1.42, le = K * K;
        function ye(He) {
          var Ws = He ? -1 : 1, Zd = He ? M : E, Vd = M * M - E * E + Ws * le * le * q * q, $d = 2 * Zd * le * q, xn = Vd / $d, ml = Math.sqrt(xn * xn + 1) - xn, Fd = ml < 1e-9 ? -18 : Math.log(ml);
          return Fd;
        }
        function at(He) {
          return (Math.exp(He) - Math.exp(-He)) / 2;
        }
        function Xe(He) {
          return (Math.exp(He) + Math.exp(-He)) / 2;
        }
        function mt(He) {
          return at(He) / Xe(He);
        }
        var ut = ye(0);
        function jr(He) {
          return E * (Xe(ut) / Xe(ut + K * He));
        }
        function Bd(He) {
          return E * (Xe(ut) * mt(ut + K * He) - at(ut)) / le;
        }
        function Rd(He) {
          return 1 - Math.pow(1 - He, 1.5);
        }
        var zd = Date.now(), fl = (ye(1) - ut) / K, qd = c.duration ? 1e3 * c.duration : 1e3 * fl * 0.8;
        function pl() {
          var He = (Date.now() - zd) / qd, Ws = Rd(He) * fl;
          He <= 1 ? (this._flyToFrame = W(pl, this), this._move(
            this.unproject(h.add(f.subtract(h).multiplyBy(Bd(Ws) / q)), S),
            this.getScaleZoom(E / jr(Ws), S),
            { flyTo: !0 }
          )) : this._move(n, l)._moveEnd(!0);
        }
        return this._moveStart(!0, c.noMoveStart), pl.call(this), this;
      },
      // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
      // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
      // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
      flyToBounds: function(n, l) {
        var c = this._getBoundsCenterZoom(n, l);
        return this.flyTo(c.center, c.zoom, l);
      },
      // @method setMaxBounds(bounds: LatLngBounds): this
      // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
      setMaxBounds: function(n) {
        return n = Le(n), this.listens("moveend", this._panInsideMaxBounds) && this.off("moveend", this._panInsideMaxBounds), n.isValid() ? (this.options.maxBounds = n, this._loaded && this._panInsideMaxBounds(), this.on("moveend", this._panInsideMaxBounds)) : (this.options.maxBounds = null, this);
      },
      // @method setMinZoom(zoom: Number): this
      // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
      setMinZoom: function(n) {
        var l = this.options.minZoom;
        return this.options.minZoom = n, this._loaded && l !== n && (this.fire("zoomlevelschange"), this.getZoom() < this.options.minZoom) ? this.setZoom(n) : this;
      },
      // @method setMaxZoom(zoom: Number): this
      // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
      setMaxZoom: function(n) {
        var l = this.options.maxZoom;
        return this.options.maxZoom = n, this._loaded && l !== n && (this.fire("zoomlevelschange"), this.getZoom() > this.options.maxZoom) ? this.setZoom(n) : this;
      },
      // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
      // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
      panInsideBounds: function(n, l) {
        this._enforcingBounds = !0;
        var c = this.getCenter(), h = this._limitCenter(c, this._zoom, Le(n));
        return c.equals(h) || this.panTo(h, l), this._enforcingBounds = !1, this;
      },
      // @method panInside(latlng: LatLng, options?: padding options): this
      // Pans the map the minimum amount to make the `latlng` visible. Use
      // padding options to fit the display to more restricted bounds.
      // If `latlng` is already within the (optionally padded) display bounds,
      // the map will not be panned.
      panInside: function(n, l) {
        l = l || {};
        var c = J(l.paddingTopLeft || l.padding || [0, 0]), h = J(l.paddingBottomRight || l.padding || [0, 0]), f = this.project(this.getCenter()), y = this.project(n), S = this.getPixelBounds(), E = be([S.min.add(c), S.max.subtract(h)]), M = E.getSize();
        if (!E.contains(y)) {
          this._enforcingBounds = !0;
          var q = y.subtract(E.getCenter()), K = E.extend(y).getSize().subtract(M);
          f.x += q.x < 0 ? -K.x : K.x, f.y += q.y < 0 ? -K.y : K.y, this.panTo(this.unproject(f), l), this._enforcingBounds = !1;
        }
        return this;
      },
      // @method invalidateSize(options: Zoom/pan options): this
      // Checks if the map container size changed and updates the map if so —
      // call it after you've changed the map size dynamically, also animating
      // pan by default. If `options.pan` is `false`, panning will not occur.
      // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
      // that it doesn't happen often even if the method is called many
      // times in a row.
      // @alternative
      // @method invalidateSize(animate: Boolean): this
      // Checks if the map container size changed and updates the map if so —
      // call it after you've changed the map size dynamically, also animating
      // pan by default.
      invalidateSize: function(n) {
        if (!this._loaded)
          return this;
        n = r({
          animate: !1,
          pan: !0
        }, n === !0 ? { animate: !0 } : n);
        var l = this.getSize();
        this._sizeChanged = !0, this._lastCenter = null;
        var c = this.getSize(), h = l.divideBy(2).round(), f = c.divideBy(2).round(), y = h.subtract(f);
        return !y.x && !y.y ? this : (n.animate && n.pan ? this.panBy(y) : (n.pan && this._rawPanBy(y), this.fire("move"), n.debounceMoveend ? (clearTimeout(this._sizeTimer), this._sizeTimer = setTimeout(i(this.fire, this, "moveend"), 200)) : this.fire("moveend")), this.fire("resize", {
          oldSize: l,
          newSize: c
        }));
      },
      // @section Methods for modifying map state
      // @method stop(): this
      // Stops the currently running `panTo` or `flyTo` animation, if any.
      stop: function() {
        return this.setZoom(this._limitZoom(this._zoom)), this.options.zoomSnap || this.fire("viewreset"), this._stop();
      },
      // @section Geolocation methods
      // @method locate(options?: Locate options): this
      // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
      // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
      // and optionally sets the map view to the user's location with respect to
      // detection accuracy (or to the world view if geolocation failed).
      // Note that, if your page doesn't use HTTPS, this method will fail in
      // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
      // See `Locate options` for more details.
      locate: function(n) {
        if (n = this._locateOptions = r({
          timeout: 1e4,
          watch: !1
          // setView: false
          // maxZoom: <Number>
          // maximumAge: 0
          // enableHighAccuracy: false
        }, n), !("geolocation" in navigator))
          return this._handleGeolocationError({
            code: 0,
            message: "Geolocation not supported."
          }), this;
        var l = i(this._handleGeolocationResponse, this), c = i(this._handleGeolocationError, this);
        return n.watch ? this._locationWatchId = navigator.geolocation.watchPosition(l, c, n) : navigator.geolocation.getCurrentPosition(l, c, n), this;
      },
      // @method stopLocate(): this
      // Stops watching location previously initiated by `map.locate({watch: true})`
      // and aborts resetting the map view if map.locate was called with
      // `{setView: true}`.
      stopLocate: function() {
        return navigator.geolocation && navigator.geolocation.clearWatch && navigator.geolocation.clearWatch(this._locationWatchId), this._locateOptions && (this._locateOptions.setView = !1), this;
      },
      _handleGeolocationError: function(n) {
        if (this._container._leaflet_id) {
          var l = n.code, c = n.message || (l === 1 ? "permission denied" : l === 2 ? "position unavailable" : "timeout");
          this._locateOptions.setView && !this._loaded && this.fitWorld(), this.fire("locationerror", {
            code: l,
            message: "Geolocation error: " + c + "."
          });
        }
      },
      _handleGeolocationResponse: function(n) {
        if (this._container._leaflet_id) {
          var l = n.coords.latitude, c = n.coords.longitude, h = new Ce(l, c), f = h.toBounds(n.coords.accuracy * 2), y = this._locateOptions;
          if (y.setView) {
            var S = this.getBoundsZoom(f);
            this.setView(h, y.maxZoom ? Math.min(S, y.maxZoom) : S);
          }
          var E = {
            latlng: h,
            bounds: f,
            timestamp: n.timestamp
          };
          for (var M in n.coords)
            typeof n.coords[M] == "number" && (E[M] = n.coords[M]);
          this.fire("locationfound", E);
        }
      },
      // TODO Appropriate docs section?
      // @section Other Methods
      // @method addHandler(name: String, HandlerClass: Function): this
      // Adds a new `Handler` to the map, given its name and constructor function.
      addHandler: function(n, l) {
        if (!l)
          return this;
        var c = this[n] = new l(this);
        return this._handlers.push(c), this.options[n] && c.enable(), this;
      },
      // @method remove(): this
      // Destroys the map and clears all related event listeners.
      remove: function() {
        if (this._initEvents(!0), this.options.maxBounds && this.off("moveend", this._panInsideMaxBounds), this._containerId !== this._container._leaflet_id)
          throw new Error("Map container is being reused by another instance");
        try {
          delete this._container._leaflet_id, delete this._containerId;
        } catch {
          this._container._leaflet_id = void 0, this._containerId = void 0;
        }
        this._locationWatchId !== void 0 && this.stopLocate(), this._stop(), Re(this._mapPane), this._clearControlPos && this._clearControlPos(), this._resizeRequest && (Y(this._resizeRequest), this._resizeRequest = null), this._clearHandlers(), this._loaded && this.fire("unload");
        var n;
        for (n in this._layers)
          this._layers[n].remove();
        for (n in this._panes)
          Re(this._panes[n]);
        return this._layers = [], this._panes = [], delete this._mapPane, delete this._renderer, this;
      },
      // @section Other Methods
      // @method createPane(name: String, container?: HTMLElement): HTMLElement
      // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
      // then returns it. The pane is created as a child of `container`, or
      // as a child of the main map pane if not set.
      createPane: function(n, l) {
        var c = "leaflet-pane" + (n ? " leaflet-" + n.replace("Pane", "") + "-pane" : ""), h = Ae("div", c, l || this._mapPane);
        return n && (this._panes[n] = h), h;
      },
      // @section Methods for Getting Map State
      // @method getCenter(): LatLng
      // Returns the geographical center of the map view
      getCenter: function() {
        return this._checkIfLoaded(), this._lastCenter && !this._moved() ? this._lastCenter.clone() : this.layerPointToLatLng(this._getCenterLayerPoint());
      },
      // @method getZoom(): Number
      // Returns the current zoom level of the map view
      getZoom: function() {
        return this._zoom;
      },
      // @method getBounds(): LatLngBounds
      // Returns the geographical bounds visible in the current map view
      getBounds: function() {
        var n = this.getPixelBounds(), l = this.unproject(n.getBottomLeft()), c = this.unproject(n.getTopRight());
        return new De(l, c);
      },
      // @method getMinZoom(): Number
      // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
      getMinZoom: function() {
        return this.options.minZoom === void 0 ? this._layersMinZoom || 0 : this.options.minZoom;
      },
      // @method getMaxZoom(): Number
      // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
      getMaxZoom: function() {
        return this.options.maxZoom === void 0 ? this._layersMaxZoom === void 0 ? 1 / 0 : this._layersMaxZoom : this.options.maxZoom;
      },
      // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
      // Returns the maximum zoom level on which the given bounds fit to the map
      // view in its entirety. If `inside` (optional) is set to `true`, the method
      // instead returns the minimum zoom level on which the map view fits into
      // the given bounds in its entirety.
      getBoundsZoom: function(n, l, c) {
        n = Le(n), c = J(c || [0, 0]);
        var h = this.getZoom() || 0, f = this.getMinZoom(), y = this.getMaxZoom(), S = n.getNorthWest(), E = n.getSouthEast(), M = this.getSize().subtract(c), q = be(this.project(E, h), this.project(S, h)).getSize(), K = oe.any3d ? this.options.zoomSnap : 1, le = M.x / q.x, ye = M.y / q.y, at = l ? Math.max(le, ye) : Math.min(le, ye);
        return h = this.getScaleZoom(at, h), K && (h = Math.round(h / (K / 100)) * (K / 100), h = l ? Math.ceil(h / K) * K : Math.floor(h / K) * K), Math.max(f, Math.min(y, h));
      },
      // @method getSize(): Point
      // Returns the current size of the map container (in pixels).
      getSize: function() {
        return (!this._size || this._sizeChanged) && (this._size = new ue(
          this._container.clientWidth || 0,
          this._container.clientHeight || 0
        ), this._sizeChanged = !1), this._size.clone();
      },
      // @method getPixelBounds(): Bounds
      // Returns the bounds of the current map view in projected pixel
      // coordinates (sometimes useful in layer and overlay implementations).
      getPixelBounds: function(n, l) {
        var c = this._getTopLeftPoint(n, l);
        return new Q(c, c.add(this.getSize()));
      },
      // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
      // the map pane? "left point of the map layer" can be confusing, specially
      // since there can be negative offsets.
      // @method getPixelOrigin(): Point
      // Returns the projected pixel coordinates of the top left point of
      // the map layer (useful in custom layer and overlay implementations).
      getPixelOrigin: function() {
        return this._checkIfLoaded(), this._pixelOrigin;
      },
      // @method getPixelWorldBounds(zoom?: Number): Bounds
      // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
      // If `zoom` is omitted, the map's current zoom level is used.
      getPixelWorldBounds: function(n) {
        return this.options.crs.getProjectedBounds(n === void 0 ? this.getZoom() : n);
      },
      // @section Other Methods
      // @method getPane(pane: String|HTMLElement): HTMLElement
      // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
      getPane: function(n) {
        return typeof n == "string" ? this._panes[n] : n;
      },
      // @method getPanes(): Object
      // Returns a plain object containing the names of all [panes](#map-pane) as keys and
      // the panes as values.
      getPanes: function() {
        return this._panes;
      },
      // @method getContainer: HTMLElement
      // Returns the HTML element that contains the map.
      getContainer: function() {
        return this._container;
      },
      // @section Conversion Methods
      // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
      // Returns the scale factor to be applied to a map transition from zoom level
      // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
      getZoomScale: function(n, l) {
        var c = this.options.crs;
        return l = l === void 0 ? this._zoom : l, c.scale(n) / c.scale(l);
      },
      // @method getScaleZoom(scale: Number, fromZoom: Number): Number
      // Returns the zoom level that the map would end up at, if it is at `fromZoom`
      // level and everything is scaled by a factor of `scale`. Inverse of
      // [`getZoomScale`](#map-getZoomScale).
      getScaleZoom: function(n, l) {
        var c = this.options.crs;
        l = l === void 0 ? this._zoom : l;
        var h = c.zoom(n * c.scale(l));
        return isNaN(h) ? 1 / 0 : h;
      },
      // @method project(latlng: LatLng, zoom: Number): Point
      // Projects a geographical coordinate `LatLng` according to the projection
      // of the map's CRS, then scales it according to `zoom` and the CRS's
      // `Transformation`. The result is pixel coordinate relative to
      // the CRS origin.
      project: function(n, l) {
        return l = l === void 0 ? this._zoom : l, this.options.crs.latLngToPoint(ve(n), l);
      },
      // @method unproject(point: Point, zoom: Number): LatLng
      // Inverse of [`project`](#map-project).
      unproject: function(n, l) {
        return l = l === void 0 ? this._zoom : l, this.options.crs.pointToLatLng(J(n), l);
      },
      // @method layerPointToLatLng(point: Point): LatLng
      // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
      // returns the corresponding geographical coordinate (for the current zoom level).
      layerPointToLatLng: function(n) {
        var l = J(n).add(this.getPixelOrigin());
        return this.unproject(l);
      },
      // @method latLngToLayerPoint(latlng: LatLng): Point
      // Given a geographical coordinate, returns the corresponding pixel coordinate
      // relative to the [origin pixel](#map-getpixelorigin).
      latLngToLayerPoint: function(n) {
        var l = this.project(ve(n))._round();
        return l._subtract(this.getPixelOrigin());
      },
      // @method wrapLatLng(latlng: LatLng): LatLng
      // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
      // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
      // CRS's bounds.
      // By default this means longitude is wrapped around the dateline so its
      // value is between -180 and +180 degrees.
      wrapLatLng: function(n) {
        return this.options.crs.wrapLatLng(ve(n));
      },
      // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
      // Returns a `LatLngBounds` with the same size as the given one, ensuring that
      // its center is within the CRS's bounds.
      // By default this means the center longitude is wrapped around the dateline so its
      // value is between -180 and +180 degrees, and the majority of the bounds
      // overlaps the CRS's bounds.
      wrapLatLngBounds: function(n) {
        return this.options.crs.wrapLatLngBounds(Le(n));
      },
      // @method distance(latlng1: LatLng, latlng2: LatLng): Number
      // Returns the distance between two geographical coordinates according to
      // the map's CRS. By default this measures distance in meters.
      distance: function(n, l) {
        return this.options.crs.distance(ve(n), ve(l));
      },
      // @method containerPointToLayerPoint(point: Point): Point
      // Given a pixel coordinate relative to the map container, returns the corresponding
      // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
      containerPointToLayerPoint: function(n) {
        return J(n).subtract(this._getMapPanePos());
      },
      // @method layerPointToContainerPoint(point: Point): Point
      // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
      // returns the corresponding pixel coordinate relative to the map container.
      layerPointToContainerPoint: function(n) {
        return J(n).add(this._getMapPanePos());
      },
      // @method containerPointToLatLng(point: Point): LatLng
      // Given a pixel coordinate relative to the map container, returns
      // the corresponding geographical coordinate (for the current zoom level).
      containerPointToLatLng: function(n) {
        var l = this.containerPointToLayerPoint(J(n));
        return this.layerPointToLatLng(l);
      },
      // @method latLngToContainerPoint(latlng: LatLng): Point
      // Given a geographical coordinate, returns the corresponding pixel coordinate
      // relative to the map container.
      latLngToContainerPoint: function(n) {
        return this.layerPointToContainerPoint(this.latLngToLayerPoint(ve(n)));
      },
      // @method mouseEventToContainerPoint(ev: MouseEvent): Point
      // Given a MouseEvent object, returns the pixel coordinate relative to the
      // map container where the event took place.
      mouseEventToContainerPoint: function(n) {
        return Ea(n, this._container);
      },
      // @method mouseEventToLayerPoint(ev: MouseEvent): Point
      // Given a MouseEvent object, returns the pixel coordinate relative to
      // the [origin pixel](#map-getpixelorigin) where the event took place.
      mouseEventToLayerPoint: function(n) {
        return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(n));
      },
      // @method mouseEventToLatLng(ev: MouseEvent): LatLng
      // Given a MouseEvent object, returns geographical coordinate where the
      // event took place.
      mouseEventToLatLng: function(n) {
        return this.layerPointToLatLng(this.mouseEventToLayerPoint(n));
      },
      // map initialization methods
      _initContainer: function(n) {
        var l = this._container = Oa(n);
        if (l) {
          if (l._leaflet_id)
            throw new Error("Map container is already initialized.");
        } else throw new Error("Map container not found.");
        fe(l, "scroll", this._onScroll, this), this._containerId = d(l);
      },
      _initLayout: function() {
        var n = this._container;
        this._fadeAnimated = this.options.fadeAnimation && oe.any3d, me(n, "leaflet-container" + (oe.touch ? " leaflet-touch" : "") + (oe.retina ? " leaflet-retina" : "") + (oe.ielt9 ? " leaflet-oldie" : "") + (oe.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
        var l = Yr(n, "position");
        l !== "absolute" && l !== "relative" && l !== "fixed" && l !== "sticky" && (n.style.position = "relative"), this._initPanes(), this._initControlPos && this._initControlPos();
      },
      _initPanes: function() {
        var n = this._panes = {};
        this._paneRenderers = {}, this._mapPane = this.createPane("mapPane", this._container), Ge(this._mapPane, new ue(0, 0)), this.createPane("tilePane"), this.createPane("overlayPane"), this.createPane("shadowPane"), this.createPane("markerPane"), this.createPane("tooltipPane"), this.createPane("popupPane"), this.options.markerZoomAnimation || (me(n.markerPane, "leaflet-zoom-hide"), me(n.shadowPane, "leaflet-zoom-hide"));
      },
      // private methods that modify map state
      // @section Map state change events
      _resetView: function(n, l, c) {
        Ge(this._mapPane, new ue(0, 0));
        var h = !this._loaded;
        this._loaded = !0, l = this._limitZoom(l), this.fire("viewprereset");
        var f = this._zoom !== l;
        this._moveStart(f, c)._move(n, l)._moveEnd(f), this.fire("viewreset"), h && this.fire("load");
      },
      _moveStart: function(n, l) {
        return n && this.fire("zoomstart"), l || this.fire("movestart"), this;
      },
      _move: function(n, l, c, h) {
        l === void 0 && (l = this._zoom);
        var f = this._zoom !== l;
        return this._zoom = l, this._lastCenter = n, this._pixelOrigin = this._getNewPixelOrigin(n), h ? c && c.pinch && this.fire("zoom", c) : ((f || c && c.pinch) && this.fire("zoom", c), this.fire("move", c)), this;
      },
      _moveEnd: function(n) {
        return n && this.fire("zoomend"), this.fire("moveend");
      },
      _stop: function() {
        return Y(this._flyToFrame), this._panAnim && this._panAnim.stop(), this;
      },
      _rawPanBy: function(n) {
        Ge(this._mapPane, this._getMapPanePos().subtract(n));
      },
      _getZoomSpan: function() {
        return this.getMaxZoom() - this.getMinZoom();
      },
      _panInsideMaxBounds: function() {
        this._enforcingBounds || this.panInsideBounds(this.options.maxBounds);
      },
      _checkIfLoaded: function() {
        if (!this._loaded)
          throw new Error("Set map center and zoom first.");
      },
      // DOM event handling
      // @section Interaction events
      _initEvents: function(n) {
        this._targets = {}, this._targets[d(this._container)] = this;
        var l = n ? Je : fe;
        l(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this), this.options.trackResize && l(window, "resize", this._onResize, this), oe.any3d && this.options.transform3DLimit && (n ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
      },
      _onResize: function() {
        Y(this._resizeRequest), this._resizeRequest = W(
          function() {
            this.invalidateSize({ debounceMoveend: !0 });
          },
          this
        );
      },
      _onScroll: function() {
        this._container.scrollTop = 0, this._container.scrollLeft = 0;
      },
      _onMoveEnd: function() {
        var n = this._getMapPanePos();
        Math.max(Math.abs(n.x), Math.abs(n.y)) >= this.options.transform3DLimit && this._resetView(this.getCenter(), this.getZoom());
      },
      _findEventTargets: function(n, l) {
        for (var c = [], h, f = l === "mouseout" || l === "mouseover", y = n.target || n.srcElement, S = !1; y; ) {
          if (h = this._targets[d(y)], h && (l === "click" || l === "preclick") && this._draggableMoved(h)) {
            S = !0;
            break;
          }
          if (h && h.listens(l, !0) && (f && !dn(y, n) || (c.push(h), f)) || y === this._container)
            break;
          y = y.parentNode;
        }
        return !c.length && !S && !f && this.listens(l, !0) && (c = [this]), c;
      },
      _isClickDisabled: function(n) {
        for (; n && n !== this._container; ) {
          if (n._leaflet_disable_click)
            return !0;
          n = n.parentNode;
        }
      },
      _handleDOMEvent: function(n) {
        var l = n.target || n.srcElement;
        if (!(!this._loaded || l._leaflet_disable_events || n.type === "click" && this._isClickDisabled(l))) {
          var c = n.type;
          c === "mousedown" && on(l), this._fireDOMEvent(n, c);
        }
      },
      _mouseEvents: ["click", "dblclick", "mouseover", "mouseout", "contextmenu"],
      _fireDOMEvent: function(n, l, c) {
        if (n.type === "click") {
          var h = r({}, n);
          h.type = "preclick", this._fireDOMEvent(h, h.type, c);
        }
        var f = this._findEventTargets(n, l);
        if (c) {
          for (var y = [], S = 0; S < c.length; S++)
            c[S].listens(l, !0) && y.push(c[S]);
          f = y.concat(f);
        }
        if (f.length) {
          l === "contextmenu" && tt(n);
          var E = f[0], M = {
            originalEvent: n
          };
          if (n.type !== "keypress" && n.type !== "keydown" && n.type !== "keyup") {
            var q = E.getLatLng && (!E._radius || E._radius <= 10);
            M.containerPoint = q ? this.latLngToContainerPoint(E.getLatLng()) : this.mouseEventToContainerPoint(n), M.layerPoint = this.containerPointToLayerPoint(M.containerPoint), M.latlng = q ? E.getLatLng() : this.layerPointToLatLng(M.layerPoint);
          }
          for (S = 0; S < f.length; S++)
            if (f[S].fire(l, M, !0), M.originalEvent._stopped || f[S].options.bubblingMouseEvents === !1 && I(this._mouseEvents, l) !== -1)
              return;
        }
      },
      _draggableMoved: function(n) {
        return n = n.dragging && n.dragging.enabled() ? n : this, n.dragging && n.dragging.moved() || this.boxZoom && this.boxZoom.moved();
      },
      _clearHandlers: function() {
        for (var n = 0, l = this._handlers.length; n < l; n++)
          this._handlers[n].disable();
      },
      // @section Other Methods
      // @method whenReady(fn: Function, context?: Object): this
      // Runs the given function `fn` when the map gets initialized with
      // a view (center and zoom) and at least one layer, or immediately
      // if it's already initialized, optionally passing a function context.
      whenReady: function(n, l) {
        return this._loaded ? n.call(l || this, { target: this }) : this.on("load", n, l), this;
      },
      // private methods for getting map state
      _getMapPanePos: function() {
        return ir(this._mapPane) || new ue(0, 0);
      },
      _moved: function() {
        var n = this._getMapPanePos();
        return n && !n.equals([0, 0]);
      },
      _getTopLeftPoint: function(n, l) {
        var c = n && l !== void 0 ? this._getNewPixelOrigin(n, l) : this.getPixelOrigin();
        return c.subtract(this._getMapPanePos());
      },
      _getNewPixelOrigin: function(n, l) {
        var c = this.getSize()._divideBy(2);
        return this.project(n, l)._subtract(c)._add(this._getMapPanePos())._round();
      },
      _latLngToNewLayerPoint: function(n, l, c) {
        var h = this._getNewPixelOrigin(c, l);
        return this.project(n, l)._subtract(h);
      },
      _latLngBoundsToNewLayerBounds: function(n, l, c) {
        var h = this._getNewPixelOrigin(c, l);
        return be([
          this.project(n.getSouthWest(), l)._subtract(h),
          this.project(n.getNorthWest(), l)._subtract(h),
          this.project(n.getSouthEast(), l)._subtract(h),
          this.project(n.getNorthEast(), l)._subtract(h)
        ]);
      },
      // layer point of the current center
      _getCenterLayerPoint: function() {
        return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
      },
      // offset of the specified place to the current center in pixels
      _getCenterOffset: function(n) {
        return this.latLngToLayerPoint(n).subtract(this._getCenterLayerPoint());
      },
      // adjust center for view to get inside bounds
      _limitCenter: function(n, l, c) {
        if (!c)
          return n;
        var h = this.project(n, l), f = this.getSize().divideBy(2), y = new Q(h.subtract(f), h.add(f)), S = this._getBoundsOffset(y, c, l);
        return Math.abs(S.x) <= 1 && Math.abs(S.y) <= 1 ? n : this.unproject(h.add(S), l);
      },
      // adjust offset for view to get inside bounds
      _limitOffset: function(n, l) {
        if (!l)
          return n;
        var c = this.getPixelBounds(), h = new Q(c.min.add(n), c.max.add(n));
        return n.add(this._getBoundsOffset(h, l));
      },
      // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
      _getBoundsOffset: function(n, l, c) {
        var h = be(
          this.project(l.getNorthEast(), c),
          this.project(l.getSouthWest(), c)
        ), f = h.min.subtract(n.min), y = h.max.subtract(n.max), S = this._rebound(f.x, -y.x), E = this._rebound(f.y, -y.y);
        return new ue(S, E);
      },
      _rebound: function(n, l) {
        return n + l > 0 ? Math.round(n - l) / 2 : Math.max(0, Math.ceil(n)) - Math.max(0, Math.floor(l));
      },
      _limitZoom: function(n) {
        var l = this.getMinZoom(), c = this.getMaxZoom(), h = oe.any3d ? this.options.zoomSnap : 1;
        return h && (n = Math.round(n / h) * h), Math.max(l, Math.min(c, n));
      },
      _onPanTransitionStep: function() {
        this.fire("move");
      },
      _onPanTransitionEnd: function() {
        Ve(this._mapPane, "leaflet-pan-anim"), this.fire("moveend");
      },
      _tryAnimatedPan: function(n, l) {
        var c = this._getCenterOffset(n)._trunc();
        return (l && l.animate) !== !0 && !this.getSize().contains(c) ? !1 : (this.panBy(c, l), !0);
      },
      _createAnimProxy: function() {
        var n = this._proxy = Ae("div", "leaflet-proxy leaflet-zoom-animated");
        this._panes.mapPane.appendChild(n), this.on("zoomanim", function(l) {
          var c = Yi, h = this._proxy.style[c];
          sr(this._proxy, this.project(l.center, l.zoom), this.getZoomScale(l.zoom, 1)), h === this._proxy.style[c] && this._animatingZoom && this._onZoomTransitionEnd();
        }, this), this.on("load moveend", this._animMoveEnd, this), this._on("unload", this._destroyAnimProxy, this);
      },
      _destroyAnimProxy: function() {
        Re(this._proxy), this.off("load moveend", this._animMoveEnd, this), delete this._proxy;
      },
      _animMoveEnd: function() {
        var n = this.getCenter(), l = this.getZoom();
        sr(this._proxy, this.project(n, l), this.getZoomScale(l, 1));
      },
      _catchTransitionEnd: function(n) {
        this._animatingZoom && n.propertyName.indexOf("transform") >= 0 && this._onZoomTransitionEnd();
      },
      _nothingToAnimate: function() {
        return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
      },
      _tryAnimatedZoom: function(n, l, c) {
        if (this._animatingZoom)
          return !0;
        if (c = c || {}, !this._zoomAnimated || c.animate === !1 || this._nothingToAnimate() || Math.abs(l - this._zoom) > this.options.zoomAnimationThreshold)
          return !1;
        var h = this.getZoomScale(l), f = this._getCenterOffset(n)._divideBy(1 - 1 / h);
        return c.animate !== !0 && !this.getSize().contains(f) ? !1 : (W(function() {
          this._moveStart(!0, c.noMoveStart || !1)._animateZoom(n, l, !0);
        }, this), !0);
      },
      _animateZoom: function(n, l, c, h) {
        this._mapPane && (c && (this._animatingZoom = !0, this._animateToCenter = n, this._animateToZoom = l, me(this._mapPane, "leaflet-zoom-anim")), this.fire("zoomanim", {
          center: n,
          zoom: l,
          noUpdate: h
        }), this._tempFireZoomEvent || (this._tempFireZoomEvent = this._zoom !== this._animateToZoom), this._move(this._animateToCenter, this._animateToZoom, void 0, !0), setTimeout(i(this._onZoomTransitionEnd, this), 250));
      },
      _onZoomTransitionEnd: function() {
        this._animatingZoom && (this._mapPane && Ve(this._mapPane, "leaflet-zoom-anim"), this._animatingZoom = !1, this._move(this._animateToCenter, this._animateToZoom, void 0, !0), this._tempFireZoomEvent && this.fire("zoom"), delete this._tempFireZoomEvent, this.fire("move"), this._moveEnd(!0));
      }
    });
    function rd(n, l) {
      return new xe(n, l);
    }
    var wt = Z.extend({
      // @section
      // @aka Control Options
      options: {
        // @option position: String = 'topright'
        // The position of the control (one of the map corners). Possible values are `'topleft'`,
        // `'topright'`, `'bottomleft'` or `'bottomright'`
        position: "topright"
      },
      initialize: function(n) {
        P(this, n);
      },
      /* @section
       * Classes extending L.Control will inherit the following methods:
       *
       * @method getPosition: string
       * Returns the position of the control.
       */
      getPosition: function() {
        return this.options.position;
      },
      // @method setPosition(position: string): this
      // Sets the position of the control.
      setPosition: function(n) {
        var l = this._map;
        return l && l.removeControl(this), this.options.position = n, l && l.addControl(this), this;
      },
      // @method getContainer: HTMLElement
      // Returns the HTMLElement that contains the control.
      getContainer: function() {
        return this._container;
      },
      // @method addTo(map: Map): this
      // Adds the control to the given map.
      addTo: function(n) {
        this.remove(), this._map = n;
        var l = this._container = this.onAdd(n), c = this.getPosition(), h = n._controlCorners[c];
        return me(l, "leaflet-control"), c.indexOf("bottom") !== -1 ? h.insertBefore(l, h.firstChild) : h.appendChild(l), this._map.on("unload", this.remove, this), this;
      },
      // @method remove: this
      // Removes the control from the map it is currently active on.
      remove: function() {
        return this._map ? (Re(this._container), this.onRemove && this.onRemove(this._map), this._map.off("unload", this.remove, this), this._map = null, this) : this;
      },
      _refocusOnMap: function(n) {
        this._map && n && n.screenX > 0 && n.screenY > 0 && this._map.getContainer().focus();
      }
    }), ss = function(n) {
      return new wt(n);
    };
    xe.include({
      // @method addControl(control: Control): this
      // Adds the given control to the map
      addControl: function(n) {
        return n.addTo(this), this;
      },
      // @method removeControl(control: Control): this
      // Removes the given control from the map
      removeControl: function(n) {
        return n.remove(), this;
      },
      _initControlPos: function() {
        var n = this._controlCorners = {}, l = "leaflet-", c = this._controlContainer = Ae("div", l + "control-container", this._container);
        function h(f, y) {
          var S = l + f + " " + l + y;
          n[f + y] = Ae("div", S, c);
        }
        h("top", "left"), h("top", "right"), h("bottom", "left"), h("bottom", "right");
      },
      _clearControlPos: function() {
        for (var n in this._controlCorners)
          Re(this._controlCorners[n]);
        Re(this._controlContainer), delete this._controlCorners, delete this._controlContainer;
      }
    });
    var Na = wt.extend({
      // @section
      // @aka Control.Layers options
      options: {
        // @option collapsed: Boolean = true
        // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
        collapsed: !0,
        position: "topright",
        // @option autoZIndex: Boolean = true
        // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
        autoZIndex: !0,
        // @option hideSingleBase: Boolean = false
        // If `true`, the base layers in the control will be hidden when there is only one.
        hideSingleBase: !1,
        // @option sortLayers: Boolean = false
        // Whether to sort the layers. When `false`, layers will keep the order
        // in which they were added to the control.
        sortLayers: !1,
        // @option sortFunction: Function = *
        // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
        // that will be used for sorting the layers, when `sortLayers` is `true`.
        // The function receives both the `L.Layer` instances and their names, as in
        // `sortFunction(layerA, layerB, nameA, nameB)`.
        // By default, it sorts layers alphabetically by their name.
        sortFunction: function(n, l, c, h) {
          return c < h ? -1 : h < c ? 1 : 0;
        }
      },
      initialize: function(n, l, c) {
        P(this, c), this._layerControlInputs = [], this._layers = [], this._lastZIndex = 0, this._handlingClick = !1, this._preventClick = !1;
        for (var h in n)
          this._addLayer(n[h], h);
        for (h in l)
          this._addLayer(l[h], h, !0);
      },
      onAdd: function(n) {
        this._initLayout(), this._update(), this._map = n, n.on("zoomend", this._checkDisabledLayers, this);
        for (var l = 0; l < this._layers.length; l++)
          this._layers[l].layer.on("add remove", this._onLayerChange, this);
        return this._container;
      },
      addTo: function(n) {
        return wt.prototype.addTo.call(this, n), this._expandIfNotCollapsed();
      },
      onRemove: function() {
        this._map.off("zoomend", this._checkDisabledLayers, this);
        for (var n = 0; n < this._layers.length; n++)
          this._layers[n].layer.off("add remove", this._onLayerChange, this);
      },
      // @method addBaseLayer(layer: Layer, name: String): this
      // Adds a base layer (radio button entry) with the given name to the control.
      addBaseLayer: function(n, l) {
        return this._addLayer(n, l), this._map ? this._update() : this;
      },
      // @method addOverlay(layer: Layer, name: String): this
      // Adds an overlay (checkbox entry) with the given name to the control.
      addOverlay: function(n, l) {
        return this._addLayer(n, l, !0), this._map ? this._update() : this;
      },
      // @method removeLayer(layer: Layer): this
      // Remove the given layer from the control.
      removeLayer: function(n) {
        n.off("add remove", this._onLayerChange, this);
        var l = this._getLayer(d(n));
        return l && this._layers.splice(this._layers.indexOf(l), 1), this._map ? this._update() : this;
      },
      // @method expand(): this
      // Expand the control container if collapsed.
      expand: function() {
        me(this._container, "leaflet-control-layers-expanded"), this._section.style.height = null;
        var n = this._map.getSize().y - (this._container.offsetTop + 50);
        return n < this._section.clientHeight ? (me(this._section, "leaflet-control-layers-scrollbar"), this._section.style.height = n + "px") : Ve(this._section, "leaflet-control-layers-scrollbar"), this._checkDisabledLayers(), this;
      },
      // @method collapse(): this
      // Collapse the control container if expanded.
      collapse: function() {
        return Ve(this._container, "leaflet-control-layers-expanded"), this;
      },
      _initLayout: function() {
        var n = "leaflet-control-layers", l = this._container = Ae("div", n), c = this.options.collapsed;
        l.setAttribute("aria-haspopup", !0), rs(l), hn(l);
        var h = this._section = Ae("section", n + "-list");
        c && (this._map.on("click", this.collapse, this), fe(l, {
          mouseenter: this._expandSafely,
          mouseleave: this.collapse
        }, this));
        var f = this._layersLink = Ae("a", n + "-toggle", l);
        f.href = "#", f.title = "Layers", f.setAttribute("role", "button"), fe(f, {
          keydown: function(y) {
            y.keyCode === 13 && this._expandSafely();
          },
          // Certain screen readers intercept the key event and instead send a click event
          click: function(y) {
            tt(y), this._expandSafely();
          }
        }, this), c || this.expand(), this._baseLayersList = Ae("div", n + "-base", h), this._separator = Ae("div", n + "-separator", h), this._overlaysList = Ae("div", n + "-overlays", h), l.appendChild(h);
      },
      _getLayer: function(n) {
        for (var l = 0; l < this._layers.length; l++)
          if (this._layers[l] && d(this._layers[l].layer) === n)
            return this._layers[l];
      },
      _addLayer: function(n, l, c) {
        this._map && n.on("add remove", this._onLayerChange, this), this._layers.push({
          layer: n,
          name: l,
          overlay: c
        }), this.options.sortLayers && this._layers.sort(i(function(h, f) {
          return this.options.sortFunction(h.layer, f.layer, h.name, f.name);
        }, this)), this.options.autoZIndex && n.setZIndex && (this._lastZIndex++, n.setZIndex(this._lastZIndex)), this._expandIfNotCollapsed();
      },
      _update: function() {
        if (!this._container)
          return this;
        Es(this._baseLayersList), Es(this._overlaysList), this._layerControlInputs = [];
        var n, l, c, h, f = 0;
        for (c = 0; c < this._layers.length; c++)
          h = this._layers[c], this._addItem(h), l = l || h.overlay, n = n || !h.overlay, f += h.overlay ? 0 : 1;
        return this.options.hideSingleBase && (n = n && f > 1, this._baseLayersList.style.display = n ? "" : "none"), this._separator.style.display = l && n ? "" : "none", this;
      },
      _onLayerChange: function(n) {
        this._handlingClick || this._update();
        var l = this._getLayer(d(n.target)), c = l.overlay ? n.type === "add" ? "overlayadd" : "overlayremove" : n.type === "add" ? "baselayerchange" : null;
        c && this._map.fire(c, l);
      },
      // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
      _createRadioElement: function(n, l) {
        var c = '<input type="radio" class="leaflet-control-layers-selector" name="' + n + '"' + (l ? ' checked="checked"' : "") + "/>", h = document.createElement("div");
        return h.innerHTML = c, h.firstChild;
      },
      _addItem: function(n) {
        var l = document.createElement("label"), c = this._map.hasLayer(n.layer), h;
        n.overlay ? (h = document.createElement("input"), h.type = "checkbox", h.className = "leaflet-control-layers-selector", h.defaultChecked = c) : h = this._createRadioElement("leaflet-base-layers_" + d(this), c), this._layerControlInputs.push(h), h.layerId = d(n.layer), fe(h, "click", this._onInputClick, this);
        var f = document.createElement("span");
        f.innerHTML = " " + n.name;
        var y = document.createElement("span");
        l.appendChild(y), y.appendChild(h), y.appendChild(f);
        var S = n.overlay ? this._overlaysList : this._baseLayersList;
        return S.appendChild(l), this._checkDisabledLayers(), l;
      },
      _onInputClick: function() {
        if (!this._preventClick) {
          var n = this._layerControlInputs, l, c, h = [], f = [];
          this._handlingClick = !0;
          for (var y = n.length - 1; y >= 0; y--)
            l = n[y], c = this._getLayer(l.layerId).layer, l.checked ? h.push(c) : l.checked || f.push(c);
          for (y = 0; y < f.length; y++)
            this._map.hasLayer(f[y]) && this._map.removeLayer(f[y]);
          for (y = 0; y < h.length; y++)
            this._map.hasLayer(h[y]) || this._map.addLayer(h[y]);
          this._handlingClick = !1, this._refocusOnMap();
        }
      },
      _checkDisabledLayers: function() {
        for (var n = this._layerControlInputs, l, c, h = this._map.getZoom(), f = n.length - 1; f >= 0; f--)
          l = n[f], c = this._getLayer(l.layerId).layer, l.disabled = c.options.minZoom !== void 0 && h < c.options.minZoom || c.options.maxZoom !== void 0 && h > c.options.maxZoom;
      },
      _expandIfNotCollapsed: function() {
        return this._map && !this.options.collapsed && this.expand(), this;
      },
      _expandSafely: function() {
        var n = this._section;
        this._preventClick = !0, fe(n, "click", tt), this.expand();
        var l = this;
        setTimeout(function() {
          Je(n, "click", tt), l._preventClick = !1;
        });
      }
    }), sd = function(n, l, c) {
      return new Na(n, l, c);
    }, fn = wt.extend({
      // @section
      // @aka Control.Zoom options
      options: {
        position: "topleft",
        // @option zoomInText: String = '<span aria-hidden="true">+</span>'
        // The text set on the 'zoom in' button.
        zoomInText: '<span aria-hidden="true">+</span>',
        // @option zoomInTitle: String = 'Zoom in'
        // The title set on the 'zoom in' button.
        zoomInTitle: "Zoom in",
        // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
        // The text set on the 'zoom out' button.
        zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
        // @option zoomOutTitle: String = 'Zoom out'
        // The title set on the 'zoom out' button.
        zoomOutTitle: "Zoom out"
      },
      onAdd: function(n) {
        var l = "leaflet-control-zoom", c = Ae("div", l + " leaflet-bar"), h = this.options;
        return this._zoomInButton = this._createButton(
          h.zoomInText,
          h.zoomInTitle,
          l + "-in",
          c,
          this._zoomIn
        ), this._zoomOutButton = this._createButton(
          h.zoomOutText,
          h.zoomOutTitle,
          l + "-out",
          c,
          this._zoomOut
        ), this._updateDisabled(), n.on("zoomend zoomlevelschange", this._updateDisabled, this), c;
      },
      onRemove: function(n) {
        n.off("zoomend zoomlevelschange", this._updateDisabled, this);
      },
      disable: function() {
        return this._disabled = !0, this._updateDisabled(), this;
      },
      enable: function() {
        return this._disabled = !1, this._updateDisabled(), this;
      },
      _zoomIn: function(n) {
        !this._disabled && this._map._zoom < this._map.getMaxZoom() && this._map.zoomIn(this._map.options.zoomDelta * (n.shiftKey ? 3 : 1));
      },
      _zoomOut: function(n) {
        !this._disabled && this._map._zoom > this._map.getMinZoom() && this._map.zoomOut(this._map.options.zoomDelta * (n.shiftKey ? 3 : 1));
      },
      _createButton: function(n, l, c, h, f) {
        var y = Ae("a", c, h);
        return y.innerHTML = n, y.href = "#", y.title = l, y.setAttribute("role", "button"), y.setAttribute("aria-label", l), rs(y), fe(y, "click", or), fe(y, "click", f, this), fe(y, "click", this._refocusOnMap, this), y;
      },
      _updateDisabled: function() {
        var n = this._map, l = "leaflet-disabled";
        Ve(this._zoomInButton, l), Ve(this._zoomOutButton, l), this._zoomInButton.setAttribute("aria-disabled", "false"), this._zoomOutButton.setAttribute("aria-disabled", "false"), (this._disabled || n._zoom === n.getMinZoom()) && (me(this._zoomOutButton, l), this._zoomOutButton.setAttribute("aria-disabled", "true")), (this._disabled || n._zoom === n.getMaxZoom()) && (me(this._zoomInButton, l), this._zoomInButton.setAttribute("aria-disabled", "true"));
      }
    });
    xe.mergeOptions({
      zoomControl: !0
    }), xe.addInitHook(function() {
      this.options.zoomControl && (this.zoomControl = new fn(), this.addControl(this.zoomControl));
    });
    var id = function(n) {
      return new fn(n);
    }, Ja = wt.extend({
      // @section
      // @aka Control.Scale options
      options: {
        position: "bottomleft",
        // @option maxWidth: Number = 100
        // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
        maxWidth: 100,
        // @option metric: Boolean = True
        // Whether to show the metric scale line (m/km).
        metric: !0,
        // @option imperial: Boolean = True
        // Whether to show the imperial scale line (mi/ft).
        imperial: !0
        // @option updateWhenIdle: Boolean = false
        // If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
      },
      onAdd: function(n) {
        var l = "leaflet-control-scale", c = Ae("div", l), h = this.options;
        return this._addScales(h, l + "-line", c), n.on(h.updateWhenIdle ? "moveend" : "move", this._update, this), n.whenReady(this._update, this), c;
      },
      onRemove: function(n) {
        n.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
      },
      _addScales: function(n, l, c) {
        n.metric && (this._mScale = Ae("div", l, c)), n.imperial && (this._iScale = Ae("div", l, c));
      },
      _update: function() {
        var n = this._map, l = n.getSize().y / 2, c = n.distance(
          n.containerPointToLatLng([0, l]),
          n.containerPointToLatLng([this.options.maxWidth, l])
        );
        this._updateScales(c);
      },
      _updateScales: function(n) {
        this.options.metric && n && this._updateMetric(n), this.options.imperial && n && this._updateImperial(n);
      },
      _updateMetric: function(n) {
        var l = this._getRoundNum(n), c = l < 1e3 ? l + " m" : l / 1e3 + " km";
        this._updateScale(this._mScale, c, l / n);
      },
      _updateImperial: function(n) {
        var l = n * 3.2808399, c, h, f;
        l > 5280 ? (c = l / 5280, h = this._getRoundNum(c), this._updateScale(this._iScale, h + " mi", h / c)) : (f = this._getRoundNum(l), this._updateScale(this._iScale, f + " ft", f / l));
      },
      _updateScale: function(n, l, c) {
        n.style.width = Math.round(this.options.maxWidth * c) + "px", n.innerHTML = l;
      },
      _getRoundNum: function(n) {
        var l = Math.pow(10, (Math.floor(n) + "").length - 1), c = n / l;
        return c = c >= 10 ? 10 : c >= 5 ? 5 : c >= 3 ? 3 : c >= 2 ? 2 : 1, l * c;
      }
    }), nd = function(n) {
      return new Ja(n);
    }, od = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>', pn = wt.extend({
      // @section
      // @aka Control.Attribution options
      options: {
        position: "bottomright",
        // @option prefix: String|false = 'Leaflet'
        // The HTML text shown before the attributions. Pass `false` to disable.
        prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (oe.inlineSvg ? od + " " : "") + "Leaflet</a>"
      },
      initialize: function(n) {
        P(this, n), this._attributions = {};
      },
      onAdd: function(n) {
        n.attributionControl = this, this._container = Ae("div", "leaflet-control-attribution"), rs(this._container);
        for (var l in n._layers)
          n._layers[l].getAttribution && this.addAttribution(n._layers[l].getAttribution());
        return this._update(), n.on("layeradd", this._addAttribution, this), this._container;
      },
      onRemove: function(n) {
        n.off("layeradd", this._addAttribution, this);
      },
      _addAttribution: function(n) {
        n.layer.getAttribution && (this.addAttribution(n.layer.getAttribution()), n.layer.once("remove", function() {
          this.removeAttribution(n.layer.getAttribution());
        }, this));
      },
      // @method setPrefix(prefix: String|false): this
      // The HTML text shown before the attributions. Pass `false` to disable.
      setPrefix: function(n) {
        return this.options.prefix = n, this._update(), this;
      },
      // @method addAttribution(text: String): this
      // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
      addAttribution: function(n) {
        return n ? (this._attributions[n] || (this._attributions[n] = 0), this._attributions[n]++, this._update(), this) : this;
      },
      // @method removeAttribution(text: String): this
      // Removes an attribution text.
      removeAttribution: function(n) {
        return n ? (this._attributions[n] && (this._attributions[n]--, this._update()), this) : this;
      },
      _update: function() {
        if (this._map) {
          var n = [];
          for (var l in this._attributions)
            this._attributions[l] && n.push(l);
          var c = [];
          this.options.prefix && c.push(this.options.prefix), n.length && c.push(n.join(", ")), this._container.innerHTML = c.join(' <span aria-hidden="true">|</span> ');
        }
      }
    });
    xe.mergeOptions({
      attributionControl: !0
    }), xe.addInitHook(function() {
      this.options.attributionControl && new pn().addTo(this);
    });
    var ad = function(n) {
      return new pn(n);
    };
    wt.Layers = Na, wt.Zoom = fn, wt.Scale = Ja, wt.Attribution = pn, ss.layers = sd, ss.zoom = id, ss.scale = nd, ss.attribution = ad;
    var It = Z.extend({
      initialize: function(n) {
        this._map = n;
      },
      // @method enable(): this
      // Enables the handler
      enable: function() {
        return this._enabled ? this : (this._enabled = !0, this.addHooks(), this);
      },
      // @method disable(): this
      // Disables the handler
      disable: function() {
        return this._enabled ? (this._enabled = !1, this.removeHooks(), this) : this;
      },
      // @method enabled(): Boolean
      // Returns `true` if the handler is enabled
      enabled: function() {
        return !!this._enabled;
      }
      // @section Extension methods
      // Classes inheriting from `Handler` must implement the two following methods:
      // @method addHooks()
      // Called when the handler is enabled, should add event hooks.
      // @method removeHooks()
      // Called when the handler is disabled, should remove the event hooks added previously.
    });
    It.addTo = function(n, l) {
      return n.addHandler(l, this), this;
    };
    var ld = { Events: Pe }, Ua = oe.touch ? "touchstart mousedown" : "mousedown", Wt = ot.extend({
      options: {
        // @section
        // @aka Draggable options
        // @option clickTolerance: Number = 3
        // The max number of pixels a user can shift the mouse pointer during a click
        // for it to be considered a valid click (as opposed to a mouse drag).
        clickTolerance: 3
      },
      // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
      // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
      initialize: function(n, l, c, h) {
        P(this, h), this._element = n, this._dragStartTarget = l || n, this._preventOutline = c;
      },
      // @method enable()
      // Enables the dragging ability
      enable: function() {
        this._enabled || (fe(this._dragStartTarget, Ua, this._onDown, this), this._enabled = !0);
      },
      // @method disable()
      // Disables the dragging ability
      disable: function() {
        this._enabled && (Wt._dragging === this && this.finishDrag(!0), Je(this._dragStartTarget, Ua, this._onDown, this), this._enabled = !1, this._moved = !1);
      },
      _onDown: function(n) {
        if (this._enabled && (this._moved = !1, !Xi(this._element, "leaflet-zoom-anim"))) {
          if (n.touches && n.touches.length !== 1) {
            Wt._dragging === this && this.finishDrag();
            return;
          }
          if (!(Wt._dragging || n.shiftKey || n.which !== 1 && n.button !== 1 && !n.touches) && (Wt._dragging = this, this._preventOutline && on(this._element), rn(), Xr(), !this._moving)) {
            this.fire("down");
            var l = n.touches ? n.touches[0] : n, c = ka(this._element);
            this._startPoint = new ue(l.clientX, l.clientY), this._startPos = ir(this._element), this._parentScale = an(c);
            var h = n.type === "mousedown";
            fe(document, h ? "mousemove" : "touchmove", this._onMove, this), fe(document, h ? "mouseup" : "touchend touchcancel", this._onUp, this);
          }
        }
      },
      _onMove: function(n) {
        if (this._enabled) {
          if (n.touches && n.touches.length > 1) {
            this._moved = !0;
            return;
          }
          var l = n.touches && n.touches.length === 1 ? n.touches[0] : n, c = new ue(l.clientX, l.clientY)._subtract(this._startPoint);
          !c.x && !c.y || Math.abs(c.x) + Math.abs(c.y) < this.options.clickTolerance || (c.x /= this._parentScale.x, c.y /= this._parentScale.y, tt(n), this._moved || (this.fire("dragstart"), this._moved = !0, me(document.body, "leaflet-dragging"), this._lastTarget = n.target || n.srcElement, window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance && (this._lastTarget = this._lastTarget.correspondingUseElement), me(this._lastTarget, "leaflet-drag-target")), this._newPos = this._startPos.add(c), this._moving = !0, this._lastEvent = n, this._updatePosition());
        }
      },
      _updatePosition: function() {
        var n = { originalEvent: this._lastEvent };
        this.fire("predrag", n), Ge(this._element, this._newPos), this.fire("drag", n);
      },
      _onUp: function() {
        this._enabled && this.finishDrag();
      },
      finishDrag: function(n) {
        Ve(document.body, "leaflet-dragging"), this._lastTarget && (Ve(this._lastTarget, "leaflet-drag-target"), this._lastTarget = null), Je(document, "mousemove touchmove", this._onMove, this), Je(document, "mouseup touchend touchcancel", this._onUp, this), sn(), es();
        var l = this._moved && this._moving;
        this._moving = !1, Wt._dragging = !1, l && this.fire("dragend", {
          noInertia: n,
          distance: this._newPos.distanceTo(this._startPos)
        });
      }
    });
    function Ba(n, l, c) {
      var h, f = [1, 4, 2, 8], y, S, E, M, q, K, le, ye;
      for (y = 0, K = n.length; y < K; y++)
        n[y]._code = ar(n[y], l);
      for (E = 0; E < 4; E++) {
        for (le = f[E], h = [], y = 0, K = n.length, S = K - 1; y < K; S = y++)
          M = n[y], q = n[S], M._code & le ? q._code & le || (ye = Us(q, M, le, l, c), ye._code = ar(ye, l), h.push(ye)) : (q._code & le && (ye = Us(q, M, le, l, c), ye._code = ar(ye, l), h.push(ye)), h.push(M));
        n = h;
      }
      return n;
    }
    function Ra(n, l) {
      var c, h, f, y, S, E, M, q, K;
      if (!n || n.length === 0)
        throw new Error("latlngs not passed");
      pt(n) || (console.warn("latlngs are not flat! Only the first ring will be used"), n = n[0]);
      var le = ve([0, 0]), ye = Le(n), at = ye.getNorthWest().distanceTo(ye.getSouthWest()) * ye.getNorthEast().distanceTo(ye.getNorthWest());
      at < 1700 && (le = mn(n));
      var Xe = n.length, mt = [];
      for (c = 0; c < Xe; c++) {
        var ut = ve(n[c]);
        mt.push(l.project(ve([ut.lat - le.lat, ut.lng - le.lng])));
      }
      for (E = M = q = 0, c = 0, h = Xe - 1; c < Xe; h = c++)
        f = mt[c], y = mt[h], S = f.y * y.x - y.y * f.x, M += (f.x + y.x) * S, q += (f.y + y.y) * S, E += S * 3;
      E === 0 ? K = mt[0] : K = [M / E, q / E];
      var jr = l.unproject(J(K));
      return ve([jr.lat + le.lat, jr.lng + le.lng]);
    }
    function mn(n) {
      for (var l = 0, c = 0, h = 0, f = 0; f < n.length; f++) {
        var y = ve(n[f]);
        l += y.lat, c += y.lng, h++;
      }
      return ve([l / h, c / h]);
    }
    var ud = {
      __proto__: null,
      clipPolygon: Ba,
      polygonCenter: Ra,
      centroid: mn
    };
    function za(n, l) {
      if (!l || !n.length)
        return n.slice();
      var c = l * l;
      return n = dd(n, c), n = hd(n, c), n;
    }
    function qa(n, l, c) {
      return Math.sqrt(is(n, l, c, !0));
    }
    function cd(n, l, c) {
      return is(n, l, c);
    }
    function hd(n, l) {
      var c = n.length, h = typeof Uint8Array < "u" ? Uint8Array : Array, f = new h(c);
      f[0] = f[c - 1] = 1, vn(n, f, l, 0, c - 1);
      var y, S = [];
      for (y = 0; y < c; y++)
        f[y] && S.push(n[y]);
      return S;
    }
    function vn(n, l, c, h, f) {
      var y = 0, S, E, M;
      for (E = h + 1; E <= f - 1; E++)
        M = is(n[E], n[h], n[f], !0), M > y && (S = E, y = M);
      y > c && (l[S] = 1, vn(n, l, c, h, S), vn(n, l, c, S, f));
    }
    function dd(n, l) {
      for (var c = [n[0]], h = 1, f = 0, y = n.length; h < y; h++)
        fd(n[h], n[f]) > l && (c.push(n[h]), f = h);
      return f < y - 1 && c.push(n[y - 1]), c;
    }
    var Za;
    function Va(n, l, c, h, f) {
      var y = h ? Za : ar(n, c), S = ar(l, c), E, M, q;
      for (Za = S; ; ) {
        if (!(y | S))
          return [n, l];
        if (y & S)
          return !1;
        E = y || S, M = Us(n, l, E, c, f), q = ar(M, c), E === y ? (n = M, y = q) : (l = M, S = q);
      }
    }
    function Us(n, l, c, h, f) {
      var y = l.x - n.x, S = l.y - n.y, E = h.min, M = h.max, q, K;
      return c & 8 ? (q = n.x + y * (M.y - n.y) / S, K = M.y) : c & 4 ? (q = n.x + y * (E.y - n.y) / S, K = E.y) : c & 2 ? (q = M.x, K = n.y + S * (M.x - n.x) / y) : c & 1 && (q = E.x, K = n.y + S * (E.x - n.x) / y), new ue(q, K, f);
    }
    function ar(n, l) {
      var c = 0;
      return n.x < l.min.x ? c |= 1 : n.x > l.max.x && (c |= 2), n.y < l.min.y ? c |= 4 : n.y > l.max.y && (c |= 8), c;
    }
    function fd(n, l) {
      var c = l.x - n.x, h = l.y - n.y;
      return c * c + h * h;
    }
    function is(n, l, c, h) {
      var f = l.x, y = l.y, S = c.x - f, E = c.y - y, M = S * S + E * E, q;
      return M > 0 && (q = ((n.x - f) * S + (n.y - y) * E) / M, q > 1 ? (f = c.x, y = c.y) : q > 0 && (f += S * q, y += E * q)), S = n.x - f, E = n.y - y, h ? S * S + E * E : new ue(f, y);
    }
    function pt(n) {
      return !C(n[0]) || typeof n[0][0] != "object" && typeof n[0][0] < "u";
    }
    function $a(n) {
      return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."), pt(n);
    }
    function Fa(n, l) {
      var c, h, f, y, S, E, M, q;
      if (!n || n.length === 0)
        throw new Error("latlngs not passed");
      pt(n) || (console.warn("latlngs are not flat! Only the first ring will be used"), n = n[0]);
      var K = ve([0, 0]), le = Le(n), ye = le.getNorthWest().distanceTo(le.getSouthWest()) * le.getNorthEast().distanceTo(le.getNorthWest());
      ye < 1700 && (K = mn(n));
      var at = n.length, Xe = [];
      for (c = 0; c < at; c++) {
        var mt = ve(n[c]);
        Xe.push(l.project(ve([mt.lat - K.lat, mt.lng - K.lng])));
      }
      for (c = 0, h = 0; c < at - 1; c++)
        h += Xe[c].distanceTo(Xe[c + 1]) / 2;
      if (h === 0)
        q = Xe[0];
      else
        for (c = 0, y = 0; c < at - 1; c++)
          if (S = Xe[c], E = Xe[c + 1], f = S.distanceTo(E), y += f, y > h) {
            M = (y - h) / f, q = [
              E.x - M * (E.x - S.x),
              E.y - M * (E.y - S.y)
            ];
            break;
          }
      var ut = l.unproject(J(q));
      return ve([ut.lat + K.lat, ut.lng + K.lng]);
    }
    var pd = {
      __proto__: null,
      simplify: za,
      pointToSegmentDistance: qa,
      closestPointOnSegment: cd,
      clipSegment: Va,
      _getEdgeIntersection: Us,
      _getBitCode: ar,
      _sqClosestPointOnSegment: is,
      isFlat: pt,
      _flat: $a,
      polylineCenter: Fa
    }, gn = {
      project: function(n) {
        return new ue(n.lng, n.lat);
      },
      unproject: function(n) {
        return new Ce(n.y, n.x);
      },
      bounds: new Q([-180, -90], [180, 90])
    }, yn = {
      R: 6378137,
      R_MINOR: 6356752314245179e-9,
      bounds: new Q([-2003750834279e-5, -1549657073972e-5], [2003750834279e-5, 1876465623138e-5]),
      project: function(n) {
        var l = Math.PI / 180, c = this.R, h = n.lat * l, f = this.R_MINOR / c, y = Math.sqrt(1 - f * f), S = y * Math.sin(h), E = Math.tan(Math.PI / 4 - h / 2) / Math.pow((1 - S) / (1 + S), y / 2);
        return h = -c * Math.log(Math.max(E, 1e-10)), new ue(n.lng * l * c, h);
      },
      unproject: function(n) {
        for (var l = 180 / Math.PI, c = this.R, h = this.R_MINOR / c, f = Math.sqrt(1 - h * h), y = Math.exp(-n.y / c), S = Math.PI / 2 - 2 * Math.atan(y), E = 0, M = 0.1, q; E < 15 && Math.abs(M) > 1e-7; E++)
          q = f * Math.sin(S), q = Math.pow((1 - q) / (1 + q), f / 2), M = Math.PI / 2 - 2 * Math.atan(y * q) - S, S += M;
        return new Ce(S * l, n.x * l / c);
      }
    }, md = {
      __proto__: null,
      LonLat: gn,
      Mercator: yn,
      SphericalMercator: Zi
    }, vd = r({}, Ht, {
      code: "EPSG:3395",
      projection: yn,
      transformation: function() {
        var n = 0.5 / (Math.PI * yn.R);
        return Wr(n, 0.5, -n, 0.5);
      }()
    }), Ga = r({}, Ht, {
      code: "EPSG:4326",
      projection: gn,
      transformation: Wr(1 / 180, 1, -1 / 180, 0.5)
    }), gd = r({}, Nt, {
      projection: gn,
      transformation: Wr(1, 0, -1, 0),
      scale: function(n) {
        return Math.pow(2, n);
      },
      zoom: function(n) {
        return Math.log(n) / Math.LN2;
      },
      distance: function(n, l) {
        var c = l.lng - n.lng, h = l.lat - n.lat;
        return Math.sqrt(c * c + h * h);
      },
      infinite: !0
    });
    Nt.Earth = Ht, Nt.EPSG3395 = vd, Nt.EPSG3857 = $i, Nt.EPSG900913 = xh, Nt.EPSG4326 = Ga, Nt.Simple = gd;
    var Pt = ot.extend({
      // Classes extending `L.Layer` will inherit the following options:
      options: {
        // @option pane: String = 'overlayPane'
        // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
        pane: "overlayPane",
        // @option attribution: String = null
        // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
        attribution: null,
        bubblingMouseEvents: !0
      },
      /* @section
       * Classes extending `L.Layer` will inherit the following methods:
       *
       * @method addTo(map: Map|LayerGroup): this
       * Adds the layer to the given map or layer group.
       */
      addTo: function(n) {
        return n.addLayer(this), this;
      },
      // @method remove: this
      // Removes the layer from the map it is currently active on.
      remove: function() {
        return this.removeFrom(this._map || this._mapToAdd);
      },
      // @method removeFrom(map: Map): this
      // Removes the layer from the given map
      //
      // @alternative
      // @method removeFrom(group: LayerGroup): this
      // Removes the layer from the given `LayerGroup`
      removeFrom: function(n) {
        return n && n.removeLayer(this), this;
      },
      // @method getPane(name? : String): HTMLElement
      // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
      getPane: function(n) {
        return this._map.getPane(n ? this.options[n] || n : this.options.pane);
      },
      addInteractiveTarget: function(n) {
        return this._map._targets[d(n)] = this, this;
      },
      removeInteractiveTarget: function(n) {
        return delete this._map._targets[d(n)], this;
      },
      // @method getAttribution: String
      // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
      getAttribution: function() {
        return this.options.attribution;
      },
      _layerAdd: function(n) {
        var l = n.target;
        if (l.hasLayer(this)) {
          if (this._map = l, this._zoomAnimated = l._zoomAnimated, this.getEvents) {
            var c = this.getEvents();
            l.on(c, this), this.once("remove", function() {
              l.off(c, this);
            }, this);
          }
          this.onAdd(l), this.fire("add"), l.fire("layeradd", { layer: this });
        }
      }
    });
    xe.include({
      // @method addLayer(layer: Layer): this
      // Adds the given layer to the map
      addLayer: function(n) {
        if (!n._layerAdd)
          throw new Error("The provided object is not a Layer.");
        var l = d(n);
        return this._layers[l] ? this : (this._layers[l] = n, n._mapToAdd = this, n.beforeAdd && n.beforeAdd(this), this.whenReady(n._layerAdd, n), this);
      },
      // @method removeLayer(layer: Layer): this
      // Removes the given layer from the map.
      removeLayer: function(n) {
        var l = d(n);
        return this._layers[l] ? (this._loaded && n.onRemove(this), delete this._layers[l], this._loaded && (this.fire("layerremove", { layer: n }), n.fire("remove")), n._map = n._mapToAdd = null, this) : this;
      },
      // @method hasLayer(layer: Layer): Boolean
      // Returns `true` if the given layer is currently added to the map
      hasLayer: function(n) {
        return d(n) in this._layers;
      },
      /* @method eachLayer(fn: Function, context?: Object): this
       * Iterates over the layers of the map, optionally specifying context of the iterator function.
       * ```
       * map.eachLayer(function(layer){
       *     layer.bindPopup('Hello');
       * });
       * ```
       */
      eachLayer: function(n, l) {
        for (var c in this._layers)
          n.call(l, this._layers[c]);
        return this;
      },
      _addLayers: function(n) {
        n = n ? C(n) ? n : [n] : [];
        for (var l = 0, c = n.length; l < c; l++)
          this.addLayer(n[l]);
      },
      _addZoomLimit: function(n) {
        (!isNaN(n.options.maxZoom) || !isNaN(n.options.minZoom)) && (this._zoomBoundLayers[d(n)] = n, this._updateZoomLevels());
      },
      _removeZoomLimit: function(n) {
        var l = d(n);
        this._zoomBoundLayers[l] && (delete this._zoomBoundLayers[l], this._updateZoomLevels());
      },
      _updateZoomLevels: function() {
        var n = 1 / 0, l = -1 / 0, c = this._getZoomSpan();
        for (var h in this._zoomBoundLayers) {
          var f = this._zoomBoundLayers[h].options;
          n = f.minZoom === void 0 ? n : Math.min(n, f.minZoom), l = f.maxZoom === void 0 ? l : Math.max(l, f.maxZoom);
        }
        this._layersMaxZoom = l === -1 / 0 ? void 0 : l, this._layersMinZoom = n === 1 / 0 ? void 0 : n, c !== this._getZoomSpan() && this.fire("zoomlevelschange"), this.options.maxZoom === void 0 && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom && this.setZoom(this._layersMaxZoom), this.options.minZoom === void 0 && this._layersMinZoom && this.getZoom() < this._layersMinZoom && this.setZoom(this._layersMinZoom);
      }
    });
    var Cr = Pt.extend({
      initialize: function(n, l) {
        P(this, l), this._layers = {};
        var c, h;
        if (n)
          for (c = 0, h = n.length; c < h; c++)
            this.addLayer(n[c]);
      },
      // @method addLayer(layer: Layer): this
      // Adds the given layer to the group.
      addLayer: function(n) {
        var l = this.getLayerId(n);
        return this._layers[l] = n, this._map && this._map.addLayer(n), this;
      },
      // @method removeLayer(layer: Layer): this
      // Removes the given layer from the group.
      // @alternative
      // @method removeLayer(id: Number): this
      // Removes the layer with the given internal ID from the group.
      removeLayer: function(n) {
        var l = n in this._layers ? n : this.getLayerId(n);
        return this._map && this._layers[l] && this._map.removeLayer(this._layers[l]), delete this._layers[l], this;
      },
      // @method hasLayer(layer: Layer): Boolean
      // Returns `true` if the given layer is currently added to the group.
      // @alternative
      // @method hasLayer(id: Number): Boolean
      // Returns `true` if the given internal ID is currently added to the group.
      hasLayer: function(n) {
        var l = typeof n == "number" ? n : this.getLayerId(n);
        return l in this._layers;
      },
      // @method clearLayers(): this
      // Removes all the layers from the group.
      clearLayers: function() {
        return this.eachLayer(this.removeLayer, this);
      },
      // @method invoke(methodName: String, …): this
      // Calls `methodName` on every layer contained in this group, passing any
      // additional parameters. Has no effect if the layers contained do not
      // implement `methodName`.
      invoke: function(n) {
        var l = Array.prototype.slice.call(arguments, 1), c, h;
        for (c in this._layers)
          h = this._layers[c], h[n] && h[n].apply(h, l);
        return this;
      },
      onAdd: function(n) {
        this.eachLayer(n.addLayer, n);
      },
      onRemove: function(n) {
        this.eachLayer(n.removeLayer, n);
      },
      // @method eachLayer(fn: Function, context?: Object): this
      // Iterates over the layers of the group, optionally specifying context of the iterator function.
      // ```js
      // group.eachLayer(function (layer) {
      // 	layer.bindPopup('Hello');
      // });
      // ```
      eachLayer: function(n, l) {
        for (var c in this._layers)
          n.call(l, this._layers[c]);
        return this;
      },
      // @method getLayer(id: Number): Layer
      // Returns the layer with the given internal ID.
      getLayer: function(n) {
        return this._layers[n];
      },
      // @method getLayers(): Layer[]
      // Returns an array of all the layers added to the group.
      getLayers: function() {
        var n = [];
        return this.eachLayer(n.push, n), n;
      },
      // @method setZIndex(zIndex: Number): this
      // Calls `setZIndex` on every layer contained in this group, passing the z-index.
      setZIndex: function(n) {
        return this.invoke("setZIndex", n);
      },
      // @method getLayerId(layer: Layer): Number
      // Returns the internal ID for a layer
      getLayerId: function(n) {
        return d(n);
      }
    }), yd = function(n, l) {
      return new Cr(n, l);
    }, Jt = Cr.extend({
      addLayer: function(n) {
        return this.hasLayer(n) ? this : (n.addEventParent(this), Cr.prototype.addLayer.call(this, n), this.fire("layeradd", { layer: n }));
      },
      removeLayer: function(n) {
        return this.hasLayer(n) ? (n in this._layers && (n = this._layers[n]), n.removeEventParent(this), Cr.prototype.removeLayer.call(this, n), this.fire("layerremove", { layer: n })) : this;
      },
      // @method setStyle(style: Path options): this
      // Sets the given path options to each layer of the group that has a `setStyle` method.
      setStyle: function(n) {
        return this.invoke("setStyle", n);
      },
      // @method bringToFront(): this
      // Brings the layer group to the top of all other layers
      bringToFront: function() {
        return this.invoke("bringToFront");
      },
      // @method bringToBack(): this
      // Brings the layer group to the back of all other layers
      bringToBack: function() {
        return this.invoke("bringToBack");
      },
      // @method getBounds(): LatLngBounds
      // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
      getBounds: function() {
        var n = new De();
        for (var l in this._layers) {
          var c = this._layers[l];
          n.extend(c.getBounds ? c.getBounds() : c.getLatLng());
        }
        return n;
      }
    }), _d = function(n, l) {
      return new Jt(n, l);
    }, Ar = Z.extend({
      /* @section
       * @aka Icon options
       *
       * @option iconUrl: String = null
       * **(required)** The URL to the icon image (absolute or relative to your script path).
       *
       * @option iconRetinaUrl: String = null
       * The URL to a retina sized version of the icon image (absolute or relative to your
       * script path). Used for Retina screen devices.
       *
       * @option iconSize: Point = null
       * Size of the icon image in pixels.
       *
       * @option iconAnchor: Point = null
       * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
       * will be aligned so that this point is at the marker's geographical location. Centered
       * by default if size is specified, also can be set in CSS with negative margins.
       *
       * @option popupAnchor: Point = [0, 0]
       * The coordinates of the point from which popups will "open", relative to the icon anchor.
       *
       * @option tooltipAnchor: Point = [0, 0]
       * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
       *
       * @option shadowUrl: String = null
       * The URL to the icon shadow image. If not specified, no shadow image will be created.
       *
       * @option shadowRetinaUrl: String = null
       *
       * @option shadowSize: Point = null
       * Size of the shadow image in pixels.
       *
       * @option shadowAnchor: Point = null
       * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
       * as iconAnchor if not specified).
       *
       * @option className: String = ''
       * A custom class name to assign to both icon and shadow images. Empty by default.
       */
      options: {
        popupAnchor: [0, 0],
        tooltipAnchor: [0, 0],
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the tiles.
        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: !1
      },
      initialize: function(n) {
        P(this, n);
      },
      // @method createIcon(oldIcon?: HTMLElement): HTMLElement
      // Called internally when the icon has to be shown, returns a `<img>` HTML element
      // styled according to the options.
      createIcon: function(n) {
        return this._createIcon("icon", n);
      },
      // @method createShadow(oldIcon?: HTMLElement): HTMLElement
      // As `createIcon`, but for the shadow beneath it.
      createShadow: function(n) {
        return this._createIcon("shadow", n);
      },
      _createIcon: function(n, l) {
        var c = this._getIconUrl(n);
        if (!c) {
          if (n === "icon")
            throw new Error("iconUrl not set in Icon options (see the docs).");
          return null;
        }
        var h = this._createImg(c, l && l.tagName === "IMG" ? l : null);
        return this._setIconStyles(h, n), (this.options.crossOrigin || this.options.crossOrigin === "") && (h.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), h;
      },
      _setIconStyles: function(n, l) {
        var c = this.options, h = c[l + "Size"];
        typeof h == "number" && (h = [h, h]);
        var f = J(h), y = J(l === "shadow" && c.shadowAnchor || c.iconAnchor || f && f.divideBy(2, !0));
        n.className = "leaflet-marker-" + l + " " + (c.className || ""), y && (n.style.marginLeft = -y.x + "px", n.style.marginTop = -y.y + "px"), f && (n.style.width = f.x + "px", n.style.height = f.y + "px");
      },
      _createImg: function(n, l) {
        return l = l || document.createElement("img"), l.src = n, l;
      },
      _getIconUrl: function(n) {
        return oe.retina && this.options[n + "RetinaUrl"] || this.options[n + "Url"];
      }
    });
    function bd(n) {
      return new Ar(n);
    }
    var ns = Ar.extend({
      options: {
        iconUrl: "marker-icon.png",
        iconRetinaUrl: "marker-icon-2x.png",
        shadowUrl: "marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
      },
      _getIconUrl: function(n) {
        return typeof ns.imagePath != "string" && (ns.imagePath = this._detectIconPath()), (this.options.imagePath || ns.imagePath) + Ar.prototype._getIconUrl.call(this, n);
      },
      _stripUrl: function(n) {
        var l = function(c, h, f) {
          var y = h.exec(c);
          return y && y[f];
        };
        return n = l(n, /^url\((['"])?(.+)\1\)$/, 2), n && l(n, /^(.*)marker-icon\.png$/, 1);
      },
      _detectIconPath: function() {
        var n = Ae("div", "leaflet-default-icon-path", document.body), l = Yr(n, "background-image") || Yr(n, "backgroundImage");
        if (document.body.removeChild(n), l = this._stripUrl(l), l)
          return l;
        var c = document.querySelector('link[href$="leaflet.css"]');
        return c ? c.href.substring(0, c.href.length - 11 - 1) : "";
      }
    }), Ha = It.extend({
      initialize: function(n) {
        this._marker = n;
      },
      addHooks: function() {
        var n = this._marker._icon;
        this._draggable || (this._draggable = new Wt(n, n, !0)), this._draggable.on({
          dragstart: this._onDragStart,
          predrag: this._onPreDrag,
          drag: this._onDrag,
          dragend: this._onDragEnd
        }, this).enable(), me(n, "leaflet-marker-draggable");
      },
      removeHooks: function() {
        this._draggable.off({
          dragstart: this._onDragStart,
          predrag: this._onPreDrag,
          drag: this._onDrag,
          dragend: this._onDragEnd
        }, this).disable(), this._marker._icon && Ve(this._marker._icon, "leaflet-marker-draggable");
      },
      moved: function() {
        return this._draggable && this._draggable._moved;
      },
      _adjustPan: function(n) {
        var l = this._marker, c = l._map, h = this._marker.options.autoPanSpeed, f = this._marker.options.autoPanPadding, y = ir(l._icon), S = c.getPixelBounds(), E = c.getPixelOrigin(), M = be(
          S.min._subtract(E).add(f),
          S.max._subtract(E).subtract(f)
        );
        if (!M.contains(y)) {
          var q = J(
            (Math.max(M.max.x, y.x) - M.max.x) / (S.max.x - M.max.x) - (Math.min(M.min.x, y.x) - M.min.x) / (S.min.x - M.min.x),
            (Math.max(M.max.y, y.y) - M.max.y) / (S.max.y - M.max.y) - (Math.min(M.min.y, y.y) - M.min.y) / (S.min.y - M.min.y)
          ).multiplyBy(h);
          c.panBy(q, { animate: !1 }), this._draggable._newPos._add(q), this._draggable._startPos._add(q), Ge(l._icon, this._draggable._newPos), this._onDrag(n), this._panRequest = W(this._adjustPan.bind(this, n));
        }
      },
      _onDragStart: function() {
        this._oldLatLng = this._marker.getLatLng(), this._marker.closePopup && this._marker.closePopup(), this._marker.fire("movestart").fire("dragstart");
      },
      _onPreDrag: function(n) {
        this._marker.options.autoPan && (Y(this._panRequest), this._panRequest = W(this._adjustPan.bind(this, n)));
      },
      _onDrag: function(n) {
        var l = this._marker, c = l._shadow, h = ir(l._icon), f = l._map.layerPointToLatLng(h);
        c && Ge(c, h), l._latlng = f, n.latlng = f, n.oldLatLng = this._oldLatLng, l.fire("move", n).fire("drag", n);
      },
      _onDragEnd: function(n) {
        Y(this._panRequest), delete this._oldLatLng, this._marker.fire("moveend").fire("dragend", n);
      }
    }), Bs = Pt.extend({
      // @section
      // @aka Marker options
      options: {
        // @option icon: Icon = *
        // Icon instance to use for rendering the marker.
        // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
        // If not specified, a common instance of `L.Icon.Default` is used.
        icon: new ns(),
        // Option inherited from "Interactive layer" abstract class
        interactive: !0,
        // @option keyboard: Boolean = true
        // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
        keyboard: !0,
        // @option title: String = ''
        // Text for the browser tooltip that appear on marker hover (no tooltip by default).
        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
        title: "",
        // @option alt: String = 'Marker'
        // Text for the `alt` attribute of the icon image.
        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
        alt: "Marker",
        // @option zIndexOffset: Number = 0
        // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
        zIndexOffset: 0,
        // @option opacity: Number = 1.0
        // The opacity of the marker.
        opacity: 1,
        // @option riseOnHover: Boolean = false
        // If `true`, the marker will get on top of others when you hover the mouse over it.
        riseOnHover: !1,
        // @option riseOffset: Number = 250
        // The z-index offset used for the `riseOnHover` feature.
        riseOffset: 250,
        // @option pane: String = 'markerPane'
        // `Map pane` where the markers icon will be added.
        pane: "markerPane",
        // @option shadowPane: String = 'shadowPane'
        // `Map pane` where the markers shadow will be added.
        shadowPane: "shadowPane",
        // @option bubblingMouseEvents: Boolean = false
        // When `true`, a mouse event on this marker will trigger the same event on the map
        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
        bubblingMouseEvents: !1,
        // @option autoPanOnFocus: Boolean = true
        // When `true`, the map will pan whenever the marker is focused (via
        // e.g. pressing `tab` on the keyboard) to ensure the marker is
        // visible within the map's bounds
        autoPanOnFocus: !0,
        // @section Draggable marker options
        // @option draggable: Boolean = false
        // Whether the marker is draggable with mouse/touch or not.
        draggable: !1,
        // @option autoPan: Boolean = false
        // Whether to pan the map when dragging this marker near its edge or not.
        autoPan: !1,
        // @option autoPanPadding: Point = Point(50, 50)
        // Distance (in pixels to the left/right and to the top/bottom) of the
        // map edge to start panning the map.
        autoPanPadding: [50, 50],
        // @option autoPanSpeed: Number = 10
        // Number of pixels the map should pan by.
        autoPanSpeed: 10
      },
      /* @section
       *
       * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
       */
      initialize: function(n, l) {
        P(this, l), this._latlng = ve(n);
      },
      onAdd: function(n) {
        this._zoomAnimated = this._zoomAnimated && n.options.markerZoomAnimation, this._zoomAnimated && n.on("zoomanim", this._animateZoom, this), this._initIcon(), this.update();
      },
      onRemove: function(n) {
        this.dragging && this.dragging.enabled() && (this.options.draggable = !0, this.dragging.removeHooks()), delete this.dragging, this._zoomAnimated && n.off("zoomanim", this._animateZoom, this), this._removeIcon(), this._removeShadow();
      },
      getEvents: function() {
        return {
          zoom: this.update,
          viewreset: this.update
        };
      },
      // @method getLatLng: LatLng
      // Returns the current geographical position of the marker.
      getLatLng: function() {
        return this._latlng;
      },
      // @method setLatLng(latlng: LatLng): this
      // Changes the marker position to the given point.
      setLatLng: function(n) {
        var l = this._latlng;
        return this._latlng = ve(n), this.update(), this.fire("move", { oldLatLng: l, latlng: this._latlng });
      },
      // @method setZIndexOffset(offset: Number): this
      // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
      setZIndexOffset: function(n) {
        return this.options.zIndexOffset = n, this.update();
      },
      // @method getIcon: Icon
      // Returns the current icon used by the marker
      getIcon: function() {
        return this.options.icon;
      },
      // @method setIcon(icon: Icon): this
      // Changes the marker icon.
      setIcon: function(n) {
        return this.options.icon = n, this._map && (this._initIcon(), this.update()), this._popup && this.bindPopup(this._popup, this._popup.options), this;
      },
      getElement: function() {
        return this._icon;
      },
      update: function() {
        if (this._icon && this._map) {
          var n = this._map.latLngToLayerPoint(this._latlng).round();
          this._setPos(n);
        }
        return this;
      },
      _initIcon: function() {
        var n = this.options, l = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide"), c = n.icon.createIcon(this._icon), h = !1;
        c !== this._icon && (this._icon && this._removeIcon(), h = !0, n.title && (c.title = n.title), c.tagName === "IMG" && (c.alt = n.alt || "")), me(c, l), n.keyboard && (c.tabIndex = "0", c.setAttribute("role", "button")), this._icon = c, n.riseOnHover && this.on({
          mouseover: this._bringToFront,
          mouseout: this._resetZIndex
        }), this.options.autoPanOnFocus && fe(c, "focus", this._panOnFocus, this);
        var f = n.icon.createShadow(this._shadow), y = !1;
        f !== this._shadow && (this._removeShadow(), y = !0), f && (me(f, l), f.alt = ""), this._shadow = f, n.opacity < 1 && this._updateOpacity(), h && this.getPane().appendChild(this._icon), this._initInteraction(), f && y && this.getPane(n.shadowPane).appendChild(this._shadow);
      },
      _removeIcon: function() {
        this.options.riseOnHover && this.off({
          mouseover: this._bringToFront,
          mouseout: this._resetZIndex
        }), this.options.autoPanOnFocus && Je(this._icon, "focus", this._panOnFocus, this), Re(this._icon), this.removeInteractiveTarget(this._icon), this._icon = null;
      },
      _removeShadow: function() {
        this._shadow && Re(this._shadow), this._shadow = null;
      },
      _setPos: function(n) {
        this._icon && Ge(this._icon, n), this._shadow && Ge(this._shadow, n), this._zIndex = n.y + this.options.zIndexOffset, this._resetZIndex();
      },
      _updateZIndex: function(n) {
        this._icon && (this._icon.style.zIndex = this._zIndex + n);
      },
      _animateZoom: function(n) {
        var l = this._map._latLngToNewLayerPoint(this._latlng, n.zoom, n.center).round();
        this._setPos(l);
      },
      _initInteraction: function() {
        if (this.options.interactive && (me(this._icon, "leaflet-interactive"), this.addInteractiveTarget(this._icon), Ha)) {
          var n = this.options.draggable;
          this.dragging && (n = this.dragging.enabled(), this.dragging.disable()), this.dragging = new Ha(this), n && this.dragging.enable();
        }
      },
      // @method setOpacity(opacity: Number): this
      // Changes the opacity of the marker.
      setOpacity: function(n) {
        return this.options.opacity = n, this._map && this._updateOpacity(), this;
      },
      _updateOpacity: function() {
        var n = this.options.opacity;
        this._icon && ft(this._icon, n), this._shadow && ft(this._shadow, n);
      },
      _bringToFront: function() {
        this._updateZIndex(this.options.riseOffset);
      },
      _resetZIndex: function() {
        this._updateZIndex(0);
      },
      _panOnFocus: function() {
        var n = this._map;
        if (n) {
          var l = this.options.icon.options, c = l.iconSize ? J(l.iconSize) : J(0, 0), h = l.iconAnchor ? J(l.iconAnchor) : J(0, 0);
          n.panInside(this._latlng, {
            paddingTopLeft: h,
            paddingBottomRight: c.subtract(h)
          });
        }
      },
      _getPopupAnchor: function() {
        return this.options.icon.options.popupAnchor;
      },
      _getTooltipAnchor: function() {
        return this.options.icon.options.tooltipAnchor;
      }
    });
    function wd(n, l) {
      return new Bs(n, l);
    }
    var Kt = Pt.extend({
      // @section
      // @aka Path options
      options: {
        // @option stroke: Boolean = true
        // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
        stroke: !0,
        // @option color: String = '#3388ff'
        // Stroke color
        color: "#3388ff",
        // @option weight: Number = 3
        // Stroke width in pixels
        weight: 3,
        // @option opacity: Number = 1.0
        // Stroke opacity
        opacity: 1,
        // @option lineCap: String= 'round'
        // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
        lineCap: "round",
        // @option lineJoin: String = 'round'
        // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
        lineJoin: "round",
        // @option dashArray: String = null
        // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
        dashArray: null,
        // @option dashOffset: String = null
        // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
        dashOffset: null,
        // @option fill: Boolean = depends
        // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
        fill: !1,
        // @option fillColor: String = *
        // Fill color. Defaults to the value of the [`color`](#path-color) option
        fillColor: null,
        // @option fillOpacity: Number = 0.2
        // Fill opacity.
        fillOpacity: 0.2,
        // @option fillRule: String = 'evenodd'
        // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
        fillRule: "evenodd",
        // className: '',
        // Option inherited from "Interactive layer" abstract class
        interactive: !0,
        // @option bubblingMouseEvents: Boolean = true
        // When `true`, a mouse event on this path will trigger the same event on the map
        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
        bubblingMouseEvents: !0
      },
      beforeAdd: function(n) {
        this._renderer = n.getRenderer(this);
      },
      onAdd: function() {
        this._renderer._initPath(this), this._reset(), this._renderer._addPath(this);
      },
      onRemove: function() {
        this._renderer._removePath(this);
      },
      // @method redraw(): this
      // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
      redraw: function() {
        return this._map && this._renderer._updatePath(this), this;
      },
      // @method setStyle(style: Path options): this
      // Changes the appearance of a Path based on the options in the `Path options` object.
      setStyle: function(n) {
        return P(this, n), this._renderer && (this._renderer._updateStyle(this), this.options.stroke && n && Object.prototype.hasOwnProperty.call(n, "weight") && this._updateBounds()), this;
      },
      // @method bringToFront(): this
      // Brings the layer to the top of all path layers.
      bringToFront: function() {
        return this._renderer && this._renderer._bringToFront(this), this;
      },
      // @method bringToBack(): this
      // Brings the layer to the bottom of all path layers.
      bringToBack: function() {
        return this._renderer && this._renderer._bringToBack(this), this;
      },
      getElement: function() {
        return this._path;
      },
      _reset: function() {
        this._project(), this._update();
      },
      _clickTolerance: function() {
        return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
      }
    }), Rs = Kt.extend({
      // @section
      // @aka CircleMarker options
      options: {
        fill: !0,
        // @option radius: Number = 10
        // Radius of the circle marker, in pixels
        radius: 10
      },
      initialize: function(n, l) {
        P(this, l), this._latlng = ve(n), this._radius = this.options.radius;
      },
      // @method setLatLng(latLng: LatLng): this
      // Sets the position of a circle marker to a new location.
      setLatLng: function(n) {
        var l = this._latlng;
        return this._latlng = ve(n), this.redraw(), this.fire("move", { oldLatLng: l, latlng: this._latlng });
      },
      // @method getLatLng(): LatLng
      // Returns the current geographical position of the circle marker
      getLatLng: function() {
        return this._latlng;
      },
      // @method setRadius(radius: Number): this
      // Sets the radius of a circle marker. Units are in pixels.
      setRadius: function(n) {
        return this.options.radius = this._radius = n, this.redraw();
      },
      // @method getRadius(): Number
      // Returns the current radius of the circle
      getRadius: function() {
        return this._radius;
      },
      setStyle: function(n) {
        var l = n && n.radius || this._radius;
        return Kt.prototype.setStyle.call(this, n), this.setRadius(l), this;
      },
      _project: function() {
        this._point = this._map.latLngToLayerPoint(this._latlng), this._updateBounds();
      },
      _updateBounds: function() {
        var n = this._radius, l = this._radiusY || n, c = this._clickTolerance(), h = [n + c, l + c];
        this._pxBounds = new Q(this._point.subtract(h), this._point.add(h));
      },
      _update: function() {
        this._map && this._updatePath();
      },
      _updatePath: function() {
        this._renderer._updateCircle(this);
      },
      _empty: function() {
        return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
      },
      // Needed by the `Canvas` renderer for interactivity
      _containsPoint: function(n) {
        return n.distanceTo(this._point) <= this._radius + this._clickTolerance();
      }
    });
    function Pd(n, l) {
      return new Rs(n, l);
    }
    var _n = Rs.extend({
      initialize: function(n, l, c) {
        if (typeof l == "number" && (l = r({}, c, { radius: l })), P(this, l), this._latlng = ve(n), isNaN(this.options.radius))
          throw new Error("Circle radius cannot be NaN");
        this._mRadius = this.options.radius;
      },
      // @method setRadius(radius: Number): this
      // Sets the radius of a circle. Units are in meters.
      setRadius: function(n) {
        return this._mRadius = n, this.redraw();
      },
      // @method getRadius(): Number
      // Returns the current radius of a circle. Units are in meters.
      getRadius: function() {
        return this._mRadius;
      },
      // @method getBounds(): LatLngBounds
      // Returns the `LatLngBounds` of the path.
      getBounds: function() {
        var n = [this._radius, this._radiusY || this._radius];
        return new De(
          this._map.layerPointToLatLng(this._point.subtract(n)),
          this._map.layerPointToLatLng(this._point.add(n))
        );
      },
      setStyle: Kt.prototype.setStyle,
      _project: function() {
        var n = this._latlng.lng, l = this._latlng.lat, c = this._map, h = c.options.crs;
        if (h.distance === Ht.distance) {
          var f = Math.PI / 180, y = this._mRadius / Ht.R / f, S = c.project([l + y, n]), E = c.project([l - y, n]), M = S.add(E).divideBy(2), q = c.unproject(M).lat, K = Math.acos((Math.cos(y * f) - Math.sin(l * f) * Math.sin(q * f)) / (Math.cos(l * f) * Math.cos(q * f))) / f;
          (isNaN(K) || K === 0) && (K = y / Math.cos(Math.PI / 180 * l)), this._point = M.subtract(c.getPixelOrigin()), this._radius = isNaN(K) ? 0 : M.x - c.project([q, n - K]).x, this._radiusY = M.y - S.y;
        } else {
          var le = h.unproject(h.project(this._latlng).subtract([this._mRadius, 0]));
          this._point = c.latLngToLayerPoint(this._latlng), this._radius = this._point.x - c.latLngToLayerPoint(le).x;
        }
        this._updateBounds();
      }
    });
    function xd(n, l, c) {
      return new _n(n, l, c);
    }
    var Ut = Kt.extend({
      // @section
      // @aka Polyline options
      options: {
        // @option smoothFactor: Number = 1.0
        // How much to simplify the polyline on each zoom level. More means
        // better performance and smoother look, and less means more accurate representation.
        smoothFactor: 1,
        // @option noClip: Boolean = false
        // Disable polyline clipping.
        noClip: !1
      },
      initialize: function(n, l) {
        P(this, l), this._setLatLngs(n);
      },
      // @method getLatLngs(): LatLng[]
      // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
      getLatLngs: function() {
        return this._latlngs;
      },
      // @method setLatLngs(latlngs: LatLng[]): this
      // Replaces all the points in the polyline with the given array of geographical points.
      setLatLngs: function(n) {
        return this._setLatLngs(n), this.redraw();
      },
      // @method isEmpty(): Boolean
      // Returns `true` if the Polyline has no LatLngs.
      isEmpty: function() {
        return !this._latlngs.length;
      },
      // @method closestLayerPoint(p: Point): Point
      // Returns the point closest to `p` on the Polyline.
      closestLayerPoint: function(n) {
        for (var l = 1 / 0, c = null, h = is, f, y, S = 0, E = this._parts.length; S < E; S++)
          for (var M = this._parts[S], q = 1, K = M.length; q < K; q++) {
            f = M[q - 1], y = M[q];
            var le = h(n, f, y, !0);
            le < l && (l = le, c = h(n, f, y));
          }
        return c && (c.distance = Math.sqrt(l)), c;
      },
      // @method getCenter(): LatLng
      // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
      getCenter: function() {
        if (!this._map)
          throw new Error("Must add layer to map before using getCenter()");
        return Fa(this._defaultShape(), this._map.options.crs);
      },
      // @method getBounds(): LatLngBounds
      // Returns the `LatLngBounds` of the path.
      getBounds: function() {
        return this._bounds;
      },
      // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
      // Adds a given point to the polyline. By default, adds to the first ring of
      // the polyline in case of a multi-polyline, but can be overridden by passing
      // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
      addLatLng: function(n, l) {
        return l = l || this._defaultShape(), n = ve(n), l.push(n), this._bounds.extend(n), this.redraw();
      },
      _setLatLngs: function(n) {
        this._bounds = new De(), this._latlngs = this._convertLatLngs(n);
      },
      _defaultShape: function() {
        return pt(this._latlngs) ? this._latlngs : this._latlngs[0];
      },
      // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
      _convertLatLngs: function(n) {
        for (var l = [], c = pt(n), h = 0, f = n.length; h < f; h++)
          c ? (l[h] = ve(n[h]), this._bounds.extend(l[h])) : l[h] = this._convertLatLngs(n[h]);
        return l;
      },
      _project: function() {
        var n = new Q();
        this._rings = [], this._projectLatlngs(this._latlngs, this._rings, n), this._bounds.isValid() && n.isValid() && (this._rawPxBounds = n, this._updateBounds());
      },
      _updateBounds: function() {
        var n = this._clickTolerance(), l = new ue(n, n);
        this._rawPxBounds && (this._pxBounds = new Q([
          this._rawPxBounds.min.subtract(l),
          this._rawPxBounds.max.add(l)
        ]));
      },
      // recursively turns latlngs into a set of rings with projected coordinates
      _projectLatlngs: function(n, l, c) {
        var h = n[0] instanceof Ce, f = n.length, y, S;
        if (h) {
          for (S = [], y = 0; y < f; y++)
            S[y] = this._map.latLngToLayerPoint(n[y]), c.extend(S[y]);
          l.push(S);
        } else
          for (y = 0; y < f; y++)
            this._projectLatlngs(n[y], l, c);
      },
      // clip polyline by renderer bounds so that we have less to render for performance
      _clipPoints: function() {
        var n = this._renderer._bounds;
        if (this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(n))) {
          if (this.options.noClip) {
            this._parts = this._rings;
            return;
          }
          var l = this._parts, c, h, f, y, S, E, M;
          for (c = 0, f = 0, y = this._rings.length; c < y; c++)
            for (M = this._rings[c], h = 0, S = M.length; h < S - 1; h++)
              E = Va(M[h], M[h + 1], n, h, !0), E && (l[f] = l[f] || [], l[f].push(E[0]), (E[1] !== M[h + 1] || h === S - 2) && (l[f].push(E[1]), f++));
        }
      },
      // simplify each clipped part of the polyline for performance
      _simplifyPoints: function() {
        for (var n = this._parts, l = this.options.smoothFactor, c = 0, h = n.length; c < h; c++)
          n[c] = za(n[c], l);
      },
      _update: function() {
        this._map && (this._clipPoints(), this._simplifyPoints(), this._updatePath());
      },
      _updatePath: function() {
        this._renderer._updatePoly(this);
      },
      // Needed by the `Canvas` renderer for interactivity
      _containsPoint: function(n, l) {
        var c, h, f, y, S, E, M = this._clickTolerance();
        if (!this._pxBounds || !this._pxBounds.contains(n))
          return !1;
        for (c = 0, y = this._parts.length; c < y; c++)
          for (E = this._parts[c], h = 0, S = E.length, f = S - 1; h < S; f = h++)
            if (!(!l && h === 0) && qa(n, E[f], E[h]) <= M)
              return !0;
        return !1;
      }
    });
    function Sd(n, l) {
      return new Ut(n, l);
    }
    Ut._flat = $a;
    var Or = Ut.extend({
      options: {
        fill: !0
      },
      isEmpty: function() {
        return !this._latlngs.length || !this._latlngs[0].length;
      },
      // @method getCenter(): LatLng
      // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
      getCenter: function() {
        if (!this._map)
          throw new Error("Must add layer to map before using getCenter()");
        return Ra(this._defaultShape(), this._map.options.crs);
      },
      _convertLatLngs: function(n) {
        var l = Ut.prototype._convertLatLngs.call(this, n), c = l.length;
        return c >= 2 && l[0] instanceof Ce && l[0].equals(l[c - 1]) && l.pop(), l;
      },
      _setLatLngs: function(n) {
        Ut.prototype._setLatLngs.call(this, n), pt(this._latlngs) && (this._latlngs = [this._latlngs]);
      },
      _defaultShape: function() {
        return pt(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
      },
      _clipPoints: function() {
        var n = this._renderer._bounds, l = this.options.weight, c = new ue(l, l);
        if (n = new Q(n.min.subtract(c), n.max.add(c)), this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(n))) {
          if (this.options.noClip) {
            this._parts = this._rings;
            return;
          }
          for (var h = 0, f = this._rings.length, y; h < f; h++)
            y = Ba(this._rings[h], n, !0), y.length && this._parts.push(y);
        }
      },
      _updatePath: function() {
        this._renderer._updatePoly(this, !0);
      },
      // Needed by the `Canvas` renderer for interactivity
      _containsPoint: function(n) {
        var l = !1, c, h, f, y, S, E, M, q;
        if (!this._pxBounds || !this._pxBounds.contains(n))
          return !1;
        for (y = 0, M = this._parts.length; y < M; y++)
          for (c = this._parts[y], S = 0, q = c.length, E = q - 1; S < q; E = S++)
            h = c[S], f = c[E], h.y > n.y != f.y > n.y && n.x < (f.x - h.x) * (n.y - h.y) / (f.y - h.y) + h.x && (l = !l);
        return l || Ut.prototype._containsPoint.call(this, n, !0);
      }
    });
    function Td(n, l) {
      return new Or(n, l);
    }
    var Bt = Jt.extend({
      /* @section
       * @aka GeoJSON options
       *
       * @option pointToLayer: Function = *
       * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
       * called when data is added, passing the GeoJSON point feature and its `LatLng`.
       * The default is to spawn a default `Marker`:
       * ```js
       * function(geoJsonPoint, latlng) {
       * 	return L.marker(latlng);
       * }
       * ```
       *
       * @option style: Function = *
       * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
       * called internally when data is added.
       * The default value is to not override any defaults:
       * ```js
       * function (geoJsonFeature) {
       * 	return {}
       * }
       * ```
       *
       * @option onEachFeature: Function = *
       * A `Function` that will be called once for each created `Feature`, after it has
       * been created and styled. Useful for attaching events and popups to features.
       * The default is to do nothing with the newly created layers:
       * ```js
       * function (feature, layer) {}
       * ```
       *
       * @option filter: Function = *
       * A `Function` that will be used to decide whether to include a feature or not.
       * The default is to include all features:
       * ```js
       * function (geoJsonFeature) {
       * 	return true;
       * }
       * ```
       * Note: dynamically changing the `filter` option will have effect only on newly
       * added data. It will _not_ re-evaluate already included features.
       *
       * @option coordsToLatLng: Function = *
       * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
       * The default is the `coordsToLatLng` static method.
       *
       * @option markersInheritOptions: Boolean = false
       * Whether default Markers for "Point" type Features inherit from group options.
       */
      initialize: function(n, l) {
        P(this, l), this._layers = {}, n && this.addData(n);
      },
      // @method addData( <GeoJSON> data ): this
      // Adds a GeoJSON object to the layer.
      addData: function(n) {
        var l = C(n) ? n : n.features, c, h, f;
        if (l) {
          for (c = 0, h = l.length; c < h; c++)
            f = l[c], (f.geometries || f.geometry || f.features || f.coordinates) && this.addData(f);
          return this;
        }
        var y = this.options;
        if (y.filter && !y.filter(n))
          return this;
        var S = zs(n, y);
        return S ? (S.feature = Vs(n), S.defaultOptions = S.options, this.resetStyle(S), y.onEachFeature && y.onEachFeature(n, S), this.addLayer(S)) : this;
      },
      // @method resetStyle( <Path> layer? ): this
      // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
      // If `layer` is omitted, the style of all features in the current layer is reset.
      resetStyle: function(n) {
        return n === void 0 ? this.eachLayer(this.resetStyle, this) : (n.options = r({}, n.defaultOptions), this._setLayerStyle(n, this.options.style), this);
      },
      // @method setStyle( <Function> style ): this
      // Changes styles of GeoJSON vector layers with the given style function.
      setStyle: function(n) {
        return this.eachLayer(function(l) {
          this._setLayerStyle(l, n);
        }, this);
      },
      _setLayerStyle: function(n, l) {
        n.setStyle && (typeof l == "function" && (l = l(n.feature)), n.setStyle(l));
      }
    });
    function zs(n, l) {
      var c = n.type === "Feature" ? n.geometry : n, h = c ? c.coordinates : null, f = [], y = l && l.pointToLayer, S = l && l.coordsToLatLng || bn, E, M, q, K;
      if (!h && !c)
        return null;
      switch (c.type) {
        case "Point":
          return E = S(h), Wa(y, n, E, l);
        case "MultiPoint":
          for (q = 0, K = h.length; q < K; q++)
            E = S(h[q]), f.push(Wa(y, n, E, l));
          return new Jt(f);
        case "LineString":
        case "MultiLineString":
          return M = qs(h, c.type === "LineString" ? 0 : 1, S), new Ut(M, l);
        case "Polygon":
        case "MultiPolygon":
          return M = qs(h, c.type === "Polygon" ? 1 : 2, S), new Or(M, l);
        case "GeometryCollection":
          for (q = 0, K = c.geometries.length; q < K; q++) {
            var le = zs({
              geometry: c.geometries[q],
              type: "Feature",
              properties: n.properties
            }, l);
            le && f.push(le);
          }
          return new Jt(f);
        case "FeatureCollection":
          for (q = 0, K = c.features.length; q < K; q++) {
            var ye = zs(c.features[q], l);
            ye && f.push(ye);
          }
          return new Jt(f);
        default:
          throw new Error("Invalid GeoJSON object.");
      }
    }
    function Wa(n, l, c, h) {
      return n ? n(l, c) : new Bs(c, h && h.markersInheritOptions && h);
    }
    function bn(n) {
      return new Ce(n[1], n[0], n[2]);
    }
    function qs(n, l, c) {
      for (var h = [], f = 0, y = n.length, S; f < y; f++)
        S = l ? qs(n[f], l - 1, c) : (c || bn)(n[f]), h.push(S);
      return h;
    }
    function wn(n, l) {
      return n = ve(n), n.alt !== void 0 ? [g(n.lng, l), g(n.lat, l), g(n.alt, l)] : [g(n.lng, l), g(n.lat, l)];
    }
    function Zs(n, l, c, h) {
      for (var f = [], y = 0, S = n.length; y < S; y++)
        f.push(l ? Zs(n[y], pt(n[y]) ? 0 : l - 1, c, h) : wn(n[y], h));
      return !l && c && f.length > 0 && f.push(f[0].slice()), f;
    }
    function kr(n, l) {
      return n.feature ? r({}, n.feature, { geometry: l }) : Vs(l);
    }
    function Vs(n) {
      return n.type === "Feature" || n.type === "FeatureCollection" ? n : {
        type: "Feature",
        properties: {},
        geometry: n
      };
    }
    var Pn = {
      toGeoJSON: function(n) {
        return kr(this, {
          type: "Point",
          coordinates: wn(this.getLatLng(), n)
        });
      }
    };
    Bs.include(Pn), _n.include(Pn), Rs.include(Pn), Ut.include({
      toGeoJSON: function(n) {
        var l = !pt(this._latlngs), c = Zs(this._latlngs, l ? 1 : 0, !1, n);
        return kr(this, {
          type: (l ? "Multi" : "") + "LineString",
          coordinates: c
        });
      }
    }), Or.include({
      toGeoJSON: function(n) {
        var l = !pt(this._latlngs), c = l && !pt(this._latlngs[0]), h = Zs(this._latlngs, c ? 2 : l ? 1 : 0, !0, n);
        return l || (h = [h]), kr(this, {
          type: (c ? "Multi" : "") + "Polygon",
          coordinates: h
        });
      }
    }), Cr.include({
      toMultiPoint: function(n) {
        var l = [];
        return this.eachLayer(function(c) {
          l.push(c.toGeoJSON(n).geometry.coordinates);
        }), kr(this, {
          type: "MultiPoint",
          coordinates: l
        });
      },
      // @method toGeoJSON(precision?: Number|false): Object
      // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
      // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
      toGeoJSON: function(n) {
        var l = this.feature && this.feature.geometry && this.feature.geometry.type;
        if (l === "MultiPoint")
          return this.toMultiPoint(n);
        var c = l === "GeometryCollection", h = [];
        return this.eachLayer(function(f) {
          if (f.toGeoJSON) {
            var y = f.toGeoJSON(n);
            if (c)
              h.push(y.geometry);
            else {
              var S = Vs(y);
              S.type === "FeatureCollection" ? h.push.apply(h, S.features) : h.push(S);
            }
          }
        }), c ? kr(this, {
          geometries: h,
          type: "GeometryCollection"
        }) : {
          type: "FeatureCollection",
          features: h
        };
      }
    });
    function Ka(n, l) {
      return new Bt(n, l);
    }
    var Ld = Ka, $s = Pt.extend({
      // @section
      // @aka ImageOverlay options
      options: {
        // @option opacity: Number = 1.0
        // The opacity of the image overlay.
        opacity: 1,
        // @option alt: String = ''
        // Text for the `alt` attribute of the image (useful for accessibility).
        alt: "",
        // @option interactive: Boolean = false
        // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
        interactive: !1,
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the image.
        // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: !1,
        // @option errorOverlayUrl: String = ''
        // URL to the overlay image to show in place of the overlay that failed to load.
        errorOverlayUrl: "",
        // @option zIndex: Number = 1
        // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
        zIndex: 1,
        // @option className: String = ''
        // A custom class name to assign to the image. Empty by default.
        className: ""
      },
      initialize: function(n, l, c) {
        this._url = n, this._bounds = Le(l), P(this, c);
      },
      onAdd: function() {
        this._image || (this._initImage(), this.options.opacity < 1 && this._updateOpacity()), this.options.interactive && (me(this._image, "leaflet-interactive"), this.addInteractiveTarget(this._image)), this.getPane().appendChild(this._image), this._reset();
      },
      onRemove: function() {
        Re(this._image), this.options.interactive && this.removeInteractiveTarget(this._image);
      },
      // @method setOpacity(opacity: Number): this
      // Sets the opacity of the overlay.
      setOpacity: function(n) {
        return this.options.opacity = n, this._image && this._updateOpacity(), this;
      },
      setStyle: function(n) {
        return n.opacity && this.setOpacity(n.opacity), this;
      },
      // @method bringToFront(): this
      // Brings the layer to the top of all overlays.
      bringToFront: function() {
        return this._map && Tr(this._image), this;
      },
      // @method bringToBack(): this
      // Brings the layer to the bottom of all overlays.
      bringToBack: function() {
        return this._map && Lr(this._image), this;
      },
      // @method setUrl(url: String): this
      // Changes the URL of the image.
      setUrl: function(n) {
        return this._url = n, this._image && (this._image.src = n), this;
      },
      // @method setBounds(bounds: LatLngBounds): this
      // Update the bounds that this ImageOverlay covers
      setBounds: function(n) {
        return this._bounds = Le(n), this._map && this._reset(), this;
      },
      getEvents: function() {
        var n = {
          zoom: this._reset,
          viewreset: this._reset
        };
        return this._zoomAnimated && (n.zoomanim = this._animateZoom), n;
      },
      // @method setZIndex(value: Number): this
      // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
      setZIndex: function(n) {
        return this.options.zIndex = n, this._updateZIndex(), this;
      },
      // @method getBounds(): LatLngBounds
      // Get the bounds that this ImageOverlay covers
      getBounds: function() {
        return this._bounds;
      },
      // @method getElement(): HTMLElement
      // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
      // used by this overlay.
      getElement: function() {
        return this._image;
      },
      _initImage: function() {
        var n = this._url.tagName === "IMG", l = this._image = n ? this._url : Ae("img");
        if (me(l, "leaflet-image-layer"), this._zoomAnimated && me(l, "leaflet-zoom-animated"), this.options.className && me(l, this.options.className), l.onselectstart = p, l.onmousemove = p, l.onload = i(this.fire, this, "load"), l.onerror = i(this._overlayOnError, this, "error"), (this.options.crossOrigin || this.options.crossOrigin === "") && (l.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), this.options.zIndex && this._updateZIndex(), n) {
          this._url = l.src;
          return;
        }
        l.src = this._url, l.alt = this.options.alt;
      },
      _animateZoom: function(n) {
        var l = this._map.getZoomScale(n.zoom), c = this._map._latLngBoundsToNewLayerBounds(this._bounds, n.zoom, n.center).min;
        sr(this._image, c, l);
      },
      _reset: function() {
        var n = this._image, l = new Q(
          this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
          this._map.latLngToLayerPoint(this._bounds.getSouthEast())
        ), c = l.getSize();
        Ge(n, l.min), n.style.width = c.x + "px", n.style.height = c.y + "px";
      },
      _updateOpacity: function() {
        ft(this._image, this.options.opacity);
      },
      _updateZIndex: function() {
        this._image && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._image.style.zIndex = this.options.zIndex);
      },
      _overlayOnError: function() {
        this.fire("error");
        var n = this.options.errorOverlayUrl;
        n && this._url !== n && (this._url = n, this._image.src = n);
      },
      // @method getCenter(): LatLng
      // Returns the center of the ImageOverlay.
      getCenter: function() {
        return this._bounds.getCenter();
      }
    }), Cd = function(n, l, c) {
      return new $s(n, l, c);
    }, Qa = $s.extend({
      // @section
      // @aka VideoOverlay options
      options: {
        // @option autoplay: Boolean = true
        // Whether the video starts playing automatically when loaded.
        // On some browsers autoplay will only work with `muted: true`
        autoplay: !0,
        // @option loop: Boolean = true
        // Whether the video will loop back to the beginning when played.
        loop: !0,
        // @option keepAspectRatio: Boolean = true
        // Whether the video will save aspect ratio after the projection.
        // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
        keepAspectRatio: !0,
        // @option muted: Boolean = false
        // Whether the video starts on mute when loaded.
        muted: !1,
        // @option playsInline: Boolean = true
        // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
        playsInline: !0
      },
      _initImage: function() {
        var n = this._url.tagName === "VIDEO", l = this._image = n ? this._url : Ae("video");
        if (me(l, "leaflet-image-layer"), this._zoomAnimated && me(l, "leaflet-zoom-animated"), this.options.className && me(l, this.options.className), l.onselectstart = p, l.onmousemove = p, l.onloadeddata = i(this.fire, this, "load"), n) {
          for (var c = l.getElementsByTagName("source"), h = [], f = 0; f < c.length; f++)
            h.push(c[f].src);
          this._url = c.length > 0 ? h : [l.src];
          return;
        }
        C(this._url) || (this._url = [this._url]), !this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(l.style, "objectFit") && (l.style.objectFit = "fill"), l.autoplay = !!this.options.autoplay, l.loop = !!this.options.loop, l.muted = !!this.options.muted, l.playsInline = !!this.options.playsInline;
        for (var y = 0; y < this._url.length; y++) {
          var S = Ae("source");
          S.src = this._url[y], l.appendChild(S);
        }
      }
      // @method getElement(): HTMLVideoElement
      // Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
      // used by this overlay.
    });
    function Ad(n, l, c) {
      return new Qa(n, l, c);
    }
    var Ya = $s.extend({
      _initImage: function() {
        var n = this._image = this._url;
        me(n, "leaflet-image-layer"), this._zoomAnimated && me(n, "leaflet-zoom-animated"), this.options.className && me(n, this.options.className), n.onselectstart = p, n.onmousemove = p;
      }
      // @method getElement(): SVGElement
      // Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
      // used by this overlay.
    });
    function Od(n, l, c) {
      return new Ya(n, l, c);
    }
    var jt = Pt.extend({
      // @section
      // @aka DivOverlay options
      options: {
        // @option interactive: Boolean = false
        // If true, the popup/tooltip will listen to the mouse events.
        interactive: !1,
        // @option offset: Point = Point(0, 0)
        // The offset of the overlay position.
        offset: [0, 0],
        // @option className: String = ''
        // A custom CSS class name to assign to the overlay.
        className: "",
        // @option pane: String = undefined
        // `Map pane` where the overlay will be added.
        pane: void 0,
        // @option content: String|HTMLElement|Function = ''
        // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
        // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
        content: ""
      },
      initialize: function(n, l) {
        n && (n instanceof Ce || C(n)) ? (this._latlng = ve(n), P(this, l)) : (P(this, n), this._source = l), this.options.content && (this._content = this.options.content);
      },
      // @method openOn(map: Map): this
      // Adds the overlay to the map.
      // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
      openOn: function(n) {
        return n = arguments.length ? n : this._source._map, n.hasLayer(this) || n.addLayer(this), this;
      },
      // @method close(): this
      // Closes the overlay.
      // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
      // and `layer.closePopup()`/`.closeTooltip()`.
      close: function() {
        return this._map && this._map.removeLayer(this), this;
      },
      // @method toggle(layer?: Layer): this
      // Opens or closes the overlay bound to layer depending on its current state.
      // Argument may be omitted only for overlay bound to layer.
      // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
      toggle: function(n) {
        return this._map ? this.close() : (arguments.length ? this._source = n : n = this._source, this._prepareOpen(), this.openOn(n._map)), this;
      },
      onAdd: function(n) {
        this._zoomAnimated = n._zoomAnimated, this._container || this._initLayout(), n._fadeAnimated && ft(this._container, 0), clearTimeout(this._removeTimeout), this.getPane().appendChild(this._container), this.update(), n._fadeAnimated && ft(this._container, 1), this.bringToFront(), this.options.interactive && (me(this._container, "leaflet-interactive"), this.addInteractiveTarget(this._container));
      },
      onRemove: function(n) {
        n._fadeAnimated ? (ft(this._container, 0), this._removeTimeout = setTimeout(i(Re, void 0, this._container), 200)) : Re(this._container), this.options.interactive && (Ve(this._container, "leaflet-interactive"), this.removeInteractiveTarget(this._container));
      },
      // @namespace DivOverlay
      // @method getLatLng: LatLng
      // Returns the geographical point of the overlay.
      getLatLng: function() {
        return this._latlng;
      },
      // @method setLatLng(latlng: LatLng): this
      // Sets the geographical point where the overlay will open.
      setLatLng: function(n) {
        return this._latlng = ve(n), this._map && (this._updatePosition(), this._adjustPan()), this;
      },
      // @method getContent: String|HTMLElement
      // Returns the content of the overlay.
      getContent: function() {
        return this._content;
      },
      // @method setContent(htmlContent: String|HTMLElement|Function): this
      // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
      // The function should return a `String` or `HTMLElement` to be used in the overlay.
      setContent: function(n) {
        return this._content = n, this.update(), this;
      },
      // @method getElement: String|HTMLElement
      // Returns the HTML container of the overlay.
      getElement: function() {
        return this._container;
      },
      // @method update: null
      // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
      update: function() {
        this._map && (this._container.style.visibility = "hidden", this._updateContent(), this._updateLayout(), this._updatePosition(), this._container.style.visibility = "", this._adjustPan());
      },
      getEvents: function() {
        var n = {
          zoom: this._updatePosition,
          viewreset: this._updatePosition
        };
        return this._zoomAnimated && (n.zoomanim = this._animateZoom), n;
      },
      // @method isOpen: Boolean
      // Returns `true` when the overlay is visible on the map.
      isOpen: function() {
        return !!this._map && this._map.hasLayer(this);
      },
      // @method bringToFront: this
      // Brings this overlay in front of other overlays (in the same map pane).
      bringToFront: function() {
        return this._map && Tr(this._container), this;
      },
      // @method bringToBack: this
      // Brings this overlay to the back of other overlays (in the same map pane).
      bringToBack: function() {
        return this._map && Lr(this._container), this;
      },
      // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
      _prepareOpen: function(n) {
        var l = this._source;
        if (!l._map)
          return !1;
        if (l instanceof Jt) {
          l = null;
          var c = this._source._layers;
          for (var h in c)
            if (c[h]._map) {
              l = c[h];
              break;
            }
          if (!l)
            return !1;
          this._source = l;
        }
        if (!n)
          if (l.getCenter)
            n = l.getCenter();
          else if (l.getLatLng)
            n = l.getLatLng();
          else if (l.getBounds)
            n = l.getBounds().getCenter();
          else
            throw new Error("Unable to get source layer LatLng.");
        return this.setLatLng(n), this._map && this.update(), !0;
      },
      _updateContent: function() {
        if (this._content) {
          var n = this._contentNode, l = typeof this._content == "function" ? this._content(this._source || this) : this._content;
          if (typeof l == "string")
            n.innerHTML = l;
          else {
            for (; n.hasChildNodes(); )
              n.removeChild(n.firstChild);
            n.appendChild(l);
          }
          this.fire("contentupdate");
        }
      },
      _updatePosition: function() {
        if (this._map) {
          var n = this._map.latLngToLayerPoint(this._latlng), l = J(this.options.offset), c = this._getAnchor();
          this._zoomAnimated ? Ge(this._container, n.add(c)) : l = l.add(n).add(c);
          var h = this._containerBottom = -l.y, f = this._containerLeft = -Math.round(this._containerWidth / 2) + l.x;
          this._container.style.bottom = h + "px", this._container.style.left = f + "px";
        }
      },
      _getAnchor: function() {
        return [0, 0];
      }
    });
    xe.include({
      _initOverlay: function(n, l, c, h) {
        var f = l;
        return f instanceof n || (f = new n(h).setContent(l)), c && f.setLatLng(c), f;
      }
    }), Pt.include({
      _initOverlay: function(n, l, c, h) {
        var f = c;
        return f instanceof n ? (P(f, h), f._source = this) : (f = l && !h ? l : new n(h, this), f.setContent(c)), f;
      }
    });
    var Fs = jt.extend({
      // @section
      // @aka Popup options
      options: {
        // @option pane: String = 'popupPane'
        // `Map pane` where the popup will be added.
        pane: "popupPane",
        // @option offset: Point = Point(0, 7)
        // The offset of the popup position.
        offset: [0, 7],
        // @option maxWidth: Number = 300
        // Max width of the popup, in pixels.
        maxWidth: 300,
        // @option minWidth: Number = 50
        // Min width of the popup, in pixels.
        minWidth: 50,
        // @option maxHeight: Number = null
        // If set, creates a scrollable container of the given height
        // inside a popup if its content exceeds it.
        // The scrollable container can be styled using the
        // `leaflet-popup-scrolled` CSS class selector.
        maxHeight: null,
        // @option autoPan: Boolean = true
        // Set it to `false` if you don't want the map to do panning animation
        // to fit the opened popup.
        autoPan: !0,
        // @option autoPanPaddingTopLeft: Point = null
        // The margin between the popup and the top left corner of the map
        // view after autopanning was performed.
        autoPanPaddingTopLeft: null,
        // @option autoPanPaddingBottomRight: Point = null
        // The margin between the popup and the bottom right corner of the map
        // view after autopanning was performed.
        autoPanPaddingBottomRight: null,
        // @option autoPanPadding: Point = Point(5, 5)
        // Equivalent of setting both top left and bottom right autopan padding to the same value.
        autoPanPadding: [5, 5],
        // @option keepInView: Boolean = false
        // Set it to `true` if you want to prevent users from panning the popup
        // off of the screen while it is open.
        keepInView: !1,
        // @option closeButton: Boolean = true
        // Controls the presence of a close button in the popup.
        closeButton: !0,
        // @option autoClose: Boolean = true
        // Set it to `false` if you want to override the default behavior of
        // the popup closing when another popup is opened.
        autoClose: !0,
        // @option closeOnEscapeKey: Boolean = true
        // Set it to `false` if you want to override the default behavior of
        // the ESC key for closing of the popup.
        closeOnEscapeKey: !0,
        // @option closeOnClick: Boolean = *
        // Set it if you want to override the default behavior of the popup closing when user clicks
        // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
        // @option className: String = ''
        // A custom CSS class name to assign to the popup.
        className: ""
      },
      // @namespace Popup
      // @method openOn(map: Map): this
      // Alternative to `map.openPopup(popup)`.
      // Adds the popup to the map and closes the previous one.
      openOn: function(n) {
        return n = arguments.length ? n : this._source._map, !n.hasLayer(this) && n._popup && n._popup.options.autoClose && n.removeLayer(n._popup), n._popup = this, jt.prototype.openOn.call(this, n);
      },
      onAdd: function(n) {
        jt.prototype.onAdd.call(this, n), n.fire("popupopen", { popup: this }), this._source && (this._source.fire("popupopen", { popup: this }, !0), this._source instanceof Kt || this._source.on("preclick", nr));
      },
      onRemove: function(n) {
        jt.prototype.onRemove.call(this, n), n.fire("popupclose", { popup: this }), this._source && (this._source.fire("popupclose", { popup: this }, !0), this._source instanceof Kt || this._source.off("preclick", nr));
      },
      getEvents: function() {
        var n = jt.prototype.getEvents.call(this);
        return (this.options.closeOnClick !== void 0 ? this.options.closeOnClick : this._map.options.closePopupOnClick) && (n.preclick = this.close), this.options.keepInView && (n.moveend = this._adjustPan), n;
      },
      _initLayout: function() {
        var n = "leaflet-popup", l = this._container = Ae(
          "div",
          n + " " + (this.options.className || "") + " leaflet-zoom-animated"
        ), c = this._wrapper = Ae("div", n + "-content-wrapper", l);
        if (this._contentNode = Ae("div", n + "-content", c), rs(l), hn(this._contentNode), fe(l, "contextmenu", nr), this._tipContainer = Ae("div", n + "-tip-container", l), this._tip = Ae("div", n + "-tip", this._tipContainer), this.options.closeButton) {
          var h = this._closeButton = Ae("a", n + "-close-button", l);
          h.setAttribute("role", "button"), h.setAttribute("aria-label", "Close popup"), h.href = "#close", h.innerHTML = '<span aria-hidden="true">&#215;</span>', fe(h, "click", function(f) {
            tt(f), this.close();
          }, this);
        }
      },
      _updateLayout: function() {
        var n = this._contentNode, l = n.style;
        l.width = "", l.whiteSpace = "nowrap";
        var c = n.offsetWidth;
        c = Math.min(c, this.options.maxWidth), c = Math.max(c, this.options.minWidth), l.width = c + 1 + "px", l.whiteSpace = "", l.height = "";
        var h = n.offsetHeight, f = this.options.maxHeight, y = "leaflet-popup-scrolled";
        f && h > f ? (l.height = f + "px", me(n, y)) : Ve(n, y), this._containerWidth = this._container.offsetWidth;
      },
      _animateZoom: function(n) {
        var l = this._map._latLngToNewLayerPoint(this._latlng, n.zoom, n.center), c = this._getAnchor();
        Ge(this._container, l.add(c));
      },
      _adjustPan: function() {
        if (this.options.autoPan) {
          if (this._map._panAnim && this._map._panAnim.stop(), this._autopanning) {
            this._autopanning = !1;
            return;
          }
          var n = this._map, l = parseInt(Yr(this._container, "marginBottom"), 10) || 0, c = this._container.offsetHeight + l, h = this._containerWidth, f = new ue(this._containerLeft, -c - this._containerBottom);
          f._add(ir(this._container));
          var y = n.layerPointToContainerPoint(f), S = J(this.options.autoPanPadding), E = J(this.options.autoPanPaddingTopLeft || S), M = J(this.options.autoPanPaddingBottomRight || S), q = n.getSize(), K = 0, le = 0;
          y.x + h + M.x > q.x && (K = y.x + h - q.x + M.x), y.x - K - E.x < 0 && (K = y.x - E.x), y.y + c + M.y > q.y && (le = y.y + c - q.y + M.y), y.y - le - E.y < 0 && (le = y.y - E.y), (K || le) && (this.options.keepInView && (this._autopanning = !0), n.fire("autopanstart").panBy([K, le]));
        }
      },
      _getAnchor: function() {
        return J(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
      }
    }), kd = function(n, l) {
      return new Fs(n, l);
    };
    xe.mergeOptions({
      closePopupOnClick: !0
    }), xe.include({
      // @method openPopup(popup: Popup): this
      // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
      // @alternative
      // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
      // Creates a popup with the specified content and options and opens it in the given point on a map.
      openPopup: function(n, l, c) {
        return this._initOverlay(Fs, n, l, c).openOn(this), this;
      },
      // @method closePopup(popup?: Popup): this
      // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
      closePopup: function(n) {
        return n = arguments.length ? n : this._popup, n && n.close(), this;
      }
    }), Pt.include({
      // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
      // Binds a popup to the layer with the passed `content` and sets up the
      // necessary event listeners. If a `Function` is passed it will receive
      // the layer as the first argument and should return a `String` or `HTMLElement`.
      bindPopup: function(n, l) {
        return this._popup = this._initOverlay(Fs, this._popup, n, l), this._popupHandlersAdded || (this.on({
          click: this._openPopup,
          keypress: this._onKeyPress,
          remove: this.closePopup,
          move: this._movePopup
        }), this._popupHandlersAdded = !0), this;
      },
      // @method unbindPopup(): this
      // Removes the popup previously bound with `bindPopup`.
      unbindPopup: function() {
        return this._popup && (this.off({
          click: this._openPopup,
          keypress: this._onKeyPress,
          remove: this.closePopup,
          move: this._movePopup
        }), this._popupHandlersAdded = !1, this._popup = null), this;
      },
      // @method openPopup(latlng?: LatLng): this
      // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
      openPopup: function(n) {
        return this._popup && (this instanceof Jt || (this._popup._source = this), this._popup._prepareOpen(n || this._latlng) && this._popup.openOn(this._map)), this;
      },
      // @method closePopup(): this
      // Closes the popup bound to this layer if it is open.
      closePopup: function() {
        return this._popup && this._popup.close(), this;
      },
      // @method togglePopup(): this
      // Opens or closes the popup bound to this layer depending on its current state.
      togglePopup: function() {
        return this._popup && this._popup.toggle(this), this;
      },
      // @method isPopupOpen(): boolean
      // Returns `true` if the popup bound to this layer is currently open.
      isPopupOpen: function() {
        return this._popup ? this._popup.isOpen() : !1;
      },
      // @method setPopupContent(content: String|HTMLElement|Popup): this
      // Sets the content of the popup bound to this layer.
      setPopupContent: function(n) {
        return this._popup && this._popup.setContent(n), this;
      },
      // @method getPopup(): Popup
      // Returns the popup bound to this layer.
      getPopup: function() {
        return this._popup;
      },
      _openPopup: function(n) {
        if (!(!this._popup || !this._map)) {
          or(n);
          var l = n.layer || n.target;
          if (this._popup._source === l && !(l instanceof Kt)) {
            this._map.hasLayer(this._popup) ? this.closePopup() : this.openPopup(n.latlng);
            return;
          }
          this._popup._source = l, this.openPopup(n.latlng);
        }
      },
      _movePopup: function(n) {
        this._popup.setLatLng(n.latlng);
      },
      _onKeyPress: function(n) {
        n.originalEvent.keyCode === 13 && this._openPopup(n);
      }
    });
    var Gs = jt.extend({
      // @section
      // @aka Tooltip options
      options: {
        // @option pane: String = 'tooltipPane'
        // `Map pane` where the tooltip will be added.
        pane: "tooltipPane",
        // @option offset: Point = Point(0, 0)
        // Optional offset of the tooltip position.
        offset: [0, 0],
        // @option direction: String = 'auto'
        // Direction where to open the tooltip. Possible values are: `right`, `left`,
        // `top`, `bottom`, `center`, `auto`.
        // `auto` will dynamically switch between `right` and `left` according to the tooltip
        // position on the map.
        direction: "auto",
        // @option permanent: Boolean = false
        // Whether to open the tooltip permanently or only on mouseover.
        permanent: !1,
        // @option sticky: Boolean = false
        // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
        sticky: !1,
        // @option opacity: Number = 0.9
        // Tooltip container opacity.
        opacity: 0.9
      },
      onAdd: function(n) {
        jt.prototype.onAdd.call(this, n), this.setOpacity(this.options.opacity), n.fire("tooltipopen", { tooltip: this }), this._source && (this.addEventParent(this._source), this._source.fire("tooltipopen", { tooltip: this }, !0));
      },
      onRemove: function(n) {
        jt.prototype.onRemove.call(this, n), n.fire("tooltipclose", { tooltip: this }), this._source && (this.removeEventParent(this._source), this._source.fire("tooltipclose", { tooltip: this }, !0));
      },
      getEvents: function() {
        var n = jt.prototype.getEvents.call(this);
        return this.options.permanent || (n.preclick = this.close), n;
      },
      _initLayout: function() {
        var n = "leaflet-tooltip", l = n + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
        this._contentNode = this._container = Ae("div", l), this._container.setAttribute("role", "tooltip"), this._container.setAttribute("id", "leaflet-tooltip-" + d(this));
      },
      _updateLayout: function() {
      },
      _adjustPan: function() {
      },
      _setPosition: function(n) {
        var l, c, h = this._map, f = this._container, y = h.latLngToContainerPoint(h.getCenter()), S = h.layerPointToContainerPoint(n), E = this.options.direction, M = f.offsetWidth, q = f.offsetHeight, K = J(this.options.offset), le = this._getAnchor();
        E === "top" ? (l = M / 2, c = q) : E === "bottom" ? (l = M / 2, c = 0) : E === "center" ? (l = M / 2, c = q / 2) : E === "right" ? (l = 0, c = q / 2) : E === "left" ? (l = M, c = q / 2) : S.x < y.x ? (E = "right", l = 0, c = q / 2) : (E = "left", l = M + (K.x + le.x) * 2, c = q / 2), n = n.subtract(J(l, c, !0)).add(K).add(le), Ve(f, "leaflet-tooltip-right"), Ve(f, "leaflet-tooltip-left"), Ve(f, "leaflet-tooltip-top"), Ve(f, "leaflet-tooltip-bottom"), me(f, "leaflet-tooltip-" + E), Ge(f, n);
      },
      _updatePosition: function() {
        var n = this._map.latLngToLayerPoint(this._latlng);
        this._setPosition(n);
      },
      setOpacity: function(n) {
        this.options.opacity = n, this._container && ft(this._container, n);
      },
      _animateZoom: function(n) {
        var l = this._map._latLngToNewLayerPoint(this._latlng, n.zoom, n.center);
        this._setPosition(l);
      },
      _getAnchor: function() {
        return J(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
      }
    }), Id = function(n, l) {
      return new Gs(n, l);
    };
    xe.include({
      // @method openTooltip(tooltip: Tooltip): this
      // Opens the specified tooltip.
      // @alternative
      // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
      // Creates a tooltip with the specified content and options and open it.
      openTooltip: function(n, l, c) {
        return this._initOverlay(Gs, n, l, c).openOn(this), this;
      },
      // @method closeTooltip(tooltip: Tooltip): this
      // Closes the tooltip given as parameter.
      closeTooltip: function(n) {
        return n.close(), this;
      }
    }), Pt.include({
      // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
      // Binds a tooltip to the layer with the passed `content` and sets up the
      // necessary event listeners. If a `Function` is passed it will receive
      // the layer as the first argument and should return a `String` or `HTMLElement`.
      bindTooltip: function(n, l) {
        return this._tooltip && this.isTooltipOpen() && this.unbindTooltip(), this._tooltip = this._initOverlay(Gs, this._tooltip, n, l), this._initTooltipInteractions(), this._tooltip.options.permanent && this._map && this._map.hasLayer(this) && this.openTooltip(), this;
      },
      // @method unbindTooltip(): this
      // Removes the tooltip previously bound with `bindTooltip`.
      unbindTooltip: function() {
        return this._tooltip && (this._initTooltipInteractions(!0), this.closeTooltip(), this._tooltip = null), this;
      },
      _initTooltipInteractions: function(n) {
        if (!(!n && this._tooltipHandlersAdded)) {
          var l = n ? "off" : "on", c = {
            remove: this.closeTooltip,
            move: this._moveTooltip
          };
          this._tooltip.options.permanent ? c.add = this._openTooltip : (c.mouseover = this._openTooltip, c.mouseout = this.closeTooltip, c.click = this._openTooltip, this._map ? this._addFocusListeners() : c.add = this._addFocusListeners), this._tooltip.options.sticky && (c.mousemove = this._moveTooltip), this[l](c), this._tooltipHandlersAdded = !n;
        }
      },
      // @method openTooltip(latlng?: LatLng): this
      // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
      openTooltip: function(n) {
        return this._tooltip && (this instanceof Jt || (this._tooltip._source = this), this._tooltip._prepareOpen(n) && (this._tooltip.openOn(this._map), this.getElement ? this._setAriaDescribedByOnLayer(this) : this.eachLayer && this.eachLayer(this._setAriaDescribedByOnLayer, this))), this;
      },
      // @method closeTooltip(): this
      // Closes the tooltip bound to this layer if it is open.
      closeTooltip: function() {
        if (this._tooltip)
          return this._tooltip.close();
      },
      // @method toggleTooltip(): this
      // Opens or closes the tooltip bound to this layer depending on its current state.
      toggleTooltip: function() {
        return this._tooltip && this._tooltip.toggle(this), this;
      },
      // @method isTooltipOpen(): boolean
      // Returns `true` if the tooltip bound to this layer is currently open.
      isTooltipOpen: function() {
        return this._tooltip.isOpen();
      },
      // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
      // Sets the content of the tooltip bound to this layer.
      setTooltipContent: function(n) {
        return this._tooltip && this._tooltip.setContent(n), this;
      },
      // @method getTooltip(): Tooltip
      // Returns the tooltip bound to this layer.
      getTooltip: function() {
        return this._tooltip;
      },
      _addFocusListeners: function() {
        this.getElement ? this._addFocusListenersOnLayer(this) : this.eachLayer && this.eachLayer(this._addFocusListenersOnLayer, this);
      },
      _addFocusListenersOnLayer: function(n) {
        var l = typeof n.getElement == "function" && n.getElement();
        l && (fe(l, "focus", function() {
          this._tooltip._source = n, this.openTooltip();
        }, this), fe(l, "blur", this.closeTooltip, this));
      },
      _setAriaDescribedByOnLayer: function(n) {
        var l = typeof n.getElement == "function" && n.getElement();
        l && l.setAttribute("aria-describedby", this._tooltip._container.id);
      },
      _openTooltip: function(n) {
        if (!(!this._tooltip || !this._map)) {
          if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
            this._openOnceFlag = !0;
            var l = this;
            this._map.once("moveend", function() {
              l._openOnceFlag = !1, l._openTooltip(n);
            });
            return;
          }
          this._tooltip._source = n.layer || n.target, this.openTooltip(this._tooltip.options.sticky ? n.latlng : void 0);
        }
      },
      _moveTooltip: function(n) {
        var l = n.latlng, c, h;
        this._tooltip.options.sticky && n.originalEvent && (c = this._map.mouseEventToContainerPoint(n.originalEvent), h = this._map.containerPointToLayerPoint(c), l = this._map.layerPointToLatLng(h)), this._tooltip.setLatLng(l);
      }
    });
    var Xa = Ar.extend({
      options: {
        // @section
        // @aka DivIcon options
        iconSize: [12, 12],
        // also can be set through CSS
        // iconAnchor: (Point),
        // popupAnchor: (Point),
        // @option html: String|HTMLElement = ''
        // Custom HTML code to put inside the div element, empty by default. Alternatively,
        // an instance of `HTMLElement`.
        html: !1,
        // @option bgPos: Point = [0, 0]
        // Optional relative position of the background, in pixels
        bgPos: null,
        className: "leaflet-div-icon"
      },
      createIcon: function(n) {
        var l = n && n.tagName === "DIV" ? n : document.createElement("div"), c = this.options;
        if (c.html instanceof Element ? (Es(l), l.appendChild(c.html)) : l.innerHTML = c.html !== !1 ? c.html : "", c.bgPos) {
          var h = J(c.bgPos);
          l.style.backgroundPosition = -h.x + "px " + -h.y + "px";
        }
        return this._setIconStyles(l, "icon"), l;
      },
      createShadow: function() {
        return null;
      }
    });
    function jd(n) {
      return new Xa(n);
    }
    Ar.Default = ns;
    var os = Pt.extend({
      // @section
      // @aka GridLayer options
      options: {
        // @option tileSize: Number|Point = 256
        // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
        tileSize: 256,
        // @option opacity: Number = 1.0
        // Opacity of the tiles. Can be used in the `createTile()` function.
        opacity: 1,
        // @option updateWhenIdle: Boolean = (depends)
        // Load new tiles only when panning ends.
        // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
        // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
        // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
        updateWhenIdle: oe.mobile,
        // @option updateWhenZooming: Boolean = true
        // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
        updateWhenZooming: !0,
        // @option updateInterval: Number = 200
        // Tiles will not update more than once every `updateInterval` milliseconds when panning.
        updateInterval: 200,
        // @option zIndex: Number = 1
        // The explicit zIndex of the tile layer.
        zIndex: 1,
        // @option bounds: LatLngBounds = undefined
        // If set, tiles will only be loaded inside the set `LatLngBounds`.
        bounds: null,
        // @option minZoom: Number = 0
        // The minimum zoom level down to which this layer will be displayed (inclusive).
        minZoom: 0,
        // @option maxZoom: Number = undefined
        // The maximum zoom level up to which this layer will be displayed (inclusive).
        maxZoom: void 0,
        // @option maxNativeZoom: Number = undefined
        // Maximum zoom number the tile source has available. If it is specified,
        // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
        // from `maxNativeZoom` level and auto-scaled.
        maxNativeZoom: void 0,
        // @option minNativeZoom: Number = undefined
        // Minimum zoom number the tile source has available. If it is specified,
        // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
        // from `minNativeZoom` level and auto-scaled.
        minNativeZoom: void 0,
        // @option noWrap: Boolean = false
        // Whether the layer is wrapped around the antimeridian. If `true`, the
        // GridLayer will only be displayed once at low zoom levels. Has no
        // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
        // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
        // tiles outside the CRS limits.
        noWrap: !1,
        // @option pane: String = 'tilePane'
        // `Map pane` where the grid layer will be added.
        pane: "tilePane",
        // @option className: String = ''
        // A custom class name to assign to the tile layer. Empty by default.
        className: "",
        // @option keepBuffer: Number = 2
        // When panning the map, keep this many rows and columns of tiles before unloading them.
        keepBuffer: 2
      },
      initialize: function(n) {
        P(this, n);
      },
      onAdd: function() {
        this._initContainer(), this._levels = {}, this._tiles = {}, this._resetView();
      },
      beforeAdd: function(n) {
        n._addZoomLimit(this);
      },
      onRemove: function(n) {
        this._removeAllTiles(), Re(this._container), n._removeZoomLimit(this), this._container = null, this._tileZoom = void 0;
      },
      // @method bringToFront: this
      // Brings the tile layer to the top of all tile layers.
      bringToFront: function() {
        return this._map && (Tr(this._container), this._setAutoZIndex(Math.max)), this;
      },
      // @method bringToBack: this
      // Brings the tile layer to the bottom of all tile layers.
      bringToBack: function() {
        return this._map && (Lr(this._container), this._setAutoZIndex(Math.min)), this;
      },
      // @method getContainer: HTMLElement
      // Returns the HTML element that contains the tiles for this layer.
      getContainer: function() {
        return this._container;
      },
      // @method setOpacity(opacity: Number): this
      // Changes the [opacity](#gridlayer-opacity) of the grid layer.
      setOpacity: function(n) {
        return this.options.opacity = n, this._updateOpacity(), this;
      },
      // @method setZIndex(zIndex: Number): this
      // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
      setZIndex: function(n) {
        return this.options.zIndex = n, this._updateZIndex(), this;
      },
      // @method isLoading: Boolean
      // Returns `true` if any tile in the grid layer has not finished loading.
      isLoading: function() {
        return this._loading;
      },
      // @method redraw: this
      // Causes the layer to clear all the tiles and request them again.
      redraw: function() {
        if (this._map) {
          this._removeAllTiles();
          var n = this._clampZoom(this._map.getZoom());
          n !== this._tileZoom && (this._tileZoom = n, this._updateLevels()), this._update();
        }
        return this;
      },
      getEvents: function() {
        var n = {
          viewprereset: this._invalidateAll,
          viewreset: this._resetView,
          zoom: this._resetView,
          moveend: this._onMoveEnd
        };
        return this.options.updateWhenIdle || (this._onMove || (this._onMove = m(this._onMoveEnd, this.options.updateInterval, this)), n.move = this._onMove), this._zoomAnimated && (n.zoomanim = this._animateZoom), n;
      },
      // @section Extension methods
      // Layers extending `GridLayer` shall reimplement the following method.
      // @method createTile(coords: Object, done?: Function): HTMLElement
      // Called only internally, must be overridden by classes extending `GridLayer`.
      // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
      // is specified, it must be called when the tile has finished loading and drawing.
      createTile: function() {
        return document.createElement("div");
      },
      // @section
      // @method getTileSize: Point
      // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
      getTileSize: function() {
        var n = this.options.tileSize;
        return n instanceof ue ? n : new ue(n, n);
      },
      _updateZIndex: function() {
        this._container && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._container.style.zIndex = this.options.zIndex);
      },
      _setAutoZIndex: function(n) {
        for (var l = this.getPane().children, c = -n(-1 / 0, 1 / 0), h = 0, f = l.length, y; h < f; h++)
          y = l[h].style.zIndex, l[h] !== this._container && y && (c = n(c, +y));
        isFinite(c) && (this.options.zIndex = c + n(-1, 1), this._updateZIndex());
      },
      _updateOpacity: function() {
        if (this._map && !oe.ielt9) {
          ft(this._container, this.options.opacity);
          var n = +/* @__PURE__ */ new Date(), l = !1, c = !1;
          for (var h in this._tiles) {
            var f = this._tiles[h];
            if (!(!f.current || !f.loaded)) {
              var y = Math.min(1, (n - f.loaded) / 200);
              ft(f.el, y), y < 1 ? l = !0 : (f.active ? c = !0 : this._onOpaqueTile(f), f.active = !0);
            }
          }
          c && !this._noPrune && this._pruneTiles(), l && (Y(this._fadeFrame), this._fadeFrame = W(this._updateOpacity, this));
        }
      },
      _onOpaqueTile: p,
      _initContainer: function() {
        this._container || (this._container = Ae("div", "leaflet-layer " + (this.options.className || "")), this._updateZIndex(), this.options.opacity < 1 && this._updateOpacity(), this.getPane().appendChild(this._container));
      },
      _updateLevels: function() {
        var n = this._tileZoom, l = this.options.maxZoom;
        if (n !== void 0) {
          for (var c in this._levels)
            c = Number(c), this._levels[c].el.children.length || c === n ? (this._levels[c].el.style.zIndex = l - Math.abs(n - c), this._onUpdateLevel(c)) : (Re(this._levels[c].el), this._removeTilesAtZoom(c), this._onRemoveLevel(c), delete this._levels[c]);
          var h = this._levels[n], f = this._map;
          return h || (h = this._levels[n] = {}, h.el = Ae("div", "leaflet-tile-container leaflet-zoom-animated", this._container), h.el.style.zIndex = l, h.origin = f.project(f.unproject(f.getPixelOrigin()), n).round(), h.zoom = n, this._setZoomTransform(h, f.getCenter(), f.getZoom()), p(h.el.offsetWidth), this._onCreateLevel(h)), this._level = h, h;
        }
      },
      _onUpdateLevel: p,
      _onRemoveLevel: p,
      _onCreateLevel: p,
      _pruneTiles: function() {
        if (this._map) {
          var n, l, c = this._map.getZoom();
          if (c > this.options.maxZoom || c < this.options.minZoom) {
            this._removeAllTiles();
            return;
          }
          for (n in this._tiles)
            l = this._tiles[n], l.retain = l.current;
          for (n in this._tiles)
            if (l = this._tiles[n], l.current && !l.active) {
              var h = l.coords;
              this._retainParent(h.x, h.y, h.z, h.z - 5) || this._retainChildren(h.x, h.y, h.z, h.z + 2);
            }
          for (n in this._tiles)
            this._tiles[n].retain || this._removeTile(n);
        }
      },
      _removeTilesAtZoom: function(n) {
        for (var l in this._tiles)
          this._tiles[l].coords.z === n && this._removeTile(l);
      },
      _removeAllTiles: function() {
        for (var n in this._tiles)
          this._removeTile(n);
      },
      _invalidateAll: function() {
        for (var n in this._levels)
          Re(this._levels[n].el), this._onRemoveLevel(Number(n)), delete this._levels[n];
        this._removeAllTiles(), this._tileZoom = void 0;
      },
      _retainParent: function(n, l, c, h) {
        var f = Math.floor(n / 2), y = Math.floor(l / 2), S = c - 1, E = new ue(+f, +y);
        E.z = +S;
        var M = this._tileCoordsToKey(E), q = this._tiles[M];
        return q && q.active ? (q.retain = !0, !0) : (q && q.loaded && (q.retain = !0), S > h ? this._retainParent(f, y, S, h) : !1);
      },
      _retainChildren: function(n, l, c, h) {
        for (var f = 2 * n; f < 2 * n + 2; f++)
          for (var y = 2 * l; y < 2 * l + 2; y++) {
            var S = new ue(f, y);
            S.z = c + 1;
            var E = this._tileCoordsToKey(S), M = this._tiles[E];
            if (M && M.active) {
              M.retain = !0;
              continue;
            } else M && M.loaded && (M.retain = !0);
            c + 1 < h && this._retainChildren(f, y, c + 1, h);
          }
      },
      _resetView: function(n) {
        var l = n && (n.pinch || n.flyTo);
        this._setView(this._map.getCenter(), this._map.getZoom(), l, l);
      },
      _animateZoom: function(n) {
        this._setView(n.center, n.zoom, !0, n.noUpdate);
      },
      _clampZoom: function(n) {
        var l = this.options;
        return l.minNativeZoom !== void 0 && n < l.minNativeZoom ? l.minNativeZoom : l.maxNativeZoom !== void 0 && l.maxNativeZoom < n ? l.maxNativeZoom : n;
      },
      _setView: function(n, l, c, h) {
        var f = Math.round(l);
        this.options.maxZoom !== void 0 && f > this.options.maxZoom || this.options.minZoom !== void 0 && f < this.options.minZoom ? f = void 0 : f = this._clampZoom(f);
        var y = this.options.updateWhenZooming && f !== this._tileZoom;
        (!h || y) && (this._tileZoom = f, this._abortLoading && this._abortLoading(), this._updateLevels(), this._resetGrid(), f !== void 0 && this._update(n), c || this._pruneTiles(), this._noPrune = !!c), this._setZoomTransforms(n, l);
      },
      _setZoomTransforms: function(n, l) {
        for (var c in this._levels)
          this._setZoomTransform(this._levels[c], n, l);
      },
      _setZoomTransform: function(n, l, c) {
        var h = this._map.getZoomScale(c, n.zoom), f = n.origin.multiplyBy(h).subtract(this._map._getNewPixelOrigin(l, c)).round();
        oe.any3d ? sr(n.el, f, h) : Ge(n.el, f);
      },
      _resetGrid: function() {
        var n = this._map, l = n.options.crs, c = this._tileSize = this.getTileSize(), h = this._tileZoom, f = this._map.getPixelWorldBounds(this._tileZoom);
        f && (this._globalTileRange = this._pxBoundsToTileRange(f)), this._wrapX = l.wrapLng && !this.options.noWrap && [
          Math.floor(n.project([0, l.wrapLng[0]], h).x / c.x),
          Math.ceil(n.project([0, l.wrapLng[1]], h).x / c.y)
        ], this._wrapY = l.wrapLat && !this.options.noWrap && [
          Math.floor(n.project([l.wrapLat[0], 0], h).y / c.x),
          Math.ceil(n.project([l.wrapLat[1], 0], h).y / c.y)
        ];
      },
      _onMoveEnd: function() {
        !this._map || this._map._animatingZoom || this._update();
      },
      _getTiledPixelBounds: function(n) {
        var l = this._map, c = l._animatingZoom ? Math.max(l._animateToZoom, l.getZoom()) : l.getZoom(), h = l.getZoomScale(c, this._tileZoom), f = l.project(n, this._tileZoom).floor(), y = l.getSize().divideBy(h * 2);
        return new Q(f.subtract(y), f.add(y));
      },
      // Private method to load tiles in the grid's active zoom level according to map bounds
      _update: function(n) {
        var l = this._map;
        if (l) {
          var c = this._clampZoom(l.getZoom());
          if (n === void 0 && (n = l.getCenter()), this._tileZoom !== void 0) {
            var h = this._getTiledPixelBounds(n), f = this._pxBoundsToTileRange(h), y = f.getCenter(), S = [], E = this.options.keepBuffer, M = new Q(
              f.getBottomLeft().subtract([E, -E]),
              f.getTopRight().add([E, -E])
            );
            if (!(isFinite(f.min.x) && isFinite(f.min.y) && isFinite(f.max.x) && isFinite(f.max.y)))
              throw new Error("Attempted to load an infinite number of tiles");
            for (var q in this._tiles) {
              var K = this._tiles[q].coords;
              (K.z !== this._tileZoom || !M.contains(new ue(K.x, K.y))) && (this._tiles[q].current = !1);
            }
            if (Math.abs(c - this._tileZoom) > 1) {
              this._setView(n, c);
              return;
            }
            for (var le = f.min.y; le <= f.max.y; le++)
              for (var ye = f.min.x; ye <= f.max.x; ye++) {
                var at = new ue(ye, le);
                if (at.z = this._tileZoom, !!this._isValidTile(at)) {
                  var Xe = this._tiles[this._tileCoordsToKey(at)];
                  Xe ? Xe.current = !0 : S.push(at);
                }
              }
            if (S.sort(function(ut, jr) {
              return ut.distanceTo(y) - jr.distanceTo(y);
            }), S.length !== 0) {
              this._loading || (this._loading = !0, this.fire("loading"));
              var mt = document.createDocumentFragment();
              for (ye = 0; ye < S.length; ye++)
                this._addTile(S[ye], mt);
              this._level.el.appendChild(mt);
            }
          }
        }
      },
      _isValidTile: function(n) {
        var l = this._map.options.crs;
        if (!l.infinite) {
          var c = this._globalTileRange;
          if (!l.wrapLng && (n.x < c.min.x || n.x > c.max.x) || !l.wrapLat && (n.y < c.min.y || n.y > c.max.y))
            return !1;
        }
        if (!this.options.bounds)
          return !0;
        var h = this._tileCoordsToBounds(n);
        return Le(this.options.bounds).overlaps(h);
      },
      _keyToBounds: function(n) {
        return this._tileCoordsToBounds(this._keyToTileCoords(n));
      },
      _tileCoordsToNwSe: function(n) {
        var l = this._map, c = this.getTileSize(), h = n.scaleBy(c), f = h.add(c), y = l.unproject(h, n.z), S = l.unproject(f, n.z);
        return [y, S];
      },
      // converts tile coordinates to its geographical bounds
      _tileCoordsToBounds: function(n) {
        var l = this._tileCoordsToNwSe(n), c = new De(l[0], l[1]);
        return this.options.noWrap || (c = this._map.wrapLatLngBounds(c)), c;
      },
      // converts tile coordinates to key for the tile cache
      _tileCoordsToKey: function(n) {
        return n.x + ":" + n.y + ":" + n.z;
      },
      // converts tile cache key to coordinates
      _keyToTileCoords: function(n) {
        var l = n.split(":"), c = new ue(+l[0], +l[1]);
        return c.z = +l[2], c;
      },
      _removeTile: function(n) {
        var l = this._tiles[n];
        l && (Re(l.el), delete this._tiles[n], this.fire("tileunload", {
          tile: l.el,
          coords: this._keyToTileCoords(n)
        }));
      },
      _initTile: function(n) {
        me(n, "leaflet-tile");
        var l = this.getTileSize();
        n.style.width = l.x + "px", n.style.height = l.y + "px", n.onselectstart = p, n.onmousemove = p, oe.ielt9 && this.options.opacity < 1 && ft(n, this.options.opacity);
      },
      _addTile: function(n, l) {
        var c = this._getTilePos(n), h = this._tileCoordsToKey(n), f = this.createTile(this._wrapCoords(n), i(this._tileReady, this, n));
        this._initTile(f), this.createTile.length < 2 && W(i(this._tileReady, this, n, null, f)), Ge(f, c), this._tiles[h] = {
          el: f,
          coords: n,
          current: !0
        }, l.appendChild(f), this.fire("tileloadstart", {
          tile: f,
          coords: n
        });
      },
      _tileReady: function(n, l, c) {
        l && this.fire("tileerror", {
          error: l,
          tile: c,
          coords: n
        });
        var h = this._tileCoordsToKey(n);
        c = this._tiles[h], c && (c.loaded = +/* @__PURE__ */ new Date(), this._map._fadeAnimated ? (ft(c.el, 0), Y(this._fadeFrame), this._fadeFrame = W(this._updateOpacity, this)) : (c.active = !0, this._pruneTiles()), l || (me(c.el, "leaflet-tile-loaded"), this.fire("tileload", {
          tile: c.el,
          coords: n
        })), this._noTilesToLoad() && (this._loading = !1, this.fire("load"), oe.ielt9 || !this._map._fadeAnimated ? W(this._pruneTiles, this) : setTimeout(i(this._pruneTiles, this), 250)));
      },
      _getTilePos: function(n) {
        return n.scaleBy(this.getTileSize()).subtract(this._level.origin);
      },
      _wrapCoords: function(n) {
        var l = new ue(
          this._wrapX ? v(n.x, this._wrapX) : n.x,
          this._wrapY ? v(n.y, this._wrapY) : n.y
        );
        return l.z = n.z, l;
      },
      _pxBoundsToTileRange: function(n) {
        var l = this.getTileSize();
        return new Q(
          n.min.unscaleBy(l).floor(),
          n.max.unscaleBy(l).ceil().subtract([1, 1])
        );
      },
      _noTilesToLoad: function() {
        for (var n in this._tiles)
          if (!this._tiles[n].loaded)
            return !1;
        return !0;
      }
    });
    function Ed(n) {
      return new os(n);
    }
    var Ir = os.extend({
      // @section
      // @aka TileLayer options
      options: {
        // @option minZoom: Number = 0
        // The minimum zoom level down to which this layer will be displayed (inclusive).
        minZoom: 0,
        // @option maxZoom: Number = 18
        // The maximum zoom level up to which this layer will be displayed (inclusive).
        maxZoom: 18,
        // @option subdomains: String|String[] = 'abc'
        // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
        subdomains: "abc",
        // @option errorTileUrl: String = ''
        // URL to the tile image to show in place of the tile that failed to load.
        errorTileUrl: "",
        // @option zoomOffset: Number = 0
        // The zoom number used in tile URLs will be offset with this value.
        zoomOffset: 0,
        // @option tms: Boolean = false
        // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
        tms: !1,
        // @option zoomReverse: Boolean = false
        // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
        zoomReverse: !1,
        // @option detectRetina: Boolean = false
        // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
        detectRetina: !1,
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the tiles.
        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: !1,
        // @option referrerPolicy: Boolean|String = false
        // Whether the referrerPolicy attribute will be added to the tiles.
        // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
        // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
        // (e.g. to validate an API token).
        // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
        referrerPolicy: !1
      },
      initialize: function(n, l) {
        this._url = n, l = P(this, l), l.detectRetina && oe.retina && l.maxZoom > 0 ? (l.tileSize = Math.floor(l.tileSize / 2), l.zoomReverse ? (l.zoomOffset--, l.minZoom = Math.min(l.maxZoom, l.minZoom + 1)) : (l.zoomOffset++, l.maxZoom = Math.max(l.minZoom, l.maxZoom - 1)), l.minZoom = Math.max(0, l.minZoom)) : l.zoomReverse ? l.minZoom = Math.min(l.maxZoom, l.minZoom) : l.maxZoom = Math.max(l.minZoom, l.maxZoom), typeof l.subdomains == "string" && (l.subdomains = l.subdomains.split("")), this.on("tileunload", this._onTileRemove);
      },
      // @method setUrl(url: String, noRedraw?: Boolean): this
      // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
      // If the URL does not change, the layer will not be redrawn unless
      // the noRedraw parameter is set to false.
      setUrl: function(n, l) {
        return this._url === n && l === void 0 && (l = !0), this._url = n, l || this.redraw(), this;
      },
      // @method createTile(coords: Object, done?: Function): HTMLElement
      // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
      // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
      // callback is called when the tile has been loaded.
      createTile: function(n, l) {
        var c = document.createElement("img");
        return fe(c, "load", i(this._tileOnLoad, this, l, c)), fe(c, "error", i(this._tileOnError, this, l, c)), (this.options.crossOrigin || this.options.crossOrigin === "") && (c.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), typeof this.options.referrerPolicy == "string" && (c.referrerPolicy = this.options.referrerPolicy), c.alt = "", c.src = this.getTileUrl(n), c;
      },
      // @section Extension methods
      // @uninheritable
      // Layers extending `TileLayer` might reimplement the following method.
      // @method getTileUrl(coords: Object): String
      // Called only internally, returns the URL for a tile given its coordinates.
      // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
      getTileUrl: function(n) {
        var l = {
          r: oe.retina ? "@2x" : "",
          s: this._getSubdomain(n),
          x: n.x,
          y: n.y,
          z: this._getZoomForUrl()
        };
        if (this._map && !this._map.options.crs.infinite) {
          var c = this._globalTileRange.max.y - n.y;
          this.options.tms && (l.y = c), l["-y"] = c;
        }
        return x(this._url, r(l, this.options));
      },
      _tileOnLoad: function(n, l) {
        oe.ielt9 ? setTimeout(i(n, this, null, l), 0) : n(null, l);
      },
      _tileOnError: function(n, l, c) {
        var h = this.options.errorTileUrl;
        h && l.getAttribute("src") !== h && (l.src = h), n(c, l);
      },
      _onTileRemove: function(n) {
        n.tile.onload = null;
      },
      _getZoomForUrl: function() {
        var n = this._tileZoom, l = this.options.maxZoom, c = this.options.zoomReverse, h = this.options.zoomOffset;
        return c && (n = l - n), n + h;
      },
      _getSubdomain: function(n) {
        var l = Math.abs(n.x + n.y) % this.options.subdomains.length;
        return this.options.subdomains[l];
      },
      // stops loading all tiles in the background layer
      _abortLoading: function() {
        var n, l;
        for (n in this._tiles)
          if (this._tiles[n].coords.z !== this._tileZoom && (l = this._tiles[n].el, l.onload = p, l.onerror = p, !l.complete)) {
            l.src = z;
            var c = this._tiles[n].coords;
            Re(l), delete this._tiles[n], this.fire("tileabort", {
              tile: l,
              coords: c
            });
          }
      },
      _removeTile: function(n) {
        var l = this._tiles[n];
        if (l)
          return l.el.setAttribute("src", z), os.prototype._removeTile.call(this, n);
      },
      _tileReady: function(n, l, c) {
        if (!(!this._map || c && c.getAttribute("src") === z))
          return os.prototype._tileReady.call(this, n, l, c);
      }
    });
    function el(n, l) {
      return new Ir(n, l);
    }
    var tl = Ir.extend({
      // @section
      // @aka TileLayer.WMS options
      // If any custom options not documented here are used, they will be sent to the
      // WMS server as extra parameters in each request URL. This can be useful for
      // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
      defaultWmsParams: {
        service: "WMS",
        request: "GetMap",
        // @option layers: String = ''
        // **(required)** Comma-separated list of WMS layers to show.
        layers: "",
        // @option styles: String = ''
        // Comma-separated list of WMS styles.
        styles: "",
        // @option format: String = 'image/jpeg'
        // WMS image format (use `'image/png'` for layers with transparency).
        format: "image/jpeg",
        // @option transparent: Boolean = false
        // If `true`, the WMS service will return images with transparency.
        transparent: !1,
        // @option version: String = '1.1.1'
        // Version of the WMS service to use
        version: "1.1.1"
      },
      options: {
        // @option crs: CRS = null
        // Coordinate Reference System to use for the WMS requests, defaults to
        // map CRS. Don't change this if you're not sure what it means.
        crs: null,
        // @option uppercase: Boolean = false
        // If `true`, WMS request parameter keys will be uppercase.
        uppercase: !1
      },
      initialize: function(n, l) {
        this._url = n;
        var c = r({}, this.defaultWmsParams);
        for (var h in l)
          h in this.options || (c[h] = l[h]);
        l = P(this, l);
        var f = l.detectRetina && oe.retina ? 2 : 1, y = this.getTileSize();
        c.width = y.x * f, c.height = y.y * f, this.wmsParams = c;
      },
      onAdd: function(n) {
        this._crs = this.options.crs || n.options.crs, this._wmsVersion = parseFloat(this.wmsParams.version);
        var l = this._wmsVersion >= 1.3 ? "crs" : "srs";
        this.wmsParams[l] = this._crs.code, Ir.prototype.onAdd.call(this, n);
      },
      getTileUrl: function(n) {
        var l = this._tileCoordsToNwSe(n), c = this._crs, h = be(c.project(l[0]), c.project(l[1])), f = h.min, y = h.max, S = (this._wmsVersion >= 1.3 && this._crs === Ga ? [f.y, f.x, y.y, y.x] : [f.x, f.y, y.x, y.y]).join(","), E = Ir.prototype.getTileUrl.call(this, n);
        return E + T(this.wmsParams, E, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + S;
      },
      // @method setParams(params: Object, noRedraw?: Boolean): this
      // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
      setParams: function(n, l) {
        return r(this.wmsParams, n), l || this.redraw(), this;
      }
    });
    function Dd(n, l) {
      return new tl(n, l);
    }
    Ir.WMS = tl, el.wms = Dd;
    var Rt = Pt.extend({
      // @section
      // @aka Renderer options
      options: {
        // @option padding: Number = 0.1
        // How much to extend the clip area around the map view (relative to its size)
        // e.g. 0.1 would be 10% of map view in each direction
        padding: 0.1
      },
      initialize: function(n) {
        P(this, n), d(this), this._layers = this._layers || {};
      },
      onAdd: function() {
        this._container || (this._initContainer(), me(this._container, "leaflet-zoom-animated")), this.getPane().appendChild(this._container), this._update(), this.on("update", this._updatePaths, this);
      },
      onRemove: function() {
        this.off("update", this._updatePaths, this), this._destroyContainer();
      },
      getEvents: function() {
        var n = {
          viewreset: this._reset,
          zoom: this._onZoom,
          moveend: this._update,
          zoomend: this._onZoomEnd
        };
        return this._zoomAnimated && (n.zoomanim = this._onAnimZoom), n;
      },
      _onAnimZoom: function(n) {
        this._updateTransform(n.center, n.zoom);
      },
      _onZoom: function() {
        this._updateTransform(this._map.getCenter(), this._map.getZoom());
      },
      _updateTransform: function(n, l) {
        var c = this._map.getZoomScale(l, this._zoom), h = this._map.getSize().multiplyBy(0.5 + this.options.padding), f = this._map.project(this._center, l), y = h.multiplyBy(-c).add(f).subtract(this._map._getNewPixelOrigin(n, l));
        oe.any3d ? sr(this._container, y, c) : Ge(this._container, y);
      },
      _reset: function() {
        this._update(), this._updateTransform(this._center, this._zoom);
        for (var n in this._layers)
          this._layers[n]._reset();
      },
      _onZoomEnd: function() {
        for (var n in this._layers)
          this._layers[n]._project();
      },
      _updatePaths: function() {
        for (var n in this._layers)
          this._layers[n]._update();
      },
      _update: function() {
        var n = this.options.padding, l = this._map.getSize(), c = this._map.containerPointToLayerPoint(l.multiplyBy(-n)).round();
        this._bounds = new Q(c, c.add(l.multiplyBy(1 + n * 2)).round()), this._center = this._map.getCenter(), this._zoom = this._map.getZoom();
      }
    }), rl = Rt.extend({
      // @section
      // @aka Canvas options
      options: {
        // @option tolerance: Number = 0
        // How much to extend the click tolerance around a path/object on the map.
        tolerance: 0
      },
      getEvents: function() {
        var n = Rt.prototype.getEvents.call(this);
        return n.viewprereset = this._onViewPreReset, n;
      },
      _onViewPreReset: function() {
        this._postponeUpdatePaths = !0;
      },
      onAdd: function() {
        Rt.prototype.onAdd.call(this), this._draw();
      },
      _initContainer: function() {
        var n = this._container = document.createElement("canvas");
        fe(n, "mousemove", this._onMouseMove, this), fe(n, "click dblclick mousedown mouseup contextmenu", this._onClick, this), fe(n, "mouseout", this._handleMouseOut, this), n._leaflet_disable_events = !0, this._ctx = n.getContext("2d");
      },
      _destroyContainer: function() {
        Y(this._redrawRequest), delete this._ctx, Re(this._container), Je(this._container), delete this._container;
      },
      _updatePaths: function() {
        if (!this._postponeUpdatePaths) {
          var n;
          this._redrawBounds = null;
          for (var l in this._layers)
            n = this._layers[l], n._update();
          this._redraw();
        }
      },
      _update: function() {
        if (!(this._map._animatingZoom && this._bounds)) {
          Rt.prototype._update.call(this);
          var n = this._bounds, l = this._container, c = n.getSize(), h = oe.retina ? 2 : 1;
          Ge(l, n.min), l.width = h * c.x, l.height = h * c.y, l.style.width = c.x + "px", l.style.height = c.y + "px", oe.retina && this._ctx.scale(2, 2), this._ctx.translate(-n.min.x, -n.min.y), this.fire("update");
        }
      },
      _reset: function() {
        Rt.prototype._reset.call(this), this._postponeUpdatePaths && (this._postponeUpdatePaths = !1, this._updatePaths());
      },
      _initPath: function(n) {
        this._updateDashArray(n), this._layers[d(n)] = n;
        var l = n._order = {
          layer: n,
          prev: this._drawLast,
          next: null
        };
        this._drawLast && (this._drawLast.next = l), this._drawLast = l, this._drawFirst = this._drawFirst || this._drawLast;
      },
      _addPath: function(n) {
        this._requestRedraw(n);
      },
      _removePath: function(n) {
        var l = n._order, c = l.next, h = l.prev;
        c ? c.prev = h : this._drawLast = h, h ? h.next = c : this._drawFirst = c, delete n._order, delete this._layers[d(n)], this._requestRedraw(n);
      },
      _updatePath: function(n) {
        this._extendRedrawBounds(n), n._project(), n._update(), this._requestRedraw(n);
      },
      _updateStyle: function(n) {
        this._updateDashArray(n), this._requestRedraw(n);
      },
      _updateDashArray: function(n) {
        if (typeof n.options.dashArray == "string") {
          var l = n.options.dashArray.split(/[, ]+/), c = [], h, f;
          for (f = 0; f < l.length; f++) {
            if (h = Number(l[f]), isNaN(h))
              return;
            c.push(h);
          }
          n.options._dashArray = c;
        } else
          n.options._dashArray = n.options.dashArray;
      },
      _requestRedraw: function(n) {
        this._map && (this._extendRedrawBounds(n), this._redrawRequest = this._redrawRequest || W(this._redraw, this));
      },
      _extendRedrawBounds: function(n) {
        if (n._pxBounds) {
          var l = (n.options.weight || 0) + 1;
          this._redrawBounds = this._redrawBounds || new Q(), this._redrawBounds.extend(n._pxBounds.min.subtract([l, l])), this._redrawBounds.extend(n._pxBounds.max.add([l, l]));
        }
      },
      _redraw: function() {
        this._redrawRequest = null, this._redrawBounds && (this._redrawBounds.min._floor(), this._redrawBounds.max._ceil()), this._clear(), this._draw(), this._redrawBounds = null;
      },
      _clear: function() {
        var n = this._redrawBounds;
        if (n) {
          var l = n.getSize();
          this._ctx.clearRect(n.min.x, n.min.y, l.x, l.y);
        } else
          this._ctx.save(), this._ctx.setTransform(1, 0, 0, 1, 0, 0), this._ctx.clearRect(0, 0, this._container.width, this._container.height), this._ctx.restore();
      },
      _draw: function() {
        var n, l = this._redrawBounds;
        if (this._ctx.save(), l) {
          var c = l.getSize();
          this._ctx.beginPath(), this._ctx.rect(l.min.x, l.min.y, c.x, c.y), this._ctx.clip();
        }
        this._drawing = !0;
        for (var h = this._drawFirst; h; h = h.next)
          n = h.layer, (!l || n._pxBounds && n._pxBounds.intersects(l)) && n._updatePath();
        this._drawing = !1, this._ctx.restore();
      },
      _updatePoly: function(n, l) {
        if (this._drawing) {
          var c, h, f, y, S = n._parts, E = S.length, M = this._ctx;
          if (E) {
            for (M.beginPath(), c = 0; c < E; c++) {
              for (h = 0, f = S[c].length; h < f; h++)
                y = S[c][h], M[h ? "lineTo" : "moveTo"](y.x, y.y);
              l && M.closePath();
            }
            this._fillStroke(M, n);
          }
        }
      },
      _updateCircle: function(n) {
        if (!(!this._drawing || n._empty())) {
          var l = n._point, c = this._ctx, h = Math.max(Math.round(n._radius), 1), f = (Math.max(Math.round(n._radiusY), 1) || h) / h;
          f !== 1 && (c.save(), c.scale(1, f)), c.beginPath(), c.arc(l.x, l.y / f, h, 0, Math.PI * 2, !1), f !== 1 && c.restore(), this._fillStroke(c, n);
        }
      },
      _fillStroke: function(n, l) {
        var c = l.options;
        c.fill && (n.globalAlpha = c.fillOpacity, n.fillStyle = c.fillColor || c.color, n.fill(c.fillRule || "evenodd")), c.stroke && c.weight !== 0 && (n.setLineDash && n.setLineDash(l.options && l.options._dashArray || []), n.globalAlpha = c.opacity, n.lineWidth = c.weight, n.strokeStyle = c.color, n.lineCap = c.lineCap, n.lineJoin = c.lineJoin, n.stroke());
      },
      // Canvas obviously doesn't have mouse events for individual drawn objects,
      // so we emulate that by calculating what's under the mouse on mousemove/click manually
      _onClick: function(n) {
        for (var l = this._map.mouseEventToLayerPoint(n), c, h, f = this._drawFirst; f; f = f.next)
          c = f.layer, c.options.interactive && c._containsPoint(l) && (!(n.type === "click" || n.type === "preclick") || !this._map._draggableMoved(c)) && (h = c);
        this._fireEvent(h ? [h] : !1, n);
      },
      _onMouseMove: function(n) {
        if (!(!this._map || this._map.dragging.moving() || this._map._animatingZoom)) {
          var l = this._map.mouseEventToLayerPoint(n);
          this._handleMouseHover(n, l);
        }
      },
      _handleMouseOut: function(n) {
        var l = this._hoveredLayer;
        l && (Ve(this._container, "leaflet-interactive"), this._fireEvent([l], n, "mouseout"), this._hoveredLayer = null, this._mouseHoverThrottled = !1);
      },
      _handleMouseHover: function(n, l) {
        if (!this._mouseHoverThrottled) {
          for (var c, h, f = this._drawFirst; f; f = f.next)
            c = f.layer, c.options.interactive && c._containsPoint(l) && (h = c);
          h !== this._hoveredLayer && (this._handleMouseOut(n), h && (me(this._container, "leaflet-interactive"), this._fireEvent([h], n, "mouseover"), this._hoveredLayer = h)), this._fireEvent(this._hoveredLayer ? [this._hoveredLayer] : !1, n), this._mouseHoverThrottled = !0, setTimeout(i(function() {
            this._mouseHoverThrottled = !1;
          }, this), 32);
        }
      },
      _fireEvent: function(n, l, c) {
        this._map._fireDOMEvent(l, c || l.type, n);
      },
      _bringToFront: function(n) {
        var l = n._order;
        if (l) {
          var c = l.next, h = l.prev;
          if (c)
            c.prev = h;
          else
            return;
          h ? h.next = c : c && (this._drawFirst = c), l.prev = this._drawLast, this._drawLast.next = l, l.next = null, this._drawLast = l, this._requestRedraw(n);
        }
      },
      _bringToBack: function(n) {
        var l = n._order;
        if (l) {
          var c = l.next, h = l.prev;
          if (h)
            h.next = c;
          else
            return;
          c ? c.prev = h : h && (this._drawLast = h), l.prev = null, l.next = this._drawFirst, this._drawFirst.prev = l, this._drawFirst = l, this._requestRedraw(n);
        }
      }
    });
    function sl(n) {
      return oe.canvas ? new rl(n) : null;
    }
    var as = function() {
      try {
        return document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml"), function(n) {
          return document.createElement("<lvml:" + n + ' class="lvml">');
        };
      } catch {
      }
      return function(n) {
        return document.createElement("<" + n + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
      };
    }(), Md = {
      _initContainer: function() {
        this._container = Ae("div", "leaflet-vml-container");
      },
      _update: function() {
        this._map._animatingZoom || (Rt.prototype._update.call(this), this.fire("update"));
      },
      _initPath: function(n) {
        var l = n._container = as("shape");
        me(l, "leaflet-vml-shape " + (this.options.className || "")), l.coordsize = "1 1", n._path = as("path"), l.appendChild(n._path), this._updateStyle(n), this._layers[d(n)] = n;
      },
      _addPath: function(n) {
        var l = n._container;
        this._container.appendChild(l), n.options.interactive && n.addInteractiveTarget(l);
      },
      _removePath: function(n) {
        var l = n._container;
        Re(l), n.removeInteractiveTarget(l), delete this._layers[d(n)];
      },
      _updateStyle: function(n) {
        var l = n._stroke, c = n._fill, h = n.options, f = n._container;
        f.stroked = !!h.stroke, f.filled = !!h.fill, h.stroke ? (l || (l = n._stroke = as("stroke")), f.appendChild(l), l.weight = h.weight + "px", l.color = h.color, l.opacity = h.opacity, h.dashArray ? l.dashStyle = C(h.dashArray) ? h.dashArray.join(" ") : h.dashArray.replace(/( *, *)/g, " ") : l.dashStyle = "", l.endcap = h.lineCap.replace("butt", "flat"), l.joinstyle = h.lineJoin) : l && (f.removeChild(l), n._stroke = null), h.fill ? (c || (c = n._fill = as("fill")), f.appendChild(c), c.color = h.fillColor || h.color, c.opacity = h.fillOpacity) : c && (f.removeChild(c), n._fill = null);
      },
      _updateCircle: function(n) {
        var l = n._point.round(), c = Math.round(n._radius), h = Math.round(n._radiusY || c);
        this._setPath(n, n._empty() ? "M0 0" : "AL " + l.x + "," + l.y + " " + c + "," + h + " 0," + 65535 * 360);
      },
      _setPath: function(n, l) {
        n._path.v = l;
      },
      _bringToFront: function(n) {
        Tr(n._container);
      },
      _bringToBack: function(n) {
        Lr(n._container);
      }
    }, Hs = oe.vml ? as : aa, ls = Rt.extend({
      _initContainer: function() {
        this._container = Hs("svg"), this._container.setAttribute("pointer-events", "none"), this._rootGroup = Hs("g"), this._container.appendChild(this._rootGroup);
      },
      _destroyContainer: function() {
        Re(this._container), Je(this._container), delete this._container, delete this._rootGroup, delete this._svgSize;
      },
      _update: function() {
        if (!(this._map._animatingZoom && this._bounds)) {
          Rt.prototype._update.call(this);
          var n = this._bounds, l = n.getSize(), c = this._container;
          (!this._svgSize || !this._svgSize.equals(l)) && (this._svgSize = l, c.setAttribute("width", l.x), c.setAttribute("height", l.y)), Ge(c, n.min), c.setAttribute("viewBox", [n.min.x, n.min.y, l.x, l.y].join(" ")), this.fire("update");
        }
      },
      // methods below are called by vector layers implementations
      _initPath: function(n) {
        var l = n._path = Hs("path");
        n.options.className && me(l, n.options.className), n.options.interactive && me(l, "leaflet-interactive"), this._updateStyle(n), this._layers[d(n)] = n;
      },
      _addPath: function(n) {
        this._rootGroup || this._initContainer(), this._rootGroup.appendChild(n._path), n.addInteractiveTarget(n._path);
      },
      _removePath: function(n) {
        Re(n._path), n.removeInteractiveTarget(n._path), delete this._layers[d(n)];
      },
      _updatePath: function(n) {
        n._project(), n._update();
      },
      _updateStyle: function(n) {
        var l = n._path, c = n.options;
        l && (c.stroke ? (l.setAttribute("stroke", c.color), l.setAttribute("stroke-opacity", c.opacity), l.setAttribute("stroke-width", c.weight), l.setAttribute("stroke-linecap", c.lineCap), l.setAttribute("stroke-linejoin", c.lineJoin), c.dashArray ? l.setAttribute("stroke-dasharray", c.dashArray) : l.removeAttribute("stroke-dasharray"), c.dashOffset ? l.setAttribute("stroke-dashoffset", c.dashOffset) : l.removeAttribute("stroke-dashoffset")) : l.setAttribute("stroke", "none"), c.fill ? (l.setAttribute("fill", c.fillColor || c.color), l.setAttribute("fill-opacity", c.fillOpacity), l.setAttribute("fill-rule", c.fillRule || "evenodd")) : l.setAttribute("fill", "none"));
      },
      _updatePoly: function(n, l) {
        this._setPath(n, la(n._parts, l));
      },
      _updateCircle: function(n) {
        var l = n._point, c = Math.max(Math.round(n._radius), 1), h = Math.max(Math.round(n._radiusY), 1) || c, f = "a" + c + "," + h + " 0 1,0 ", y = n._empty() ? "M0 0" : "M" + (l.x - c) + "," + l.y + f + c * 2 + ",0 " + f + -c * 2 + ",0 ";
        this._setPath(n, y);
      },
      _setPath: function(n, l) {
        n._path.setAttribute("d", l);
      },
      // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
      _bringToFront: function(n) {
        Tr(n._path);
      },
      _bringToBack: function(n) {
        Lr(n._path);
      }
    });
    oe.vml && ls.include(Md);
    function il(n) {
      return oe.svg || oe.vml ? new ls(n) : null;
    }
    xe.include({
      // @namespace Map; @method getRenderer(layer: Path): Renderer
      // Returns the instance of `Renderer` that should be used to render the given
      // `Path`. It will ensure that the `renderer` options of the map and paths
      // are respected, and that the renderers do exist on the map.
      getRenderer: function(n) {
        var l = n.options.renderer || this._getPaneRenderer(n.options.pane) || this.options.renderer || this._renderer;
        return l || (l = this._renderer = this._createRenderer()), this.hasLayer(l) || this.addLayer(l), l;
      },
      _getPaneRenderer: function(n) {
        if (n === "overlayPane" || n === void 0)
          return !1;
        var l = this._paneRenderers[n];
        return l === void 0 && (l = this._createRenderer({ pane: n }), this._paneRenderers[n] = l), l;
      },
      _createRenderer: function(n) {
        return this.options.preferCanvas && sl(n) || il(n);
      }
    });
    var nl = Or.extend({
      initialize: function(n, l) {
        Or.prototype.initialize.call(this, this._boundsToLatLngs(n), l);
      },
      // @method setBounds(latLngBounds: LatLngBounds): this
      // Redraws the rectangle with the passed bounds.
      setBounds: function(n) {
        return this.setLatLngs(this._boundsToLatLngs(n));
      },
      _boundsToLatLngs: function(n) {
        return n = Le(n), [
          n.getSouthWest(),
          n.getNorthWest(),
          n.getNorthEast(),
          n.getSouthEast()
        ];
      }
    });
    function Nd(n, l) {
      return new nl(n, l);
    }
    ls.create = Hs, ls.pointsToPath = la, Bt.geometryToLayer = zs, Bt.coordsToLatLng = bn, Bt.coordsToLatLngs = qs, Bt.latLngToCoords = wn, Bt.latLngsToCoords = Zs, Bt.getFeature = kr, Bt.asFeature = Vs, xe.mergeOptions({
      // @option boxZoom: Boolean = true
      // Whether the map can be zoomed to a rectangular area specified by
      // dragging the mouse while pressing the shift key.
      boxZoom: !0
    });
    var ol = It.extend({
      initialize: function(n) {
        this._map = n, this._container = n._container, this._pane = n._panes.overlayPane, this._resetStateTimeout = 0, n.on("unload", this._destroy, this);
      },
      addHooks: function() {
        fe(this._container, "mousedown", this._onMouseDown, this);
      },
      removeHooks: function() {
        Je(this._container, "mousedown", this._onMouseDown, this);
      },
      moved: function() {
        return this._moved;
      },
      _destroy: function() {
        Re(this._pane), delete this._pane;
      },
      _resetState: function() {
        this._resetStateTimeout = 0, this._moved = !1;
      },
      _clearDeferredResetState: function() {
        this._resetStateTimeout !== 0 && (clearTimeout(this._resetStateTimeout), this._resetStateTimeout = 0);
      },
      _onMouseDown: function(n) {
        if (!n.shiftKey || n.which !== 1 && n.button !== 1)
          return !1;
        this._clearDeferredResetState(), this._resetState(), Xr(), rn(), this._startPoint = this._map.mouseEventToContainerPoint(n), fe(document, {
          contextmenu: or,
          mousemove: this._onMouseMove,
          mouseup: this._onMouseUp,
          keydown: this._onKeyDown
        }, this);
      },
      _onMouseMove: function(n) {
        this._moved || (this._moved = !0, this._box = Ae("div", "leaflet-zoom-box", this._container), me(this._container, "leaflet-crosshair"), this._map.fire("boxzoomstart")), this._point = this._map.mouseEventToContainerPoint(n);
        var l = new Q(this._point, this._startPoint), c = l.getSize();
        Ge(this._box, l.min), this._box.style.width = c.x + "px", this._box.style.height = c.y + "px";
      },
      _finish: function() {
        this._moved && (Re(this._box), Ve(this._container, "leaflet-crosshair")), es(), sn(), Je(document, {
          contextmenu: or,
          mousemove: this._onMouseMove,
          mouseup: this._onMouseUp,
          keydown: this._onKeyDown
        }, this);
      },
      _onMouseUp: function(n) {
        if (!(n.which !== 1 && n.button !== 1) && (this._finish(), !!this._moved)) {
          this._clearDeferredResetState(), this._resetStateTimeout = setTimeout(i(this._resetState, this), 0);
          var l = new De(
            this._map.containerPointToLatLng(this._startPoint),
            this._map.containerPointToLatLng(this._point)
          );
          this._map.fitBounds(l).fire("boxzoomend", { boxZoomBounds: l });
        }
      },
      _onKeyDown: function(n) {
        n.keyCode === 27 && (this._finish(), this._clearDeferredResetState(), this._resetState());
      }
    });
    xe.addInitHook("addHandler", "boxZoom", ol), xe.mergeOptions({
      // @option doubleClickZoom: Boolean|String = true
      // Whether the map can be zoomed in by double clicking on it and
      // zoomed out by double clicking while holding shift. If passed
      // `'center'`, double-click zoom will zoom to the center of the
      //  view regardless of where the mouse was.
      doubleClickZoom: !0
    });
    var al = It.extend({
      addHooks: function() {
        this._map.on("dblclick", this._onDoubleClick, this);
      },
      removeHooks: function() {
        this._map.off("dblclick", this._onDoubleClick, this);
      },
      _onDoubleClick: function(n) {
        var l = this._map, c = l.getZoom(), h = l.options.zoomDelta, f = n.originalEvent.shiftKey ? c - h : c + h;
        l.options.doubleClickZoom === "center" ? l.setZoom(f) : l.setZoomAround(n.containerPoint, f);
      }
    });
    xe.addInitHook("addHandler", "doubleClickZoom", al), xe.mergeOptions({
      // @option dragging: Boolean = true
      // Whether the map is draggable with mouse/touch or not.
      dragging: !0,
      // @section Panning Inertia Options
      // @option inertia: Boolean = *
      // If enabled, panning of the map will have an inertia effect where
      // the map builds momentum while dragging and continues moving in
      // the same direction for some time. Feels especially nice on touch
      // devices. Enabled by default.
      inertia: !0,
      // @option inertiaDeceleration: Number = 3000
      // The rate with which the inertial movement slows down, in pixels/second².
      inertiaDeceleration: 3400,
      // px/s^2
      // @option inertiaMaxSpeed: Number = Infinity
      // Max speed of the inertial movement, in pixels/second.
      inertiaMaxSpeed: 1 / 0,
      // px/s
      // @option easeLinearity: Number = 0.2
      easeLinearity: 0.2,
      // TODO refactor, move to CRS
      // @option worldCopyJump: Boolean = false
      // With this option enabled, the map tracks when you pan to another "copy"
      // of the world and seamlessly jumps to the original one so that all overlays
      // like markers and vector layers are still visible.
      worldCopyJump: !1,
      // @option maxBoundsViscosity: Number = 0.0
      // If `maxBounds` is set, this option will control how solid the bounds
      // are when dragging the map around. The default value of `0.0` allows the
      // user to drag outside the bounds at normal speed, higher values will
      // slow down map dragging outside bounds, and `1.0` makes the bounds fully
      // solid, preventing the user from dragging outside the bounds.
      maxBoundsViscosity: 0
    });
    var ll = It.extend({
      addHooks: function() {
        if (!this._draggable) {
          var n = this._map;
          this._draggable = new Wt(n._mapPane, n._container), this._draggable.on({
            dragstart: this._onDragStart,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this), this._draggable.on("predrag", this._onPreDragLimit, this), n.options.worldCopyJump && (this._draggable.on("predrag", this._onPreDragWrap, this), n.on("zoomend", this._onZoomEnd, this), n.whenReady(this._onZoomEnd, this));
        }
        me(this._map._container, "leaflet-grab leaflet-touch-drag"), this._draggable.enable(), this._positions = [], this._times = [];
      },
      removeHooks: function() {
        Ve(this._map._container, "leaflet-grab"), Ve(this._map._container, "leaflet-touch-drag"), this._draggable.disable();
      },
      moved: function() {
        return this._draggable && this._draggable._moved;
      },
      moving: function() {
        return this._draggable && this._draggable._moving;
      },
      _onDragStart: function() {
        var n = this._map;
        if (n._stop(), this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
          var l = Le(this._map.options.maxBounds);
          this._offsetLimit = be(
            this._map.latLngToContainerPoint(l.getNorthWest()).multiplyBy(-1),
            this._map.latLngToContainerPoint(l.getSouthEast()).multiplyBy(-1).add(this._map.getSize())
          ), this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity));
        } else
          this._offsetLimit = null;
        n.fire("movestart").fire("dragstart"), n.options.inertia && (this._positions = [], this._times = []);
      },
      _onDrag: function(n) {
        if (this._map.options.inertia) {
          var l = this._lastTime = +/* @__PURE__ */ new Date(), c = this._lastPos = this._draggable._absPos || this._draggable._newPos;
          this._positions.push(c), this._times.push(l), this._prunePositions(l);
        }
        this._map.fire("move", n).fire("drag", n);
      },
      _prunePositions: function(n) {
        for (; this._positions.length > 1 && n - this._times[0] > 50; )
          this._positions.shift(), this._times.shift();
      },
      _onZoomEnd: function() {
        var n = this._map.getSize().divideBy(2), l = this._map.latLngToLayerPoint([0, 0]);
        this._initialWorldOffset = l.subtract(n).x, this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
      },
      _viscousLimit: function(n, l) {
        return n - (n - l) * this._viscosity;
      },
      _onPreDragLimit: function() {
        if (!(!this._viscosity || !this._offsetLimit)) {
          var n = this._draggable._newPos.subtract(this._draggable._startPos), l = this._offsetLimit;
          n.x < l.min.x && (n.x = this._viscousLimit(n.x, l.min.x)), n.y < l.min.y && (n.y = this._viscousLimit(n.y, l.min.y)), n.x > l.max.x && (n.x = this._viscousLimit(n.x, l.max.x)), n.y > l.max.y && (n.y = this._viscousLimit(n.y, l.max.y)), this._draggable._newPos = this._draggable._startPos.add(n);
        }
      },
      _onPreDragWrap: function() {
        var n = this._worldWidth, l = Math.round(n / 2), c = this._initialWorldOffset, h = this._draggable._newPos.x, f = (h - l + c) % n + l - c, y = (h + l + c) % n - l - c, S = Math.abs(f + c) < Math.abs(y + c) ? f : y;
        this._draggable._absPos = this._draggable._newPos.clone(), this._draggable._newPos.x = S;
      },
      _onDragEnd: function(n) {
        var l = this._map, c = l.options, h = !c.inertia || n.noInertia || this._times.length < 2;
        if (l.fire("dragend", n), h)
          l.fire("moveend");
        else {
          this._prunePositions(+/* @__PURE__ */ new Date());
          var f = this._lastPos.subtract(this._positions[0]), y = (this._lastTime - this._times[0]) / 1e3, S = c.easeLinearity, E = f.multiplyBy(S / y), M = E.distanceTo([0, 0]), q = Math.min(c.inertiaMaxSpeed, M), K = E.multiplyBy(q / M), le = q / (c.inertiaDeceleration * S), ye = K.multiplyBy(-le / 2).round();
          !ye.x && !ye.y ? l.fire("moveend") : (ye = l._limitOffset(ye, l.options.maxBounds), W(function() {
            l.panBy(ye, {
              duration: le,
              easeLinearity: S,
              noMoveStart: !0,
              animate: !0
            });
          }));
        }
      }
    });
    xe.addInitHook("addHandler", "dragging", ll), xe.mergeOptions({
      // @option keyboard: Boolean = true
      // Makes the map focusable and allows users to navigate the map with keyboard
      // arrows and `+`/`-` keys.
      keyboard: !0,
      // @option keyboardPanDelta: Number = 80
      // Amount of pixels to pan when pressing an arrow key.
      keyboardPanDelta: 80
    });
    var ul = It.extend({
      keyCodes: {
        left: [37],
        right: [39],
        down: [40],
        up: [38],
        zoomIn: [187, 107, 61, 171],
        zoomOut: [189, 109, 54, 173]
      },
      initialize: function(n) {
        this._map = n, this._setPanDelta(n.options.keyboardPanDelta), this._setZoomDelta(n.options.zoomDelta);
      },
      addHooks: function() {
        var n = this._map._container;
        n.tabIndex <= 0 && (n.tabIndex = "0"), fe(n, {
          focus: this._onFocus,
          blur: this._onBlur,
          mousedown: this._onMouseDown
        }, this), this._map.on({
          focus: this._addHooks,
          blur: this._removeHooks
        }, this);
      },
      removeHooks: function() {
        this._removeHooks(), Je(this._map._container, {
          focus: this._onFocus,
          blur: this._onBlur,
          mousedown: this._onMouseDown
        }, this), this._map.off({
          focus: this._addHooks,
          blur: this._removeHooks
        }, this);
      },
      _onMouseDown: function() {
        if (!this._focused) {
          var n = document.body, l = document.documentElement, c = n.scrollTop || l.scrollTop, h = n.scrollLeft || l.scrollLeft;
          this._map._container.focus(), window.scrollTo(h, c);
        }
      },
      _onFocus: function() {
        this._focused = !0, this._map.fire("focus");
      },
      _onBlur: function() {
        this._focused = !1, this._map.fire("blur");
      },
      _setPanDelta: function(n) {
        var l = this._panKeys = {}, c = this.keyCodes, h, f;
        for (h = 0, f = c.left.length; h < f; h++)
          l[c.left[h]] = [-1 * n, 0];
        for (h = 0, f = c.right.length; h < f; h++)
          l[c.right[h]] = [n, 0];
        for (h = 0, f = c.down.length; h < f; h++)
          l[c.down[h]] = [0, n];
        for (h = 0, f = c.up.length; h < f; h++)
          l[c.up[h]] = [0, -1 * n];
      },
      _setZoomDelta: function(n) {
        var l = this._zoomKeys = {}, c = this.keyCodes, h, f;
        for (h = 0, f = c.zoomIn.length; h < f; h++)
          l[c.zoomIn[h]] = n;
        for (h = 0, f = c.zoomOut.length; h < f; h++)
          l[c.zoomOut[h]] = -n;
      },
      _addHooks: function() {
        fe(document, "keydown", this._onKeyDown, this);
      },
      _removeHooks: function() {
        Je(document, "keydown", this._onKeyDown, this);
      },
      _onKeyDown: function(n) {
        if (!(n.altKey || n.ctrlKey || n.metaKey)) {
          var l = n.keyCode, c = this._map, h;
          if (l in this._panKeys) {
            if (!c._panAnim || !c._panAnim._inProgress)
              if (h = this._panKeys[l], n.shiftKey && (h = J(h).multiplyBy(3)), c.options.maxBounds && (h = c._limitOffset(J(h), c.options.maxBounds)), c.options.worldCopyJump) {
                var f = c.wrapLatLng(c.unproject(c.project(c.getCenter()).add(h)));
                c.panTo(f);
              } else
                c.panBy(h);
          } else if (l in this._zoomKeys)
            c.setZoom(c.getZoom() + (n.shiftKey ? 3 : 1) * this._zoomKeys[l]);
          else if (l === 27 && c._popup && c._popup.options.closeOnEscapeKey)
            c.closePopup();
          else
            return;
          or(n);
        }
      }
    });
    xe.addInitHook("addHandler", "keyboard", ul), xe.mergeOptions({
      // @section Mouse wheel options
      // @option scrollWheelZoom: Boolean|String = true
      // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
      // it will zoom to the center of the view regardless of where the mouse was.
      scrollWheelZoom: !0,
      // @option wheelDebounceTime: Number = 40
      // Limits the rate at which a wheel can fire (in milliseconds). By default
      // user can't zoom via wheel more often than once per 40 ms.
      wheelDebounceTime: 40,
      // @option wheelPxPerZoomLevel: Number = 60
      // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
      // mean a change of one full zoom level. Smaller values will make wheel-zooming
      // faster (and vice versa).
      wheelPxPerZoomLevel: 60
    });
    var cl = It.extend({
      addHooks: function() {
        fe(this._map._container, "wheel", this._onWheelScroll, this), this._delta = 0;
      },
      removeHooks: function() {
        Je(this._map._container, "wheel", this._onWheelScroll, this);
      },
      _onWheelScroll: function(n) {
        var l = Da(n), c = this._map.options.wheelDebounceTime;
        this._delta += l, this._lastMousePos = this._map.mouseEventToContainerPoint(n), this._startTime || (this._startTime = +/* @__PURE__ */ new Date());
        var h = Math.max(c - (+/* @__PURE__ */ new Date() - this._startTime), 0);
        clearTimeout(this._timer), this._timer = setTimeout(i(this._performZoom, this), h), or(n);
      },
      _performZoom: function() {
        var n = this._map, l = n.getZoom(), c = this._map.options.zoomSnap || 0;
        n._stop();
        var h = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), f = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(h)))) / Math.LN2, y = c ? Math.ceil(f / c) * c : f, S = n._limitZoom(l + (this._delta > 0 ? y : -y)) - l;
        this._delta = 0, this._startTime = null, S && (n.options.scrollWheelZoom === "center" ? n.setZoom(l + S) : n.setZoomAround(this._lastMousePos, l + S));
      }
    });
    xe.addInitHook("addHandler", "scrollWheelZoom", cl);
    var Jd = 600;
    xe.mergeOptions({
      // @section Touch interaction options
      // @option tapHold: Boolean
      // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
      tapHold: oe.touchNative && oe.safari && oe.mobile,
      // @option tapTolerance: Number = 15
      // The max number of pixels a user can shift his finger during touch
      // for it to be considered a valid tap.
      tapTolerance: 15
    });
    var hl = It.extend({
      addHooks: function() {
        fe(this._map._container, "touchstart", this._onDown, this);
      },
      removeHooks: function() {
        Je(this._map._container, "touchstart", this._onDown, this);
      },
      _onDown: function(n) {
        if (clearTimeout(this._holdTimeout), n.touches.length === 1) {
          var l = n.touches[0];
          this._startPos = this._newPos = new ue(l.clientX, l.clientY), this._holdTimeout = setTimeout(i(function() {
            this._cancel(), this._isTapValid() && (fe(document, "touchend", tt), fe(document, "touchend touchcancel", this._cancelClickPrevent), this._simulateEvent("contextmenu", l));
          }, this), Jd), fe(document, "touchend touchcancel contextmenu", this._cancel, this), fe(document, "touchmove", this._onMove, this);
        }
      },
      _cancelClickPrevent: function n() {
        Je(document, "touchend", tt), Je(document, "touchend touchcancel", n);
      },
      _cancel: function() {
        clearTimeout(this._holdTimeout), Je(document, "touchend touchcancel contextmenu", this._cancel, this), Je(document, "touchmove", this._onMove, this);
      },
      _onMove: function(n) {
        var l = n.touches[0];
        this._newPos = new ue(l.clientX, l.clientY);
      },
      _isTapValid: function() {
        return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
      },
      _simulateEvent: function(n, l) {
        var c = new MouseEvent(n, {
          bubbles: !0,
          cancelable: !0,
          view: window,
          // detail: 1,
          screenX: l.screenX,
          screenY: l.screenY,
          clientX: l.clientX,
          clientY: l.clientY
          // button: 2,
          // buttons: 2
        });
        c._simulated = !0, l.target.dispatchEvent(c);
      }
    });
    xe.addInitHook("addHandler", "tapHold", hl), xe.mergeOptions({
      // @section Touch interaction options
      // @option touchZoom: Boolean|String = *
      // Whether the map can be zoomed by touch-dragging with two fingers. If
      // passed `'center'`, it will zoom to the center of the view regardless of
      // where the touch events (fingers) were. Enabled for touch-capable web
      // browsers.
      touchZoom: oe.touch,
      // @option bounceAtZoomLimits: Boolean = true
      // Set it to false if you don't want the map to zoom beyond min/max zoom
      // and then bounce back when pinch-zooming.
      bounceAtZoomLimits: !0
    });
    var dl = It.extend({
      addHooks: function() {
        me(this._map._container, "leaflet-touch-zoom"), fe(this._map._container, "touchstart", this._onTouchStart, this);
      },
      removeHooks: function() {
        Ve(this._map._container, "leaflet-touch-zoom"), Je(this._map._container, "touchstart", this._onTouchStart, this);
      },
      _onTouchStart: function(n) {
        var l = this._map;
        if (!(!n.touches || n.touches.length !== 2 || l._animatingZoom || this._zooming)) {
          var c = l.mouseEventToContainerPoint(n.touches[0]), h = l.mouseEventToContainerPoint(n.touches[1]);
          this._centerPoint = l.getSize()._divideBy(2), this._startLatLng = l.containerPointToLatLng(this._centerPoint), l.options.touchZoom !== "center" && (this._pinchStartLatLng = l.containerPointToLatLng(c.add(h)._divideBy(2))), this._startDist = c.distanceTo(h), this._startZoom = l.getZoom(), this._moved = !1, this._zooming = !0, l._stop(), fe(document, "touchmove", this._onTouchMove, this), fe(document, "touchend touchcancel", this._onTouchEnd, this), tt(n);
        }
      },
      _onTouchMove: function(n) {
        if (!(!n.touches || n.touches.length !== 2 || !this._zooming)) {
          var l = this._map, c = l.mouseEventToContainerPoint(n.touches[0]), h = l.mouseEventToContainerPoint(n.touches[1]), f = c.distanceTo(h) / this._startDist;
          if (this._zoom = l.getScaleZoom(f, this._startZoom), !l.options.bounceAtZoomLimits && (this._zoom < l.getMinZoom() && f < 1 || this._zoom > l.getMaxZoom() && f > 1) && (this._zoom = l._limitZoom(this._zoom)), l.options.touchZoom === "center") {
            if (this._center = this._startLatLng, f === 1)
              return;
          } else {
            var y = c._add(h)._divideBy(2)._subtract(this._centerPoint);
            if (f === 1 && y.x === 0 && y.y === 0)
              return;
            this._center = l.unproject(l.project(this._pinchStartLatLng, this._zoom).subtract(y), this._zoom);
          }
          this._moved || (l._moveStart(!0, !1), this._moved = !0), Y(this._animRequest);
          var S = i(l._move, l, this._center, this._zoom, { pinch: !0, round: !1 }, void 0);
          this._animRequest = W(S, this, !0), tt(n);
        }
      },
      _onTouchEnd: function() {
        if (!this._moved || !this._zooming) {
          this._zooming = !1;
          return;
        }
        this._zooming = !1, Y(this._animRequest), Je(document, "touchmove", this._onTouchMove, this), Je(document, "touchend touchcancel", this._onTouchEnd, this), this._map.options.zoomAnimation ? this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), !0, this._map.options.zoomSnap) : this._map._resetView(this._center, this._map._limitZoom(this._zoom));
      }
    });
    xe.addInitHook("addHandler", "touchZoom", dl), xe.BoxZoom = ol, xe.DoubleClickZoom = al, xe.Drag = ll, xe.Keyboard = ul, xe.ScrollWheelZoom = cl, xe.TapHold = hl, xe.TouchZoom = dl, t.Bounds = Q, t.Browser = oe, t.CRS = Nt, t.Canvas = rl, t.Circle = _n, t.CircleMarker = Rs, t.Class = Z, t.Control = wt, t.DivIcon = Xa, t.DivOverlay = jt, t.DomEvent = td, t.DomUtil = Xh, t.Draggable = Wt, t.Evented = ot, t.FeatureGroup = Jt, t.GeoJSON = Bt, t.GridLayer = os, t.Handler = It, t.Icon = Ar, t.ImageOverlay = $s, t.LatLng = Ce, t.LatLngBounds = De, t.Layer = Pt, t.LayerGroup = Cr, t.LineUtil = pd, t.Map = xe, t.Marker = Bs, t.Mixin = ld, t.Path = Kt, t.Point = ue, t.PolyUtil = ud, t.Polygon = Or, t.Polyline = Ut, t.Popup = Fs, t.PosAnimation = Ma, t.Projection = md, t.Rectangle = nl, t.Renderer = Rt, t.SVG = ls, t.SVGOverlay = Ya, t.TileLayer = Ir, t.Tooltip = Gs, t.Transformation = Vi, t.Util = X, t.VideoOverlay = Qa, t.bind = i, t.bounds = be, t.canvas = sl, t.circle = xd, t.circleMarker = Pd, t.control = ss, t.divIcon = jd, t.extend = r, t.featureGroup = _d, t.geoJSON = Ka, t.geoJson = Ld, t.gridLayer = Ed, t.icon = bd, t.imageOverlay = Cd, t.latLng = ve, t.latLngBounds = Le, t.layerGroup = yd, t.map = rd, t.marker = wd, t.point = J, t.polygon = Td, t.polyline = Sd, t.popup = kd, t.rectangle = Nd, t.setOptions = P, t.stamp = d, t.svg = il, t.svgOverlay = Od, t.tileLayer = el, t.tooltip = Id, t.transformation = Wr, t.version = o, t.videoOverlay = Ad;
    var Ud = window.L;
    t.noConflict = function() {
      return window.L = Ud, this;
    }, window.L = t;
  });
})(Wn, Wn.exports);
var ce = Wn.exports;
const b4 = /* @__PURE__ */ ea(ce);
/*!
Copyright (c) 2016 Dominik Moritz

This file is part of the leaflet locate control. It is licensed under the MIT license.
You can find the project at: https://github.com/domoritz/leaflet-locatecontrol
*/
const ur = (a, e) => {
  e.split(" ").forEach((t) => {
    a.classList.add(t);
  });
}, cr = (a, e) => {
  e.split(" ").forEach((t) => {
    a.classList.remove(t);
  });
}, bh = ce.Marker.extend({
  initialize(a, e) {
    ce.setOptions(this, e), this._latlng = a, this.createIcon();
  },
  /**
   * Create a styled circle location marker
   */
  createIcon() {
    const a = this.options, e = [
      ["stroke", a.color],
      ["stroke-width", a.weight],
      ["fill", a.fillColor],
      ["fill-opacity", a.fillOpacity],
      ["opacity", a.opacity]
    ].filter(([o, r]) => r !== void 0).map(([o, r]) => `${o}="${r}"`).join(" "), t = this._getIconSVG(a, e);
    this._locationIcon = ce.divIcon({
      className: t.className,
      html: t.svg,
      iconSize: [t.w, t.h]
    }), this.setIcon(this._locationIcon);
  },
  /**
   * Return the raw svg for the shape
   *
   * Split so can be easily overridden
   */
  _getIconSVG(a, e) {
    const t = a.radius, o = a.weight, r = t + o, s = r * 2;
    return {
      className: "leaflet-control-locate-location",
      svg: `<svg xmlns="http://www.w3.org/2000/svg" width="${s}" height="${s}" version="1.1" viewBox="-${r} -${r} ${s} ${s}"><circle r="${t}" ${e} /></svg>`,
      w: s,
      h: s
    };
  },
  setStyle(a) {
    ce.setOptions(this, a), this.createIcon();
  }
}), w4 = bh.extend({
  initialize(a, e, t) {
    ce.setOptions(this, t), this._latlng = a, this._heading = e, this.createIcon();
  },
  setHeading(a) {
    this._heading = a;
  },
  /**
   * Create a styled arrow compass marker
   */
  _getIconSVG(a, e) {
    const t = a.radius, o = t + a.weight + a.depth, r = o * 2, s = this._arrowPoints(t, a.width, a.depth, this._heading);
    return {
      className: "leaflet-control-locate-heading",
      svg: `<svg xmlns="http://www.w3.org/2000/svg" width="${r}" height="${r}" version="1.1" viewBox="-${o} -${o} ${r} ${r}"><path d="${s}" ${e} /></svg>`,
      w: r,
      h: r
    };
  },
  _arrowPoints(a, e, t, o) {
    const r = (o - 90) * Math.PI / 180, s = Math.cos(r), i = Math.sin(r), u = -Math.sin(r), d = Math.cos(r), m = e / 2, v = a * s, p = a * i, g = v + m * u, w = p + m * d, _ = v - m * u, P = p - m * d, T = v + t * s, k = p + t * i;
    return `M ${g},${w} L ${_},${P} L ${T},${k} Z`;
  }
}), P4 = ce.Control.extend({
  options: {
    /** Position of the control */
    position: "topleft",
    /** The layer that the user's location should be drawn on. By default creates a new layer. */
    layer: void 0,
    /**
     * Automatically sets the map view (zoom and pan) to the user's location as it updates.
     * While the map is following the user's location, the control is in the `following` state,
     * which changes the style of the control and the circle marker.
     *
     * Possible values:
     *  - false: never updates the map view when location changes.
     *  - 'once': set the view when the location is first determined
     *  - 'always': always updates the map view when location changes.
     *              The map view follows the user's location.
     *  - 'untilPan': like 'always', except stops updating the
     *                view if the user has manually panned the map.
     *                The map view follows the user's location until she pans.
     *  - 'untilPanOrZoom': (default) like 'always', except stops updating the
     *                view if the user has manually panned the map.
     *                The map view follows the user's location until she pans.
     */
    setView: "untilPanOrZoom",
    /** Keep the current map zoom level when setting the view and only pan. */
    keepCurrentZoomLevel: !1,
    /** After activating the plugin by clicking on the icon, zoom to the selected zoom level, even when keepCurrentZoomLevel is true. Set to 'false' to disable this feature. */
    initialZoomLevel: !1,
    /**
     * This callback can be used to override the viewport tracking
     * This function should return a LatLngBounds object.
     *
     * For example to extend the viewport to ensure that a particular LatLng is visible:
     *
     * getLocationBounds: function(locationEvent) {
     *    return locationEvent.bounds.extend([-33.873085, 151.219273]);
     * },
     */
    getLocationBounds(a) {
      return a.bounds;
    },
    /** Smooth pan and zoom to the location of the marker. Only works in Leaflet 1.0+. */
    flyTo: !1,
    /**
     * The user location can be inside and outside the current view when the user clicks on the
     * control that is already active. Both cases can be configures separately.
     * Possible values are:
     *  - 'setView': zoom and pan to the current location
     *  - 'stop': stop locating and remove the location marker
     */
    clickBehavior: {
      /** What should happen if the user clicks on the control while the location is within the current view. */
      inView: "stop",
      /** What should happen if the user clicks on the control while the location is outside the current view. */
      outOfView: "setView",
      /**
       * What should happen if the user clicks on the control while the location is within the current view
       * and we could be following but are not. Defaults to a special value which inherits from 'inView';
       */
      inViewNotFollowing: "inView"
    },
    /**
     * If set, save the map bounds just before centering to the user's
     * location. When control is disabled, set the view back to the
     * bounds that were saved.
     */
    returnToPrevBounds: !1,
    /**
     * Keep a cache of the location after the user deactivates the control. If set to false, the user has to wait
     * until the locate API returns a new location before they see where they are again.
     */
    cacheLocation: !0,
    /** If set, a circle that shows the location accuracy is drawn. */
    drawCircle: !0,
    /** If set, the marker at the users' location is drawn. */
    drawMarker: !0,
    /** If set and supported then show the compass heading */
    showCompass: !0,
    /** The class to be used to create the marker. For example L.CircleMarker or L.Marker */
    markerClass: bh,
    /** The class us be used to create the compass bearing arrow */
    compassClass: w4,
    /** Accuracy circle style properties. NOTE these styles should match the css animations styles */
    circleStyle: {
      className: "leaflet-control-locate-circle",
      color: "#136AEC",
      fillColor: "#136AEC",
      fillOpacity: 0.15,
      weight: 0
    },
    /** Inner marker style properties. Only works if your marker class supports `setStyle`. */
    markerStyle: {
      className: "leaflet-control-locate-marker",
      color: "#fff",
      fillColor: "#2A93EE",
      fillOpacity: 1,
      weight: 3,
      opacity: 1,
      radius: 9
    },
    /** Compass */
    compassStyle: {
      fillColor: "#2A93EE",
      fillOpacity: 1,
      weight: 0,
      color: "#fff",
      opacity: 1,
      radius: 9,
      // How far is the arrow from the center of the marker
      width: 9,
      // Width of the arrow
      depth: 6
      // Length of the arrow
    },
    /**
     * Changes to accuracy circle and inner marker while following.
     * It is only necessary to provide the properties that should change.
     */
    followCircleStyle: {},
    followMarkerStyle: {
      // color: '#FFA500',
      // fillColor: '#FFB000'
    },
    followCompassStyle: {},
    /** The CSS class for the icon. For example fa-location-arrow or fa-map-marker */
    icon: "leaflet-control-locate-location-arrow",
    iconLoading: "leaflet-control-locate-spinner",
    /** The element to be created for icons. For example span or i */
    iconElementTag: "span",
    /** The element to be created for the text. For example small or span */
    textElementTag: "small",
    /** Padding around the accuracy circle. */
    circlePadding: [0, 0],
    /** Use metric units. */
    metric: !0,
    /**
     * This callback can be used in case you would like to override button creation behavior.
     * This is useful for DOM manipulation frameworks such as angular etc.
     * This function should return an object with HtmlElement for the button (link property) and the icon (icon property).
     */
    createButtonCallback(a, e) {
      const t = ce.DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single", a);
      t.title = e.strings.title, t.href = "#", t.setAttribute("role", "button");
      const o = ce.DomUtil.create(e.iconElementTag, e.icon, t);
      if (e.strings.text !== void 0) {
        const r = ce.DomUtil.create(e.textElementTag, "leaflet-locate-text", t);
        r.textContent = e.strings.text, t.classList.add("leaflet-locate-text-active"), t.parentNode.style.display = "flex", e.icon.length > 0 && o.classList.add("leaflet-locate-icon");
      }
      return { link: t, icon: o };
    },
    /** This event is called in case of any location error that is not a time out error. */
    onLocationError(a, e) {
      alert(a.message);
    },
    /**
     * This event is called when the user's location is outside the bounds set on the map.
     * The event is called repeatedly when the location changes.
     */
    onLocationOutsideMapBounds(a) {
      a.stop(), alert(a.options.strings.outsideMapBoundsMsg);
    },
    /** Display a pop-up when the user click on the inner marker. */
    showPopup: !0,
    strings: {
      title: "Show me where I am",
      metersUnit: "meters",
      feetUnit: "feet",
      popup: "You are within {distance} {unit} from this point",
      outsideMapBoundsMsg: "You seem located outside the boundaries of the map"
    },
    /** The default options passed to leaflets locate method. */
    locateOptions: {
      maxZoom: 1 / 0,
      watch: !0,
      // if you overwrite this, visualization cannot be updated
      setView: !1
      // have to set this to false because we have to
      // do setView manually
    }
  },
  initialize(a) {
    for (const e in a)
      typeof this.options[e] == "object" ? ce.extend(this.options[e], a[e]) : this.options[e] = a[e];
    this.options.followMarkerStyle = ce.extend({}, this.options.markerStyle, this.options.followMarkerStyle), this.options.followCircleStyle = ce.extend({}, this.options.circleStyle, this.options.followCircleStyle), this.options.followCompassStyle = ce.extend({}, this.options.compassStyle, this.options.followCompassStyle);
  },
  /**
   * Add control to map. Returns the container for the control.
   */
  onAdd(a) {
    const e = ce.DomUtil.create("div", "leaflet-control-locate leaflet-bar leaflet-control");
    this._container = e, this._map = a, this._layer = this.options.layer || new ce.LayerGroup(), this._layer.addTo(a), this._event = void 0, this._compassHeading = null, this._prevBounds = null;
    const t = this.options.createButtonCallback(e, this.options);
    return this._link = t.link, this._icon = t.icon, ce.DomEvent.on(
      this._link,
      "click",
      function(o) {
        ce.DomEvent.stopPropagation(o), ce.DomEvent.preventDefault(o), this._onClick();
      },
      this
    ).on(this._link, "dblclick", ce.DomEvent.stopPropagation), this._resetVariables(), this._map.on("unload", this._unload, this), e;
  },
  /**
   * This method is called when the user clicks on the control.
   */
  _onClick() {
    this._justClicked = !0;
    const a = this._isFollowing();
    if (this._userPanned = !1, this._userZoomed = !1, this._active && !this._event)
      this.stop();
    else if (this._active) {
      const e = this.options.clickBehavior;
      let t = e.outOfView;
      switch (this._map.getBounds().contains(this._event.latlng) && (t = a ? e.inView : e.inViewNotFollowing), e[t] && (t = e[t]), t) {
        case "setView":
          this.setView();
          break;
        case "stop":
          this.stop(), this.options.returnToPrevBounds && (this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds).bind(this._map)(this._prevBounds);
          break;
      }
    } else
      this.options.returnToPrevBounds && (this._prevBounds = this._map.getBounds()), this.start();
    this._updateContainerStyle();
  },
  /**
   * Starts the plugin:
   * - activates the engine
   * - draws the marker (if coordinates available)
   */
  start() {
    this._activate(), this._event && (this._drawMarker(this._map), this.options.setView && this.setView()), this._updateContainerStyle();
  },
  /**
   * Stops the plugin:
   * - deactivates the engine
   * - reinitializes the button
   * - removes the marker
   */
  stop() {
    this._deactivate(), this._cleanClasses(), this._resetVariables(), this._removeMarker();
  },
  /**
   * Keep the control active but stop following the location
   */
  stopFollowing() {
    this._userPanned = !0, this._updateContainerStyle(), this._drawMarker();
  },
  /**
   * This method launches the location engine.
   * It is called before the marker is updated,
   * event if it does not mean that the event will be ready.
   *
   * Override it if you want to add more functionalities.
   * It should set the this._active to true and do nothing if
   * this._active is true.
   */
  _activate() {
    if (!(this._active || !this._map) && (this._map.locate(this.options.locateOptions), this._map.fire("locateactivate", this), this._active = !0, this._map.on("locationfound", this._onLocationFound, this), this._map.on("locationerror", this._onLocationError, this), this._map.on("dragstart", this._onDrag, this), this._map.on("zoomstart", this._onZoom, this), this._map.on("zoomend", this._onZoomEnd, this), this.options.showCompass)) {
      const a = "ondeviceorientationabsolute" in window;
      if (a || "ondeviceorientation" in window) {
        const e = this, t = function() {
          ce.DomEvent.on(window, a ? "deviceorientationabsolute" : "deviceorientation", e._onDeviceOrientation, e);
        };
        DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission == "function" ? DeviceOrientationEvent.requestPermission().then(function(o) {
          o === "granted" && t();
        }) : t();
      }
    }
  },
  /**
   * Called to stop the location engine.
   *
   * Override it to shutdown any functionalities you added on start.
   */
  _deactivate() {
    !this._active || !this._map || (this._map.stopLocate(), this._map.fire("locatedeactivate", this), this._active = !1, this.options.cacheLocation || (this._event = void 0), this._map.off("locationfound", this._onLocationFound, this), this._map.off("locationerror", this._onLocationError, this), this._map.off("dragstart", this._onDrag, this), this._map.off("zoomstart", this._onZoom, this), this._map.off("zoomend", this._onZoomEnd, this), this.options.showCompass && (this._compassHeading = null, "ondeviceorientationabsolute" in window ? ce.DomEvent.off(window, "deviceorientationabsolute", this._onDeviceOrientation, this) : "ondeviceorientation" in window && ce.DomEvent.off(window, "deviceorientation", this._onDeviceOrientation, this)));
  },
  /**
   * Zoom (unless we should keep the zoom level) and an to the current view.
   */
  setView() {
    if (this._drawMarker(), this._isOutsideMapBounds())
      this._event = void 0, this.options.onLocationOutsideMapBounds(this);
    else if (this._justClicked && this.options.initialZoomLevel !== !1)
      (this.options.flyTo ? this._map.flyTo : this._map.setView).bind(this._map)([this._event.latitude, this._event.longitude], this.options.initialZoomLevel);
    else if (this.options.keepCurrentZoomLevel)
      (this.options.flyTo ? this._map.flyTo : this._map.panTo).bind(this._map)([this._event.latitude, this._event.longitude]);
    else {
      let a = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
      this._ignoreEvent = !0, a.bind(this._map)(this.options.getLocationBounds(this._event), {
        padding: this.options.circlePadding,
        maxZoom: this.options.initialZoomLevel || this.options.locateOptions.maxZoom
      }), ce.Util.requestAnimFrame(function() {
        this._ignoreEvent = !1;
      }, this);
    }
  },
  /**
   *
   */
  _drawCompass() {
    if (!this._event)
      return;
    const a = this._event.latlng;
    if (this.options.showCompass && a && this._compassHeading !== null) {
      const e = this._isFollowing() ? this.options.followCompassStyle : this.options.compassStyle;
      this._compass ? (this._compass.setLatLng(a), this._compass.setHeading(this._compassHeading), this._compass.setStyle && this._compass.setStyle(e)) : this._compass = new this.options.compassClass(a, this._compassHeading, e).addTo(this._layer);
    }
    this._compass && (!this.options.showCompass || this._compassHeading === null) && (this._compass.removeFrom(this._layer), this._compass = null);
  },
  /**
   * Draw the marker and accuracy circle on the map.
   *
   * Uses the event retrieved from onLocationFound from the map.
   */
  _drawMarker() {
    this._event.accuracy === void 0 && (this._event.accuracy = 0);
    const a = this._event.accuracy, e = this._event.latlng;
    if (this.options.drawCircle) {
      const i = this._isFollowing() ? this.options.followCircleStyle : this.options.circleStyle;
      this._circle ? this._circle.setLatLng(e).setRadius(a).setStyle(i) : this._circle = ce.circle(e, a, i).addTo(this._layer);
    }
    let t, o;
    if (this.options.metric ? (t = a.toFixed(0), o = this.options.strings.metersUnit) : (t = (a * 3.2808399).toFixed(0), o = this.options.strings.feetUnit), this.options.drawMarker) {
      const i = this._isFollowing() ? this.options.followMarkerStyle : this.options.markerStyle;
      this._marker ? (this._marker.setLatLng(e), this._marker.setStyle && this._marker.setStyle(i)) : this._marker = new this.options.markerClass(e, i).addTo(this._layer);
    }
    this._drawCompass();
    const r = this.options.strings.popup;
    function s() {
      return typeof r == "string" ? ce.Util.template(r, { distance: t, unit: o }) : typeof r == "function" ? r({ distance: t, unit: o }) : r;
    }
    this.options.showPopup && r && this._marker && this._marker.bindPopup(s())._popup.setLatLng(e), this.options.showPopup && r && this._compass && this._compass.bindPopup(s())._popup.setLatLng(e);
  },
  /**
   * Remove the marker from map.
   */
  _removeMarker() {
    this._layer.clearLayers(), this._marker = void 0, this._circle = void 0;
  },
  /**
   * Unload the plugin and all event listeners.
   * Kind of the opposite of onAdd.
   */
  _unload() {
    this.stop(), this._map && this._map.off("unload", this._unload, this);
  },
  /**
   * Sets the compass heading
   */
  _setCompassHeading(a) {
    !isNaN(parseFloat(a)) && isFinite(a) ? (a = Math.round(a), this._compassHeading = a, ce.Util.requestAnimFrame(this._drawCompass, this)) : this._compassHeading = null;
  },
  /**
   * If the compass fails calibration just fail safely and remove the compass
   */
  _onCompassNeedsCalibration() {
    this._setCompassHeading();
  },
  /**
   * Process and normalise compass events
   */
  _onDeviceOrientation(a) {
    this._active && (a.webkitCompassHeading ? this._setCompassHeading(a.webkitCompassHeading) : a.absolute && a.alpha && this._setCompassHeading(360 - a.alpha));
  },
  /**
   * Calls deactivate and dispatches an error.
   */
  _onLocationError(a) {
    a.code == 3 && this.options.locateOptions.watch || (this.stop(), this.options.onLocationError(a, this));
  },
  /**
   * Stores the received event and updates the marker.
   */
  _onLocationFound(a) {
    if (!(this._event && this._event.latlng.lat === a.latlng.lat && this._event.latlng.lng === a.latlng.lng && this._event.accuracy === a.accuracy) && this._active) {
      switch (this._event = a, this._drawMarker(), this._updateContainerStyle(), this.options.setView) {
        case "once":
          this._justClicked && this.setView();
          break;
        case "untilPan":
          this._userPanned || this.setView();
          break;
        case "untilPanOrZoom":
          !this._userPanned && !this._userZoomed && this.setView();
          break;
        case "always":
          this.setView();
          break;
      }
      this._justClicked = !1;
    }
  },
  /**
   * When the user drags. Need a separate event so we can bind and unbind event listeners.
   */
  _onDrag() {
    this._event && !this._ignoreEvent && (this._userPanned = !0, this._updateContainerStyle(), this._drawMarker());
  },
  /**
   * When the user zooms. Need a separate event so we can bind and unbind event listeners.
   */
  _onZoom() {
    this._event && !this._ignoreEvent && (this._userZoomed = !0, this._updateContainerStyle(), this._drawMarker());
  },
  /**
   * After a zoom ends update the compass and handle sideways zooms
   */
  _onZoomEnd() {
    this._event && this._drawCompass(), this._event && !this._ignoreEvent && this._marker && !this._map.getBounds().pad(-0.3).contains(this._marker.getLatLng()) && (this._userPanned = !0, this._updateContainerStyle(), this._drawMarker());
  },
  /**
   * Compute whether the map is following the user location with pan and zoom.
   */
  _isFollowing() {
    if (!this._active)
      return !1;
    if (this.options.setView === "always")
      return !0;
    if (this.options.setView === "untilPan")
      return !this._userPanned;
    if (this.options.setView === "untilPanOrZoom")
      return !this._userPanned && !this._userZoomed;
  },
  /**
   * Check if location is in map bounds
   */
  _isOutsideMapBounds() {
    return this._event === void 0 ? !1 : this._map.options.maxBounds && !this._map.options.maxBounds.contains(this._event.latlng);
  },
  /**
   * Toggles button class between following and active.
   */
  _updateContainerStyle() {
    this._container && (this._active && !this._event ? this._setClasses("requesting") : this._isFollowing() ? this._setClasses("following") : this._active ? this._setClasses("active") : this._cleanClasses());
  },
  /**
   * Sets the CSS classes for the state.
   */
  _setClasses(a) {
    a == "requesting" ? (cr(this._container, "active following"), ur(this._container, "requesting"), cr(this._icon, this.options.icon), ur(this._icon, this.options.iconLoading)) : a == "active" ? (cr(this._container, "requesting following"), ur(this._container, "active"), cr(this._icon, this.options.iconLoading), ur(this._icon, this.options.icon)) : a == "following" && (cr(this._container, "requesting"), ur(this._container, "active following"), cr(this._icon, this.options.iconLoading), ur(this._icon, this.options.icon));
  },
  /**
   * Removes all classes from button.
   */
  _cleanClasses() {
    ce.DomUtil.removeClass(this._container, "requesting"), ce.DomUtil.removeClass(this._container, "active"), ce.DomUtil.removeClass(this._container, "following"), cr(this._icon, this.options.iconLoading), ur(this._icon, this.options.icon);
  },
  /**
   * Reinitializes state variables.
   */
  _resetVariables() {
    this._active = !1, this._justClicked = !1, this._userPanned = !1, this._userZoomed = !1;
  }
});
var lu = { exports: {} };
(function(a, e) {
  (function(t, o) {
    o(e);
  })(Mr, function(t) {
    var o = L.MarkerClusterGroup = L.FeatureGroup.extend({
      options: {
        maxClusterRadius: 80,
        //A cluster will cover at most this many pixels from its center
        iconCreateFunction: null,
        clusterPane: L.Marker.prototype.options.pane,
        spiderfyOnEveryZoom: !1,
        spiderfyOnMaxZoom: !0,
        showCoverageOnHover: !0,
        zoomToBoundsOnClick: !0,
        singleMarkerMode: !1,
        disableClusteringAtZoom: null,
        // Setting this to false prevents the removal of any clusters outside of the viewpoint, which
        // is the default behaviour for performance reasons.
        removeOutsideVisibleBounds: !0,
        // Set to false to disable all animations (zoom and spiderfy).
        // If false, option animateAddingMarkers below has no effect.
        // If L.DomUtil.TRANSITION is falsy, this option has no effect.
        animate: !0,
        //Whether to animate adding markers after adding the MarkerClusterGroup to the map
        // If you are adding individual markers set to true, if adding bulk markers leave false for massive performance gains.
        animateAddingMarkers: !1,
        // Make it possible to provide custom function to calculate spiderfy shape positions
        spiderfyShapePositions: null,
        //Increase to increase the distance away that spiderfied markers appear from the center
        spiderfyDistanceMultiplier: 1,
        // Make it possible to specify a polyline options on a spider leg
        spiderLegPolylineOptions: { weight: 1.5, color: "#222", opacity: 0.5 },
        // When bulk adding layers, adds markers in chunks. Means addLayers may not add all the layers in the call, others will be loaded during setTimeouts
        chunkedLoading: !1,
        chunkInterval: 200,
        // process markers for a maximum of ~ n milliseconds (then trigger the chunkProgress callback)
        chunkDelay: 50,
        // at the end of each interval, give n milliseconds back to system/browser
        chunkProgress: null,
        // progress callback: function(processed, total, elapsed) (e.g. for a progress indicator)
        //Options to pass to the L.Polygon constructor
        polygonOptions: {}
      },
      initialize: function(s) {
        L.Util.setOptions(this, s), this.options.iconCreateFunction || (this.options.iconCreateFunction = this._defaultIconCreateFunction), this._featureGroup = L.featureGroup(), this._featureGroup.addEventParent(this), this._nonPointGroup = L.featureGroup(), this._nonPointGroup.addEventParent(this), this._inZoomAnimation = 0, this._needsClustering = [], this._needsRemoving = [], this._currentShownBounds = null, this._queue = [], this._childMarkerEventHandlers = {
          dragstart: this._childMarkerDragStart,
          move: this._childMarkerMoved,
          dragend: this._childMarkerDragEnd
        };
        var i = L.DomUtil.TRANSITION && this.options.animate;
        L.extend(this, i ? this._withAnimation : this._noAnimation), this._markerCluster = i ? L.MarkerCluster : L.MarkerClusterNonAnimated;
      },
      addLayer: function(s) {
        if (s instanceof L.LayerGroup)
          return this.addLayers([s]);
        if (!s.getLatLng)
          return this._nonPointGroup.addLayer(s), this.fire("layeradd", { layer: s }), this;
        if (!this._map)
          return this._needsClustering.push(s), this.fire("layeradd", { layer: s }), this;
        if (this.hasLayer(s))
          return this;
        this._unspiderfy && this._unspiderfy(), this._addLayer(s, this._maxZoom), this.fire("layeradd", { layer: s }), this._topClusterLevel._recalculateBounds(), this._refreshClustersIcons();
        var i = s, u = this._zoom;
        if (s.__parent)
          for (; i.__parent._zoom >= u; )
            i = i.__parent;
        return this._currentShownBounds.contains(i.getLatLng()) && (this.options.animateAddingMarkers ? this._animationAddLayer(s, i) : this._animationAddLayerNonAnimated(s, i)), this;
      },
      removeLayer: function(s) {
        return s instanceof L.LayerGroup ? this.removeLayers([s]) : s.getLatLng ? this._map ? s.__parent ? (this._unspiderfy && (this._unspiderfy(), this._unspiderfyLayer(s)), this._removeLayer(s, !0), this.fire("layerremove", { layer: s }), this._topClusterLevel._recalculateBounds(), this._refreshClustersIcons(), s.off(this._childMarkerEventHandlers, this), this._featureGroup.hasLayer(s) && (this._featureGroup.removeLayer(s), s.clusterShow && s.clusterShow()), this) : this : (!this._arraySplice(this._needsClustering, s) && this.hasLayer(s) && this._needsRemoving.push({ layer: s, latlng: s._latlng }), this.fire("layerremove", { layer: s }), this) : (this._nonPointGroup.removeLayer(s), this.fire("layerremove", { layer: s }), this);
      },
      //Takes an array of markers and adds them in bulk
      addLayers: function(s, i) {
        if (!L.Util.isArray(s))
          return this.addLayer(s);
        var u = this._featureGroup, d = this._nonPointGroup, m = this.options.chunkedLoading, v = this.options.chunkInterval, p = this.options.chunkProgress, g = s.length, w = 0, _ = !0, P;
        if (this._map) {
          var T = (/* @__PURE__ */ new Date()).getTime(), k = L.bind(function() {
            var C = (/* @__PURE__ */ new Date()).getTime();
            for (this._map && this._unspiderfy && this._unspiderfy(); w < g; w++) {
              if (m && w % 200 === 0) {
                var I = (/* @__PURE__ */ new Date()).getTime() - C;
                if (I > v)
                  break;
              }
              if (P = s[w], P instanceof L.LayerGroup) {
                _ && (s = s.slice(), _ = !1), this._extractNonGroupLayers(P, s), g = s.length;
                continue;
              }
              if (!P.getLatLng) {
                d.addLayer(P), i || this.fire("layeradd", { layer: P });
                continue;
              }
              if (!this.hasLayer(P) && (this._addLayer(P, this._maxZoom), i || this.fire("layeradd", { layer: P }), P.__parent && P.__parent.getChildCount() === 2)) {
                var z = P.__parent.getAllChildMarkers(), H = z[0] === P ? z[1] : z[0];
                u.removeLayer(H);
              }
            }
            p && p(w, g, (/* @__PURE__ */ new Date()).getTime() - T), w === g ? (this._topClusterLevel._recalculateBounds(), this._refreshClustersIcons(), this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds)) : setTimeout(k, this.options.chunkDelay);
          }, this);
          k();
        } else
          for (var x = this._needsClustering; w < g; w++) {
            if (P = s[w], P instanceof L.LayerGroup) {
              _ && (s = s.slice(), _ = !1), this._extractNonGroupLayers(P, s), g = s.length;
              continue;
            }
            if (!P.getLatLng) {
              d.addLayer(P);
              continue;
            }
            this.hasLayer(P) || x.push(P);
          }
        return this;
      },
      //Takes an array of markers and removes them in bulk
      removeLayers: function(s) {
        var i, u, d = s.length, m = this._featureGroup, v = this._nonPointGroup, p = !0;
        if (!this._map) {
          for (i = 0; i < d; i++) {
            if (u = s[i], u instanceof L.LayerGroup) {
              p && (s = s.slice(), p = !1), this._extractNonGroupLayers(u, s), d = s.length;
              continue;
            }
            this._arraySplice(this._needsClustering, u), v.removeLayer(u), this.hasLayer(u) && this._needsRemoving.push({ layer: u, latlng: u._latlng }), this.fire("layerremove", { layer: u });
          }
          return this;
        }
        if (this._unspiderfy) {
          this._unspiderfy();
          var g = s.slice(), w = d;
          for (i = 0; i < w; i++) {
            if (u = g[i], u instanceof L.LayerGroup) {
              this._extractNonGroupLayers(u, g), w = g.length;
              continue;
            }
            this._unspiderfyLayer(u);
          }
        }
        for (i = 0; i < d; i++) {
          if (u = s[i], u instanceof L.LayerGroup) {
            p && (s = s.slice(), p = !1), this._extractNonGroupLayers(u, s), d = s.length;
            continue;
          }
          if (!u.__parent) {
            v.removeLayer(u), this.fire("layerremove", { layer: u });
            continue;
          }
          this._removeLayer(u, !0, !0), this.fire("layerremove", { layer: u }), m.hasLayer(u) && (m.removeLayer(u), u.clusterShow && u.clusterShow());
        }
        return this._topClusterLevel._recalculateBounds(), this._refreshClustersIcons(), this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds), this;
      },
      //Removes all layers from the MarkerClusterGroup
      clearLayers: function() {
        return this._map || (this._needsClustering = [], this._needsRemoving = [], delete this._gridClusters, delete this._gridUnclustered), this._noanimationUnspiderfy && this._noanimationUnspiderfy(), this._featureGroup.clearLayers(), this._nonPointGroup.clearLayers(), this.eachLayer(function(s) {
          s.off(this._childMarkerEventHandlers, this), delete s.__parent;
        }, this), this._map && this._generateInitialClusters(), this;
      },
      //Override FeatureGroup.getBounds as it doesn't work
      getBounds: function() {
        var s = new L.LatLngBounds();
        this._topClusterLevel && s.extend(this._topClusterLevel._bounds);
        for (var i = this._needsClustering.length - 1; i >= 0; i--)
          s.extend(this._needsClustering[i].getLatLng());
        return s.extend(this._nonPointGroup.getBounds()), s;
      },
      //Overrides LayerGroup.eachLayer
      eachLayer: function(s, i) {
        var u = this._needsClustering.slice(), d = this._needsRemoving, m, v, p;
        for (this._topClusterLevel && this._topClusterLevel.getAllChildMarkers(u), v = u.length - 1; v >= 0; v--) {
          for (m = !0, p = d.length - 1; p >= 0; p--)
            if (d[p].layer === u[v]) {
              m = !1;
              break;
            }
          m && s.call(i, u[v]);
        }
        this._nonPointGroup.eachLayer(s, i);
      },
      //Overrides LayerGroup.getLayers
      getLayers: function() {
        var s = [];
        return this.eachLayer(function(i) {
          s.push(i);
        }), s;
      },
      //Overrides LayerGroup.getLayer, WARNING: Really bad performance
      getLayer: function(s) {
        var i = null;
        return s = parseInt(s, 10), this.eachLayer(function(u) {
          L.stamp(u) === s && (i = u);
        }), i;
      },
      //Returns true if the given layer is in this MarkerClusterGroup
      hasLayer: function(s) {
        if (!s)
          return !1;
        var i, u = this._needsClustering;
        for (i = u.length - 1; i >= 0; i--)
          if (u[i] === s)
            return !0;
        for (u = this._needsRemoving, i = u.length - 1; i >= 0; i--)
          if (u[i].layer === s)
            return !1;
        return !!(s.__parent && s.__parent._group === this) || this._nonPointGroup.hasLayer(s);
      },
      //Zoom down to show the given layer (spiderfying if necessary) then calls the callback
      zoomToShowLayer: function(s, i) {
        var u = this._map;
        typeof i != "function" && (i = function() {
        });
        var d = function() {
          (u.hasLayer(s) || u.hasLayer(s.__parent)) && !this._inZoomAnimation && (this._map.off("moveend", d, this), this.off("animationend", d, this), u.hasLayer(s) ? i() : s.__parent._icon && (this.once("spiderfied", i, this), s.__parent.spiderfy()));
        };
        s._icon && this._map.getBounds().contains(s.getLatLng()) ? i() : s.__parent._zoom < Math.round(this._map._zoom) ? (this._map.on("moveend", d, this), this._map.panTo(s.getLatLng())) : (this._map.on("moveend", d, this), this.on("animationend", d, this), s.__parent.zoomToBounds());
      },
      //Overrides FeatureGroup.onAdd
      onAdd: function(s) {
        this._map = s;
        var i, u, d;
        if (!isFinite(this._map.getMaxZoom()))
          throw "Map has no maxZoom specified";
        for (this._featureGroup.addTo(s), this._nonPointGroup.addTo(s), this._gridClusters || this._generateInitialClusters(), this._maxLat = s.options.crs.projection.MAX_LATITUDE, i = 0, u = this._needsRemoving.length; i < u; i++)
          d = this._needsRemoving[i], d.newlatlng = d.layer._latlng, d.layer._latlng = d.latlng;
        for (i = 0, u = this._needsRemoving.length; i < u; i++)
          d = this._needsRemoving[i], this._removeLayer(d.layer, !0), d.layer._latlng = d.newlatlng;
        this._needsRemoving = [], this._zoom = Math.round(this._map._zoom), this._currentShownBounds = this._getExpandedVisibleBounds(), this._map.on("zoomend", this._zoomEnd, this), this._map.on("moveend", this._moveEnd, this), this._spiderfierOnAdd && this._spiderfierOnAdd(), this._bindEvents(), u = this._needsClustering, this._needsClustering = [], this.addLayers(u, !0);
      },
      //Overrides FeatureGroup.onRemove
      onRemove: function(s) {
        s.off("zoomend", this._zoomEnd, this), s.off("moveend", this._moveEnd, this), this._unbindEvents(), this._map._mapPane.className = this._map._mapPane.className.replace(" leaflet-cluster-anim", ""), this._spiderfierOnRemove && this._spiderfierOnRemove(), delete this._maxLat, this._hideCoverage(), this._featureGroup.remove(), this._nonPointGroup.remove(), this._featureGroup.clearLayers(), this._map = null;
      },
      getVisibleParent: function(s) {
        for (var i = s; i && !i._icon; )
          i = i.__parent;
        return i || null;
      },
      //Remove the given object from the given array
      _arraySplice: function(s, i) {
        for (var u = s.length - 1; u >= 0; u--)
          if (s[u] === i)
            return s.splice(u, 1), !0;
      },
      /**
       * Removes a marker from all _gridUnclustered zoom levels, starting at the supplied zoom.
       * @param marker to be removed from _gridUnclustered.
       * @param z integer bottom start zoom level (included)
       * @private
       */
      _removeFromGridUnclustered: function(s, i) {
        for (var u = this._map, d = this._gridUnclustered, m = Math.floor(this._map.getMinZoom()); i >= m && d[i].removeObject(s, u.project(s.getLatLng(), i)); i--)
          ;
      },
      _childMarkerDragStart: function(s) {
        s.target.__dragStart = s.target._latlng;
      },
      _childMarkerMoved: function(s) {
        if (!this._ignoreMove && !s.target.__dragStart) {
          var i = s.target._popup && s.target._popup.isOpen();
          this._moveChild(s.target, s.oldLatLng, s.latlng), i && s.target.openPopup();
        }
      },
      _moveChild: function(s, i, u) {
        s._latlng = i, this.removeLayer(s), s._latlng = u, this.addLayer(s);
      },
      _childMarkerDragEnd: function(s) {
        var i = s.target.__dragStart;
        delete s.target.__dragStart, i && this._moveChild(s.target, i, s.target._latlng);
      },
      //Internal function for removing a marker from everything.
      //dontUpdateMap: set to true if you will handle updating the map manually (for bulk functions)
      _removeLayer: function(s, i, u) {
        var d = this._gridClusters, m = this._gridUnclustered, v = this._featureGroup, p = this._map, g = Math.floor(this._map.getMinZoom());
        i && this._removeFromGridUnclustered(s, this._maxZoom);
        var w = s.__parent, _ = w._markers, P;
        for (this._arraySplice(_, s); w && (w._childCount--, w._boundsNeedUpdate = !0, !(w._zoom < g)); )
          i && w._childCount <= 1 ? (P = w._markers[0] === s ? w._markers[1] : w._markers[0], d[w._zoom].removeObject(w, p.project(w._cLatLng, w._zoom)), m[w._zoom].addObject(P, p.project(P.getLatLng(), w._zoom)), this._arraySplice(w.__parent._childClusters, w), w.__parent._markers.push(P), P.__parent = w.__parent, w._icon && (v.removeLayer(w), u || v.addLayer(P))) : w._iconNeedsUpdate = !0, w = w.__parent;
        delete s.__parent;
      },
      _isOrIsParent: function(s, i) {
        for (; i; ) {
          if (s === i)
            return !0;
          i = i.parentNode;
        }
        return !1;
      },
      //Override L.Evented.fire
      fire: function(s, i, u) {
        if (i && i.layer instanceof L.MarkerCluster) {
          if (i.originalEvent && this._isOrIsParent(i.layer._icon, i.originalEvent.relatedTarget))
            return;
          s = "cluster" + s;
        }
        L.FeatureGroup.prototype.fire.call(this, s, i, u);
      },
      //Override L.Evented.listens
      listens: function(s, i) {
        return L.FeatureGroup.prototype.listens.call(this, s, i) || L.FeatureGroup.prototype.listens.call(this, "cluster" + s, i);
      },
      //Default functionality
      _defaultIconCreateFunction: function(s) {
        var i = s.getChildCount(), u = " marker-cluster-";
        return i < 10 ? u += "small" : i < 100 ? u += "medium" : u += "large", new L.DivIcon({ html: "<div><span>" + i + "</span></div>", className: "marker-cluster" + u, iconSize: new L.Point(40, 40) });
      },
      _bindEvents: function() {
        var s = this._map, i = this.options.spiderfyOnMaxZoom, u = this.options.showCoverageOnHover, d = this.options.zoomToBoundsOnClick, m = this.options.spiderfyOnEveryZoom;
        (i || d || m) && this.on("clusterclick clusterkeypress", this._zoomOrSpiderfy, this), u && (this.on("clustermouseover", this._showCoverage, this), this.on("clustermouseout", this._hideCoverage, this), s.on("zoomend", this._hideCoverage, this));
      },
      _zoomOrSpiderfy: function(s) {
        var i = s.layer, u = i;
        if (!(s.type === "clusterkeypress" && s.originalEvent && s.originalEvent.keyCode !== 13)) {
          for (; u._childClusters.length === 1; )
            u = u._childClusters[0];
          u._zoom === this._maxZoom && u._childCount === i._childCount && this.options.spiderfyOnMaxZoom ? i.spiderfy() : this.options.zoomToBoundsOnClick && i.zoomToBounds(), this.options.spiderfyOnEveryZoom && i.spiderfy(), s.originalEvent && s.originalEvent.keyCode === 13 && this._map._container.focus();
        }
      },
      _showCoverage: function(s) {
        var i = this._map;
        this._inZoomAnimation || (this._shownPolygon && i.removeLayer(this._shownPolygon), s.layer.getChildCount() > 2 && s.layer !== this._spiderfied && (this._shownPolygon = new L.Polygon(s.layer.getConvexHull(), this.options.polygonOptions), i.addLayer(this._shownPolygon)));
      },
      _hideCoverage: function() {
        this._shownPolygon && (this._map.removeLayer(this._shownPolygon), this._shownPolygon = null);
      },
      _unbindEvents: function() {
        var s = this.options.spiderfyOnMaxZoom, i = this.options.showCoverageOnHover, u = this.options.zoomToBoundsOnClick, d = this.options.spiderfyOnEveryZoom, m = this._map;
        (s || u || d) && this.off("clusterclick clusterkeypress", this._zoomOrSpiderfy, this), i && (this.off("clustermouseover", this._showCoverage, this), this.off("clustermouseout", this._hideCoverage, this), m.off("zoomend", this._hideCoverage, this));
      },
      _zoomEnd: function() {
        this._map && (this._mergeSplitClusters(), this._zoom = Math.round(this._map._zoom), this._currentShownBounds = this._getExpandedVisibleBounds());
      },
      _moveEnd: function() {
        if (!this._inZoomAnimation) {
          var s = this._getExpandedVisibleBounds();
          this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, s), this._topClusterLevel._recursivelyAddChildrenToMap(null, Math.round(this._map._zoom), s), this._currentShownBounds = s;
        }
      },
      _generateInitialClusters: function() {
        var s = Math.ceil(this._map.getMaxZoom()), i = Math.floor(this._map.getMinZoom()), u = this.options.maxClusterRadius, d = u;
        typeof u != "function" && (d = function() {
          return u;
        }), this.options.disableClusteringAtZoom !== null && (s = this.options.disableClusteringAtZoom - 1), this._maxZoom = s, this._gridClusters = {}, this._gridUnclustered = {};
        for (var m = s; m >= i; m--)
          this._gridClusters[m] = new L.DistanceGrid(d(m)), this._gridUnclustered[m] = new L.DistanceGrid(d(m));
        this._topClusterLevel = new this._markerCluster(this, i - 1);
      },
      //Zoom: Zoom to start adding at (Pass this._maxZoom to start at the bottom)
      _addLayer: function(s, i) {
        var u = this._gridClusters, d = this._gridUnclustered, m = Math.floor(this._map.getMinZoom()), v, p;
        for (this.options.singleMarkerMode && this._overrideMarkerIcon(s), s.on(this._childMarkerEventHandlers, this); i >= m; i--) {
          v = this._map.project(s.getLatLng(), i);
          var g = u[i].getNearObject(v);
          if (g) {
            g._addChild(s), s.__parent = g;
            return;
          }
          if (g = d[i].getNearObject(v), g) {
            var w = g.__parent;
            w && this._removeLayer(g, !1);
            var _ = new this._markerCluster(this, i, g, s);
            u[i].addObject(_, this._map.project(_._cLatLng, i)), g.__parent = _, s.__parent = _;
            var P = _;
            for (p = i - 1; p > w._zoom; p--)
              P = new this._markerCluster(this, p, P), u[p].addObject(P, this._map.project(g.getLatLng(), p));
            w._addChild(P), this._removeFromGridUnclustered(g, i);
            return;
          }
          d[i].addObject(s, v);
        }
        this._topClusterLevel._addChild(s), s.__parent = this._topClusterLevel;
      },
      /**
       * Refreshes the icon of all "dirty" visible clusters.
       * Non-visible "dirty" clusters will be updated when they are added to the map.
       * @private
       */
      _refreshClustersIcons: function() {
        this._featureGroup.eachLayer(function(s) {
          s instanceof L.MarkerCluster && s._iconNeedsUpdate && s._updateIcon();
        });
      },
      //Enqueue code to fire after the marker expand/contract has happened
      _enqueue: function(s) {
        this._queue.push(s), this._queueTimeout || (this._queueTimeout = setTimeout(L.bind(this._processQueue, this), 300));
      },
      _processQueue: function() {
        for (var s = 0; s < this._queue.length; s++)
          this._queue[s].call(this);
        this._queue.length = 0, clearTimeout(this._queueTimeout), this._queueTimeout = null;
      },
      //Merge and split any existing clusters that are too big or small
      _mergeSplitClusters: function() {
        var s = Math.round(this._map._zoom);
        this._processQueue(), this._zoom < s && this._currentShownBounds.intersects(this._getExpandedVisibleBounds()) ? (this._animationStart(), this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, this._getExpandedVisibleBounds()), this._animationZoomIn(this._zoom, s)) : this._zoom > s ? (this._animationStart(), this._animationZoomOut(this._zoom, s)) : this._moveEnd();
      },
      //Gets the maps visible bounds expanded in each direction by the size of the screen (so the user cannot see an area we do not cover in one pan)
      _getExpandedVisibleBounds: function() {
        if (this.options.removeOutsideVisibleBounds) {
          if (L.Browser.mobile)
            return this._checkBoundsMaxLat(this._map.getBounds());
        } else return this._mapBoundsInfinite;
        return this._checkBoundsMaxLat(this._map.getBounds().pad(1));
      },
      /**
       * Expands the latitude to Infinity (or -Infinity) if the input bounds reach the map projection maximum defined latitude
       * (in the case of Web/Spherical Mercator, it is 85.0511287798 / see https://en.wikipedia.org/wiki/Web_Mercator#Formulas).
       * Otherwise, the removeOutsideVisibleBounds option will remove markers beyond that limit, whereas the same markers without
       * this option (or outside MCG) will have their position floored (ceiled) by the projection and rendered at that limit,
       * making the user think that MCG "eats" them and never displays them again.
       * @param bounds L.LatLngBounds
       * @returns {L.LatLngBounds}
       * @private
       */
      _checkBoundsMaxLat: function(s) {
        var i = this._maxLat;
        return i !== void 0 && (s.getNorth() >= i && (s._northEast.lat = 1 / 0), s.getSouth() <= -i && (s._southWest.lat = -1 / 0)), s;
      },
      //Shared animation code
      _animationAddLayerNonAnimated: function(s, i) {
        if (i === s)
          this._featureGroup.addLayer(s);
        else if (i._childCount === 2) {
          i._addToMap();
          var u = i.getAllChildMarkers();
          this._featureGroup.removeLayer(u[0]), this._featureGroup.removeLayer(u[1]);
        } else
          i._updateIcon();
      },
      /**
       * Extracts individual (i.e. non-group) layers from a Layer Group.
       * @param group to extract layers from.
       * @param output {Array} in which to store the extracted layers.
       * @returns {*|Array}
       * @private
       */
      _extractNonGroupLayers: function(s, i) {
        var u = s.getLayers(), d = 0, m;
        for (i = i || []; d < u.length; d++) {
          if (m = u[d], m instanceof L.LayerGroup) {
            this._extractNonGroupLayers(m, i);
            continue;
          }
          i.push(m);
        }
        return i;
      },
      /**
       * Implements the singleMarkerMode option.
       * @param layer Marker to re-style using the Clusters iconCreateFunction.
       * @returns {L.Icon} The newly created icon.
       * @private
       */
      _overrideMarkerIcon: function(s) {
        var i = s.options.icon = this.options.iconCreateFunction({
          getChildCount: function() {
            return 1;
          },
          getAllChildMarkers: function() {
            return [s];
          }
        });
        return i;
      }
    });
    L.MarkerClusterGroup.include({
      _mapBoundsInfinite: new L.LatLngBounds(new L.LatLng(-1 / 0, -1 / 0), new L.LatLng(1 / 0, 1 / 0))
    }), L.MarkerClusterGroup.include({
      _noAnimation: {
        //Non Animated versions of everything
        _animationStart: function() {
        },
        _animationZoomIn: function(s, i) {
          this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), s), this._topClusterLevel._recursivelyAddChildrenToMap(null, i, this._getExpandedVisibleBounds()), this.fire("animationend");
        },
        _animationZoomOut: function(s, i) {
          this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), s), this._topClusterLevel._recursivelyAddChildrenToMap(null, i, this._getExpandedVisibleBounds()), this.fire("animationend");
        },
        _animationAddLayer: function(s, i) {
          this._animationAddLayerNonAnimated(s, i);
        }
      },
      _withAnimation: {
        //Animated versions here
        _animationStart: function() {
          this._map._mapPane.className += " leaflet-cluster-anim", this._inZoomAnimation++;
        },
        _animationZoomIn: function(s, i) {
          var u = this._getExpandedVisibleBounds(), d = this._featureGroup, m = Math.floor(this._map.getMinZoom()), v;
          this._ignoreMove = !0, this._topClusterLevel._recursively(u, s, m, function(p) {
            var g = p._latlng, w = p._markers, _;
            for (u.contains(g) || (g = null), p._isSingleParent() && s + 1 === i ? (d.removeLayer(p), p._recursivelyAddChildrenToMap(null, i, u)) : (p.clusterHide(), p._recursivelyAddChildrenToMap(g, i, u)), v = w.length - 1; v >= 0; v--)
              _ = w[v], u.contains(_._latlng) || d.removeLayer(_);
          }), this._forceLayout(), this._topClusterLevel._recursivelyBecomeVisible(u, i), d.eachLayer(function(p) {
            !(p instanceof L.MarkerCluster) && p._icon && p.clusterShow();
          }), this._topClusterLevel._recursively(u, s, i, function(p) {
            p._recursivelyRestoreChildPositions(i);
          }), this._ignoreMove = !1, this._enqueue(function() {
            this._topClusterLevel._recursively(u, s, m, function(p) {
              d.removeLayer(p), p.clusterShow();
            }), this._animationEnd();
          });
        },
        _animationZoomOut: function(s, i) {
          this._animationZoomOutSingle(this._topClusterLevel, s - 1, i), this._topClusterLevel._recursivelyAddChildrenToMap(null, i, this._getExpandedVisibleBounds()), this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), s, this._getExpandedVisibleBounds());
        },
        _animationAddLayer: function(s, i) {
          var u = this, d = this._featureGroup;
          d.addLayer(s), i !== s && (i._childCount > 2 ? (i._updateIcon(), this._forceLayout(), this._animationStart(), s._setPos(this._map.latLngToLayerPoint(i.getLatLng())), s.clusterHide(), this._enqueue(function() {
            d.removeLayer(s), s.clusterShow(), u._animationEnd();
          })) : (this._forceLayout(), u._animationStart(), u._animationZoomOutSingle(i, this._map.getMaxZoom(), this._zoom)));
        }
      },
      // Private methods for animated versions.
      _animationZoomOutSingle: function(s, i, u) {
        var d = this._getExpandedVisibleBounds(), m = Math.floor(this._map.getMinZoom());
        s._recursivelyAnimateChildrenInAndAddSelfToMap(d, m, i + 1, u);
        var v = this;
        this._forceLayout(), s._recursivelyBecomeVisible(d, u), this._enqueue(function() {
          if (s._childCount === 1) {
            var p = s._markers[0];
            this._ignoreMove = !0, p.setLatLng(p.getLatLng()), this._ignoreMove = !1, p.clusterShow && p.clusterShow();
          } else
            s._recursively(d, u, m, function(g) {
              g._recursivelyRemoveChildrenFromMap(d, m, i + 1);
            });
          v._animationEnd();
        });
      },
      _animationEnd: function() {
        this._map && (this._map._mapPane.className = this._map._mapPane.className.replace(" leaflet-cluster-anim", "")), this._inZoomAnimation--, this.fire("animationend");
      },
      //Force a browser layout of stuff in the map
      // Should apply the current opacity and location to all elements so we can update them again for an animation
      _forceLayout: function() {
        L.Util.falseFn(document.body.offsetWidth);
      }
    }), L.markerClusterGroup = function(s) {
      return new L.MarkerClusterGroup(s);
    };
    var r = L.MarkerCluster = L.Marker.extend({
      options: L.Icon.prototype.options,
      initialize: function(s, i, u, d) {
        L.Marker.prototype.initialize.call(
          this,
          u ? u._cLatLng || u.getLatLng() : new L.LatLng(0, 0),
          { icon: this, pane: s.options.clusterPane }
        ), this._group = s, this._zoom = i, this._markers = [], this._childClusters = [], this._childCount = 0, this._iconNeedsUpdate = !0, this._boundsNeedUpdate = !0, this._bounds = new L.LatLngBounds(), u && this._addChild(u), d && this._addChild(d);
      },
      //Recursively retrieve all child markers of this cluster
      getAllChildMarkers: function(s, i) {
        s = s || [];
        for (var u = this._childClusters.length - 1; u >= 0; u--)
          this._childClusters[u].getAllChildMarkers(s, i);
        for (var d = this._markers.length - 1; d >= 0; d--)
          i && this._markers[d].__dragStart || s.push(this._markers[d]);
        return s;
      },
      //Returns the count of how many child markers we have
      getChildCount: function() {
        return this._childCount;
      },
      //Zoom to the minimum of showing all of the child markers, or the extents of this cluster
      zoomToBounds: function(s) {
        for (var i = this._childClusters.slice(), u = this._group._map, d = u.getBoundsZoom(this._bounds), m = this._zoom + 1, v = u.getZoom(), p; i.length > 0 && d > m; ) {
          m++;
          var g = [];
          for (p = 0; p < i.length; p++)
            g = g.concat(i[p]._childClusters);
          i = g;
        }
        d > m ? this._group._map.setView(this._latlng, m) : d <= v ? this._group._map.setView(this._latlng, v + 1) : this._group._map.fitBounds(this._bounds, s);
      },
      getBounds: function() {
        var s = new L.LatLngBounds();
        return s.extend(this._bounds), s;
      },
      _updateIcon: function() {
        this._iconNeedsUpdate = !0, this._icon && this.setIcon(this);
      },
      //Cludge for Icon, we pretend to be an icon for performance
      createIcon: function() {
        return this._iconNeedsUpdate && (this._iconObj = this._group.options.iconCreateFunction(this), this._iconNeedsUpdate = !1), this._iconObj.createIcon();
      },
      createShadow: function() {
        return this._iconObj.createShadow();
      },
      _addChild: function(s, i) {
        this._iconNeedsUpdate = !0, this._boundsNeedUpdate = !0, this._setClusterCenter(s), s instanceof L.MarkerCluster ? (i || (this._childClusters.push(s), s.__parent = this), this._childCount += s._childCount) : (i || this._markers.push(s), this._childCount++), this.__parent && this.__parent._addChild(s, !0);
      },
      /**
       * Makes sure the cluster center is set. If not, uses the child center if it is a cluster, or the marker position.
       * @param child L.MarkerCluster|L.Marker that will be used as cluster center if not defined yet.
       * @private
       */
      _setClusterCenter: function(s) {
        this._cLatLng || (this._cLatLng = s._cLatLng || s._latlng);
      },
      /**
       * Assigns impossible bounding values so that the next extend entirely determines the new bounds.
       * This method avoids having to trash the previous L.LatLngBounds object and to create a new one, which is much slower for this class.
       * As long as the bounds are not extended, most other methods would probably fail, as they would with bounds initialized but not extended.
       * @private
       */
      _resetBounds: function() {
        var s = this._bounds;
        s._southWest && (s._southWest.lat = 1 / 0, s._southWest.lng = 1 / 0), s._northEast && (s._northEast.lat = -1 / 0, s._northEast.lng = -1 / 0);
      },
      _recalculateBounds: function() {
        var s = this._markers, i = this._childClusters, u = 0, d = 0, m = this._childCount, v, p, g, w;
        if (m !== 0) {
          for (this._resetBounds(), v = 0; v < s.length; v++)
            g = s[v]._latlng, this._bounds.extend(g), u += g.lat, d += g.lng;
          for (v = 0; v < i.length; v++)
            p = i[v], p._boundsNeedUpdate && p._recalculateBounds(), this._bounds.extend(p._bounds), g = p._wLatLng, w = p._childCount, u += g.lat * w, d += g.lng * w;
          this._latlng = this._wLatLng = new L.LatLng(u / m, d / m), this._boundsNeedUpdate = !1;
        }
      },
      //Set our markers position as given and add it to the map
      _addToMap: function(s) {
        s && (this._backupLatlng = this._latlng, this.setLatLng(s)), this._group._featureGroup.addLayer(this);
      },
      _recursivelyAnimateChildrenIn: function(s, i, u) {
        this._recursively(
          s,
          this._group._map.getMinZoom(),
          u - 1,
          function(d) {
            var m = d._markers, v, p;
            for (v = m.length - 1; v >= 0; v--)
              p = m[v], p._icon && (p._setPos(i), p.clusterHide());
          },
          function(d) {
            var m = d._childClusters, v, p;
            for (v = m.length - 1; v >= 0; v--)
              p = m[v], p._icon && (p._setPos(i), p.clusterHide());
          }
        );
      },
      _recursivelyAnimateChildrenInAndAddSelfToMap: function(s, i, u, d) {
        this._recursively(
          s,
          d,
          i,
          function(m) {
            m._recursivelyAnimateChildrenIn(s, m._group._map.latLngToLayerPoint(m.getLatLng()).round(), u), m._isSingleParent() && u - 1 === d ? (m.clusterShow(), m._recursivelyRemoveChildrenFromMap(s, i, u)) : m.clusterHide(), m._addToMap();
          }
        );
      },
      _recursivelyBecomeVisible: function(s, i) {
        this._recursively(s, this._group._map.getMinZoom(), i, null, function(u) {
          u.clusterShow();
        });
      },
      _recursivelyAddChildrenToMap: function(s, i, u) {
        this._recursively(
          u,
          this._group._map.getMinZoom() - 1,
          i,
          function(d) {
            if (i !== d._zoom)
              for (var m = d._markers.length - 1; m >= 0; m--) {
                var v = d._markers[m];
                u.contains(v._latlng) && (s && (v._backupLatlng = v.getLatLng(), v.setLatLng(s), v.clusterHide && v.clusterHide()), d._group._featureGroup.addLayer(v));
              }
          },
          function(d) {
            d._addToMap(s);
          }
        );
      },
      _recursivelyRestoreChildPositions: function(s) {
        for (var i = this._markers.length - 1; i >= 0; i--) {
          var u = this._markers[i];
          u._backupLatlng && (u.setLatLng(u._backupLatlng), delete u._backupLatlng);
        }
        if (s - 1 === this._zoom)
          for (var d = this._childClusters.length - 1; d >= 0; d--)
            this._childClusters[d]._restorePosition();
        else
          for (var m = this._childClusters.length - 1; m >= 0; m--)
            this._childClusters[m]._recursivelyRestoreChildPositions(s);
      },
      _restorePosition: function() {
        this._backupLatlng && (this.setLatLng(this._backupLatlng), delete this._backupLatlng);
      },
      //exceptBounds: If set, don't remove any markers/clusters in it
      _recursivelyRemoveChildrenFromMap: function(s, i, u, d) {
        var m, v;
        this._recursively(
          s,
          i - 1,
          u - 1,
          function(p) {
            for (v = p._markers.length - 1; v >= 0; v--)
              m = p._markers[v], (!d || !d.contains(m._latlng)) && (p._group._featureGroup.removeLayer(m), m.clusterShow && m.clusterShow());
          },
          function(p) {
            for (v = p._childClusters.length - 1; v >= 0; v--)
              m = p._childClusters[v], (!d || !d.contains(m._latlng)) && (p._group._featureGroup.removeLayer(m), m.clusterShow && m.clusterShow());
          }
        );
      },
      //Run the given functions recursively to this and child clusters
      // boundsToApplyTo: a L.LatLngBounds representing the bounds of what clusters to recurse in to
      // zoomLevelToStart: zoom level to start running functions (inclusive)
      // zoomLevelToStop: zoom level to stop running functions (inclusive)
      // runAtEveryLevel: function that takes an L.MarkerCluster as an argument that should be applied on every level
      // runAtBottomLevel: function that takes an L.MarkerCluster as an argument that should be applied at only the bottom level
      _recursively: function(s, i, u, d, m) {
        var v = this._childClusters, p = this._zoom, g, w;
        if (i <= p && (d && d(this), m && p === u && m(this)), p < i || p < u)
          for (g = v.length - 1; g >= 0; g--)
            w = v[g], w._boundsNeedUpdate && w._recalculateBounds(), s.intersects(w._bounds) && w._recursively(s, i, u, d, m);
      },
      //Returns true if we are the parent of only one cluster and that cluster is the same as us
      _isSingleParent: function() {
        return this._childClusters.length > 0 && this._childClusters[0]._childCount === this._childCount;
      }
    });
    L.Marker.include({
      clusterHide: function() {
        var s = this.options.opacity;
        return this.setOpacity(0), this.options.opacity = s, this;
      },
      clusterShow: function() {
        return this.setOpacity(this.options.opacity);
      }
    }), L.DistanceGrid = function(s) {
      this._cellSize = s, this._sqCellSize = s * s, this._grid = {}, this._objectPoint = {};
    }, L.DistanceGrid.prototype = {
      addObject: function(s, i) {
        var u = this._getCoord(i.x), d = this._getCoord(i.y), m = this._grid, v = m[d] = m[d] || {}, p = v[u] = v[u] || [], g = L.Util.stamp(s);
        this._objectPoint[g] = i, p.push(s);
      },
      updateObject: function(s, i) {
        this.removeObject(s), this.addObject(s, i);
      },
      //Returns true if the object was found
      removeObject: function(s, i) {
        var u = this._getCoord(i.x), d = this._getCoord(i.y), m = this._grid, v = m[d] = m[d] || {}, p = v[u] = v[u] || [], g, w;
        for (delete this._objectPoint[L.Util.stamp(s)], g = 0, w = p.length; g < w; g++)
          if (p[g] === s)
            return p.splice(g, 1), w === 1 && delete v[u], !0;
      },
      eachObject: function(s, i) {
        var u, d, m, v, p, g, w, _ = this._grid;
        for (u in _) {
          p = _[u];
          for (d in p)
            for (g = p[d], m = 0, v = g.length; m < v; m++)
              w = s.call(i, g[m]), w && (m--, v--);
        }
      },
      getNearObject: function(s) {
        var i = this._getCoord(s.x), u = this._getCoord(s.y), d, m, v, p, g, w, _, P, T = this._objectPoint, k = this._sqCellSize, x = null;
        for (d = u - 1; d <= u + 1; d++)
          if (p = this._grid[d], p) {
            for (m = i - 1; m <= i + 1; m++)
              if (g = p[m], g)
                for (v = 0, w = g.length; v < w; v++)
                  _ = g[v], P = this._sqDist(T[L.Util.stamp(_)], s), (P < k || P <= k && x === null) && (k = P, x = _);
          }
        return x;
      },
      _getCoord: function(s) {
        var i = Math.floor(s / this._cellSize);
        return isFinite(i) ? i : s;
      },
      _sqDist: function(s, i) {
        var u = i.x - s.x, d = i.y - s.y;
        return u * u + d * d;
      }
    }, function() {
      L.QuickHull = {
        /*
         * @param {Object} cpt a point to be measured from the baseline
         * @param {Array} bl the baseline, as represented by a two-element
         *   array of latlng objects.
         * @returns {Number} an approximate distance measure
         */
        getDistant: function(s, i) {
          var u = i[1].lat - i[0].lat, d = i[0].lng - i[1].lng;
          return d * (s.lat - i[0].lat) + u * (s.lng - i[0].lng);
        },
        /*
         * @param {Array} baseLine a two-element array of latlng objects
         *   representing the baseline to project from
         * @param {Array} latLngs an array of latlng objects
         * @returns {Object} the maximum point and all new points to stay
         *   in consideration for the hull.
         */
        findMostDistantPointFromBaseLine: function(s, i) {
          var u = 0, d = null, m = [], v, p, g;
          for (v = i.length - 1; v >= 0; v--) {
            if (p = i[v], g = this.getDistant(p, s), g > 0)
              m.push(p);
            else
              continue;
            g > u && (u = g, d = p);
          }
          return { maxPoint: d, newPoints: m };
        },
        /*
         * Given a baseline, compute the convex hull of latLngs as an array
         * of latLngs.
         *
         * @param {Array} latLngs
         * @returns {Array}
         */
        buildConvexHull: function(s, i) {
          var u = [], d = this.findMostDistantPointFromBaseLine(s, i);
          return d.maxPoint ? (u = u.concat(
            this.buildConvexHull([s[0], d.maxPoint], d.newPoints)
          ), u = u.concat(
            this.buildConvexHull([d.maxPoint, s[1]], d.newPoints)
          ), u) : [s[0]];
        },
        /*
         * Given an array of latlngs, compute a convex hull as an array
         * of latlngs
         *
         * @param {Array} latLngs
         * @returns {Array}
         */
        getConvexHull: function(s) {
          var i = !1, u = !1, d = !1, m = !1, v = null, p = null, g = null, w = null, _ = null, P = null, T;
          for (T = s.length - 1; T >= 0; T--) {
            var k = s[T];
            (i === !1 || k.lat > i) && (v = k, i = k.lat), (u === !1 || k.lat < u) && (p = k, u = k.lat), (d === !1 || k.lng > d) && (g = k, d = k.lng), (m === !1 || k.lng < m) && (w = k, m = k.lng);
          }
          u !== i ? (P = p, _ = v) : (P = w, _ = g);
          var x = [].concat(
            this.buildConvexHull([P, _], s),
            this.buildConvexHull([_, P], s)
          );
          return x;
        }
      };
    }(), L.MarkerCluster.include({
      getConvexHull: function() {
        var s = this.getAllChildMarkers(), i = [], u, d;
        for (d = s.length - 1; d >= 0; d--)
          u = s[d].getLatLng(), i.push(u);
        return L.QuickHull.getConvexHull(i);
      }
    }), L.MarkerCluster.include({
      _2PI: Math.PI * 2,
      _circleFootSeparation: 25,
      //related to circumference of circle
      _circleStartAngle: 0,
      _spiralFootSeparation: 28,
      //related to size of spiral (experiment!)
      _spiralLengthStart: 11,
      _spiralLengthFactor: 5,
      _circleSpiralSwitchover: 9,
      //show spiral instead of circle from this marker count upwards.
      // 0 -> always spiral; Infinity -> always circle
      spiderfy: function() {
        if (!(this._group._spiderfied === this || this._group._inZoomAnimation)) {
          var s = this.getAllChildMarkers(null, !0), i = this._group, u = i._map, d = u.latLngToLayerPoint(this._latlng), m;
          this._group._unspiderfy(), this._group._spiderfied = this, this._group.options.spiderfyShapePositions ? m = this._group.options.spiderfyShapePositions(s.length, d) : s.length >= this._circleSpiralSwitchover ? m = this._generatePointsSpiral(s.length, d) : (d.y += 10, m = this._generatePointsCircle(s.length, d)), this._animationSpiderfy(s, m);
        }
      },
      unspiderfy: function(s) {
        this._group._inZoomAnimation || (this._animationUnspiderfy(s), this._group._spiderfied = null);
      },
      _generatePointsCircle: function(s, i) {
        var u = this._group.options.spiderfyDistanceMultiplier * this._circleFootSeparation * (2 + s), d = u / this._2PI, m = this._2PI / s, v = [], p, g;
        for (d = Math.max(d, 35), v.length = s, p = 0; p < s; p++)
          g = this._circleStartAngle + p * m, v[p] = new L.Point(i.x + d * Math.cos(g), i.y + d * Math.sin(g))._round();
        return v;
      },
      _generatePointsSpiral: function(s, i) {
        var u = this._group.options.spiderfyDistanceMultiplier, d = u * this._spiralLengthStart, m = u * this._spiralFootSeparation, v = u * this._spiralLengthFactor * this._2PI, p = 0, g = [], w;
        for (g.length = s, w = s; w >= 0; w--)
          w < s && (g[w] = new L.Point(i.x + d * Math.cos(p), i.y + d * Math.sin(p))._round()), p += m / d + w * 5e-4, d += v / p;
        return g;
      },
      _noanimationUnspiderfy: function() {
        var s = this._group, i = s._map, u = s._featureGroup, d = this.getAllChildMarkers(null, !0), m, v;
        for (s._ignoreMove = !0, this.setOpacity(1), v = d.length - 1; v >= 0; v--)
          m = d[v], u.removeLayer(m), m._preSpiderfyLatlng && (m.setLatLng(m._preSpiderfyLatlng), delete m._preSpiderfyLatlng), m.setZIndexOffset && m.setZIndexOffset(0), m._spiderLeg && (i.removeLayer(m._spiderLeg), delete m._spiderLeg);
        s.fire("unspiderfied", {
          cluster: this,
          markers: d
        }), s._ignoreMove = !1, s._spiderfied = null;
      }
    }), L.MarkerClusterNonAnimated = L.MarkerCluster.extend({
      _animationSpiderfy: function(s, i) {
        var u = this._group, d = u._map, m = u._featureGroup, v = this._group.options.spiderLegPolylineOptions, p, g, w, _;
        for (u._ignoreMove = !0, p = 0; p < s.length; p++)
          _ = d.layerPointToLatLng(i[p]), g = s[p], w = new L.Polyline([this._latlng, _], v), d.addLayer(w), g._spiderLeg = w, g._preSpiderfyLatlng = g._latlng, g.setLatLng(_), g.setZIndexOffset && g.setZIndexOffset(1e6), m.addLayer(g);
        this.setOpacity(0.3), u._ignoreMove = !1, u.fire("spiderfied", {
          cluster: this,
          markers: s
        });
      },
      _animationUnspiderfy: function() {
        this._noanimationUnspiderfy();
      }
    }), L.MarkerCluster.include({
      _animationSpiderfy: function(s, i) {
        var u = this, d = this._group, m = d._map, v = d._featureGroup, p = this._latlng, g = m.latLngToLayerPoint(p), w = L.Path.SVG, _ = L.extend({}, this._group.options.spiderLegPolylineOptions), P = _.opacity, T, k, x, C, I, z;
        for (P === void 0 && (P = L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity), w ? (_.opacity = 0, _.className = (_.className || "") + " leaflet-cluster-spider-leg") : _.opacity = P, d._ignoreMove = !0, T = 0; T < s.length; T++)
          k = s[T], z = m.layerPointToLatLng(i[T]), x = new L.Polyline([p, z], _), m.addLayer(x), k._spiderLeg = x, w && (C = x._path, I = C.getTotalLength() + 0.1, C.style.strokeDasharray = I, C.style.strokeDashoffset = I), k.setZIndexOffset && k.setZIndexOffset(1e6), k.clusterHide && k.clusterHide(), v.addLayer(k), k._setPos && k._setPos(g);
        for (d._forceLayout(), d._animationStart(), T = s.length - 1; T >= 0; T--)
          z = m.layerPointToLatLng(i[T]), k = s[T], k._preSpiderfyLatlng = k._latlng, k.setLatLng(z), k.clusterShow && k.clusterShow(), w && (x = k._spiderLeg, C = x._path, C.style.strokeDashoffset = 0, x.setStyle({ opacity: P }));
        this.setOpacity(0.3), d._ignoreMove = !1, setTimeout(function() {
          d._animationEnd(), d.fire("spiderfied", {
            cluster: u,
            markers: s
          });
        }, 200);
      },
      _animationUnspiderfy: function(s) {
        var i = this, u = this._group, d = u._map, m = u._featureGroup, v = s ? d._latLngToNewLayerPoint(this._latlng, s.zoom, s.center) : d.latLngToLayerPoint(this._latlng), p = this.getAllChildMarkers(null, !0), g = L.Path.SVG, w, _, P, T, k, x;
        for (u._ignoreMove = !0, u._animationStart(), this.setOpacity(1), _ = p.length - 1; _ >= 0; _--)
          w = p[_], w._preSpiderfyLatlng && (w.closePopup(), w.setLatLng(w._preSpiderfyLatlng), delete w._preSpiderfyLatlng, x = !0, w._setPos && (w._setPos(v), x = !1), w.clusterHide && (w.clusterHide(), x = !1), x && m.removeLayer(w), g && (P = w._spiderLeg, T = P._path, k = T.getTotalLength() + 0.1, T.style.strokeDashoffset = k, P.setStyle({ opacity: 0 })));
        u._ignoreMove = !1, setTimeout(function() {
          var C = 0;
          for (_ = p.length - 1; _ >= 0; _--)
            w = p[_], w._spiderLeg && C++;
          for (_ = p.length - 1; _ >= 0; _--)
            w = p[_], w._spiderLeg && (w.clusterShow && w.clusterShow(), w.setZIndexOffset && w.setZIndexOffset(0), C > 1 && m.removeLayer(w), d.removeLayer(w._spiderLeg), delete w._spiderLeg);
          u._animationEnd(), u.fire("unspiderfied", {
            cluster: i,
            markers: p
          });
        }, 200);
      }
    }), L.MarkerClusterGroup.include({
      //The MarkerCluster currently spiderfied (if any)
      _spiderfied: null,
      unspiderfy: function() {
        this._unspiderfy.apply(this, arguments);
      },
      _spiderfierOnAdd: function() {
        this._map.on("click", this._unspiderfyWrapper, this), this._map.options.zoomAnimation && this._map.on("zoomstart", this._unspiderfyZoomStart, this), this._map.on("zoomend", this._noanimationUnspiderfy, this), L.Browser.touch || this._map.getRenderer(this);
      },
      _spiderfierOnRemove: function() {
        this._map.off("click", this._unspiderfyWrapper, this), this._map.off("zoomstart", this._unspiderfyZoomStart, this), this._map.off("zoomanim", this._unspiderfyZoomAnim, this), this._map.off("zoomend", this._noanimationUnspiderfy, this), this._noanimationUnspiderfy();
      },
      //On zoom start we add a zoomanim handler so that we are guaranteed to be last (after markers are animated)
      //This means we can define the animation they do rather than Markers doing an animation to their actual location
      _unspiderfyZoomStart: function() {
        this._map && this._map.on("zoomanim", this._unspiderfyZoomAnim, this);
      },
      _unspiderfyZoomAnim: function(s) {
        L.DomUtil.hasClass(this._map._mapPane, "leaflet-touching") || (this._map.off("zoomanim", this._unspiderfyZoomAnim, this), this._unspiderfy(s));
      },
      _unspiderfyWrapper: function() {
        this._unspiderfy();
      },
      _unspiderfy: function(s) {
        this._spiderfied && this._spiderfied.unspiderfy(s);
      },
      _noanimationUnspiderfy: function() {
        this._spiderfied && this._spiderfied._noanimationUnspiderfy();
      },
      //If the given layer is currently being spiderfied then we unspiderfy it so it isn't on the map anymore etc
      _unspiderfyLayer: function(s) {
        s._spiderLeg && (this._featureGroup.removeLayer(s), s.clusterShow && s.clusterShow(), s.setZIndexOffset && s.setZIndexOffset(0), this._map.removeLayer(s._spiderLeg), delete s._spiderLeg);
      }
    }), L.MarkerClusterGroup.include({
      /**
       * Updates the icon of all clusters which are parents of the given marker(s).
       * In singleMarkerMode, also updates the given marker(s) icon.
       * @param layers L.MarkerClusterGroup|L.LayerGroup|Array(L.Marker)|Map(L.Marker)|
       * L.MarkerCluster|L.Marker (optional) list of markers (or single marker) whose parent
       * clusters need to be updated. If not provided, retrieves all child markers of this.
       * @returns {L.MarkerClusterGroup}
       */
      refreshClusters: function(s) {
        return s ? s instanceof L.MarkerClusterGroup ? s = s._topClusterLevel.getAllChildMarkers() : s instanceof L.LayerGroup ? s = s._layers : s instanceof L.MarkerCluster ? s = s.getAllChildMarkers() : s instanceof L.Marker && (s = [s]) : s = this._topClusterLevel.getAllChildMarkers(), this._flagParentsIconsNeedUpdate(s), this._refreshClustersIcons(), this.options.singleMarkerMode && this._refreshSingleMarkerModeMarkers(s), this;
      },
      /**
       * Simply flags all parent clusters of the given markers as having a "dirty" icon.
       * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
       * @private
       */
      _flagParentsIconsNeedUpdate: function(s) {
        var i, u;
        for (i in s)
          for (u = s[i].__parent; u; )
            u._iconNeedsUpdate = !0, u = u.__parent;
      },
      /**
       * Re-draws the icon of the supplied markers.
       * To be used in singleMarkerMode only.
       * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
       * @private
       */
      _refreshSingleMarkerModeMarkers: function(s) {
        var i, u;
        for (i in s)
          u = s[i], this.hasLayer(u) && u.setIcon(this._overrideMarkerIcon(u));
      }
    }), L.Marker.include({
      /**
       * Updates the given options in the marker's icon and refreshes the marker.
       * @param options map object of icon options.
       * @param directlyRefreshClusters boolean (optional) true to trigger
       * MCG.refreshClustersOf() right away with this single marker.
       * @returns {L.Marker}
       */
      refreshIconOptions: function(s, i) {
        var u = this.options.icon;
        return L.setOptions(u, s), this.setIcon(u), i && this.__parent && this.__parent._group.refreshClusters(this), this;
      }
    }), t.MarkerClusterGroup = o, t.MarkerCluster = r, Object.defineProperty(t, "__esModule", { value: !0 });
  });
})(lu, lu.exports);
const x4 = "{{stroke}}", S4 = "{{fill}}", wh = () => ({
  coloredIconFromSvg: (e, t) => {
    const o = t.replace(/#(\w{6})/, (d, m) => {
      const v = parseInt(m.slice(0, 2), 16), p = parseInt(m.slice(2, 4), 16), g = parseInt(m.slice(4, 6), 16), w = Math.round(v + (255 - v) * 0.75), _ = Math.round(p + (255 - p) * 0.75), P = Math.round(g + (255 - g) * 0.75);
      return `rgb(${w}, ${_}, ${P})`;
    }), i = decodeURIComponent(e.split(",")[1]).replace(S4, o).replace(x4, t), u = `data:image/svg+xml,${encodeURIComponent(i)}`;
    return b4.icon({
      iconUrl: u,
      iconSize: [25, 41],
      iconAnchor: [12, 41]
    });
  }
}), T4 = { class: "relative z-10 h-full w-full" }, L4 = /* @__PURE__ */ A("div", {
  id: "map",
  class: "h-full w-full"
}, null, -1), C4 = [
  L4
], XP = /* @__PURE__ */ G({
  __name: "LeafletMap",
  props: {
    markers: {},
    markersInteractive: { type: Boolean },
    flyToOnClick: { type: Boolean },
    customControls: {}
  },
  emits: ["location-selected"],
  setup(a, { expose: e, emit: t }) {
    const { notify: o } = qo(), { t: r } = At(), { coloredIconFromSvg: s } = wh(), i = a, u = t, d = B(), m = B(), v = B({});
    let p, g = null;
    Ee(async () => {
      const F = {
        center: ce.latLng(48.2629765, 14.2601941),
        zoom: 18,
        zoomControl: !1
      };
      p = ce.map("map", F), ce.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 19
      }).addTo(p), _(), p.on("contextmenu", (se) => {
        ce.marker(se.latlng).addTo(p);
      }), w(), i.markers && x(i.markers);
    });
    const w = () => {
      p.on("click", (F) => {
        if (d.value && p.removeLayer(d.value), !i.flyToOnClick) return;
        const se = F.latlng.clone(), pe = p.getBounds(), Te = (pe.getNorth() - pe.getSouth()) * 0.4;
        se.lat -= Te, p.flyTo(se, p.getZoom()), d.value = ce.marker(F.latlng, {
          icon: s(oi, "#0000ff")
        }), d.value.addTo(p), T({ latitude: F.latlng.lat, longitude: F.latlng.lng });
      });
    }, _ = () => {
      ce.control.zoom({ position: "bottomright" }).addTo(p), g = ce.layerGroup(), new P4({
        layer: g,
        position: "bottomright",
        strings: {
          title: r("geolocation.locate"),
          popup: r("geolocation.within", { distance: "{distance}", unit: "{unit}" })
        },
        locateOptions: {
          enableHighAccuracy: !0
        },
        onLocationError: () => {
          o("error", r("geolocation.title"), r("geolocation.denied"));
        }
      }).addTo(p).start(), P();
    }, P = () => {
      var F;
      if (i.customControls)
        for (const se of i.customControls) {
          const pe = (F = v.value) == null ? void 0 : F[se.id];
          if (pe && se.visible) continue;
          if (!se.visible) {
            pe && (pe.remove(), delete v.value[se.id]);
            continue;
          }
          const Te = ce.Control.extend({
            onAdd() {
              const Y = ce.DomUtil.create("div", "leaflet-bar"), X = ce.DomUtil.create("a", "text-black", Y);
              X.href = "#", X.title = se.title ?? "", X.innerHTML = se.content, ce.DomEvent.disableClickPropagation(Y);
              let Z = !1;
              const he = () => {
                X.classList.toggle("text-black", !Z), X.classList.toggle("!text-primary-500", Z);
              };
              return he(), X.addEventListener("click", async (Pe) => {
                Pe.preventDefault(), se.toggleable && (Z = !Z, he()), await se.action();
              }), Y;
            }
          }), W = new Te({ position: "bottomright" });
          v.value[se.id] = W, W.addTo(p);
        }
    }, T = async (F) => {
      u("location-selected", F);
    };
    Ie(
      () => i.markers,
      (F) => {
        F && C(F);
      }
    ), Ie(
      () => i.markersInteractive,
      () => {
        i.markers && C(i.markers);
      }
    );
    const k = B(), x = (F) => {
      var Te;
      if (!p) return;
      const se = ze(p);
      if ((Te = m.value) == null || Te.forEach((W) => {
        W.marker.remove();
      }), k.value) {
        const W = ze(k.value);
        se.removeLayer(W);
      }
      m.value = [];
      const pe = new ce.MarkerClusterGroup({
        iconCreateFunction: function(W) {
          const Y = W.getChildCount();
          return ce.divIcon({
            html: "<span>" + Y + "</span>",
            className: "custom-cluster-icon",
            // referencing the CSS class above
            iconSize: ce.point(40, 40)
            // Dimensions matching the CSS size (optional but recommended)
          });
        },
        disableClusteringAtZoom: 12
      });
      F == null || F.forEach((W) => {
        var Pe;
        const Y = ce.latLng(W.latitude, W.longitude), X = I(W.type), Z = s(X, W.getColor()), he = ce.marker(Y, {
          icon: Z,
          interactive: i.markersInteractive ?? !1,
          zIndexOffset: W.zIndexOffset ?? 0
        });
        W.toolTipHtml && he.bindTooltip(W.toolTipHtml, { direction: "top", offset: [0, -10], permanent: !1, opacity: 0.9 }), W.onClickCallback && he.on("click", () => {
          W.onClickCallback && W.onClickCallback();
        }), (Pe = m.value) == null || Pe.push({
          marker: he,
          type: W.type,
          id: W.id,
          callback: W.onClickCallback
        }), pe.addLayer(he);
      }), se.addLayer(pe), k.value = pe;
    }, C = Xn(x, 300), I = (F) => {
      switch (F) {
        case "star":
          return _h;
        case "check":
          return _4;
        case "cross":
          return yh;
        case "default":
          return oi;
      }
      return oi;
    };
    return e({ getLocatedPosition: () => {
      const F = g == null ? void 0 : g.getLayers();
      if (F != null && F.length) {
        const se = F[F.length - 1], { lat: pe, lng: Te } = se.getLatLng();
        return { latitude: pe, longitude: Te };
      } else
        return {};
    }, getMapCenter: () => {
      const { lat: F, lng: se } = p.getCenter();
      return { latitude: F, longitude: se };
    } }), Ie(() => i.customControls, P, { deep: !0 }), (F, se) => (j(), R("div", T4, C4));
  }
}), A4 = { class: "flex flex-col space-y-1" }, O4 = { class: "text-xs text-gray-500 dark:text-gray-400" }, k4 = { class: "flex grow items-center" }, I4 = { class: "sr-only" }, j4 = /* @__PURE__ */ A("span", {
  "aria-hidden": "true",
  class: "pointer-events-none absolute h-full w-full rounded-md bg-transparent"
}, null, -1), si = /* @__PURE__ */ G({
  __name: "ToggleInput",
  props: {
    modelValue: { type: [Boolean, Number] },
    name: {},
    label: {},
    description: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: e }) {
    const t = a, o = e, r = U({
      get() {
        return t.modelValue ? typeof t.modelValue == "number" ? t.modelValue !== 0 : t.modelValue : !1;
      },
      set(s) {
        typeof t.modelValue == "number" ? o("update:modelValue", s ? 1 : 0) : o("update:modelValue", s);
      }
    });
    return (s, i) => (j(), ne(D(c0), null, {
      default: ee(() => [
        A("div", A4, [
          $(D(d0), { class: "block text-sm font-medium text-gray-700 dark:text-white" }, {
            default: ee(() => [
              Oe(V(s.label), 1)
            ]),
            _: 1
          }),
          A("div", O4, V(s.description), 1),
          A("div", k4, [
            $(D(h0), {
              name: s.name,
              modelValue: r.value,
              "onUpdate:modelValue": i[0] || (i[0] = (u) => r.value = u),
              class: ae(["dark:ring-offset-dark-700 group relative inline-flex h-5 w-10 flex-shrink-0 items-center justify-center rounded-full ring-offset-white focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-primary-500", s.disabled ? "cursor-not-allowed" : "cursor-pointer"])
            }, {
              default: ee(() => [
                A("span", I4, V(s.label), 1),
                j4,
                A("span", {
                  "aria-hidden": "true",
                  class: ae([s.modelValue ? "bg-primary-600" : "dark:bg-dark-700 bg-gray-200", "pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"])
                }, null, 2),
                A("span", {
                  "aria-hidden": "true",
                  class: ae([
                    s.modelValue ? "translate-x-5" : "translate-x-0",
                    "pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out"
                  ])
                }, null, 2)
              ]),
              _: 1
            }, 8, ["name", "modelValue", "class"])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), E4 = {
  key: 0,
  class: "space-y-6"
}, D4 = { class: "space-y-1" }, M4 = { class: "mb-2" }, N4 = { class: "space-y-1" }, J4 = { class: "mb-2" }, U4 = { class: "space-y-1" }, B4 = { class: "mb-2" }, R4 = { class: "space-y-1" }, z4 = { class: "mb-2" }, q4 = { class: "space-y-3" }, Z4 = { class: "mb-2" }, V4 = { class: "mb-1 text-sm font-medium text-gray-700" }, $4 = { class: "space-y-1" }, F4 = ["src", "alt"], G4 = { class: "text-sm" }, H4 = { class: "mb-1 text-sm font-medium text-gray-700" }, W4 = { class: "space-y-1" }, K4 = { class: "text-sm" }, ex = /* @__PURE__ */ G({
  __name: "MapFilter",
  props: /* @__PURE__ */ lt({
    projectId: {},
    showUserFilter: { type: Boolean, default: !0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ lt(["update:model-value"], ["update:modelValue"]),
  async setup(a, { emit: e }) {
    let t, o;
    const { t: r } = At(), { coloredIconFromSvg: s } = wh(), [i] = pr(bu.name), [u] = pr(_u.name), [d] = pr(wu.name), [m] = pr(yu.name), v = B([]), p = B([]), g = B([]), w = B([]), _ = bt(a, "modelValue"), P = e, T = a, k = async () => {
      v.value = (await i.list()).data ?? [];
    }, x = async () => {
      p.value = await u.listByProjectId(T.projectId) ?? [];
    }, C = async () => {
      g.value = await d.listByProjectId(T.projectId) ?? [];
    }, I = async () => {
      w.value = (await m.listByProjectId(T.projectId, new Si({ expand: ["ProductGroup"] }))).data ?? [];
    }, z = U(() => [
      { id: "visits", label: r("map.legend.visits"), icon: s(oi, "#cccccc") },
      { id: "open_tasks", label: r("map.legend.open_tasks"), icon: s(yh, "#dc3545") },
      { id: "potentials", label: r("map.legend.potentials"), icon: s(_h, "#FFD700") }
    ]), H = U(
      () => v.value.map((W) => ({
        text: W.label ?? "",
        value: W.id
      }))
    ), F = U(
      () => p.value.filter((W) => {
        var Y, X;
        return W.statusGroupId && ((Y = _.value) == null ? void 0 : Y.statusGroups.includes(W.statusGroupId)) || ((X = _.value) == null ? void 0 : X.statusGroups.length) == 0;
      }).map((W) => ({
        text: W.name ?? "",
        value: W.id
      }))
    ), se = U(
      () => g.value.map((W) => ({
        text: W.name ?? "",
        value: W.id
      }))
    ), pe = U(() => {
      const W = w.value.map((Y) => {
        var X;
        return {
          text: ((X = Y.productGroup) == null ? void 0 : X.name) ?? "",
          value: Y.productGroupId
        };
      });
      return Array.from(new Map(W.map((Y) => [Y.value, Y])).values());
    }), Te = U({
      get: () => {
        var W, Y;
        return (W = _.value) != null && W.visitStartDate && ((Y = _.value) != null && Y.visitEndDate) ? [_.value.visitStartDate, _.value.visitEndDate] : [];
      },
      set: (W) => {
        _.value && (Array.isArray(W) && W.length === 2 ? (_.value.visitStartDate = W[0], _.value.visitEndDate = W[1]) : (_.value.visitStartDate = null, _.value.visitEndDate = null));
      }
    });
    return [t, o] = Ks(() => k()), await t, o(), [t, o] = Ks(() => x()), await t, o(), [t, o] = Ks(() => C()), await t, o(), [t, o] = Ks(() => I()), await t, o(), Ie(
      _,
      (W) => {
        W && P("update:model-value", W);
      },
      { deep: !0 }
    ), (W, Y) => _.value ? (j(), R("div", E4, [
      A("div", D4, [
        A("h3", M4, V(D(r)("map.filters.general_filters")), 1),
        $(Zt, {
          label: D(r)("map.filters.group_status"),
          modelValue: _.value.statusGroups,
          "onUpdate:modelValue": Y[0] || (Y[0] = (X) => _.value.statusGroups = X),
          multiple: !0,
          items: H.value,
          name: "group-status"
        }, null, 8, ["label", "modelValue", "items"]),
        $(Zt, {
          label: D(r)("map.filters.project_status"),
          modelValue: _.value.projectStatuses,
          "onUpdate:modelValue": Y[1] || (Y[1] = (X) => _.value.projectStatuses = X),
          multiple: !0,
          items: F.value,
          name: "project-status"
        }, null, 8, ["label", "modelValue", "items"]),
        $(dt, {
          label: D(r)("map.filters.postal_code"),
          modelValue: _.value.zip,
          "onUpdate:modelValue": Y[2] || (Y[2] = (X) => _.value.zip = X),
          name: "postal-code"
        }, null, 8, ["label", "modelValue"]),
        $(dt, {
          label: D(r)("map.filters.street"),
          modelValue: _.value.street,
          "onUpdate:modelValue": Y[3] || (Y[3] = (X) => _.value.street = X),
          name: "street"
        }, null, 8, ["label", "modelValue"]),
        $(dt, {
          label: D(r)("map.filters.city"),
          modelValue: _.value.city,
          "onUpdate:modelValue": Y[4] || (Y[4] = (X) => _.value.city = X),
          name: "city"
        }, null, 8, ["label", "modelValue"]),
        $(dt, {
          label: D(r)("map.filters.country"),
          modelValue: _.value.country,
          "onUpdate:modelValue": Y[5] || (Y[5] = (X) => _.value.country = X),
          name: "country"
        }, null, 8, ["label", "modelValue"]),
        W.showUserFilter ? (j(), ne(Zt, {
          key: 0,
          label: D(r)("map.filters.reference_users"),
          modelValue: _.value.assignedUserIds,
          "onUpdate:modelValue": Y[6] || (Y[6] = (X) => _.value.assignedUserIds = X),
          multiple: !0,
          items: se.value,
          name: "assigned-to"
        }, null, 8, ["label", "modelValue", "items"])) : te("", !0),
        $(si, {
          label: D(r)("map.filters.show_unassigned"),
          modelValue: _.value.showUnassigned,
          "onUpdate:modelValue": Y[7] || (Y[7] = (X) => _.value.showUnassigned = X),
          name: "show-unassigned"
        }, null, 8, ["label", "modelValue"])
      ]),
      A("div", N4, [
        A("h3", J4, V(D(r)("map.filters.report_filters")), 1),
        $(si, {
          label: D(r)("map.filters.show_visits"),
          modelValue: _.value.showVisits,
          "onUpdate:modelValue": Y[8] || (Y[8] = (X) => _.value.showVisits = X),
          name: "show-reports"
        }, null, 8, ["label", "modelValue"]),
        $(Ps, {
          range: !0,
          label: D(r)("map.filters.visit_date"),
          modelValue: Te.value,
          "onUpdate:modelValue": Y[9] || (Y[9] = (X) => Te.value = X),
          name: "report-date"
        }, null, 8, ["label", "modelValue"])
      ]),
      A("div", U4, [
        A("h3", B4, V(D(r)("map.filters.task_filters")), 1),
        $(si, {
          label: D(r)("map.filters.show_open_tasks"),
          modelValue: _.value.showTasks,
          "onUpdate:modelValue": Y[10] || (Y[10] = (X) => _.value.showTasks = X),
          name: "show-open-tasks"
        }, null, 8, ["label", "modelValue"])
      ]),
      A("div", R4, [
        A("h3", z4, V(D(r)("map.filters.potential_filters")), 1),
        $(si, {
          label: D(r)("map.filters.show_potentials"),
          modelValue: _.value.showPotentials,
          "onUpdate:modelValue": Y[11] || (Y[11] = (X) => _.value.showPotentials = X),
          name: "show-potential"
        }, null, 8, ["label", "modelValue"]),
        $(Zt, {
          label: D(r)("map.filters.potential"),
          multiple: !0,
          modelValue: _.value.potentials,
          "onUpdate:modelValue": Y[12] || (Y[12] = (X) => _.value.potentials = X),
          items: pe.value,
          name: "potential"
        }, null, 8, ["label", "modelValue", "items"])
      ]),
      A("div", q4, [
        A("h3", Z4, V(D(r)("map.legend.title")), 1),
        A("div", null, [
          A("h4", V4, V(D(r)("map.legend.pin_types")), 1),
          A("div", $4, [
            (j(!0), R(Se, null, Ke(z.value, (X) => (j(), R("div", {
              key: X.id,
              class: "flex items-center gap-2"
            }, [
              A("img", {
                src: X.icon.options.iconUrl,
                class: "h-6 w-4",
                alt: X.label
              }, null, 8, F4),
              A("span", G4, V(X.label), 1)
            ]))), 128))
          ])
        ]),
        A("div", null, [
          A("h4", H4, V(D(r)("map.legend.status_colors")), 1),
          A("div", W4, [
            (j(!0), R(Se, null, Ke(p.value, (X) => (j(), R("div", {
              key: X.id,
              class: "flex items-center gap-2"
            }, [
              A("span", {
                class: "inline-block h-3 w-3 rounded-full border border-gray-300",
                style: _t({ backgroundColor: X.color ?? "#cccccc" })
              }, null, 4),
              A("span", K4, V(X.name), 1)
            ]))), 128))
          ])
        ])
      ])
    ])) : te("", !0);
  }
}), Q4 = {
  key: 0,
  class: "text-primary-600"
}, Y4 = { class: "text-sm" }, tx = /* @__PURE__ */ G({
  __name: "NestedAnswers",
  props: /* @__PURE__ */ lt({
    asCard: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ lt(["change"], ["update:modelValue"]),
  setup(a, { emit: e }) {
    const { getAnswerValue: t, setAnswerValue: o, checkDependencies: r, getTitle: s } = wP(), i = bt(a, "modelValue"), u = e, d = (v) => {
      i.value && (o(v, i.value.entry), r(i.value), u("change"));
    }, m = U(() => i.value ? s(i.value.entry) : "");
    return (v, p) => {
      var w, _;
      const g = Yn("NestedAnswers", !0);
      return j(), R("div", {
        class: ae(v.asCard ? "space-y-4" : "space-y-6")
      }, [
        i.value ? (j(), R("div", {
          key: 0,
          class: ae(v.asCard ? "space-y-2 rounded-md border-2 border-gray-200 p-4" : "space-y-4")
        }, [
          A("div", null, [
            A("h2", {
              class: ae(v.asCard ? "font-semibold" : "text-2xl")
            }, [
              Oe(V(m.value) + " ", 1),
              i.value.entry.isRequired ? (j(), R("span", Q4, "*")) : te("", !0)
            ], 2),
            A("p", Y4, V(i.value.entry.description), 1)
          ]),
          $(D(y3), {
            readonly: v.readonly,
            question: i.value.entry,
            "model-value": D(t)(i.value.entry),
            "onUpdate:modelValue": d
          }, null, 8, ["readonly", "question", "model-value"])
        ], 2)) : te("", !0),
        (_ = (w = i.value) == null ? void 0 : w.dependencies) != null && _.length ? (j(!0), R(Se, { key: 1 }, Ke(i.value.dependencies.filter((P) => {
          var T;
          return (T = P.entry) == null ? void 0 : T.visible;
        }) ?? [], (P) => {
          var T;
          return j(), R("div", {
            class: ae(["space-y-4", v.asCard ? "ml-4" : ""]),
            key: (T = P.entry) == null ? void 0 : T.id
          }, [
            $(g, {
              "model-value": P,
              "as-card": v.asCard,
              onChange: p[0] || (p[0] = (k) => u("change"))
            }, null, 8, ["model-value", "as-card"])
          ], 2);
        }), 128)) : te("", !0)
      ], 2);
    };
  }
}), X4 = {
  "aria-live": "assertive",
  class: "pointer-events-none fixed inset-0 z-40 flex items-end px-4 py-6 sm:items-start sm:p-6"
}, e3 = { class: "flex w-full flex-col items-center space-y-4 sm:items-end" }, t3 = { class: "p-4" }, r3 = { class: "flex items-start" }, s3 = { class: "flex-shrink-0" }, i3 = { class: "ml-3 w-0 flex-1 pt-0.5" }, n3 = { class: "text-sm font-medium text-gray-900 dark:text-white" }, o3 = { class: "dark:text-dark-400 mt-1 text-sm text-gray-500" }, a3 = { class: "ml-4 flex flex-shrink-0" }, l3 = ["onClick"], u3 = /* @__PURE__ */ A("span", { class: "sr-only" }, "Close", -1), rx = /* @__PURE__ */ G({
  __name: "Notification",
  setup(a) {
    const { emitter: e, notify: t } = qo(), { t: o } = At(), r = B([]);
    e.on("notify", (d) => {
      const m = {
        type: d.type,
        title: d.title,
        text: d.text,
        exception: d.exception,
        show: !0
      };
      r.value.push(m), setTimeout(() => {
        const v = r.value.indexOf(m);
        v >= 0 && r.value.splice(v, 1);
      }, 10 * 1e3);
    });
    const s = (d) => {
      switch (d) {
        case "success":
          return "check";
        case "warning":
          return "triangle-exclamation";
        case "error":
          return "xmark";
        case "info":
          return "info-circle";
        default:
          return "check";
      }
    }, i = (d) => {
      switch (d) {
        case "success":
          return "text-green-500";
        case "warning":
          return "text-yellow-500";
        case "error":
          return "text-red-500";
        case "info":
          return "text-blue-500";
        default:
          return "text-green-500";
      }
    }, u = (d) => {
      try {
        navigator.clipboard.writeText(d), t("success", o("common.error_text_copied_title"), o("common.error_text_copied_text"));
      } catch {
        t("error", o("common.error_text_copy_failed_title"), o("common.error_text_copy_failed_text"));
      }
    };
    return (d, m) => (j(), ne(Qn, { to: "body" }, [
      A("div", X4, [
        A("div", e3, [
          $(tf, {
            "enter-active-class": "transition duration-300 ease-out",
            "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
            "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
            "leave-active-class": "transition duration-100 ease-in",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: ee(() => [
              (j(!0), R(Se, null, Ke(r.value, (v, p) => (j(), R("div", {
                key: p,
                class: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-2xl ring-1 ring-black ring-opacity-5"
              }, [
                A("div", t3, [
                  A("div", r3, [
                    A("div", s3, [
                      $(D(je), {
                        icon: ["fal", s(v.type)],
                        class: ae(["h-6 w-6", i(v.type)])
                      }, null, 8, ["icon", "class"])
                    ]),
                    A("div", i3, [
                      A("p", n3, V(v.title), 1),
                      A("p", o3, V(v.text), 1),
                      v.exception ? (j(), ne(ws, {
                        key: 0,
                        class: "mt-2",
                        onClick: (g) => u(v.exception),
                        variant: "text"
                      }, {
                        default: ee(() => [
                          Oe(V(D(o)("common.copy_error_text")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])) : te("", !0)
                    ]),
                    A("div", a3, [
                      A("button", {
                        type: "button",
                        onClick: (g) => r.value.splice(r.value.indexOf(v), 1),
                        class: "dark:text-dark-400 dark:ring-offset-dark-800 dark:hover:text-dark-500 inline-flex rounded-md bg-transparent text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                      }, [
                        u3,
                        $(D(je), {
                          icon: ["fal", "close"],
                          class: "h-5 w-5"
                        })
                      ], 8, l3)
                    ])
                  ])
                ])
              ]))), 128))
            ]),
            _: 1
          })
        ])
      ])
    ]));
  }
}), c3 = { class: "h-4 w-full rounded-full bg-gray-300 dark:bg-gray-700" }, h3 = { key: 0 }, sx = /* @__PURE__ */ G({
  __name: "ProgressBar",
  props: {
    progressPercent: {},
    text: { type: Boolean }
  },
  setup(a) {
    return (e, t) => (j(), R("div", c3, [
      A("div", {
        class: ae(["h-4 rounded-full bg-primary-500 text-center align-middle text-sm font-medium text-white", e.progressPercent === 0 ? "ml-2" : "p-0.5"]),
        style: _t({ width: `${e.progressPercent}%` })
      }, [
        e.text ? (j(), R("span", h3, V(e.progressPercent) + "%", 1)) : te("", !0)
      ], 6)
    ]));
  }
}), d3 = () => ({ questionOptionToSelectionItem: (...e) => e.sort((t, o) => (t.order ?? 0) - (o.order ?? 0)).map((t) => ({
  text: t.text,
  value: t.id ?? t.value
})) }), f3 = { class: "relative grid h-10 min-w-full grid-cols-2 gap-4 md:min-w-40" }, p3 = ["value", "required", "name"], m3 = /* @__PURE__ */ G({
  __name: "YesNoInput",
  props: /* @__PURE__ */ lt({
    name: {},
    required: { type: Boolean },
    readonly: { type: Boolean }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a) {
    const e = a, t = bt(a, "modelValue"), o = (r) => {
      e.readonly || (t.value = r);
    };
    return (r, s) => (j(), R("div", f3, [
      A("input", {
        type: "text",
        value: t.value !== void 0 ? t.value : "",
        required: r.required,
        name: r.name,
        class: "pointer-events-none absolute inset-0 opacity-0"
      }, null, 8, p3),
      A("button", {
        type: "button",
        class: ae(["flex min-w-20 items-center justify-center rounded-full bg-red-500 bg-opacity-90 text-white", t.value !== !1 ? "opacity-60" : ""]),
        onClick: s[0] || (s[0] = St((i) => o(!1), ["prevent"]))
      }, [
        $(D(je), {
          class: "h-5 w-5",
          icon: ["fal", "xmark"]
        })
      ], 2),
      A("button", {
        type: "button",
        class: ae(["flex min-w-20 items-center justify-center rounded-full bg-green-700 bg-opacity-80 text-white", t.value !== !0 ? "opacity-50" : ""]),
        onClick: s[1] || (s[1] = St((i) => o(!0), ["prevent"]))
      }, [
        $(D(je), {
          class: "h-5 w-5",
          icon: ["fal", "check"]
        })
      ], 2)
    ]));
  }
}), v3 = { key: 2 }, g3 = { key: 3 }, y3 = /* @__PURE__ */ G({
  __name: "QuestionInput",
  props: /* @__PURE__ */ lt({
    question: {},
    required: { type: Boolean },
    readonly: { type: Boolean }
  }, {
    modelValue: { type: [String, Number, Boolean, Date, Array] },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a) {
    const { questionOptionToSelectionItem: e } = d3(), { t } = At(), o = bt(a, "modelValue"), r = a, s = U({
      get: () => o.value,
      set: (v) => {
        o.value = v;
      }
    }), i = U({
      get: () => o.value,
      set: (v) => {
        o.value = v;
      }
    }), u = U({
      get: () => o.value === void 0 ? void 0 : o.value,
      set: (v) => {
        o.value = v;
      }
    }), d = U({
      get: () => o.value,
      set: (v) => {
        o.value = v;
      }
    }), m = U(() => r.question.type === _e.ThreeWayToggle || r.question.type === _e.Checkbox || r.question.type === _e.PotentialEvaluation || r.question.type === _e.Radio);
    return (v, p) => v.question.type === D(_e).Number || v.question.type === D(_e).Text || v.question.type === D(_e).ProductCount ? (j(), ne(dt, {
      key: 0,
      modelValue: s.value,
      "onUpdate:modelValue": p[0] || (p[0] = (g) => s.value = g),
      name: v.question.id ?? "",
      required: v.required || v.question.isRequired,
      readonly: v.readonly,
      placeholder: v.question.placeholder,
      type: v.question.type === D(_e).Number || v.question.type === D(_e).ProductCount ? "number" : "text"
    }, null, 8, ["modelValue", "name", "required", "readonly", "placeholder", "type"])) : v.question.type === D(_e).Date ? (j(), ne(Ps, {
      key: 1,
      placeholder: v.question.placeholder,
      modelValue: i.value,
      "onUpdate:modelValue": p[1] || (p[1] = (g) => i.value = g),
      name: v.question.id ?? "",
      required: v.question.isRequired,
      disabled: v.readonly,
      readonly: v.readonly
    }, null, 8, ["placeholder", "modelValue", "name", "required", "disabled", "readonly"])) : v.question.options && m.value ? (j(), R("div", v3, [
      v.question.type === D(_e).ThreeWayToggle ? (j(), ne(hh, {
        key: 0,
        name: v.question.id ?? "",
        required: v.required || v.question.isRequired,
        items: D(e)(...v.question.options),
        modelValue: o.value,
        "onUpdate:modelValue": p[2] || (p[2] = (g) => o.value = g),
        readonly: v.readonly
      }, null, 8, ["name", "required", "items", "modelValue", "readonly"])) : v.question.type === D(_e).Radio ? (j(), ne(ch, {
        key: 1,
        items: D(e)(...v.question.options),
        required: v.required || v.question.isRequired,
        name: v.question.id ?? "",
        modelValue: o.value,
        "onUpdate:modelValue": p[3] || (p[3] = (g) => o.value = g),
        readonly: v.readonly
      }, null, 8, ["items", "required", "name", "modelValue", "readonly"])) : v.question.type === D(_e).Checkbox || v.question.type === D(_e).PotentialEvaluation ? (j(), ne(O1, {
        key: 2,
        items: D(e)(...v.question.options),
        required: v.required || v.question.isRequired,
        name: v.question.id ?? "",
        modelValue: d.value,
        "onUpdate:modelValue": p[4] || (p[4] = (g) => d.value = g),
        readonly: v.readonly
      }, null, 8, ["items", "required", "name", "modelValue", "readonly"])) : te("", !0)
    ])) : v.question.options ? v.question.type === D(_e).YesNo ? (j(), ne(m3, {
      key: 4,
      class: "md:max-w-80",
      modelValue: u.value,
      "onUpdate:modelValue": p[5] || (p[5] = (g) => u.value = g),
      required: v.required || v.question.isRequired,
      name: v.question.id ?? "",
      readonly: v.readonly
    }, null, 8, ["modelValue", "required", "name", "readonly"])) : te("", !0) : (j(), R("span", g3, V(D(t)("questions.options.no_options")), 1));
  }
}), _3 = ["aria-orientation"], ix = /* @__PURE__ */ G({
  __name: "Separator",
  props: {
    orientation: { default: "horizontal" },
    label: {}
  },
  setup(a) {
    const e = a;
    return (t, o) => (j(), R("div", rf(t.$attrs, {
      "aria-orientation": e.orientation,
      class: ["relative shrink-0 bg-gray-900/10", e.orientation === "vertical" ? "w-px self-stretch" : "h-px w-full"]
    }), [
      e.label ? (j(), R("span", {
        key: 0,
        class: ae(["text-xs text-muted-foreground bg-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex justify-center items-center", e.orientation === "vertical" ? "w-[1px] px-1 py-2" : "h-[1px] py-1 px-2"])
      }, V(e.label), 3)) : te("", !0)
    ], 16, _3));
  }
}), b3 = "data:image/webp;base64,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", w3 = { class: "grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8" }, P3 = { class: "text-center" }, x3 = /* @__PURE__ */ A("img", {
  class: "mx-auto mb-8 h-10 w-auto",
  src: b3,
  alt: "RentSales"
}, null, -1), S3 = { class: "mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl" }, T3 = { class: "mt-6 text-base leading-7 text-gray-600" }, nx = /* @__PURE__ */ G({
  __name: "SigninFailed",
  setup(a) {
    const { t: e } = At();
    return (t, o) => (j(), R("main", w3, [
      A("div", P3, [
        x3,
        A("h1", S3, V(D(e)("signin_failed.title")), 1),
        A("p", T3, V(D(e)("signin_failed.text")), 1)
      ])
    ]));
  }
}), L3 = { class: "flex flex-col gap-1" }, C3 = ["id", "name", "disabled", "checked"], ox = /* @__PURE__ */ G({
  __name: "SingleCheckboxInput",
  props: {
    modelValue: { type: Boolean },
    indeterminate: { type: Boolean },
    name: {},
    label: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: e }) {
    const t = a, o = e, r = B(), s = (i) => {
      var u;
      o("update:modelValue", ((u = i.target) == null ? void 0 : u.checked) ?? !1);
    };
    return Ie(
      () => t.indeterminate,
      (i) => {
        r.value && i && (r.value.indeterminate = i);
      }
    ), Ee(() => {
      r.value && (r.value.indeterminate = t.indeterminate ?? !1);
    }), (i, u) => (j(), R("div", L3, [
      i.label ? (j(), ne(Mt, {
        key: 0,
        name: i.name
      }, {
        default: ee(() => [
          Oe(V(i.label), 1)
        ]),
        _: 1
      }, 8, ["name"])) : te("", !0),
      A("input", {
        ref_key: "checkbox",
        ref: r,
        id: i.name,
        name: i.name,
        disabled: i.disabled,
        type: "checkbox",
        checked: i.modelValue,
        onInput: s,
        class: "h-4 w-4 rounded border-gray-200 bg-transparent text-primary-500 focus:ring-primary-500"
      }, null, 40, C3)
    ]));
  }
}), A3 = /* @__PURE__ */ A("div", { class: "fixed inset-0 bg-gray-300 bg-opacity-75 transition-opacity" }, null, -1), O3 = { class: "fixed inset-0 overflow-hidden" }, k3 = { class: "absolute inset-0 overflow-hidden" }, I3 = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10" }, j3 = { class: "px-4 sm:px-6" }, E3 = { class: "flex items-start justify-between" }, D3 = { class: "ml-3 flex h-7 items-center gap-2" }, M3 = /* @__PURE__ */ A("span", { class: "sr-only" }, "Close panel", -1), N3 = /* @__PURE__ */ A("div", { class: "dark:border-dark-600 h-96 rounded-lg border border-dashed border-gray-200 shadow-xl" }, null, -1), ax = /* @__PURE__ */ G({
  __name: "SlideOver",
  props: /* @__PURE__ */ lt({
    title: {}
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ lt(["submit"], ["update:modelValue"]),
  setup(a, { emit: e }) {
    const t = bt(a, "modelValue"), o = B(), r = e;
    Ie(
      () => t.value,
      (i) => {
        i && it(() => {
          var d;
          const u = (d = o.value) == null ? void 0 : d.querySelector("input");
          u == null || u.focus();
        });
      }
    );
    const s = () => {
      t.value = !1;
    };
    return (i, u) => (j(), ne(D(Xo), {
      as: "template",
      show: t.value
    }, {
      default: ee(() => [
        $(D(Jc), {
          as: "div",
          class: "relative z-20",
          onClose: s
        }, {
          default: ee(() => [
            $(D(_s), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: ee(() => [
                A3
              ]),
              _: 1
            }),
            A("div", O3, [
              A("div", k3, [
                A("div", I3, [
                  $(D(_s), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": "translate-x-full",
                    "enter-to": "translate-x-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-x-0",
                    "leave-to": "translate-x-full"
                  }, {
                    default: ee(() => [
                      $(D(Uc), { class: "pointer-events-auto w-screen max-w-lg" }, {
                        default: ee(() => [
                          A("form", {
                            class: "flex h-full flex-col overflow-y-auto bg-white py-6 shadow-xl",
                            onSubmit: u[1] || (u[1] = St((d) => r("submit"), ["prevent"]))
                          }, [
                            A("div", j3, [
                              A("div", E3, [
                                $(D(Bc), { class: "text-lg font-medium text-gray-900 dark:text-white" }, {
                                  default: ee(() => [
                                    Oe(V(i.title), 1)
                                  ]),
                                  _: 1
                                }),
                                A("div", D3, [
                                  ge(i.$slots, "buttons", {
                                    close: () => t.value = !1
                                  }, () => [
                                    A("button", {
                                      type: "button",
                                      class: "dark:focus:ring-offset-dark-800 flex items-center justify-center rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-white",
                                      onClick: u[0] || (u[0] = (d) => t.value = !1)
                                    }, [
                                      M3,
                                      $(D(je), {
                                        icon: ["fal", "xmark"],
                                        class: "h-6 w-6",
                                        "aria-hidden": "true"
                                      })
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            A("div", {
                              class: "relative mt-6 flex-1 px-4 sm:px-6",
                              ref_key: "slotContainer",
                              ref: o
                            }, [
                              ge(i.$slots, "default", {}, () => [
                                N3
                              ])
                            ], 512)
                          ], 32)
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  })
                ])
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), J3 = { class: "flex flex-col gap-4" }, U3 = { class: "flex flex-wrap items-center justify-between gap-2" }, B3 = { class: "flex items-center gap-2" }, R3 = {
  key: 0,
  class: "flex items-center gap-3"
}, z3 = { class: "text-xl font-semibold" }, q3 = { key: 1 }, Z3 = { class: "flex flex-wrap items-center justify-start gap-x-4 gap-y-2 sm:justify-end" }, V3 = { class: "mb-1 text-sm font-medium" }, $3 = { class: "list-inside list-disc text-sm" }, F3 = { class: "min-w-screen-sm w-full overflow-x-auto sm:min-w-0" }, G3 = { class: "min-w-full table-fixed overflow-hidden print:overflow-visible" }, H3 = { class: "dark:border-dark-700 border-b border-gray-200 text-left text-gray-700" }, W3 = ["onClick"], K3 = { class: "flex items-center justify-between gap-1.5" }, Q3 = { class: "flex-1" }, Y3 = { class: "w-3" }, X3 = { key: 0 }, eP = ["onClick"], tP = { class: "dark:divide-dark-700 divide-y divide-gray-200 whitespace-nowrap text-sm" }, rP = ["onClick"], sP = { key: 1 }, iP = { colspan: "100%" }, nP = { class: "px-2 py-2.5 text-sm text-gray-500" }, oP = {
  key: 0,
  class: "dark:border-dark-700 flex w-full items-center justify-between border-t border-gray-200 py-2",
  "aria-label": "Pagination"
}, aP = { class: "flex items-center gap-2" }, lP = { class: "dark:text-dark-400 text-sm text-gray-700" }, uP = { class: "hidden shrink-0 items-center space-x-4 sm:flex" }, cP = { class: "hidden shrink-0 lg:flex" }, hP = { class: "dark:text-dark-400 text-sm text-gray-700" }, dP = { class: "font-medium" }, fP = { class: "font-medium" }, pP = { class: "font-medium" }, mP = { class: "flex w-full flex-1 justify-end space-x-2 sm:w-auto sm:flex-none" }, lx = /* @__PURE__ */ G({
  __name: "Table",
  props: {
    headers: {},
    function: { type: Function },
    items: {},
    title: {},
    icon: {},
    detailRouteName: {},
    detailRouteParamName: {},
    filterable: { type: Boolean },
    searchable: { type: Boolean },
    showLoadingIndicator: { type: Boolean },
    settingsName: {}
  },
  emits: ["item-selected"],
  setup(a, { expose: e, emit: t }) {
    var Y, X;
    const { t: o } = At(), r = a, s = t, i = fu("table-settings", { pageSize: 15, showFilters: !1 }), u = {
      pageNumber: 1,
      sortBy: (Y = r.headers.find((Z) => Z.sortByDefault)) == null ? void 0 : Y.field,
      sortDescending: ((X = r.headers.find((Z) => Z.sortByDefault)) == null ? void 0 : X.sortByDefaultDescending) ?? !1
    }, d = r.settingsName ? lf(r.settingsName, u) : B(u), m = B(!1), v = B(null), p = B(""), g = B({}), w = B(!1), _ = U(() => {
      var Z;
      return v.value ? (Z = v.value) == null ? void 0 : Z.hasPreviousPage : !1;
    }), P = U(() => {
      var Z;
      return v.value ? (Z = v.value) == null ? void 0 : Z.hasNextPage : !1;
    }), T = U(() => r.headers.some((Z) => Z.field && Z.type)), k = U(
      () => new Ct({
        isGroup: !0,
        logicalOperator: xu.And,
        filters: Object.values(g.value).filter((Z) => {
          var he;
          return Z.stringValue || Z.numberValue || Z.dateTimeValue || (((he = Z.enumValues) == null ? void 0 : he.length) ?? 0) > 0 || Z.booleanValue !== void 0;
        })
      })
    ), x = async () => r.function ? r.function(
      d.value.pageNumber,
      i.value.pageSize,
      d.value.sortBy,
      d.value.sortDescending,
      r.headers.filter((Z) => Z.searchable && Z.field).map((Z) => Z.field),
      p.value,
      k.value
    ) : { data: r.items }, C = async () => {
      m.value = !0, d.value.pageNumber--, v.value = await x(), m.value = !1;
    }, I = async () => {
      m.value = !0, d.value.pageNumber++, v.value = await x(), m.value = !1;
    }, z = async (Z) => {
      const he = Z.field;
      !he || !Z.sortable || (m.value = !0, d.value.sortBy === he && d.value.sortDescending === !0 ? (d.value.sortBy = void 0, d.value.sortDescending = !1) : (d.value.sortBy !== he ? d.value.sortDescending = !1 : d.value.sortDescending = !d.value.sortDescending, d.value.sortBy = he), v.value = await x(), m.value = !1);
    }, H = Xn(async () => {
      m.value = !0, d.value.pageNumber = 1, v.value = await x(), m.value = !1;
    }), F = () => {
      p.value = "", H();
    }, se = async () => {
      d.value.pageNumber = 1, v.value = await x();
    }, pe = async () => {
      w.value = !0;
      try {
        v.value = await x();
      } finally {
        w.value = !1;
      }
    }, Te = () => {
      i.value.showFilters = !i.value.showFilters;
    }, W = (Z) => Z.type === "datetime" ? [
      { text: o("table.before"), value: vt.LessThan },
      { text: o("table.after"), value: vt.GreaterThan }
    ] : [
      { text: o("table.contains"), value: vt.Contains },
      { text: o("table.equals"), value: vt.Equals },
      { text: o("table.lower_than"), value: vt.LessThan },
      { text: o("table.lower_than_equals"), value: vt.LessThanEquals },
      { text: o("table.greater_than"), value: vt.GreaterThan },
      { text: o("table.greater_than_equals"), value: vt.GreaterThanEquals }
    ];
    return Ee(async () => {
      for (const Z of r.headers)
        !Z.field || !Z.type || (g.value[Z.field] = new Ct({
          property: Z.field,
          operator: Z.type === "datetime" ? vt.GreaterThan : Z.type === "boolean" ? vt.Equals : vt.Contains
        }));
      await pe();
    }), Ie(
      () => r.items,
      async (Z) => {
        Z && (v.value = { data: Z });
      }
    ), Ie(
      () => r.headers,
      () => {
        if (!d.value.sortBy || !r.headers.find((Z) => Z.field === d.value.sortBy)) {
          const Z = r.headers.find((he) => he.sortByDefault);
          d.value.sortBy = Z == null ? void 0 : Z.field, d.value.sortDescending = (Z == null ? void 0 : Z.sortByDefaultDescending) ?? !1;
        }
      },
      { deep: !0 }
    ), uf(
      g,
      async () => {
        await pe();
      },
      { deep: !0, debounce: 250, maxWait: 500 }
    ), e({
      refresh: pe,
      reset: se
    }), (Z, he) => {
      var Pe, ot, ue, Gt;
      return j(), R("div", J3, [
        A("div", U3, [
          A("div", B3, [
            ge(Z.$slots, "title", {}, () => [
              Z.title ? (j(), R("div", R3, [
                Z.icon ? (j(), ne(D(je), {
                  key: 0,
                  icon: ["fal", Z.icon],
                  class: "h-6 w-6 flex-shrink-0 text-gray-600",
                  "aria-hidden": "true"
                }, null, 8, ["icon"])) : te("", !0),
                A("h2", z3, V(Z.title), 1)
              ])) : (j(), R("div", q3))
            ]),
            Z.showLoadingIndicator && w.value ? (j(), ne(Ai, {
              key: 0,
              class: "!h-5 !w-5 border-gray-400"
            })) : te("", !0)
          ]),
          A("div", Z3, [
            Z.filterable && T.value ? (j(), ne(gs, {
              key: 0,
              placement: "bottom-start"
            }, {
              trigger: ee(() => {
                var J;
                return [
                  A("div", {
                    class: "flex cursor-pointer items-center justify-center",
                    onClick: Te
                  }, [
                    $(D(je), {
                      icon: [(J = k.value.filters) != null && J.length ? "fas" : "fal", "filters"],
                      class: "h-5 w-5 flex-shrink-0 text-gray-700 transition duration-200 ease-in-out dark:text-white"
                    }, null, 8, ["icon"])
                  ])
                ];
              }),
              content: ee(() => {
                var J;
                return [
                  Oe(V(D(o)("table.filters_set", ((J = k.value.filters) == null ? void 0 : J.length) ?? 0)), 1)
                ];
              }),
              _: 1
            })) : te("", !0),
            Z.searchable ? (j(), ne(gs, {
              key: 1,
              placement: "bottom-start"
            }, {
              trigger: ee(() => [
                Z.headers.some((J) => J.searchable && J.field) ? (j(), ne(dt, {
                  key: 0,
                  name: "search",
                  class: "w-64",
                  placeholder: D(o)("table.search"),
                  modelValue: p.value,
                  "onUpdate:modelValue": he[0] || (he[0] = (J) => p.value = J),
                  onInput: D(H)
                }, {
                  left: ee(() => [
                    $(D(je), {
                      icon: ["fal", "magnifying-glass"],
                      class: "dark:text-dark-400 h-3 w-3 text-gray-700"
                    })
                  ]),
                  right: ee(() => [
                    $(D(je), {
                      icon: ["fal", "xmark"],
                      class: "dark:text-dark-400 h-3 w-3 flex-shrink-0 cursor-pointer text-gray-700 transition duration-200 ease-in-out",
                      onClick: F
                    })
                  ]),
                  _: 1
                }, 8, ["placeholder", "modelValue", "onInput"])) : te("", !0)
              ]),
              content: ee(() => [
                A("div", V3, V(D(o)("table.search_fields")), 1),
                A("ul", $3, [
                  (j(!0), R(Se, null, Ke(Z.headers.filter((J) => J.searchable), (J) => (j(), R("li", {
                    key: J.title
                  }, V(J.title), 1))), 128))
                ])
              ]),
              _: 1
            })) : te("", !0),
            ge(Z.$slots, "right")
          ])
        ]),
        A("div", null, [
          A("div", F3, [
            A("table", G3, [
              A("thead", H3, [
                A("tr", null, [
                  (j(!0), R(Se, null, Ke(Z.headers, (J) => (j(), R("th", {
                    key: J.key,
                    class: ae(["px-2 py-2 text-xs font-medium uppercase dark:text-white", [`${J.field && J.sortable ? "cursor-pointer" : ""}`, J.classes]]),
                    onClick: (Q) => z(J)
                  }, [
                    A("div", K3, [
                      A("span", Q3, V(J.title), 1),
                      A("div", Y3, [
                        Ur($(D(je), {
                          icon: ["fal", "arrow-up"],
                          class: ae(["h-3 w-3 flex-shrink-0 text-gray-700 transition duration-200 ease-in-out dark:text-white", D(d).sortDescending ? "rotate-180" : ""])
                        }, null, 8, ["class"]), [
                          [ai, D(d).sortBy && J.field === D(d).sortBy]
                        ]),
                        Ur($(D(je), {
                          icon: ["fal", "arrow-up-arrow-down"],
                          class: "h-3 w-3 flex-shrink-0 text-gray-700 transition duration-200 ease-in-out dark:text-white"
                        }, null, 512), [
                          [ai, J.sortable && J.field !== D(d).sortBy]
                        ])
                      ])
                    ])
                  ], 10, W3))), 128))
                ]),
                $(Kn, {
                  "enter-active-class": "transition ease-out duration-200",
                  "enter-from-class": "opacity-0 translate-y-1",
                  "enter-to-class": "opacity-100 translate-y-0",
                  "leave-active-class": "transition ease-in duration-150",
                  "leave-from-class": "opacity-100 translate-y-0",
                  "leave-to-class": "opacity-0 translate-y-1"
                }, {
                  default: ee(() => [
                    T.value && D(i).showFilters && Z.filterable ? (j(), R("tr", X3, [
                      (j(!0), R(Se, null, Ke(Z.headers, (J) => (j(), R("th", {
                        key: J.key,
                        class: ae(["px-2 pb-2 text-xs font-normal uppercase dark:text-white", [`${J.field && J.sortable ? "cursor-pointer" : ""}`, J.classes]]),
                        onClick: (Q) => z(J)
                      }, [
                        J.field && J.type && g.value[J.field] ? (j(), R("div", {
                          key: 0,
                          onClick: he[1] || (he[1] = St(() => {
                          }, ["stop"])),
                          class: "flex w-full items-center justify-between gap-1.5"
                        }, [
                          J.type === "number" || J.type === "datetime" ? (j(), ne(Zt, {
                            key: 0,
                            "dropdown-class": J.type === "datetime" ? "w-28" : "w-36",
                            name: `${J.field}-operator`,
                            modelValue: g.value[J.field].operator,
                            "onUpdate:modelValue": (Q) => g.value[J.field].operator = Q,
                            items: W(J)
                          }, null, 8, ["dropdown-class", "name", "modelValue", "onUpdate:modelValue", "items"])) : te("", !0),
                          J.type === "string" ? (j(), ne(dt, {
                            key: 1,
                            modelValue: g.value[J.field].stringValue,
                            "onUpdate:modelValue": (Q) => g.value[J.field].stringValue = Q,
                            name: `${J.field}-value`,
                            class: "flex-1",
                            clearable: !0
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])) : te("", !0),
                          J.type === "number" ? (j(), ne(dt, {
                            key: 2,
                            modelValue: g.value[J.field].numberValue,
                            "onUpdate:modelValue": (Q) => g.value[J.field].numberValue = Q,
                            type: "number",
                            name: `${J.field}-value`,
                            class: "flex-1",
                            clearable: !0
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])) : te("", !0),
                          J.type === "datetime" ? (j(), ne(Ps, {
                            key: 3,
                            modelValue: g.value[J.field].dateTimeValue,
                            "onUpdate:modelValue": (Q) => g.value[J.field].dateTimeValue = Q,
                            name: `${J.field}-value`,
                            "enable-time-picker": !0,
                            format: "dd.MM.yyyy HH:mm",
                            class: "min-w-[145px] flex-1"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])) : te("", !0),
                          J.type === "enum" && J.enumItems ? (j(), ne(Zt, {
                            key: 4,
                            class: "flex-1",
                            name: `${J.field}-value`,
                            multiple: !0,
                            modelValue: g.value[J.field].enumValues,
                            "onUpdate:modelValue": (Q) => g.value[J.field].enumValues = Q,
                            items: J.enumItems
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "items"])) : te("", !0),
                          J.type === "boolean" ? (j(), ne(hh, {
                            key: 5,
                            name: `${J.field}-value`,
                            modelValue: g.value[J.field].booleanValue,
                            "onUpdate:modelValue": (Q) => g.value[J.field].booleanValue = Q,
                            indeterminable: !0,
                            items: [
                              { value: !0, text: D(o)("common.yes") },
                              { value: !1, text: D(o)("common.no") }
                            ]
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "items"])) : te("", !0)
                        ])) : te("", !0)
                      ], 10, eP))), 128))
                    ])) : te("", !0)
                  ]),
                  _: 1
                })
              ]),
              A("tbody", tP, [
                v.value && v.value.data.length > 0 ? (j(!0), R(Se, { key: 0 }, Ke(v.value.data, (J) => (j(), R("tr", {
                  class: "dark:hover:bg-dark-900/50 cursor-pointer transition duration-100 ease-in-out hover:bg-gray-50",
                  key: J.id,
                  onClick: (Q) => s("item-selected", J)
                }, [
                  (j(!0), R(Se, null, Ke(Z.headers, (Q) => (j(), R("td", {
                    class: "m-0 p-0",
                    key: `${Q.key}-${J.id}`
                  }, [
                    (j(), ne(sf(r.detailRouteName ? "router-link" : "span"), {
                      tabindex: "-1",
                      class: ae(["dark:text-dark-300 flex h-full w-full truncate px-1 py-2 text-gray-500 focus:outline-none sm:px-2", Q.classes]),
                      to: r.detailRouteName ? { name: r.detailRouteName, params: { [r.detailRouteParamName ?? "id"]: J.id } } : ""
                    }, {
                      default: ee(() => [
                        ge(Z.$slots, Q.key, { item: J })
                      ]),
                      _: 2
                    }, 1032, ["class", "to"]))
                  ]))), 128))
                ], 8, rP))), 128)) : (j(), R("tr", sP, [
                  A("td", iP, [
                    A("p", nP, V(D(o)("table.no_data")), 1)
                  ])
                ]))
              ])
            ])
          ]),
          v.value && v.value.count && v.value.count > 0 ? (j(), R("nav", oP, [
            A("div", aP, [
              $(Zt, {
                name: "pageSize",
                modelValue: D(i).pageSize,
                "onUpdate:modelValue": [
                  he[2] || (he[2] = (J) => D(i).pageSize = J),
                  pe
                ],
                items: [
                  { text: "15", value: 15 },
                  { text: "30", value: 30 },
                  { text: "50", value: 50 },
                  { text: "200", value: 200 }
                ]
              }, null, 8, ["modelValue"]),
              A("span", lP, V(D(o)("table.entries")), 1)
            ]),
            A("div", uP, [
              A("div", cP, [
                A("p", hP, [
                  A("span", dP, V(((Pe = v.value) == null ? void 0 : Pe.from) ?? 0), 1),
                  Oe(" " + V(D(o)("table.to")) + " ", 1),
                  A("span", fP, V(((ot = v.value) == null ? void 0 : ot.to) ?? 0), 1),
                  Oe(" " + V(D(o)("table.from")) + " ", 1),
                  A("span", pP, V(((ue = v.value) == null ? void 0 : ue.count) ?? 0), 1),
                  Oe(" " + V(D(o)("table.results", (Gt = v.value) == null ? void 0 : Gt.count)), 1)
                ])
              ])
            ]),
            A("div", mP, [
              $(ws, {
                type: "button",
                disabled: !_.value || m.value,
                onClick: he[3] || (he[3] = (J) => C()),
                class: "button button--default",
                variant: "default"
              }, {
                default: ee(() => [
                  $(D(je), {
                    icon: ["fal", "chevron-left"],
                    class: "h-3 w-3 text-gray-600",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              }, 8, ["disabled"]),
              $(ws, {
                type: "button",
                disabled: !P.value || m.value,
                onClick: he[4] || (he[4] = (J) => I()),
                class: "button button--default",
                variant: "default"
              }, {
                default: ee(() => [
                  $(D(je), {
                    icon: ["fal", "chevron-right"],
                    class: "h-3 w-3 text-gray-600",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])) : te("", !0)
        ])
      ]);
    };
  }
}), vP = { class: "space-y-1" }, gP = { class: "relative" }, yP = { class: "dark:bg-dark-500 flex w-full items-center rounded-md border-[1px] border-gray-200 bg-gray-100 shadow-sm" }, _P = ["name", "id", "placeholder", "disabled", "autocomplete", "required", "readonly", "rows"], ux = /* @__PURE__ */ G({
  __name: "TextArea",
  props: /* @__PURE__ */ lt({
    name: {},
    label: {},
    placeholder: { default: "" },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    required: { type: Boolean },
    autocomplete: {},
    pattern: {},
    title: {},
    clearable: { type: Boolean },
    rows: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a, { expose: e }) {
    const t = bt(a, "modelValue"), o = B();
    return e({ focus: () => {
      var i;
      return (i = o.value) == null ? void 0 : i.focus();
    }, selectAll: () => {
      var i;
      return (i = o.value) == null ? void 0 : i.select();
    } }), (i, u) => (j(), R("div", vP, [
      i.label ? (j(), ne(Mt, {
        key: 0,
        name: i.name
      }, {
        default: ee(() => [
          Oe(V(i.label), 1)
        ]),
        _: 1
      }, 8, ["name"])) : te("", !0),
      A("div", gP, [
        A("div", yP, [
          Ur(A("textarea", {
            ref_key: "input",
            ref: o,
            "onUpdate:modelValue": u[0] || (u[0] = (d) => t.value = d),
            name: i.name,
            id: i.name,
            class: ae(["placeholder:dark:text-dark-500 block max-w-full flex-1 rounded-md border-none bg-white px-3 py-1.5 shadow-sm placeholder:text-gray-400 focus-visible:outline-none dark:text-white sm:text-sm", [
              i.readonly ? "focus:outline-none focus:ring-0" : "focus:border-primary-500 focus:ring-primary-500 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 dark:focus:border-primary-500 dark:focus:ring-primary-500"
            ]]),
            placeholder: i.placeholder,
            disabled: i.disabled,
            autocomplete: i.autocomplete,
            required: i.required,
            readonly: i.readonly,
            rows: i.rows
          }, null, 10, _P), [
            [nf, t.value]
          ])
        ])
      ])
    ]));
  }
}), bP = "special_question.product_count", wP = () => {
  const { t: a } = At(), e = (p) => {
    var g;
    return p.type === _e.PotentialEvaluation ? a(p.title ?? "") : p.type === _e.ProductCount && "referencedProduct" in p ? a(bP, {
      product: ((g = p.referencedProduct) == null ? void 0 : g.name) ?? ""
    }) : p.title ?? "";
  }, t = (p) => {
    switch (p == null ? void 0 : p.type) {
      case _e.Text:
      case _e.ThreeWayToggle:
      case _e.Radio:
        return p.valueText;
      case _e.Number:
      case _e.ProductCount:
        return p.valueNumber;
      case _e.Date:
        return p.valueDate;
      case _e.YesNo:
        return p.valueBoolean;
      case _e.Checkbox:
        return p.valueList;
      case _e.PotentialEvaluation:
        return p.valueList;
      default:
        return "";
    }
  }, o = (p) => {
    var w, _;
    let g;
    for (const P of p) {
      if (P.visible === !1) continue;
      let T;
      P.type === _e.YesNo ? P.valueBoolean === !0 ? T = P.yesTriggerProjectStatusId : P.valueBoolean === !1 && (T = P.noTriggerProjectStatusId) : P.type === _e.Radio && (T = (_ = (w = P.options) == null ? void 0 : w.find((k) => k.value === P.valueText)) == null ? void 0 : _.triggerProjectStatusId), T && (g = T);
    }
    return g;
  }, r = (p, g) => {
    g && (typeof p == "string" ? g.valueText = p : typeof p == "number" ? g.valueNumber = p : p instanceof Date ? g.valueDate = p : typeof p == "boolean" ? g.valueBoolean = p : Array.isArray(p) && (g.valueList = p));
  }, s = (p, g) => {
    if (p.dependencies)
      for (const w of p.dependencies) {
        const _ = w.entry;
        g ? _.visible = !1 : p.entry.type === _e.Text || p.entry.type === _e.ThreeWayToggle || p.entry.type === _e.Radio ? i(_, p.entry) : p.entry.type === _e.Number || p.entry.type === _e.ProductCount ? u(_, p.entry) : p.entry.type === _e.Date ? d(_, p.entry) : p.entry.type === _e.YesNo ? m(_, p.entry) : p.entry.type === _e.Checkbox || p.entry.type === _e.PotentialEvaluation ? v(_, p.entry) : _.visible = !1, _.visible === !1 && (_.valueText = _.valueBoolean = _.valueDate = _.valueList = _.valueNumber = void 0), s(w, !_.visible);
      }
  }, i = (p, g) => {
    var w;
    g.valueText !== void 0 && ((w = p.dependency) == null ? void 0 : w.condition) === gt.Equal && (p.visible = g.valueText === p.dependency.valueText);
  }, u = (p, g) => {
    var _, P, T, k, x;
    if (g.valueNumber === void 0) return;
    const w = g.valueNumber;
    ((_ = p.dependency) == null ? void 0 : _.condition) === gt.Equal ? p.visible = w === p.dependency.valueNumber : ((P = p.dependency) == null ? void 0 : P.condition) === gt.GreaterThan ? p.visible = p.dependency.valueNumber !== void 0 && w > p.dependency.valueNumber : ((T = p.dependency) == null ? void 0 : T.condition) === gt.LessThan ? p.visible = p.dependency.valueNumber !== void 0 && w < p.dependency.valueNumber : ((k = p.dependency) == null ? void 0 : k.condition) === gt.GreaterThanOrEqual ? p.visible = p.dependency.valueNumber !== void 0 && w >= p.dependency.valueNumber : ((x = p.dependency) == null ? void 0 : x.condition) === gt.LessThanOrEqual && (p.visible = p.dependency.valueNumber !== void 0 && w <= p.dependency.valueNumber);
  }, d = (p, g) => {
    var P, T, k, x;
    if (!g.valueDate) return;
    const w = Vt.fromJSDate(g.valueDate).startOf("day"), _ = Vt.fromJSDate(((P = p.dependency) == null ? void 0 : P.valueDate) ?? /* @__PURE__ */ new Date()).startOf("day");
    ((T = p.dependency) == null ? void 0 : T.condition) === gt.Equal ? p.visible = w.equals(_) : ((k = p.dependency) == null ? void 0 : k.condition) === gt.Before ? p.visible = w < _ : ((x = p.dependency) == null ? void 0 : x.condition) === gt.After && (p.visible = w > _);
  }, m = (p, g) => {
    var w;
    g.valueBoolean !== void 0 && ((w = p.dependency) == null ? void 0 : w.condition) === gt.Equal && (p.visible = g.valueBoolean === p.dependency.valueBoolean);
  }, v = (p, g) => {
    var _, P;
    const w = g.valueList;
    !w || !((_ = p.dependency) != null && _.valueList) || ((P = p.dependency) == null ? void 0 : P.condition) === gt.Contains && (p.visible = p.dependency.valueList.every((T) => w.includes(T)));
  };
  return { getAnswerValue: t, setAnswerValue: r, checkDependencies: s, getTitle: e, getTriggeredProjectStatusId: o };
}, uu = (a, e) => {
  const t = (o) => (o ?? "").trim().toLowerCase();
  return t(a.street) === t(e.street) && t(a.details) === t(e.details) && t(a.postalCode) === t(e.postalCode) && t(a.city) === t(e.city) && t(a.country) === t(e.country);
}, cx = (a) => new qr({
  street: a.street ?? "",
  details: a.details ?? "",
  postalCode: a.zip ?? "",
  city: a.city ?? "",
  country: a.country ?? ""
}), hx = (a, e) => new We({
  ...e,
  street: a.street,
  details: a.details,
  zip: a.postalCode,
  city: a.city,
  country: a.country,
  latitude: a.latitude,
  longitude: a.longitude
}), dx = (a) => new qr({
  street: a.street ?? "",
  details: a.details ?? "",
  postalCode: a.postalCode ?? "",
  city: a.city ?? "",
  country: a.country ?? ""
}), fx = async (a, e) => {
  try {
    const t = await a.validateAddress(e);
    if (t.isComplete && t.validatedAddress)
      return t.validatedAddress;
  } catch (t) {
    console.error("Address validation failed, using original address", t);
  }
  return e;
}, px = (a) => {
  const { place: e, validatedAddress: t, clickedLocation: o } = a;
  return e.longitude != null && e.latitude != null ? { longitude: e.longitude, latitude: e.latitude } : (t == null ? void 0 : t.longitude) != null && (t == null ? void 0 : t.latitude) != null ? { longitude: t.longitude, latitude: t.latitude } : (o == null ? void 0 : o.longitude) != null && (o == null ? void 0 : o.latitude) != null ? { longitude: o.longitude, latitude: o.latitude } : { longitude: void 0, latitude: void 0 };
}, mx = (a) => {
  const { confirm: e } = gh(), { notifyApiException: t } = fc(), { t: o } = At();
  return { validateAddressWithConfirm: async (s) => {
    try {
      const i = await a.validateAddress(s);
      return i.isComplete && i.validatedAddress && uu(s, i.validatedAddress) ? { proceed: !0 } : i.isComplete && i.validatedAddress && !uu(s, i.validatedAddress) ? {
        proceed: !0,
        suggestedAddress: i.validatedAddress
      } : { proceed: await e(
        o("address_validation.title"),
        o("address_validation.text"),
        o("address_validation.save_anyway"),
        o("common.cancel")
      ) };
    } catch (i) {
      return t(i), { proceed: !1 };
    }
  } };
}, vx = () => ({ formatDate: (t) => t ? Vt.fromJSDate(t).setLocale("de-AT").toLocaleString({
  weekday: "long",
  month: "short",
  day: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit"
}) : "", formatDateShort: (t) => t ? Vt.fromJSDate(t).setLocale("de-AT").toLocaleString({
  weekday: "short",
  month: "short",
  day: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit"
}) : "" }), gx = (a, e, t) => {
  const o = (a == null ? void 0 : a.trim()) || "import.csv", r = o.toLowerCase().endsWith(".csv") ? o.slice(0, -4) : o;
  return `${Vt.fromJSDate(e ?? /* @__PURE__ */ new Date()).toFormat("yyyy-MM-dd")}_${r}${t ? `_${t}` : ""}.csv`;
}, yx = () => ({ downloadFile: (e, t) => {
  const o = window.URL.createObjectURL(new Blob([e.data], { type: "text/csv" })), r = document.createElement("a");
  r.href = o, r.setAttribute("download", t), document.body.appendChild(r), r.click(), r.remove(), window.URL.revokeObjectURL(o);
} }), _x = () => ({ groupEntries: (e) => {
  var r, s;
  const t = /* @__PURE__ */ new Map();
  for (const i of e)
    i.id && t.set(i.id, { entry: i });
  const o = [];
  for (const i of e) {
    if (!i.id) continue;
    const u = t.get(i.id);
    if (!u) continue;
    const d = ((r = i == null ? void 0 : i.dependency) == null ? void 0 : r.dependencyQuestionId) ?? ((s = i == null ? void 0 : i.dependency) == null ? void 0 : s.dependencyAnswerId);
    if (d) {
      const m = t.get(d);
      m && (m.dependencies || (m.dependencies = []), m.dependencies.push(u));
    } else
      o.push(u);
  }
  return o;
} }), bx = () => ({ initSentry: (e, t, o) => {
  if (!(o != null && o.sentryDsn) || o.sentryDsn.trim() === "") {
    console.log("Sentry DSN is not set, skipping Sentry initialization");
    return;
  }
  ii.init({
    app: e,
    dsn: o.sentryDsn,
    integrations: [ii.browserTracingIntegration({ router: t }), ii.replayIntegration()],
    tracesSampleRate: 1,
    tracePropagationTargets: [
      "localhost",
      "https://backoffice.rentsales.app",
      "https://rentsales.app",
      "https://staging.backoffice.rentsales.codebeam.app",
      "https://staging.rentsales.codebeam.app/"
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    environment: o.environment
  });
} });
class Ph {
  constructor() {
    this.statusGroups = [], this.projectStatuses = [], this.zip = "", this.street = "", this.city = "", this.country = "", this.assignedUserIds = [], this.showUnassigned = !0, this.showVisits = !0, this.visitStartDate = null, this.visitEndDate = null, this.showTasks = !0, this.showPotentials = !0, this.potentials = [];
  }
  static Defaults() {
    const e = new Ph();
    return e.visitStartDate = new Date((/* @__PURE__ */ new Date()).setDate((/* @__PURE__ */ new Date()).getDate() - 1)), e.visitEndDate = /* @__PURE__ */ new Date(), e;
  }
}
class wx {
  constructor(e, t, o, r = "default", s, i, u, d = 0) {
    this.zIndexOffset = 0, this.id = e, this.longitude = t, this.latitude = o, this.type = r, this.color = s, this.toolTipHtml = i, this.onClickCallback = u, this.zIndexOffset = d;
  }
  getDefaultColor() {
    switch (this.type) {
      case "star":
        return "#FFD700";
      case "check":
        return "#28a745";
      case "cross":
        return "#dc3545";
      case "default":
      default:
        return "#cccccc";
    }
  }
  getColor() {
    return this.color || this.getDefaultColor();
  }
}
class cu {
  constructor() {
    this.backendUrl = "", this.vapidPublicKey = "", this.sentryDsn = "", this.environment = "development";
  }
  static async load() {
    return (await ke.get("/config.json")).data;
  }
}
const Px = (a) => (a.defaults.withCredentials = !0, a), xx = (a, e) => (a.interceptors.response.use(
  (t) => t,
  async (t) => {
    var o;
    return ((o = t.response) == null ? void 0 : o.status) === 401 && e(), Promise.reject(t);
  }
), a), Sx = async (a, e) => {
  const t = await cu.load();
  if (!t || !t.backendUrl)
    throw new Error("Invalid configuration. Please check your config.json file.");
  const o = t.backendUrl, r = [
    up,
    cp,
    mu,
    vu,
    gp,
    hp,
    dp,
    fp,
    pp,
    mp,
    vp,
    gu,
    yp,
    yu,
    _p,
    bp,
    wp,
    Pp,
    _u,
    xp,
    Sp,
    Tp,
    Lp,
    Cp,
    bu,
    Ap,
    Op,
    kp,
    Ip,
    wu,
    jp
  ];
  a.bind(cu.name).toConstantValue(t);
  for (const s of r)
    a.bind(s.name).toConstantValue(new s(o, e));
}, PP = [
  df,
  ff,
  pf,
  mf,
  vf,
  If,
  gf,
  yf,
  _f,
  bf,
  wf,
  Pf,
  xf,
  Sf,
  Tf,
  Lf,
  Cf,
  Af,
  jf,
  Of,
  kf
];
hf.add(...PP);
const Tx = Ef("session", () => {
  const a = fu("session", {}), e = B(!1), [t] = pr(mu.name), o = async () => {
    e.value || (a.value = await t.getSession(), e.value = !0);
  }, r = U(() => {
    var u;
    return ((u = a.value) == null ? void 0 : u.id) !== void 0;
  }), s = async () => {
    await t.logout(), a.value = {};
  }, i = U(() => a.value.role === Pu.Admin);
  return { session: a, sessionInitialized: e, initSession: o, logout: s, isAuthenticated: r, isAdmin: i };
}), Lx = {
  de: pu
};
export {
  xi as Absence,
  Ep as AbsenceType,
  up as AbsencesApi,
  UP as AccordionItem,
  Ph as ActiveMapFilter,
  BP as ActivityFeed,
  RP as ActivityFeedItem,
  qr as Address,
  qP as AddressInputGroup,
  yo as AddressValidationResult,
  vr as Answer,
  Su as AnswerBulkUpdateParams,
  Tu as AnswerCreateParams,
  ro as AnswerDependency,
  to as AnswerOption,
  Lu as AnswerUpdateParams,
  cp as AnswersApi,
  zp as ApiException,
  mu as AuthApi,
  yl as AutocompleteTextInput,
  ZP as Badge,
  ws as Button,
  hh as ButtonSelection,
  VP as CardContainer,
  O1 as CheckboxInput,
  $P as ChipsInput,
  Ai as CircularSpinner,
  FP as ColorInput,
  zr as ColumnDefinition,
  Np as ColumnType,
  cu as Configuration,
  GP as ConfirmDialog,
  We as Contact,
  lo as ContactCreateParams,
  Cu as ContactFilter,
  Dt as ContactStatus,
  hp as ContactStatusApi,
  ni as ContactType,
  Au as ContactUpdateParams,
  vu as ContactsApi,
  hc as Country,
  Ou as CreateEndOfDayQuestionnaireParams,
  Ru as CreateProjectQuestionnairesParams,
  Ps as DateInput,
  HP as DateTimeInput,
  Uo as DeactivatedUser,
  gt as DependencyCondition,
  r4 as Dialog,
  WP as DropdownMenu,
  KP as Dropzone,
  Nr as EndOfDayQuestionnaire,
  dp as EndOfDayQuestionnairesApi,
  no as ExtendedSession,
  Ct as Filter,
  vt as FilterOperator,
  ys as FilterPreset,
  ju as FilterPresetCreateParams,
  Iu as FilterPresetUpdateParams,
  fp as FilterPresetsApi,
  rc as FollowUpParams,
  pi as FollowUpResponse,
  QP as IconButton,
  mo as Import,
  pp as ImportsApi,
  Mt as InputLabel,
  YP as Layout,
  ko as LeadQuestionHeader,
  oo as LeadTeam,
  tc as LeadsExportParams,
  XP as LeafletMap,
  Si as ListParams,
  ec as LocationParams,
  xu as LogicalFilterOperator,
  ex as MapFilter,
  Dp as MemberType,
  ao as MinimalContactStatus,
  Io as MinimalTask,
  Ju as MonthlyTargetUpdateParams,
  sc as MultiTaskUpdateParams,
  tx as NestedAnswers,
  rx as Notification,
  mp as NotificationsApi,
  Gu as NotifyParams,
  _r as Organisation,
  vp as OrganisationsApi,
  ms as PagedOfAbsence,
  so as PagedOfAnswer,
  uo as PagedOfContact,
  co as PagedOfContactStatus,
  Jo as PagedOfDeactivatedUser,
  ho as PagedOfEndOfDayQuestionnaire,
  fo as PagedOfFilterPreset,
  po as PagedOfImport,
  vo as PagedOfOrganisation,
  vs as PagedOfPotential,
  li as PagedOfProduct,
  _o as PagedOfProductGroup,
  di as PagedOfProject,
  ui as PagedOfProjectMember,
  ci as PagedOfProjectProductGroup,
  Ao as PagedOfQuestion,
  fi as PagedOfRegion,
  Oo as PagedOfStatusGroup,
  Dr as PagedOfSubmission,
  Do as PagedOfTaskList,
  vi as PagedOfTeam,
  mi as PagedOfTeamMember,
  gi as PagedOfUser,
  zo as PagedOfVisit,
  Er as Place,
  go as PlaceAutocompleteSuggestion,
  gu as PlacesApi,
  Li as Potential,
  gp as PotentialsApi,
  N as ProblemDetails,
  gr as Product,
  bP as ProductCountQuestionKey,
  Eu as ProductCreateParams,
  $t as ProductGroup,
  yp as ProductGroupsApi,
  Du as ProductUpdateParams,
  yu as ProductsApi,
  sx as ProgressBar,
  st as Project,
  Po as ProjectChooserItem,
  zu as ProjectCreateParams,
  br as ProjectMember,
  Mu as ProjectMemberCreateParams,
  Nu as ProjectMemberUpdateParams,
  _p as ProjectMembersApi,
  Jr as ProjectProductGroup,
  Uu as ProjectProductGroupCreateParams,
  Bu as ProjectProductGroupUpdateParams,
  bp as ProjectProductGroupsApi,
  hi as ProjectQuestionnaire,
  bo as ProjectQuestionnaireDetail,
  Jp as ProjectQuestionnaireType,
  wp as ProjectQuestionnairesApi,
  Qt as ProjectStatus,
  _u as ProjectStatusApi,
  Zu as ProjectStatusCreateParams,
  xo as ProjectStatusOrderItem,
  $u as ProjectStatusOrderUpdateParams,
  Vu as ProjectStatusUpdateParams,
  qu as ProjectUpdateParams,
  Pp as ProjectsApi,
  Fu as PushSubscriptionCreateParams,
  xp as PushSubscriptionsApi,
  er as Question,
  Wu as QuestionCreateParams,
  To as QuestionDependency,
  Co as QuestionDependencyCreateParams,
  Lo as QuestionDependencyUpdateParams,
  y3 as QuestionInput,
  xs as QuestionOption,
  _e as QuestionType,
  Hu as QuestionUpdateParams,
  wo as Questionnaire,
  So as QuestionnaireDetail,
  Ti as QuestionnaireOverview,
  Sp as QuestionnairesApi,
  Tp as QuestionsApi,
  ch as RadioInput,
  we as Record,
  yr as Region,
  Ku as RegionCreateParams,
  Qu as RegionUpdateParams,
  Lp as RegionsApi,
  Pu as Role,
  Cp as SearchApi,
  Yu as SearchParams,
  Up as SearchType,
  Zt as SelectInput,
  wx as SemanticMarker,
  ix as Separator,
  io as Session,
  nx as SigninFailed,
  ox as SingleCheckboxInput,
  ax as SlideOver,
  Br as StatusGroup,
  bu as StatusGroupApi,
  Xu as StatusGroupUpdateParams,
  Et as Submission,
  Bp as SubmissionType,
  Ap as SubmissionsApi,
  lx as Table,
  yt as Task,
  jo as TaskCreateParams,
  Mo as TaskImportResult,
  No as TaskImportRowError,
  Rp as TaskImportRowErrorCode,
  Ci as TaskList,
  ic as TaskListParams,
  Mp as TaskSearchType,
  Eo as TaskUpdateParams,
  Op as TasksApi,
  Xt as Team,
  ac as TeamCreateParams,
  wr as TeamMember,
  nc as TeamMemberCreateParams,
  oc as TeamMemberUpdateParams,
  kp as TeamMembersApi,
  lc as TeamUpdateParams,
  Ip as TeamsApi,
  ux as TextArea,
  dt as TextInput,
  si as ToggleInput,
  gs as Tooltip,
  ku as UpdateEndOfDayQuestionnaireParams,
  Ze as User,
  Bo as UserResponsibilities,
  Ro as UserSalesTarget,
  wu as UsersApi,
  qt as Visit,
  uc as VisitCreateParams,
  cc as VisitUpdateParams,
  jp as VisitsApi,
  m3 as YesNoInput,
  hx as addressToContact,
  uu as addressesEqual,
  gx as buildImportFileName,
  Px as configureAxios,
  xx as configureAxiosInterceptors,
  Sx as configureContainer,
  cx as contactToAddress,
  PP as icons,
  _4 as pinCheck,
  yh as pinCross,
  oi as pinDefault,
  _h as pinStar,
  dx as placeToAddress,
  px as resolveCoordinates,
  Lx as translations,
  mx as useAddressValidation,
  wP as useAnswers,
  fc as useApiNotify,
  gh as useConfirm,
  vx as useDate,
  yx as useDownloadFile,
  Vp as useEnumConvert,
  d3 as useModelConvert,
  qo as useNotify,
  eo as usePopper,
  _x as useQuestionnaireEntries,
  bx as useSentry,
  Tx as useSessionStore,
  Zp as useStringConvert,
  fx as validateAndAutoApplyAddress
};
//# sourceMappingURL=shared.js.map
